const messagesRU = {
    code: "ru",
    messages: {
        cache: {
            management: "Управление кэшем",
            createNew: "Создать новый кэш",
            keySearchPlaceholder: "Поиск ключа (поддержка wildcard: *chat*, chat*, *chat)",
            type: "Тип кэша",
            actorType: "Тип актора",
            selectAutomation: "Выбрать автоматизацию",
            selectChatbot: "Выбрать чат-бота",
            selectUser: "Выбрать пользователя",
            clearFilters: "Очистить фильтры",
            deleteSelected: "Удалить выбранные",
            extendSelected: "Продлить срок выбранных",
            makeSelectedNeverExpire: "Сделать выбранные бессрочными",
            deleteAllActorCaches: "Удалить все кэши этого актора",
            emptyState: "Кэш пока не найден",
            editCache: "Редактировать кэш",
            key: "Ключ кэша",
            keyPlaceholder: "Пример: user_session_123",
            value: "Значение кэша",
            stringValuePlaceholder: "Строковое значение",
            dataType: "Тип данных",
            validityDuration: "Срок действия",
            neverExpire: "Никогда не истекает",
            specifyDuration: "Указать срок",
            specifyDate: "Указать дату",
            minutes: "Минуты",
            hours: "Часы",
            days: "Дни",
            update: "Обновить",
            create: "Создать",
            bulkExtend: "Массовое продление",
            bulkExtendInfo: "Срок действия {count} кэша(ей) будет продлён.",
            newValidityDuration: "Новый срок действия",
            extend: "Продлить",
            keyLabel: "Ключ",
            valueLabel: "Значение",
            typeLabel: "Тип",
            createdBy: "Создано",
            createdAt: "Дата создания",
            updatedBy: "Обновлено",
            expiresAt: "Истекает",
            actions: "Действия",
            edit: "Редактировать",
            extendDuration: "Продлить срок",
            makeNeverExpire: "Сделать бессрочным",
            loadError: "Не удалось загрузить список кэша",
            updateSuccess: "Кэш обновлён",
            createSuccess: "Кэш создан",
            saveError: "Не удалось сохранить кэш",
            deleteCache: "Удалить кэш",
            confirmDelete: "Да, удалить",
            deleteSuccess: "Кэш удалён",
            extendSuccess24h: "Срок кэша продлён на 24 часа",
            extendError: "Не удалось продлить срок кэша",
            deleteActorCaches: "Удалить кэши актора",
            deleteActorCachesConfirm: "Вы уверены, что хотите удалить все кэши \"{actor}\"? Это действие нельзя отменить.",
            confirmDeleteAll: "Да, удалить всё",
            countDeleted: "Удалено {count} кэша(ей)",
            bulkDelete: "Массовое удаление",
            bulkDeleteConfirm: "Будет удалено {count} кэша(ей). Вы уверены?",
            bulkMakeNeverExpire: "Массовое бессрочное",
            bulkMakeNeverExpireConfirm: "Срок действия будет снят с {count} кэша(ей). Вы уверены?",
            makeNeverExpireSuccess: "Кэш установлен как бессрочный",
            makeNeverExpireError: "Не удалось сделать кэш бессрочным",
            bulkExtendError: "Не удалось продлить сроки кэша",
            bulkExtendSuccess: "Срок {count} кэша(ей) продлён",
            bulkMakeNeverExpireSuccess: "{count} кэша(ей) установлены как бессрочные",
            deleteCacheConfirm: "Вы уверены, что хотите удалить кэш \"{key}\"?",
            selectedCount: "Выбрано {count} кэша(ей)",
            valueTitle: "Значение кэша: {key}",
            never: "Никогда",
            automation: "Автоматизация",
            chatbot: "Чат-бот",
            user: "Пользователь",
            api: "API",
            all: "Все",
            public: "Публичный",
            private: "Приватный"
        },
        zoho: {
            SETTING_GROUP: "Настройки",
            usermapping: "Сопоставление пользователей"
        },
        chatWindow: {
            descending: "По убыванию",
            ascending: "По возрастанию",
            filterTable: "Фильтр",
            thereIsNoChatContent: "Нет содержимого чата.",
            thereIsNoChatContentDsc: "Здесь вы можете просматривать содержимое чата и отправлять сообщения.",
            interactions: "Взаимодействия:",
            departments: "Отделы",
            channels: "Каналы",
            date: "Дата",
            lastChatStatus: "Последний статус чата",
            all: "Все",
            queued: "В очереди",
            open: "Открыто",
            closed: "Закрыто",
            private: "Частное",
            chatbot: "Чат-бот",
            lostMissed: "Потерянные / Пропущенные",
            interaction: "Взаимодействие",
            myActiveInbox: "Мой активный почтовый ящик",
            activeQueueInbox: "Активный + Очередь почтовый ящик",
            chatbotActiveInbox: "Активный почтовый ящик чат-бота",
            myDepartmentsActiveInbox: "Активный почтовый ящик моих отделов",
            notInteractedYesterday: "Вчера не было взаимодействий",
            queueInbox: "Очередь почтового ящика",
            whatsappActiveInbox: "Активный почтовый ящик WhatsApp",
            socialMediaActiveInbox: "Активный почтовый ящик соцсетей",
            missedThisMonth: "Пропущенные чаты в этом месяце",
            chooseAFileOrDragItHere: "Выберите файл или перетащите его сюда!",
            watching: "Наблюдаю",
            selectFilter: "Выбрать фильтр",
            clearAll: "Очистить все",
            me: "Я",
            today: "Сегодня",
            yesterday: "Вчера",
            thisWeek: "Эта неделя",
            lastWeek: "Прошлая неделя",
            last7Days: "Последние 7 дней",
            last30Days: "Последние 30 дней",
            thisMonth: "Этот месяц",
            lastMonth: "Прошлый месяц",
            last24h: "Последние 24 часа",
            custom: "Настроить",
            startMessage: "Начать сообщение",
            goToAgentReport: "Перейти к отчету агента",
            agentDetail: "Детали агента",
            agentList: "Список агентов",
            selectedFilter: "Выбранный фильтр",
            groupBy: "Группировать",
            none: "Нет группы",
            agent: "Представитель",
            department: "Отдел",
            sortBy: "Сортировать",
            lastPostAbove: "Последнее сообщение сверху",
            newChatsAbove: "Новые чаты сверху",
            oldChatsAbove: "Старые чаты сверху",
            live: "Жить",
            systemStatus: "Состояние системы",
            refresh: "Обновить",
            close: "Закрыть",
            totalCustomers: "Общее количество клиентов",
            totalAnswered: "Всего отвечено",
            waitingAnswer: "Ожидание ответа",
            totalAgentInChat: "Всего агентов в чате",
            onlineAgentCount: "Количество онлайн агентов",
            totalCustomer: "Всего клиентов",
            answered: "Отвечено",
            unanswered: "Без ответа",
            noContactWasFoundMatchingTheCurrentFilters: "Не найдено контактов, соответствующих текущим фильтрам.",
            you: "Ты",
            others: "Другие",
            queue: "Очередь",
            chatbotContact: "Чатбот",
            closedContact: "Закрыто",
            myInteractions: "Мои взаимодействия",
            special: "Особенный",
            allInteractions: "Все контакты",
            waiting: "Ожидающие",
            tag: "Тег",
            website: "Веб-сайт",
            channel: "Канал",
            platform: "Платформа",
            answerStatus: "Статус ответа",
            departmentToWhichItIsAffiliated: "Прикрепленный отдел",
            owner: "Владелец",
            switchToLiveSupportMode: "Переключиться в режим прямой поддержки",
            switchToLiveSupportModeConfirmation: "Вы хотите переключиться в режим прямой поддержки для просмотра этого контакта?",
            hiddenChatsWarning: "В этом списке {count} чатов, которые вы не можете видеть",
            clickToSeeDetails: "Нажмите, чтобы увидеть детали",
            viewDetails: "Просмотреть детали",
            hiddenChatsDetails: "Детали скрытых чатов",
            totalHiddenChats: "Всего скрытых чатов",
            examples: "Примеры",
            reasons: {
                visitorNotFound: "Посетитель не найден",
                noChannelAccess: "У вас нет доступа к этому каналу",
                ownedByOtherNotChannelOwner: "Принадлежит другому пользователю (Вы не владелец канала)",
                ownedByOtherNoChannel: "Принадлежит другому пользователю (Без канала)",
                noOwnerAdminOnly: "Чат без владельца (Только администраторы и владельцы каналов могут видеть)"
            }
        },
        chat: {
            inbox: "Входящие",
            layouts: {
                chat: "Макет Чата",
                table: "Макет Таблицы",
                kanban: "Макет Канбан"
            },
            filters: {
                allContacts: "Все Контакты",
                myInbox: "Моя Входящая",
                myContacts: "Мои Контакты",
                missed: "Пропущенные",
                unanswered: "Без ответа",
                unassigned: "Не Назначенные",
                chatbot: "Чатбот"
            },
            groups: {
                views: "Представления",
                customFilters: "Пользовательские Фильтры",
                team: "Команда",
                contacts: "Контакты",
                system: "Система"
            },
            sidebar: {
                tabScreen: "Экран вкладок",
                search: "Поиск",
                addNewFilter: "Добавить новый фильтр",
                edit: "Редактировать",
                showInTable: "Показать в режиме таблицы",
                showInKanban: "Показать в режиме Канбан",
                rename: "Переименовать",
                makePublic: "Сделать публичным",
                makePrivate: "Сделать приватным",
                moveToTop: "Переместить вверх",
                moveToBottom: "Переместить вниз",
                delete: "Удалить",
                renameFilterTitle: "Переименовать фильтр",
                filterNamePlaceholder: "Введите название фильтра",
                positionUpdateError: "Ошибка при обновлении позиции",
                filterNameEmpty: "Название фильтра не может быть пустым",
                filterNameUpdated: "Название фильтра обновлено",
                filterNameUpdateError: "Ошибка при обновлении названия фильтра",
                filterVisibilityUpdateError: "Ошибка при обновлении видимости фильтра",
                filterMadePrivate: "Фильтр установлен как приватный",
                filterMadePublic: "Фильтр установлен как публичный",
                filterMovedToTop: "Фильтр перемещён вверх",
                filterMovedToBottom: "Фильтр перемещён вниз",
                filterMoveError: "Ошибка при перемещении фильтра",
                onlyCreatorOrRootCanDeletePublic: "Только создатель или пользователь root может удалять публичные фильтры",
                deleteFilterTitle: "Удалить фильтр",
                deleteFilterConfirm: "Вы уверены, что хотите удалить фильтр \"{name}\"?",
                deleteFilterOk: "Удалить",
                deleteFilterCancel: "Отмена",
                filterDeleted: "Фильтр удалён",
                filterDeleteError: "Ошибка при удалении фильтра",
                websiteAnalytics: "Аналитика сайта"
            },
            gridContactList: {
                emptyConversationsTitle: "Чат не найден",
                emptyConversationsDescription: "У вас пока нет активного чата. Вы можете начать новый чат со страницы клиента.",
                markAsUnanswered: "Отметить как без ответа",
                markAsAnswered: "Отметить как отвеченный",
                removeVIP: "Убрать VIP",
                markAsVIP: "Отметить как VIP",
                markAsRead: "Отметить как прочитанное",
                markAsUnread: "Отметить как непрочитанное",
                closeChat: "Закрыть чат",
                markedAsAnswered: "Отмечено как отвеченный",
                markedAsUnanswered: "Отмечено как без ответа",
                operationFailed: "Операция не удалась",
                markedAsVIP: "Отмечено как VIP",
                vipRemoved: "VIP убран",
                markedAsUnread: "Отмечено как непрочитанное",
                markedAsRead: "Отмечено как прочитанное",
                confirmCloseChat: "Вы уверены, что хотите завершить чат?",
                chatClosed: "Чат закрыт"
            },
            tableContactList: {
                editFilter: "Редактировать фильтр",
                chatStatus: "Статус Чата",
                grouping: "Группировка",
                allContacts: "Все контакты",
                groupNone: "Нет",
                groupTag: "Тег",
                groupDepartment: "Отдел",
                groupChannel: "Канал",
                groupPlatform: "Платформа",
                groupOwner: "Владелец",
                groupUsers: "Участники",
                groupAnswerStatus: "Статус ответа",
                statusAll: "Все",
                statusOpen: "Открыт",
                statusClosed: "Закрыт",
                statusUnknown: "Неизвестно",
                copyLabel: "Копия",
                filterCreatedSuccess: "Фильтр успешно создан",
                filterCreatedNameDuplicate: "Имя \"{createName}\" уже использовалось. Фильтр создан как \"{filterName}\".",
                filterCreateFailed: "Не удалось создать фильтр",
                filterCreateError: "Произошла ошибка при создании фильтра.",
                platformSupsis: "Supsis",
                platformEmail: "Email",
                platformWhatsapp: "WhatsApp",
                platformWeb: "Веб",
                platformInstagram: "Instagram",
                platformTelegram: "Telegram",
                platformMessenger: "Messenger",
                platformMetaLeads: "Лиды Meta",
                platformTrendyol: "Trendyol",
                platformLinkedin: "LinkedIn",
                answerStatusAnswered: "Отвечено",
                answerStatusUnanswered: "Без ответа"
            },
            kanbanContactList: {
                filterHide: "Скрыть фильтры",
                filterAdd: "Добавить фильтр",
                broadcast: "Рассылка",
                broadcastSelectPlaceholder: "Выберите рассылку...",
                loading: "Загрузка...",
                broadcastNotFound: "Рассылка не найдена",
                broadcastTitle: "Название",
                broadcastDate: "Дата",
                broadcastStatus: "Статус",
                broadcastProgress: "Прогресс",
                refresh: "Обновить",
                kanbanLoading: "Загрузка Kanban...",
                deletedUser: "Удалённый пользователь",
                unowned: "Без владельца",
                activeInChat: "Активен (в чате)",
                newInQueue: "Новый (в очереди)",
                agentDown: "Агент отключён",
                closed: "Закрыт",
                blocked: "Заблокирован",
                unblocked: "Разблокирован",
                groupsLoadError: "Ошибка загрузки групп",
                dataLoadError: "Ошибка загрузки данных",
                broadcastsLoadError: "Ошибка загрузки рассылок",
                dataRefreshed: "Данные обновлены",
                refreshError: "Ошибка при обновлении",
                unknownContact: "Неизвестный контакт",
                assigned: "Не назначен",
                platformMobile: "Мобильный",
                broadcastStatusCreated: "Создано",
                broadcastStatusScheduled: "Запланировано",
                broadcastStatusQueued: "В очереди",
                broadcastStatusRunning: "Отправка",
                broadcastStatusCompleted: "Завершено",
                broadcastStatusFailed: "Ошибка",
                broadcastStatusCancelled: "Отменено",
                metaLeadNewLead: "Новый лид",
                metaLeadInitialContact: "Первый контакт",
                metaLeadNeedsAssessment: "Оценка потребностей",
                metaLeadProposalSent: "Предложение отправлено",
                metaLeadProposalReview: "Проверка предложения",
                metaLeadNegotiation: "Переговоры",
                metaLeadDecisionStage: "Этап решения",
                metaLeadClosure: "Закрытие",
                metaLeadFollowUp: "Допродажа",
                broadcastSent: "Отправлено",
                broadcastDelivered: "Доставлено",
                broadcastRead: "Прочитано",
                broadcastFailed: "Ошибка",
                broadcastEdited: "Изменено",
                broadcastDeleted: "Удалено",
                triggerTypeApi: "API",
                triggerTypeBroadcast: "Рассылка",
                triggerTypeAutomation: "Автоматизация",
                emptyGroup: "Нет контактов в этой группе",
                loadMore: "Загрузить ещё...",
                groupSelectTitle: "Выберите поле группировки",
                searchPlaceholder: "Поиск...",
                categoryBasic: "Основное",
                categoryDemographic: "Демография",
                categoryTags: "Теги и категория",
                categoryMeta: "Лиды Meta",
                categoryBroadcast: "Рассылка",
                categoryOther: "Другое",
                fieldAnswerStatus: "Статус ответа",
                fieldLastConversationStatus: "Статус чата",
                fieldOwner: "Владелец",
                fieldUsers: "Участники",
                fieldChannel: "Канал",
                fieldPlatform: "Платформа",
                fieldCountry: "Страна",
                fieldCity: "Город",
                fieldBrowser: "Браузер",
                fieldPreferredLang: "Язык",
                fieldTags: "Теги",
                fieldDepartment: "Отдел",
                fieldMetaLeadStatus: "Статус лида",
                fieldMetaLeadAdName: "Название объявления",
                fieldMetaLeadAdsetName: "Набор объявлений",
                fieldMetaLeadCampaignName: "Кампания",
                fieldMetaLeadFormName: "Название формы",
                fieldMetaLeadPlatform: "Платформа Meta",
                fieldLastBroadcastStatus: "Статус рассылки",
                fieldLastBroadcastReason: "Причина рассылки",
                fieldBlockedSnapshot: "Статус блокировки",
                fieldLastTriggerType: "Тип триггера",
                fieldZohoLeadStatus: "Статус лида Zoho",
                fieldZohoLeadSource: "Источник лида Zoho",
                broadcastTriggerSuccess: "Ответил на сообщение рассылки!",
                broadcastTriggerWaiting: "Ожидание ответа...",
                unknownUser: "Неизвестный пользователь",
                unread: "Не прочитано",
                platformIg: "Instagram",
                platformFb: "Facebook"
            },
            gridContactListToolBar: {
                chatStatus: "Статус Чата",
                sortBy: "Сортировать по",
                all: "Все",
                open: "Открыт",
                closed: "Закрыт",
                allStatus: "Все",
                lastActivity: "Последняя Активность",
                createdAt: "Дата Создания",
                unknown: "Неизвестно"
            },
            chatCloseSettings: {
                selectPhone: "Выберите телефон",
                selectPhoneDescription: "С какого телефона вы хотите позвонить на {number}?",
                call: "Позвонить",
                unnamedChannel: "Канал без названия",
                typeVisitorName: "Введите имя посетителя...",
                webphoneCall: "Позвонить через Webphone",
                hideSystemMessages: "Скрыть системные сообщения",
                chatbotDebugMode: "Режим отладки чат-бота",
                createTask: "Создать задачу",
                showProfile: "Показать профиль",
                sendCapiEvent: "Отправить событие CAPI",
                noPhoneNumber: "Номер для звонка не найден",
                noWebphoneChannel: "Канал Webphone не найден",
                webphoneCalling: "Звонок на {number} через Webphone...",
                unknown: "Неизвестно",
                channelTypeKirmiziSantral: "Кызыл Сантраль",
                channelTypeTelnyx: "Telnyx",
                channelTypeNetgsm: "NetGSM",
                channelTypeWebPhone: "Веб-телефон",
                platformWeb: "Веб",
                platformWhatsapp: "WhatsApp",
                platformWhatsappBusiness: "WhatsApp Business",
                platformInstagram: "Instagram",
                platformInstagramV2: "Instagram V2",
                platformMessenger: "Messenger",
                platformTelegram: "Telegram",
                platformTrendyol: "Trendyol",
                platformEmail: "Эл. почта",
                platformSms: "SMS",
                vipCustomerTooltip: "★ VIP-клиент"
            },
            contactDetail: {
                removeVIPTooltip: "Убрать VIP",
                markAsVIPTooltip: "Отметить как VIP (Пользователи, отмеченные как VIP, всегда будут отображаться вверху в чатах).",
                customerOwnership: "Владение Клиентом",
                ownershipDescription: "Когда назначается владение клиентом, только владелец и полные администраторы могут видеть его",
                unowned: "Без владельца",
                assignToMe: "Назначить Мне",
                removeOwnership: "Убрать Владение",
                dragPlaceholder: "Переместить сюда",
                currentConversationDepartment: "Текущий Отдел Разговора",
                pastInteractionDepartments: "Прошлые Отделы Взаимодействия",
                createdAt: "Дата Создания",
                updatedAt: "Дата Обновления",
                zohoSync: "Синхронизация Zoho",
                zohoSyncQuestion: "Хотите ли вы выполнить операции изменения контакта также в Zoho?",
                basicInfo: "Информация о Контакте",
                loginInfo: "Информация Формы Контакта",
                profileFields: "Поля Профиля",
                systemInfo: "Системная Информация"
            },
            contactDetailItem: {
                removeOwnership: "Убрать Владение",
                assignOwnershipToMe: "Назначить Владение Мне",
                vipCustomer: "VIP Клиент",
                contentCopiedSuccess: "Содержимое успешно скопировано!",
                invalidEmail: "Неверный адрес электронной почты!",
                invalidValue: "Неверное значение!"
            },
            filtersSection: {
                addFilter: "Добавить Фильтр",
                all: "Все",
                open: "Открыт",
                closed: "Закрыт",
                relevance: "Релевантность",
                lastActivityNewest: "Самая Новая Активность",
                lastActivityOldest: "Самая Старая Активность",
                noParticipant: "Без Участника",
                ownershipFilter: "Фильтр Владения",
                metaReferral: "Meta Реферал",
                userStatus: "Статус Пользователя",
                unowned: "Без владельца",
                fromAds: "Из Рекламы",
                notFromAds: "Не Из Рекламы",
                blockedUsers: "Заблокированные Пользователи",
                unblockedUsers: "Незаблокированные Пользователи",
                unread: "Непрочитанное",
                read: "Прочитанное",
                yes: "Да",
                no: "Нет",
                answered: "Отвеченный",
                unanswered: "Без Ответа",
                active: "Активный",
                lost: "Потерянный",
                new: "Новый",
                chatbot: "Чатбот",
                closedStatus: "Закрыт",
                platform: "Платформа",
                channel: "Канал",
                department: "Отдел",
                tag: "Тег",
                participant: "Участник",
                ownership: "Владение",
                lastActivityTime: "Время Последней Активности",
                fullName: "Полное Имя",
                email: "Email",
                phone: "Телефон",
                vipCustomer: "VIP Клиент",
                hasVIP: "Имеет VIP",
                noVIP: "Нет VIP",
                operatingSystem: "Операционная Система",
                browser: "Браузер",
                ipAddress: "IP Адрес",
                visitingPage: "Посещенная Страница",
                adInteraction: "Взаимодействие с Рекламой",
                blockedStatus: "Статус Блокировки",
                connectionTime: "Время Подключения",
                createdAt: "Дата Создания",
                updatedAt: "Дата Обновления",
                readStatus: "Статус Чтения",
                missedChat: "Пропущенный Чат",
                answerStatus: "Статус Ответа",
                lastConversationStatus: "Статус Последнего Разговора",
                lastTriggerState: "Состояние Последнего Триггера",
                type: "Тип",
                name: "Имя",
                enterTriggerName: "Введите имя триггера...",
                zohoInfo: "Информация Zoho",
                id: "ID",
                enterContactOrLeadId: "Введите ID Контакта или Лида...",
                broadcastMessage: "Массовое Сообщение",
                today: "Сегодня",
                yesterday: "Вчера",
                thisWeek: "Эта Неделя",
                lastWeek: "Прошлая Неделя",
                last7Days: "Последние 7 Дней",
                last30Days: "Последние 30 Дней",
                thisMonth: "Этот Месяц",
                lastMonth: "Прошлый Месяц"
            },
            filterChip: {
                operator: "Оператор:",
                enterText: "Введите текст...",
                enterNumber: "Введите число...",
                type: "Тип",
                value: "Значение",
                enterValue: "Введите значение...",
                addFilter: "Добавить Фильтр",
                equals: "Равно",
                contains: "Содержит",
                startsWith: "Начинается С",
                endsWith: "Заканчивается На",
                greaterThan: "Больше Чем",
                lessThan: "Меньше Чем",
                greaterThanOrEqual: "Больше Или Равно",
                lessThanOrEqual: "Меньше Или Равно",
                between: "Между",
                custom: "Пользовательский",
                select: "Выбрать"
            },
            filterPanel: {
                backToChat: "Вернуться к Виду Чата",
                publicFilter: "Публичный Фильтр",
                privateFilter: "Приватный Фильтр",
                editFilterName: "Редактировать Имя Фильтра",
                contactsFound: " контактов найдено",
                enterFilterName: "Введите имя фильтра",
                filterSuggestions: "Предложения Фильтров",
                private: "Приватный",
                public: "Публичный",
                createFilter: "Создать Фильтр",
                update: "Обновить",
                changeToPublic: "Изменить на Публичный",
                changeToPrivate: "Изменить на Приватный",
                delete: "Удалить",
                clearSearch: "Очистить Поиск",
                previous: "Назад",
                next: "Вперед",
                searchTerm: "Поисковый Термин:",
                whichFieldToSearch: "В каком поле вы хотите искать?",
                contactId: "ID Контакта",
                conversationId: "ID Разговора",
                noSearchAllFields: "Нет, искать во всех полях",
                yesSearchOnlyField: "Да, искать только в {field}",
                search: "Поиск",
                allFields: "Все Поля",
                fullname: "Полное имя",
                email: "Email",
                whatsappNumber: "Номер WhatsApp",
                phone: "Телефон",
                contactIdField: "поле ID контакта",
                conversationIdField: "ID Разговора",
                searchAllFieldsPlaceholder: "Введите то, что вы хотите найти во всех полях",
                searchFullnamePlaceholder: "Введите то, что вы хотите найти по Полному Имени",
                searchEmailPlaceholder: "Введите то, что вы хотите найти по Email",
                searchWhatsappPlaceholder: "Введите то, что вы хотите найти по WhatsApp",
                searchPhonePlaceholder: "Введите то, что вы хотите найти по Телефону",
                searchContactIdPlaceholder: "Введите ID Контакта, который вы хотите найти",
                searchConversationIdPlaceholder: "Введите ID Разговора, который вы хотите найти",
                searchPlaceholder: "Поиск",
                edited: " (Отредактировано)",
                unnamedFilter: "Фильтр Без Имени",
                all: "Все",
                open: "Открыт",
                closed: "Закрыт",
                unknown: "Неизвестно",
                filterUpdatedSuccess: "Фильтр успешно обновлен",
                filterUpdatedDescription: "Фильтр \"{name}\" был обновлен.",
                filterUpdateFailed: "Фильтр не был обновлен",
                filterUpdateError: "Произошла ошибка при обновлении фильтра.",
                filterSavedSuccess: "Фильтр успешно сохранен",
                filterSavedDescription: "Имя \"{createName}\" уже использовалось. Фильтр был создан как \"{filterName}\".",
                filterCreatedDescription: "Фильтр \"{filterName}\" был создан.",
                filterSaveFailed: "Фильтр не был сохранен",
                filterSaveError: "Произошла ошибка при сохранении фильтра.",
                aiFilterCreatedSuccess: "AI Фильтр успешно создан",
                aiFilterCreatedDescription: "Имя \"{createName}\" уже использовалось. Фильтр был создан как \"{filterName}\" и применен.",
                aiFilterCreatedApplied: "Фильтр \"{filterName}\" был создан и применен.",
                aiFilterCreateFailed: "Фильтр не был создан",
                aiFilterCreateError: "Произошла ошибка при создании AI фильтра.",
                phoneDetected: "Номер Телефона Обнаружен",
                emailDetected: "Адрес Email Обнаружен",
                idFormatDetected: "Формат ID Обнаружен",
                contactIdDetected: "ID Контакта Обнаружен",
                conversationIdDetected: "ID Разговора Обнаружен",
                searchMode: "Режим Поиска",
                phoneDetectedMessage: "Введенное значение похоже на номер телефона. Хотите искать только в поле номера телефона?",
                emailDetectedMessage: "Введенное значение похоже на адрес электронной почты. Хотите искать только в поле электронной почты?",
                idFormatDetectedMessage: "Введенное значение похоже на формат ID. В каком поле вы хотите искать?",
                phoneField: "поле номера телефона",
                emailField: "поле электронной почты",
                conversationIdFieldName: "поле ID разговора",
                idField: "поле ID",
                deleteFilter: "Удалить Фильтр",
                deleteFilterConfirm: "Вы уверены, что хотите удалить фильтр \"{name}\"? Это действие нельзя отменить.",
                cancel: "Отмена",
                filterDeletedSuccess: "Фильтр успешно удален",
                filterDeletedDescription: "Фильтр \"{name}\" был удален.",
                filterDeleteFailed: "Фильтр не был удален",
                filterDeleteError: "Произошла ошибка при удалении фильтра.",
                visibilityUpdatedSuccess: "Видимость успешно обновлена",
                visibilityUpdatedDescription: "Фильтр был установлен как \"{visibility}\".",
                visibilityUpdateFailed: "Видимость не была обновлена",
                visibilityUpdateError: "Произошла ошибка при обновлении фильтра.",
                publicVisibility: "публичный",
                privateVisibility: "приватный"
            },
            contactList: {
                noContactsFound: "Контакты не найдены",
                unknownContact: "Неизвестный Контакт",
                unknown: "Неизвестно",
                fullName: "Полное Имя",
                platform: "Платформа",
                email: "Email",
                phone: "Телефон",
                tags: "Теги",
                status: "Статус",
                lastActivity: "Последняя Активность",
                answerStatus: "Статус Ответа",
                channel: "Канал",
                owner: "Владелец",
                vip: "VIP",
                connectionTime: "Время Подключения",
                unread: "Непрочитанное",
                departments: "Отделы",
                operatingSystem: "Операционная Система",
                browser: "Браузер",
                countryCity: "Страна - Город",
                ipAddress: "IP Адрес",
                visitingPage: "Посещенная Страница",
                lastConversationDate: "Дата Последнего Разговора",
                blockedStatus: "Статус Блокировки",
                lastConversationParticipants: "Участники Последнего Разговора",
                preferredLanguage: "Предпочитаемый Язык",
                createdAt: "Дата Создания",
                updatedAt: "Дата Обновления",
                broadcastStatus: "Статус Broadcast",
                broadcastAnswer: "Ответ Broadcast",
                zohoContactId: "ID Контакта Zoho",
                zohoLeadId: "ID Лида Zoho",
                profileFields: "Поля Профиля",
                closed: "Закрыт",
                open: "Открыт",
                unknownStatus: "Неизвестно",
                answered: "Отвеченный",
                unanswered: "Без Ответа",
                unreadStatus: "Непрочитанное",
                readStatus: "Прочитанное",
                vipStatus: "VIP",
                normal: "Обычный",
                blocked: "Заблокирован",
                today: "Сегодня",
                yesterday: "Вчера",
                enqueued: "В Очереди",
                sent: "Отправлено",
                delivered: "Доставлено",
                read: "Прочитано",
                deleted: "Удалено",
                failed: "Неудачно",
                replied: "Ответил",
                notReplied: "Не Ответил",
                jsonProperty: "Свойство JSON",
                jsonCopiedSuccess: "Содержимое JSON успешно скопировано!"
            }
        },
        form: {
            title: {
                titleSettings: "Настройки заголовка",
                fullNameSettings: "Настройки полного имени",
                emailSettings: "Настройки электронной почты",
                addressSettings: "Настройки адреса",
                phoneSettings: "Настройки телефона",
                datePickerSettings: "Настройки выбора даты",
                shortTextSettings: "Настройки короткого текста",
                longTextSettings: "Настройки длинного текста",
                dropDownListSettings: "Настройки выпадающего списка",
                singleChoiceSettings: "Настройки одиночного выбора",
                multipleSelectionSettings: "Настройки множественного выбора",
                numberSettings: "Настройки чисел",
                hourSettings: "Настройки часов",
                spinnerSettings: "Настройки спиннера",
                sendSettings: "Настройки отправки",
                starRatingSettings: "Настройки звездного рейтинга",
                ratingScaleSettings: "Настройки шкалы оценок",
                separationElementSettings: "Настройки элемента разделения",
                fileUploadSettings: "Настройки загрузки файлов",
                imageSettings: "Настройки изображения"
            },
            lineColor: "Цвет линии",
            separatorColorInfo: "Выберите или введите цвет разделителя (например, #RRGGBB)",
            separatorHeight: "Высота разделителя",
            separatorHeightInfo: "Введите высоту разделителя",
            bottomSpace: "Нижний отступ",
            bottomSpaceInfo: "Добавьте пространство под разделителем",
            topSpace: "Верхний отступ",
            topSpaceInfo: "Добавьте пространство над разделителем",
            sideSpace: "Боковой отступ",
            sideSpaceInfo: "Добавьте пространство слева и справа от разделителя",
            onlyImageUpload: "Можно загрузить только изображение!",
            imageSizeLimit: "Размер вашего изображения должен быть не более 5 МБ!",
            image: "Изображение",
            size: "Размер",
            width: "Ширина",
            height: "Высота",
            imageAlignment: "Выравнивание изображения",
            wide: "Широкий",
            small: "Маленький",
            textAlignment: "Выравнивание текста",
            chooseHorizontalAlignment: "Выберите, как выровнять этот заголовок по горизонтали.",
            headerSize: "Размер заголовка",
            addSmallTextBelowHeader: "Добавьте меньший текст под заголовком",
            subHeaderText: "Текст подзаголовка",
            subLabel1: "Подметка(1)",
            subLabel2: "Подметка(2)",
            validPhoneNumber: "Пожалуйста, введите действительный номер телефона",
            masked: "Замаскированный",
            copyField: "Скопировать поле",
            copyFieldDescription: "Создайте копию этого поля, сохраняя все его сохраненные настройки",
            enterQuestion: "Введите вопрос",
            notRequired: "Не требуется",
            addDescriptionBelowField: "Добавьте короткое описание под полем",
            setDefault: "Установить как по умолчанию",
            pleaseSelect: "Пожалуйста, выберите",
            placeholder: "Место для текста",
            required: "Обязательно",
            fieldEmptyError: "Не разрешать отправку формы, если это поле пусто",
            subLabels: "Подподписи",
            addressLine1: "Адрес, строка 1",
            addressLine2: "Адрес, строка 2",
            postalCode: "Почтовый индекс",
            stateProvince: "Регион / Штат",
            chooseLabelAlignment: "Выберите, как выровнять текст метки по горизонтали",
            right: "ПРАВО",
            left: "ЛЕВО",
            top: "ВЕРХ",
            labelAlignment: "Выравнивание метки",
            fieldLabel: "Метка поля",
            read: "Прочитано",
            itemsPerPage: "элементов/страница",
            downloadAllDataAsPDF: "Скачать все данные в формате PDF",
            downloadAllDataAsExcel: "Скачать все данные в формате Excel",
            downloadSelectedDataAsPDF: "Скачать выбранные данные в формате PDF",
            downloadSelectedDataAsExcel: "Скачать выбранные данные в формате Excel",
            selectItemToViewDetails: "Выберите элемент, чтобы увидеть детали.",
            deleteFormConfirm: "При удалении этой формы все связанные с ней данные будут удалены безвозвратно. Вы уверены, что хотите продолжить?",
            redicetFormAnswer: "ПЕРЕДАТЬ ОТВЕТЫ ФОРМЫ",
            redicetFormAnswerDesc: "При перенаправлении ответов формы в тикет-систему обязательно запрашивайте у пользователя в форме номер телефона или адрес электронной почты. Эта информация важна для более быстрой и эффективной связи с пользователем.",
            redicetFormAnswerDesc2: "Ответы формы направляются в систему в виде тикетов",
            rediectAnswersToTicket: "Перенаправлять входящие ответы в тикет",
            errorTicketMode: "Ошибка обновления режима тикетов:",
            formView: "Посмотреть форму",
            formEdit: "Форма обновления",
            totalResponse: "Общий ответ",
            totalUnreadResponse: "Всего непрочитанных ответов",
            totalReadResponse: "Общий отклик на чтение",
            totalArchivedResponse: "Всего архивных ответов",
            singleChoice: "Единичный выбор",
            _delete: "Удалить",
            inbox: "Входящие",
            edit: "Редактировать",
            forms: "Формы",
            formsDesc: "Здесь вы можете управлять своими формами.",
            createaForm: "создать форму",
            allForms: "все формы",
            formPublish: {
                shareFast: "ДЕЛИТЕСЬ БЫСТРО",
                shareFastDesc: "Прямая ссылка на форму и социальный обмен",
                add: "ДОБАВИТЬ",
                addDesc: "Различные варианты встраивания веб-страниц",
                assignForm: "ВЫРОВНЯТЬ ФОРМУ",
                assignFormDesc: "Назначайте свои формы другим",
                emails: "ЭЛЕКТРОННАЯ ПОЧТА",
                emailsDesc: "Напоминания и мгновенный обмен информацией",
                prefill: "PREFILL",
                prefillDesc: "Предварительное заполнение форм",
                pdf: "PDF",
                pdfDesc: "Скачать заполняемый PDF",
                platforms: "ПЛАТФОРМЫ",
                platformsDesc: "Варианты публикации сторонних разработчиков",
                linkToYour: "АДРЕС ССЫЛКИ НА ВАШУ ФОРМУ",
                linkToYourDesc: "Ваша форма была надежно опубликована и готова к использованию по этому адресу.",
                shareWithLink: "ПОДЕЛИТЬСЯ ССЫЛКОЙ",
                publicForm: "Публичная форма",
                copyLink: "КОПИРОВАТЬ ССЫЛКУ",
                openInNewTab: "ОТКРЫТЬ В НОВОЙ ВКЛАДКЕ",
                linkCopied: "Ссылка скопирована",
                codeCopied: "Скопированный код",
                iframe: "IFRAME",
                iframeDesc: "Добавьте форму на страницу с помощью iFrame",
                openWindow: "ОТКРЫТОЕ ОКНО",
                openWindowDesc: "Ссылка на всплывающую форму",
                formAddDesc: "Скопируйте и вставьте этот сниппет в код и разместите форму на своем сайте."
            },
            formSettings: {
                enterNameForm: "Введите имя для этой формы",
                selectStatusForm: "Выберите статус вашей формы",
                disabled: "Инвалиды",
                disableSpecifiedTime: "Отключение в указанное время",
                disableFormResponse: "Отключение при достижении лимита ответов формы",
                pageShownAfterForm: "Страница, отображаемая после отправки формы",
                formNotFound: "Форма не найдена.",
                errorLoadingform: "При загрузке формы произошла ошибка.",
                formUpdated: "Заголовок формы был успешно обновлен.",
                formErrorUpdated: "Произошла ошибка при обновлении заголовка формы",
                formSettings: "НАСТРОЙКИ ФОРМЫ",
                changeFormStateAndProperties: "Настройки формы",
                title: "Название",
                newFormSettings: "Настройки новой формы",
                formStatus: "Статус формы",
                activateOrDeactivate: "Активируйте, деактивируйте или условно активируйте вашу форму",
                effective: "ЭФФЕКТИВНО",
                yourFromIsVisible: "Теперь ваша форма видна и может принимать ответы.",
                emails: "ЭЛЕКТРОННАЯ ПОЧТА",
                emailsDesc: "Отправка писем автоответчика и писем с уведомлениями",
                conditions: "УСЛОВИЯ",
                conditionsDesc: "Секция условной логики, которая запускает действия на основе вводимых данных формы",
                thankYouPage: "СТРАНИЦА БЛАГОДАРНОСТЕЙ",
                thankYouPageDesc: "Страница, отображаемая после отправки формы",
                integretions: "ИНТЕГРАЦИИ",
                integretionsDesc: "Подключите вашу форму к другим приложениям"
            },
            clickToDeleteYourLogo: "Нажмите, чтобы удалить свой логотип",
            create: "Создать",
            settings: "Настройки",
            load: "Загрузить",
            insertFormField: "Вставка поля формы",
            addYourLogo: "Добавьте свой логотип",
            surveyElements: {
                surveyElements: "Элементы исследования",
                dataTable: "Таблица данных",
                starRating: "Звездный рейтинг",
                evaluationScale: "Шкала оценки"
            },
            pageElements: {
                pageElements: "Элементы страницы",
                separationElement: "Элемент разделения",
                partitionCollapse: "Распад раздела",
                pageBreak: "Конец страницы"
            },
            basicElements: {
                basicElements: "Основные элементы",
                shortText: "Короткий текст",
                longText: "Длинный текст",
                paragraph: "Параграф",
                dropDownList: "Выпадающий список",
                singleChoice: "Единственный выбор",
                multipleSelection: "Множественный выбор",
                number: "Номер",
                image: "Изображение",
                fileUpload: "Загрузка файлов",
                hour: "Час",
                spinner: "Спиннер",
                send: "Отправить"
            },
            formElements: {
                formElements: "Элементы формы",
                title: "Название",
                fullName: "Полное имя",
                email: "Электронная почта",
                address: "Адрес",
                phone: "Телефон",
                datePicker: "Подборщик даты",
                appointment: "Назначение",
                signature: "Подпись",
                productList: "список продуктов"
            },
            startWithaBlankForm: "Начните с пустого бланка",
            startFromScratch: "Начните с нуля",
            createOrTransferaForm: "Создайте или перенесите форму, чтобы начать сбор данных",
            createForm: "Создать форму",
            trashBin: "Корзина",
            formAutomations: "Автоматизация форм",
            trashBinList: {
                title: "Корзина",
                description: "Ваши удалённые формы перечислены здесь",
                loading: "Загрузка удалённых форм...",
                restore: "Восстановить",
                permanentDelete: "Удалить навсегда",
                delete: "Удалить",
                emptyTitle: "Корзина пуста",
                emptyDescription: "Удалённые формы не найдены",
                totalResponses: "Всего ответов",
                unread: "Непрочитанные",
                read: "Прочитанные",
                archived: "В архиве",
                restoreConfirmDescription: "Вы уверены, что хотите восстановить эту форму? Форма и все её данные будут добавлены в список активных форм.",
                deleteConfirmDescription: "Вы уверены, что хотите навсегда удалить эту форму? Это действие нельзя отменить, и все данные, связанные с формой, будут удалены.",
                deletedToday: "Удалено сегодня",
                deletedYesterday: "Удалено вчера",
                deletedDaysAgo: "Удалено {count} дней назад",
                deletedWeeksAgo: "Удалено {weeks} недель назад",
                deletedMonthsAgo: "Удалено {months} месяцев назад",
                restoreSuccess: "Форма успешно восстановлена",
                restoreError: "Произошла ошибка при восстановлении формы",
                deleteSuccess: "Форма удалена навсегда",
                deleteError: "Произошла ошибка при удалении формы"
            }
        },
        automation: {
            deleteAutomationsTitle: "Удалить Автоматизации",
            deleteAutomationsConfirmation: "Вы уверены, что хотите удалить {count} автоматизаций? Это действие нельзя отменить.",
            automationsMoveError: "Ошибка при перемещении автоматизаций",
            noAutomationToMove: "Не найдено автоматизации для перемещения",
            deleteCategoryConfirmation: "Вы уверены, что хотите удалить категорию \"{categoryName}\"? Автоматизации в этой категории будут перенесены в категорию \"{generalCategory}\".",
            automationsMovedToCategory: "{count} автоматизаций перенесено в категорию \"{categoryName}\"",
            automationImportedSuccessfully: "Автоматизация {name} успешно импортирована",
            automationPasteError: "Ошибка при вставке автоматизации",
            invalidAutomationExport: "В буфере обмена не найден действительный экспорт автоматизации Supsis",
            invalidAutomationJSON: "В буфере обмена не найден действительный JSON автоматизации",
            clipboardNotSupported: "Доступ к буферу обмена не поддерживается в этом браузере",
            automationJSONCopyError: "Ошибка при копировании автоматизации",
            automationCopiedToClipboardFallback: "Автоматизация скопирована в буфер обмена как JSON (резервный метод)",
            automationCopiedToClipboard: "Автоматизация скопирована в буфер обмена как JSON. Вы можете вставить её с помощью Ctrl+V в другой панели клиента.",
            automationCopyError: "Ошибка при копировании автоматизации",
            automationCopied: "Автоматизация скопирована",
            automationMoveError: "Ошибка при перемещении автоматизации",
            automationMovedToCategory: "Автоматизация перенесена в категорию \"{categoryName}\"",
            categoryDeletedSuccessfully: "Категория успешно удалена",
            categoryDeleteError: "Ошибка при удалении категории",
            automationsDeleteError: "Ошибка при удалении автоматизаций",
            automationsDeletedSuccessfully: "Автоматизации удалены успешно",
            categoryUpdatedSuccessfully: "Категория обновлена",
            categoryUpdateError: "Ошибка при обновлении категории",
            categorySaveError: "Ошибка при сохранении категории",
            categoryCreatedSuccessfully: "Категория создана. Вы можете перетащить автоматизации в эту категорию.",
            categoryNameAlreadyExists: "Категория с таким именем уже существует",
            categoryNameRequired: "Название категории не может быть пустым",
            moveAllAutomations: "Переместить Все Автоматизации",
            deleteAutomations: "{count} автоматизаций удалено",
            selectedAutomations: "{count} автоматизаций выбрано",
            pasteInfoMessage: "Обнаружена автоматизация, скопированная в буфер обмена! Создайте новую автоматизацию немедленно, вставив её с помощью <strong>Ctrl+V</strong>.",
            categoryName: "Название Категории",
            categoryNamePlaceholder: "Введите название категории",
            editCategory: "Редактировать Категорию",
            deleteCategory: "Удалить Категорию",
            createCategory: "Добавить Категорию",
            publishAutomation: "Опубликовано",
            unpublishAutomation: "Остановлено",
            timerAutomation: "Запланировано",
            eventAutomation: "Событие",
            deleteAutomation: "Удалить Автоматизацию",
            changeCategory: "Изменить Категорию",
            copyAutomation: "Копировать Автоматизацию",
            copyAutomationAsJSON: "Копировать как JSON",
            emptyCategoryMessage: "Вы можете добавить автоматизации в категорию, перетащив их сюда",
            whenFormSubmitted: "Когда форма отправлена",
            taskCreated2: "Задача создана",
            waitingTaskCreation: "Ожидание создания задачи...",
            calendarEventCreated: "Событие создано в календаре",
            calendarEventUpdated: "Событие обновлено в календаре",
            calendarEventDeleted: "Событие удалено из календаря",
            reservationCreated: "Резервирование создано",
            reservationDateChanged: "Дата резервирования изменена",
            reservationDeleted: "Резервирование удалено",
            chatLost: "Когда чат потерян",
            webchatCompleted: "Когда веб-чат завершен",
            instagramCompleted: "Когда чат из Instagram завершен",
            messengerCompleted: "Когда чат из Messenger завершен",
            whatsappCompleted: "Когда чат из WhatsApp завершен",
            telegramCompleted: "Когда чат из Telegram завершен",
            chatAssignedToAgent: "Когда чат назначен агенту",
            profileButtonClicked: "Когда кнопка автоматизации нажата в профиле",
            operatedTask: "Выполняемая задача",
            tableSelection: "Выбор таблицы",
            selectTable: "Выбор таблицы",
            whichTableAutomationAddRecords: "В какой таблице вы хотите запустить автоматизацию при добавлении записи? Пожалуйста, выберите.",
            whichTableAutomationUpdateRecords: "Вы хотите запустить автоматизацию при обновлении записи в какой таблице? Пожалуйста, выберите.",
            whichTableAutomationDeletedRecords: "Из какой таблицы вы хотите запустить автоматизацию при удалении записи? Пожалуйста, выберите.",
            whichTableAutomationClickRecords: "В какой таблице вы хотите запустить автоматизацию при нажатии кнопки автоматизации на записи? Пожалуйста, выберите.",
            selectAtLeastOneField: "Необходимо выбрать хотя бы одно поле",
            generalCategory: "Общее",
            configureTrackFields: "Настроить отслеживаемые поля",
            configureMessageFilter: "Настроить фильтр сообщений",
            makeFreeTier: "Сделать бесплатным",
            revertFreeTier: "Вернуть обычный уровень",
            webhook: "Webhook",
            system: "Система",
            freeTierTooltip: "Эта автоматизация в бесплатном тарифе. Использование не будет списываться с вашей квоты.",
            freeTierBadge: "Бесплатный тариф",
            trackFieldsLabel: "Поля для отслеживания",
            trackFieldsSelectPlaceholder: "Если поле не выбрано, будут отслеживаться все поля",
            selectFieldPlaceholder: "Выберите поле",
            tableMustBeSelectedFirst: "Сначала необходимо выбрать таблицу для автоматизации",
            fieldsLoadError: "Ошибка загрузки полей",
            trackFieldsUpdated: "Отслеживаемые поля обновлены",
            updateError: "Ошибка при обновлении",
            automationMadeFreeTier: "Автоматизация установлена как бесплатный тариф",
            makeFreeTierError: "Ошибка при установке бесплатного тарифа",
            automationRevertedToNormalTier: "Автоматизация возвращена к обычному тарифу",
            revertFreeTierError: "Ошибка при возврате к обычному тарифу",
            wrongPassword: "Неверный пароль!",
            configLoadError: "Ошибка загрузки конфигурации",
            messageFilterConfigUpdated: "Конфигурация фильтра сообщений обновлена",
            freeTierPasswordPrompt: "Введите пароль для бесплатного тарифа:",
            configurePreFilters: "Настроить предварительные фильтры",
            configureExecutionPrivacy: "Настроить разрешение на выполнение",
            editDescription: "Редактировать описание",
            permissions: {
                title: "Права доступа",
                mode: "Режим прав",
                publicMode: "Публичный",
                customMode: "Пользовательский",
                publicModeDesc: "Все пользователи могут просматривать и редактировать эту автоматизацию.",
                customModeDesc: "Только указанные пользователи и отделы имеют доступ к этой автоматизации.",
                confirmPublicMode: "Переключить на публичный режим",
                confirmPublicModeDesc: "После этой операции все пользователи смогут получить доступ к этой автоматизации. Продолжить?",
                addUser: "Добавить пользователя",
                addDepartment: "Добавить отдел",
                selectUser: "Выберите пользователя",
                selectDepartment: "Выберите отдел",
                add: "Добавить",
                targetHeader: "Пользователь/Отдел",
                matrixInfo: "Выберите права, которые хотите предоставить каждому пользователю или отделу.",
                noTargetsAdded: "Пользователи и отделы ещё не добавлены. Добавьте выше, чтобы предоставить права.",
                confirmRemoveTarget: "Удалить право",
                confirmRemoveTargetDesc: "Вы уверены, что хотите удалить права для этого пользователя или отдела?",
                saveSuccess: "Права доступа успешно сохранены",
                saveError: "Ошибка при сохранении прав доступа",
                unknownUser: "Неизвестный пользователь",
                unknownDepartment: "Неизвестный отдел",
                noReadAccess: "У вас нет доступа к этой автоматизации.",
                usersTab: "Пользователи",
                departmentsTab: "Отделы",
                authorizedUsers: "Авторизованные пользователи",
                otherUsers: "Другие пользователи",
                authorizedDepartments: "Авторизованные отделы",
                otherDepartments: "Другие отделы",
                cannotChangeOwnPermission: "Вы не можете изменить свои собственные права",
                you: "Вы",
                customPermissionDefined: "Пользовательские права для этого пользователя",
                customPermission: "Пользовательские права",
                grantPermission: "Предоставить право",
                revokePermission: "Удалить право",
                applyToOthers: "Применить к другим автоматизациям",
                applyToOthersDesc: "Применить эти настройки прав к выбранным автоматизациям",
                applyToOthersTitle: "Применить настройки прав к другим автоматизациям",
                applyToOthersWarning: "Текущие настройки прав выбранных автоматизаций будут заменены настройками этой автоматизации.",
                selectAll: "Выбрать все",
                selectedCount: "Выбрано автоматизаций: {count}",
                applyToSelected: "Применить к выбранным",
                noAutomationsFound: "Автоматизации не найдены",
                searchPlaceholder: "Поиск автоматизации или категории...",
                applySuccess: "Настройки прав успешно применены к {count} автоматизациям",
                applyFailed: "Не удалось применить настройки прав к {count} автоматизациям",
                applyError: "Ошибка при применении настроек прав",
                groups: {
                    basic: "Основное",
                    flow: "Поток",
                    meta: "Информация",
                    publish: "Публикация",
                    actions: "Действия",
                    plan: "План",
                    filter: "Фильтр"
                },
                scopes: {
                    read: "Просмотр",
                    readDesc: "Право на просмотр автоматизации",
                    flowUpdate: "Редактирование потока",
                    flowUpdateDesc: "Право на добавление, удаление и редактирование блоков автоматизации",
                    metaUpdate: "Редактирование информации",
                    metaUpdateDesc: "Право на редактирование названия, описания и категории автоматизации",
                    publish: "Публикация",
                    publishDesc: "Право на публикацию и снятие с публикации автоматизации",
                    delete: "Удаление",
                    deleteDesc: "Право на удаление автоматизации",
                    duplicate: "Дублирование",
                    duplicateDesc: "Право на дублирование автоматизации",
                    planView: "Просмотр планов",
                    planViewDesc: "Право на просмотр планов выполнения автоматизации",
                    planCancel: "Отмена плана",
                    planCancelDesc: "Право на отмену запланированных планов",
                    reschedule: "Перенос",
                    rescheduleDesc: "Право на перенос автоматизации",
                    prefilterUpdate: "Редактирование фильтра",
                    prefilterUpdateDesc: "Право на редактирование конфигурации предварительного фильтра"
                }
            },
            planStatus: "Статус плана",
            scheduled: "Запланировано",
            completed: "Завершено",
            cancelled: "Отменено",
            startTest: "Начать тест",
            unpublish: "Отменить публикацию",
            whenMessagePicked: "Когда сообщение выбирается через интерфейс чата",
            whenTaskCompleted: "Когда задача завершена",
            whenTaskDeleted: "Когда задача удаляется",
            whenTaskAssigneeChanged: "При изменении назначенного задания",
            whenTaskPriorityChanged: "При изменении приоритета задачи",
            whenTaskDueDateChanged: "Когда изменяется дата выполнения задачи",
            whenTaskStatusChanged: "При изменении статуса задачи",
            whenTaskArchived: "Когда задача архивируется",
            whenTagAdded: "Когда к задаче добавляется тег",
            whenTagRemovedTask: "Когда тег удаляется из задачи",
            whenTagChecklist: "Когда контрольный список задачи завершен",
            whenReminderActivated: "Когда активируется напоминание",
            whenTicketCreated: "Когда создается билет",
            whenTicketStageChanged: "При изменении стадии билета",
            whenTicketAssigneeChanged: "При изменении получателя билета",
            whenTicketClosed: "Когда билет закрывается",
            whenTicketUpdated: "Когда билет обновляется",
            archivingDate: "Дата архивации",
            autoPlanAndTaskHistory: "План автоматизации и история задач",
            automation: "Автоматизация",
            botScenario: "Сценарий бота",
            nameSurname: "ИмяФамилия",
            phone164: "*Введите номер в формате E164. Например: 905396667744",
            whichWpChannels: "Какие каналы Whatsapp добавить?",
            findContact: "Найти контакт",
            findContacts: "Найти контакты",
            offsetDesc: "Пропустить первые N контактов. Значение по умолчанию - '0'. Используйте это значение для прокрутки контактов.",
            limitDesc: "Максимальное количество контактов для возврата после смещения. Значение по умолчанию - '10'. Используйте это значение для постраничного просмотра",
            contact: "Контакт",
            selectAction: "Выберите действие",
            addMethod: "Добавить метод",
            selectField: "Выберите поле",
            schedulerRunningPlanEx: "Пример плана выполнения планировщика",
            schedulerPlanner: "Планировщик расписания",
            taskCreated: "Задача создана?",
            taskStatus: "Статусы задач",
            terminateReason: "Причина завершения",
            taskDuration: "Длительность задачи",
            taskWakeUpCount: "Количество пробуждений задачи",
            completedAt: "Завершено",
            cancelledAt: "Отменено",
            nextRunAt: "Следующий запуск",
            configSchedulerAuto: "Настроить таймер для автоматизации",
            saveChanges: "Сохранить изменения",
            catchAllWebhooks: "Перехватывать все веб-хуки с этого URL",
            webhookDataExPreview: "Предварительный просмотр образца данных Webhook (будет показан после отправки запроса)",
            webhookUrlCopied: "URL Webhook скопирован в буфер обмена",
            selectAnBlock: "Выбрать блок",
            dataFormats: "Форматы данных",
            whenRecordCreated: "Когда создается запись",
            whenRecordUpdated: "Когда запись обновляется",
            whenRecordDelete: "Когда запись удаляется",
            whenRecordAutomation: "Когда нажимается кнопка автоматизации записи",
            whenWebhookTriggered: "Когда срабатывает веб-хук",
            whenChatCreated: "Когда создается чат",
            whenChatClosed: "Когда чат закрывается",
            whenChatRated: "Когда чат оценивается",
            whenNewContactCreated: "Когда создается новый контакт",
            whenContactUpdate: "Когда контакт обновляется",
            whenContactPropUpdate: "При обновлении свойств контакта",
            whenNewTagAdded: "При добавлении нового тега",
            whenTagRemoved: "Когда тег удаляется",
            whenNewEmailReceived: "Когда получено новое электронное письмо",
            whenNewTaskCreated: "Когда создается новая задача",
            whenNewMetaleadCreated: "Когда создается новый мета-лид",
            whenNewAgentCreated: "Когда создается новый агент",
            whenAgentOnline: "Когда агент выходит в сеть",
            whenAgentOffline: "Когда агент выходит из сети",
            whenAgentStatusChanged: "Когда статус агента изменяется",
            whenAgentLogin: "Когда агент входит в систему",
            whenNewInvoiceCreated: "Когда создается новый счет-фактура",
            whenNewWpReceived: "Когда получено новое сообщение Whatsapp",
            whenNewReservationCreated: "Когда создается новое бронирование",
            whenNewChatbotReceived: "Когда получено новое сообщение чатбота",
            chatWebhookAutomation: "Поймать веб-крючок и запустить автоматизацию",
            automationName: "Имя автоматизации",
            supsisObject: "Объект Supsis",
            selectModule: "Модель выбора",
            bodyType: "Тип тела",
            selectBodyType: "Выбрать тип тела",
            selectMethod: "Выбрать метод",
            trigger: "Триггер",
            published: "Опубликовано",
            createdAt: "Создано",
            action: "Действие",
            type: "Тип",
            view: "Посмотреть",
            createTimerAutomation: "Создание таймера автоматизации",
            createEventBasedAutomation: "Создание автоматизации на основе событий",
            createWebhookAutomation: "Создание автоматизации Webhook",
            automationsCouldNotBeDeleted: "Автоматизации не могут быть удалены",
            timerAutomationCreatedSuccessfully: "Автоматизация таймера создана успешно",
            eventAutomationCreatedSuccessfully: "Автоматизация событий создана успешно",
            webhookAutomationCreatedSuccessfully: "Автоматизация вебхука создана успешно",
            automationsCouldNotBeFetched: "Автоматизации не удалось получить",
            automationPublishedStateUpdatedSuccessfully: "Автоматизация успешно обновила опубликованное состояние",
            automationPublishedStateCouldNotBeUpdated: "Не удалось обновить состояние публикации автоматизации",
            createAnEventAutomation: "Создать автоматизацию события",
            automations: "Автоматизации",
            allAutomations: "Все автоматизации",
            scheduledAutomations: "Автоматизации по расписанию",
            eventBasedAutomations: "Автоматизации, основанные на событиях",
            buttonAutomations: "Автоматизации по кнопкам",
            webhookAutomations: "Автоматизации по вебхукам",
            analytics: "Аналитика",
            insights: "Статистика",
            trash: "Корзина",
            sandboxPage: {
                title: "Удалённые сценарии автоматизации",
                description: "Автоматизации, которые не будут восстановлены, будут окончательно удалены системой в течение 30 дней",
                emptyState: "Нет удалённых автоматизаций в корзине",
                unnamedAutomation: "Автоматизация без названия",
                restore: "Восстановить",
                timerAutomation: "Автоматизация по таймеру",
                eventAutomation: "Автоматизация по событию",
                webhook: "Вебхук",
                buttonAutomation: "Автоматизация по кнопке",
                tableButtonAutomation: "Автоматизация по кнопке таблицы",
                chatbotAutomation: "Автоматизация чат-бота",
                unknown: "Неизвестно",
                user: "Пользователь",
                restoreConfirmTitle: "Вы уверены, что хотите восстановить эту автоматизацию?",
                restoreConfirmContent: "Автоматизация {name} будет восстановлена.",
                restoreSuccess: "Автоматизация восстановлена",
                restoreFailed: "Ошибка восстановления",
                loadError: "Ошибка при загрузке удалённых автоматизаций"
            },
            insightsPage: {
                title: "Статистика автоматизации",
                selectAutomation: "Выберите автоматизацию",
                dateRange: "Диапазон дат",
                datePlaceholderStart: "Начало",
                datePlaceholderEnd: "Конец",
                lastWeek: "Последняя неделя",
                lastMonth: "Последний месяц",
                last3Months: "Последние 3 месяца",
                statusFilter: "Фильтр статуса",
                statusScheduled: "Запланировано",
                statusRunning: "Выполняется",
                statusWaitingReply: "Ожидание ответа",
                statusDone: "Завершено",
                statusFailed: "Ошибка",
                statusCancelled: "Отменено",
                clearFilters: "Очистить фильтры",
                refreshData: "Обновить данные",
                activeFilters: "Активные фильтры:",
                totalTasks: "Всего задач",
                executedTasks: "Выполненные задачи",
                successRate: "Процент успеха",
                successfulTasks: "Успешные задачи",
                avgDuration: "Средняя длительность",
                avgWorkDuration: "Средняя длительность работы",
                activeTasks: "Активные задачи",
                runningNow: "Выполняется сейчас",
                dailyTaskExecution: "Ежедневное выполнение задач",
                statusDistribution: "Распределение по статусам",
                durationDistribution: "Распределение по длительности",
                terminateReasons: "Причины завершения",
                automationPerformance: "Производительность автоматизации",
                view: "Просмотр",
                automationName: "Название автоматизации",
                executionCount: "Количество выполнений",
                actions: "Действия",
                totalTasksLegend: "Всего задач",
                successfulLegend: "Успешно",
                failedLegend: "Ошибка",
                taskCount: "Количество задач",
                ms: "мс",
                sec: "сек",
                min: "мин",
                hour: "ч",
                automationsLoadError: "Ошибка при загрузке автоматизаций",
                insightsLoadError: "Ошибка при загрузке статистики"
            },
            settingsWidget: {
                viewActivityLogs: "Просмотр журнала активности",
                activityLogsTitle: "Журнал активности",
                activityLogsEmpty: "Записей активности пока нет",
                activityLogsLoadError: "Ошибка при загрузке журнала активности",
                exportedToClipboard: "Автоматизация скопирована в буфер обмена",
                settings: "Настройки"
            },
            blocks: {
                ASSIGN_OWNER: "Назначить Владельца",
                SHOW_WIDGET: "Показать виджет",
                REPLY_TRENDYOL_QUESTION: "Ответить на вопрос Trendyol",
                START_POINT: "ТОЧКА СТАРТА",
                AI_ASSISTANT: "AI ПОМОЩНИК",
                BOT_RESPONSE: "ОТВЕТ БОТА",
                AI_BOT_RESPONSE: "AI RESPONSE (GPT-4o)",
                AI_CLASSIFICATION: "КЛАССИФИКАЦИЯ AI",
                AI_MENU_FLOW: "AI МЕНЮ",
                OTP_WHATSAPP_FLOW: "OTP Whatsapp",
                OTP_SMS_FLOW: "OTP SMS",
                OTP_MAIL_FLOW: "OTP MAIL",
                AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
                PLATFORM_FLOW: "ПЛАТФОРМА",
                DEFAULT_FALLBACK: "ВОЗВРАТ ПО УМОЛЧАНИЮ",
                DEFAULT_TIMEOUT: "ТАЙМАУТ ПО УМОЛЧАНИЮ",
                AI_FUNCTIONS: "AI ФУНКЦИИ",
                FILTER: "ФИЛЬТР",
                FLOW: "FLOW",
                ATTACHMENT_INPUT: "ВВОД ВЛОЖЕНИЙ",
                USER_INPUT: "ПОЛЬЗОВАТЕЛЬСКИЙ ВВОД",
                GO_TO_STEP: "ПЕРЕЙТИ К ШАГУ",
                WEBHOOK: "ВЕБХУК",
                SET_ATTRIBUTE: "УСТАНОВИТЬ АТРИБУТ",
                QUESTION: "ВОПРОС",
                CLOSE_CHAT: "ЗАКРЫТЬ ЧАТ",
                CREATE_TICKET: "СОЗДАТЬ БИЛЕТ",
                TRANSFER_CHAT: "ПЕРЕДАТЬ ЧАТ",
                TRANSFER_TO_CHATBOT: "ПЕРЕСЛАТЬ ЧАТБОТУ",
                TAG_CHAT: "ДОБАВИТЬ ТЕГ",
                REMOVE_TAG: "УДАЛИТЬ ТЕГ",
                SET_DEPARTMENT: "УСТАНОВИТЬ ОТДЕЛ",
                SEND_TRANSCRIPT: "ОТПРАВИТЬ СТЕНОГРАММУ",
                SEND_SMS: "ОТПРАВИТЬ СМС",
                SEND_MAIL: "SEND MAIL",
                CREATE_EVENT: "СОЗДАТЬ СОБЫТИЕ",
                CREATE_RESERVATION: "СОЗДАТЬ РЕЗЕРВАЦИЮ",
                RESERVATION_OPEN_URL: "ОТКРЫТЫЙ URL РЕЗЕРВАЦИИ",
                RESERVATION_SELECT_DAY: "ВЫБЕРИТЕ ДЕНЬ БРОНИРОВАНИЯ",
                RESERVATION_EVENT_LIST: "ПОСЕТИТЕЛЬ СПИСКА РЕЗЕРВИРОВАНИЯ",
                RESERVATION_SELECT_TIME: "ВЫБЕРИТЕ ВРЕМЯ БРОНИРОВАНИЯ",
                CREATE_TASK: "СОЗДАТЬ ЗАДАЧУ",
                UPDATE_TASK: "ОБНОВИТЬ ЗАДАНИЕ",
                SHOPIFY_SHOW_PRODUCTS: "SHOPIFY: Показать товары",
                SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY: Наличие товара",
                SHOPIFY_ORDER_STATUS: "SHOPIFY: Статус заказа",
                AKINON_SHOW_PRODUCTS: "AKINON: Показать товары",
                AKINON_FIND_PRODUCT: "AKINON: Найти товар",
                AKINON_ORDER_STATUS: "AKINON: Статус заказа",
                AKINON_SELECT_ORDER: "AKINON: Выбрать заказ",
                AKINON_SELECT_SIZE: "AKINON: Выбрать размер",
                AKINON_FIND_NEAREST_STOCK: "AKINON: Наличие в ближайшем магазине",
                AKINON_FIND_NEAREST_STORES: "AKINON: Ближайшие магазины",
                AKINON_SHOW_DISCOUNT_CODES: "AKINON: Показать коды скидок",
                SUPPRESSION_ADD: "БЛОКИРОВАТЬ КОНТАКТ",
                SUPPRESSION_REMOVE: "РАЗБЛОКИРОВАТЬ КОНТАКТ",
                ADD_TO_SEGMENT: "ДОБАВИТЬ СЕГМЕНТ",
                REMOVE_FROM_SEGMENT: "УДАЛИТЬ ИЗ СЕГМЕНТА",
                IDEASOFT_SELECT_ORDER: "ВЫБРАТЬ ЗАКАЗ",
                IDEASOFT_ORDER_STATUS: "ПОЛУЧИТЬ СТАТУС ЗАКАЗА",
                IDEASOFT_GET_MEMBER_INFO: "ЗАПОЛНИТЬ ИНФОРМАЦИЮ О ПОЛЬЗОВАТЕЛЕ",
                TICKET_UPDATE: "ОБНОВИТЬ БИЛЕТ",
                TSOFT_SELECT_ORDER: "ВЫБРАТЬ ЗАКАЗ",
                TSOFT_ORDER_STATUS: "ПОЛУЧИТЬ СТАТУС ЗАКАЗА",
                TICIMAX_V2_SELECT_ORDER: "ВЫБРАТЬ ЗАКАЗ",
                TICIMAX_V2_ORDER_STATUS: "ПОЛУЧИТЬ СТАТУС ЗАКАЗА",
                IKAS_GET_MEMBER_INFO: "Получить данные участника",
                IKAS_SELECT_ORDER: "Выбрать заказ",
                IKAS_ORDER_STATUS: "Получить статус заказа",
                GET_LOCATION: "ПОЛУЧИТЬ МЕСТОПОЛОЖЕНИЕ",
                FALLBACK: "Альтернативный вариант",
                TIMEOUT: "ТАЙМАУТ",
                SUCCESS: "УСПЕШНО",
                FAILURE: "НЕУДАЧА",
                PROBEL_SELECT_BRANCH: "Выбрать филиал",
                PROBEL_SELECT_CLINIC: "Выберите поликлинику",
                PROBEL_SELECT_DAY: "Выберите день приема",
                PROBEL_SELECT_HOUR: "Выберите время приема",
                PROBEL_MAKE_APPOINTMENT: "Записаться на прием",
                PROBEL_CANCEL_APPOINTMENT: "Отмена назначения",
                PROBEL_GET_PATIENT_TOKEN: "Получить токен пациента",
                PROBEL_FILL_INFO: "Получить информацию MERNIS",
                PROBEL_SELECT_APPOINTMENT: "Выбрать назначение",
                SEND_WP_BUSINESS_MESSAGE: "ОТПРАВИТЬ СООБЩЕНИЕ WHATSAPP",
                MESSENGER_SEND_MESSAGE: "ОТПРАВИТЬ СООБЩЕНИЕ MESSENGER",
                INSTAGRAM_SEND_MESSAGE: "ОТПРАВИТЬ СООБЩЕНИЕ INSTAGRAM",
                INSTAGRAM_COMMENT_REPLY: "ОТВЕТИТЬ НА КОММЕНТАРИЙ",
                INSTAGRAM_COMMENT_DELETE: "УДАЛИТЬ КОММЕНТАРИЙ",
                INSTAGRAM_COMMENT_SHOW: "ПОКАЗАТЬ КОММЕНТАРИЙ",
                INSTAGRAM_COMMENT_HIDE: "СКРЫТЬ КОММЕНТАРИЙ",
                INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "ОТВЕТИТЬ КАК ПРИВАТНЫЙ",
                LOOP: "зацикливать",
                LOOP_NEXT: "зацикливать следующий элемент",
                LOOP_BREAK: "прервать цикл",
                LOOP_CONTINUE: "Продолжить следующий цикл",
                LOOP_FINISH: "Завершить цикл",
                SLEEP: "Спать",
                NOOP: "Пропустить",
                CATCH_WEBHOOK: "Отловить webhook",
                TERMINATE_AUTOMATION: "Завершить автоматизацию",
                OPEN_AI: "OPEN_AI",
                CREATE_CONTACT: "Создать контакт",
                UPDATE_CONTACT: "Обновить контакт",
                FIND_CONTACTS: "Найти контакты",
                FIND_CONTACT: "Найти контакт",
                FIND_CHATS: "Найти чаты",
                FIND_CHAT: "Найти чат",
                WAIT_FOR: "Подождать",
                STRING_FORMAT: "Форматировать строку",
                NUMBER_FORMAT: "Форматировать число",
                DATE_FORMAT: "Форматировать дату",
                RECORDS_FROM_CSV: "Записи из CSV",
                MESSAGE_RECEIVED: "Сообщение получено",
                ASK_AI: "Спросите Аи",
                TABLE_CREATE_RECORD: "Создать запись",
                TABLE_DELETE_RECORD: "Удалить запись",
                TABLE_UPDATE_RECORD: "Обновление регистрации",
                TABLE_FIND_RECORD: "Найти запись",
                TABLE_FIND_RECORDS: "Запись списка",
                ZOHO_FIND_RECORDS_BY_PHONE: "Zoho: Поиск записей (по телефону)",
                ZOHO_ADD_ATTACHMENT_TO_RECORD: "Добавить файл к записи Zoho",
                ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD: "Загрузить изображение в пользовательское поле Zoho",
                ZOHO_CREATE_RECORD: "Создать запись Zoho",
                GET_SUPSIS_RECORD_BY_ID: "Получить запись",
                META_SEND_CAPI_EVENT: "Отправить событие CAPI",
                GOOGLE_DRIVE_UPLOAD_FILE: "Загрузить файл",
                GOOGLE_DRIVE_DOWNLOAD_FILE: "Скачать файл",
                GOOGLE_DRIVE_GET_FILE_INFO: "Получить информацию о файле",
                GOOGLE_DRIVE_DELETE_FILE: "Удалить файл",
                FEEDBACK_AI_ASSISTANT: "ОТЗЫВ ИИ-ПОМОЩНИКА",
                INSERT_TO_SYSTEM_PROMPT: "ВСТАВИТЬ В СИСТЕМНУЮ ИНСТРУКЦИЮ",
                AI_CALL: "ИИ-ЗВОНОК",
                TAVILY_WEB_SEARCH: "ВЕБ-ПОИСК (TAVILY)",
                RUN_JAVASCRIPT: "ЗАПУСТИТЬ JAVASCRIPT",
                SEND_JSON_RESPONSE: "ОТВЕТИТЬ НА ВЕБХУК",
                CACHE_WRITE: "ЗАПИСЬ В КЭШ",
                CACHE_READ: "ЧТЕНИЕ ИЗ КЭША",
                CACHE_EXTEND: "ПРОДЛЕНИЕ КЭША",
                CACHE_DELETE: "УДАЛЕНИЕ ИЗ КЭША",
                YOUTUBE_REPLY_COMMENT: "Ответить на комментарий",
                YOUTUBE_UPDATE_COMMENT_STATUS: "Обновить статус комментария",
                YOUTUBE_SET_MODERATION_STATUS: "Установить статус модерации",
                GOOGLE_BUSINESS_REPLY_REVIEW: "Ответить на отзыв",
                GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS: "Обновить статус отзыва",
                GOOGLE_PLAY_REPLY_REVIEW: "Ответить на отзыв",
                GOOGLE_PLAY_UPDATE_REVIEW_STATUS: "Обновить статус отзыва",
                APP_STORE_REPLY_REVIEW: "Ответить на отзыв",
                APP_STORE_UPDATE_REVIEW_STATUS: "Обновить статус отзыва",
                APP_STORE_DELETE_REVIEW_RESPONSE: "Удалить ответ на отзыв",
                OPENROUTER_RESPONSE: "Ответ OpenRouter AI",
                OPENAI_RESPONSE: "Генерация с OpenAI",
                GOOGLE_AI_RESPONSE: "Генерация с Google AI",
                ANTHROPIC_RESPONSE: "Генерация с Anthropic",
                MISTRAL_RESPONSE: "Генерация с Mistral",
                AZURE_RESPONSE: "Генерация с Azure",
                BEDROCK_RESPONSE: "Генерация с AWS Bedrock",
                COHERE_RESPONSE: "Генерация с Cohere",
                XAI_RESPONSE: "Генерация с xAI",
                DEEPINFRA_RESPONSE: "Генерация с DeepInfra",
                TOGETHER_RESPONSE: "Генерация с Together",
                FIREWORKS_RESPONSE: "Генерация с Fireworks",
                SILICONFLOW_RESPONSE: "Генерация с SiliconFlow",
                PARASAIL_RESPONSE: "Генерация с Parasail",
                NEBIUS_RESPONSE: "Генерация с Nebius",
                ALIBABA_RESPONSE: "Генерация с Alibaba",
                XIAOMI_RESPONSE: "Генерация с Xiaomi",
                SAMBANOVA_RESPONSE: "Генерация с SambaNova",
                MOONSHOT_RESPONSE: "Генерация с Moonshot",
                MINIMAX_RESPONSE: "Генерация с MiniMax",
                NVIDIA_RESPONSE: "Генерация с NVIDIA",
                FALLIMENTO: "ОШИБКА",
                OPENAI_WEB_SEARCH: "ВЕБ-ПОИСК (OPENAI)",
                PLATTFORM_FLOW: "ПЛАТФОРМА",
                PUNTO_INICIO: "ТОЧКА НАЧАЛА",
                SUCCESSO: "УСПЕХ",
                autoForwardToOwnerForce: "Автоматическая переадресация владельцу (даже при активном чат-боте)"
            },
            newAutomation: "Новая автоматизация",
            totalAutomations: "Всего автоматизаций: {count}",
            totalAutomationsWithHidden: "Всего автоматизаций: {total} ({visible} видимых)",
            whenVoiceAgentCallStarted: "Когда звонок голосового агента начат",
            whenVoiceAgentCallEnded: "Когда звонок голосового агента завершен",
            whenVoiceAgentCallAnalyzed: "Когда звонок голосового агента проанализирован",
            enablePreFilters: "Включить предварительные фильтры",
            preFilterDescription: "Предварительные фильтры позволяют определить, когда должна запускаться автоматизация. Если они включены, автоматизация будет срабатывать только для событий, соответствующих заданным вами условиям.",
            preFilters: "Предварительные фильтры",
            executionRules: "Правила выполнения",
            preFilterInfo: "С помощью предварительных фильтров вы можете определить, когда должна запускаться автоматизация. Автоматизация будет срабатывать только для событий, соответствующих заданным вами условиям.",
            preFiltersSaved: "Предварительные фильтры успешно сохранены",
            preFiltersSaveError: "Ошибка при сохранении предварительных фильтров",
            preFiltersConfiguration: "Настройка предварительных фильтров",
            executionPrivacyTitle: "Право на выполнение",
            executionPrivacyDescription: "Какие пользователи или отделы могут выполнять эту автоматизацию? Если оставить пустым — все пользователи.",
            executionPrivacyPublic: "Все пользователи могут выполнять эту автоматизацию",
            executionPrivacyConfiguration: "Настройка права на выполнение",
            executionPrivacySaved: "Право на выполнение успешно сохранено",
            executionPrivacySaveError: "Ошибка при сохранении права на выполнение",
            addDescription: "Добавить описание...",
            descriptionPlaceholder: "Введите описание автоматизации...",
            descriptionSaved: "Описание успешно сохранено",
            descriptionSaveError: "Ошибка при сохранении описания",
            makePublicExecution: "Сделать публичной",
            makePublicExecutionConfirmTitle: "Вы уверены, что хотите сделать эту автоматизацию публичной?",
            makePublicExecutionConfirmContent: "После этой операции все представители смогут выполнять эту автоматизацию.",
            madePublicExecution: "Автоматизация сделана публичной",
            openrouterResponse: "Ответ OpenRouter AI",
            selectProvider: "Выберите провайдера",
            modelName: "Модель",
            modelHint: "Напр.: google/gemini-2.0-flash-001, openai/gpt-4o",
            systemInstructions: "Системные инструкции (необязательно)",
            systemInstructionsPlaceholder: "Опишите, как должен вести себя ИИ...",
            promptPlaceholder: "Напишите ваш вопрос для ИИ...",
            advancedSettings: "Дополнительные настройки",
            temperatureHint: "Низкие значения — более предсказуемые ответы, высокие — более творческие (0–2)",
            maxTokens: "Макс. токенов",
            maxTokensHint: "Максимальное количество генерируемых токенов",
            maxTokensPlaceholder: "По умолчанию: лимит модели",
            selectChannel: "Выберите канал (необязательно)",
            autoSelectChannel: "Автовыбор",
            automationPublishedStateUpdatedSupdatedSuccessfully: "Состояние публикации автоматизации успешно обновлено",
            automationsCouldNouldNotBeFetched: "Не удалось загрузить автоматизации",
            automazioni: "Автоматизации",
            cancelado: "Отменено",
            webhookAutomationCutomationCreatedSuccessfully: "Автоматизация вебхука успешно создана"
        },
        modules: {
            kanbanSettings: {
                title: "Настройки",
                column: "Настройки столбца",
                selectField: "Выберите поле",
                selectFieldPlaceholder: "Выберите поле",
                card: "Настройки карточки",
                selectFields: "Выберите поля для отображения на карточке",
                cancel: "Отмена",
                save: "Сохранить",
                kanban: "Настройки Канбан"
            },
            moduleDeletedSuccessfully: "Модуль успешно удален",
            deleteModuleTitle: "Удалить модуль",
            deleteModuleContent: "Вы уверены, что хотите удалить этот модуль?",
            modules: "Модули",
            relations: "Связи",
            newRelation: "Новая связь",
            editRelation: "Редактировать связь",
            modulesSettings: "Настройки Модулей",
            displayName: "Отображаемое Имя",
            description: "Описание",
            table: "Таблица",
            menuApiSettings: "Настройки Меню и API",
            icon: "Иконка",
            save: "Сохранить",
            exampleIcon: "Пример: extension, home",
            newModule: "Новый Модуль",
            moduleName: "Имя Модуля",
            apiName: "Имя API",
            type: "Тип",
            apiAccess: "Доступ к API",
            actions: "Действия",
            module: "Модуль",
            relation: "Отношение",
            moduleRelationName: "Модуль/Отношение",
            moduleRelationTable: "Таблица Модуль/Отношение",
            showInMainMenu: "Показать в Главном Меню",
            apiEnabled: "API Включен",
            settings: "Настройки",
            createModule: "Создать Модуль",
            relationType: "Тип отношения",
            relationTypeTableToTable: "Таблица к таблице",
            relationTypeTableToStandart: "Таблица к стандартному модулю",
            relationTypeStandartToTable: "Стандартный модуль к таблице",
            fromColumn: "От",
            toColumn: "К",
            apiDoc: "Документация API",
            standartModule: "Стандартный модуль",
            customTable: "Таблица",
            localField: "Локальное поле",
            showingRemoteFieldInList: "Показать удаленное поле в списке",
            relationSettings: "Настройки отношения",
            remoteField: "Удаленное поле",
            localFieldType: "Тип локального поля",
            standart: "Стандартный",
            custom: "Пользовательский",
            contact: "Контакт",
            viewRecord: "Просмотр записи",
            recordDetail: "Детали записи",
            recordNotFound: "Запись или информация таблицы не найдена",
            relatedLists: "Связанные списки",
            recordViewer: "Просмотр записей",
            createFailed: "Не удалось создать модуль",
            createSuccess: "Модуль успешно создан",
            updateSuccess: "Модуль успешно обновлён",
            updateFailed: "Не удалось обновить модуль",
            editModule: "Редактировать модуль",
            priority_high: "Высокий",
            priority_highest: "Наивысший",
            priority_low: "Низкий",
            priority_lowest: "Наинизший",
            priority_medium: "Средний"
        },
        tables: {
            enterWidgetName: "Введите имя виджета",
            widgetName: "Имя виджета",
            renameWidget: "Переименовать виджет",
            assistantCapabilities: "Возможности помощника",
            addNewFieldsToTable: "Может добавлять новые поля в таблицу",
            editExistingFields: "Может редактировать существующие поля",
            deleteUnnecessaryFields: "Может удалять ненужные поля",
            filterRecords: "Может фильтровать записи",
            groupRecords: "Может группировать записи",
            hideFieldsCapability: "Может скрывать поля",
            createConditionalFormatting: "Может создавать условное форматирование",
            createCalculationFormulas: "Может создавать расчетные формулы",
            createSampleRecords: "Может создавать примерные записи",
            examplePrompt: "Пример: Добавьте поля Имя, Фамилия, Электронная почта и Телефон для информации о клиенте в эту таблицу...",
            supsisAssistantTables: "Supsis Assistant: Таблицы",
            supsisAssistantWritePrompt: "Опишите, что вы хотите, чтобы сделал Supsis Assistant",
            supsisAssistantExamplePrompt: "Создайте таблицу для отслеживания встреч. Включите такие поля, как тема встречи, дата, участники, ответственный, принятые решения и последующие действия.",
            sendSupsisAssistant: "Отправить в Supsis Assistant",
            examplePromptsTitle: "Примеры запросов:",
            examplePrompts: {
                addCustomerInfoFields: "Добавьте поля Имя, Фамилия, Электронная почта и Телефон для информации о клиенте в эту таблицу.",
                addOrderFields: "Добавьте поля Название продукта, Количество, Цена за единицу, Общая сумма и Дата заказа в таблицу заказов.",
                addBirthDateField: "Добавьте поле Дата рождения в эту таблицу и установите формат даты как ДД/ММ/ГГГГ.",
                updateStatusField: "Обновите поле Статус, сделайте его выпадающим с опциями: Ожидает, В процессе, Завершено, Отменено.",
                replaceAddressFields: "Удалите поле Адрес и добавьте вместо него поля Адресная строка 1, Адресная строка 2, Район, Город и Почтовый индекс.",
                alignTextFields: "Выравняйте все текстовые поля по центру и ограничьте максимальную длину текста до 100 символов.",
                addAutoIncrementID: "Добавьте поле с автоинкрементом ID с префиксом PRD- для продукта.",
                addTotalAmountFormula: "Добавьте поле Общая сумма как формулу для вычисления произведения количества и цены за единицу.",
                createActiveCustomersFilter: "Создайте фильтр для отображения только активных клиентов.",
                filterRecentUsers: "Отфильтруйте пользователей, зарегистрировавшихся за последние 30 дней.",
                groupByStatus: "Группируйте записи по столбцу Статус.",
                hideAllExceptDeliveryAndOrderNo: "Скрыть все поля, кроме Даты доставки и Номера заказа.",
                colorCodeOrders: "Окрасьте задержанные заказы в красный цвет, заказы, которые должны быть доставлены сегодня, в желтый, а завершенные заказы — в зеленый.",
                highlightHighPaymentRecords: "Выделите записи с суммой оплаты более 1000 TL фиолетовым цветом.",
                groupAndHighlightUnpaidOrders: "Группируйте по дате заказа и выделяйте неоплаченные заказы красным.",
                createSampleRecords: "Создайте 10 примерных записей в этой таблице.",
                addSampleRecordsForAliAndAhmet: "Добавьте 5 примерных записей с именами клиентов Али и Ахмет.",
                createRandomSampleOrders: "Создайте 20 случайных записей заказов с случайными статусами.",
                hrCandidateTracking: "Я хочу создать программное обеспечение для отслеживания кандидатов (ATS) для наших HR-процессов. Включите все, что должно быть в ATS. Используйте турецкие названия полей.",
                crmModuleCreation: "Создайте все необходимые модули для управления взаимоотношениями с клиентами (CRM). Включите информацию о клиентах, записи встреч и управление возможностями.",
                realEstatePortfolioManagement: "Я хочу настроить систему управления портфелем недвижимости. Она должна обрабатывать детали объектов, запросы клиентов и отслеживание продаж.",
                schoolManagementSystem: "Я хочу управлять отслеживанием студентов, учителей и расписания занятий для системы управления школой. Используйте турецкие названия полей.",
                projectManagementSystem: "Я хочу создать систему управления проектами. Включите задачи, членов команды, отслеживание времени и функции отчетности.",
                inventoryAndWarehouseManagement: "Я хочу создать систему для управления запасами и складом. Она должна обрабатывать прием/выдачу продуктов, уровни запасов и отслеживание поставщиков.",
                serviceAndMaintenanceTracking: "Я хочу систему отслеживания обслуживания и ремонта. Она должна управлять устройствами клиентов, историей обслуживания и назначениями техников.",
                restaurantManagementSystem: "Я хочу настроить систему управления рестораном. Включите отслеживание столов, управление заказами, отображение на кухне и операции выставления счетов."
            },
            createAppWithSupsisAssistant: "Создать приложение с Supsis Assistant",
            noWidgets: "Виджеты не добавлены",
            widgetLoadError: "Произошла ошибка при загрузке виджета",
            createDashboardSupsisAssistant: "Создать панель с Supsis Assistant",
            youtubeDesc: "Вставьте видео YouTube в ваш панель",
            iframeDesc: "Вставьте внешний веб-контент в ваш панель",
            countdownDesc: "Добавьте отсчет обратного отсчета для отслеживания важных сроков",
            countdown: "Отсчет",
            textDesc: "Добавьте персонализированный текстовый контент на ваш панель",
            numbersDesc: "Получите быстрый обзор всех числовых столбцов",
            numbers: "Числа",
            addWidget: "Добавить виджет",
            graphDesc: "Создайте графический виджет для визуализации данных в ваших таблицах",
            graph: "График",
            suggested: "Предложенные",
            creationDate: "Дата создания",
            priority_lowest: "Низший",
            priority_low: "Низкий",
            priority_medium: "Средний",
            priority_high: "Высокий",
            priority_highest: "Высший",
            createFailed: "Не удалось создать модуль",
            createSuccess: "Модуль успешно создан",
            today: "Сегодня",
            month: "Месяц",
            week: "Неделя",
            day: "День",
            table: "Таблица",
            kanban: "Канбан",
            calendar: "Календарь",
            colorBy: "Цвет По",
            startDateField: "Поле Даты Начала",
            endDateField: "Поле Даты Окончания (Необязательно)",
            eventCardFields: "Поля Карточки События",
            selectColorField: "Выбрать Поле Цвета",
            selectStartDateField: "Выбрать Поле Даты Начала",
            selectEndDateField: "Выбрать Поле Даты Окончания",
            cancel: "Отмена",
            save: "Сохранить",
            kanbanNotAvailable: "Просмотр Канбан Недоступен",
            needDropdownField: "Для использования просмотра Канбан необходимо хотя бы одно статическое поле выпадающего списка в вашей таблице. Вы можете добавить новое поле или отредактировать существующее в настройках таблицы.",
            notAvailable: "Просмотр Календаря Недоступен",
            needDateField: "Для использования просмотра календаря необходимо хотя бы одно поле даты в вашей таблице. Вы можете добавить новое поле или отредактировать существующее в настройках таблицы.",
            switchToTable: "Переключиться на Просмотр Таблицы",
            operator: "Оператор",
            conditionalColor: "Условное цвет",
            groupField: "Групповое поле",
            selectDirection: "Выберите направление",
            showEmptyGroups: "Показать пустые группы",
            clearGrouping: "Очистить группировку",
            applyGrouping: "Применить группировку",
            sortDirection: "Направление сортировки",
            downloadSelectedRecords: "Загрузить выбранные записи",
            downloadSelected: "Загрузить выбранные",
            downloadSelectedWithCount: "Загрузить выбранные ({count})",
            downloadThisPage: "Загрузить эту страницу",
            downloadAll: "Загрузить всё",
            downloadRecords: "Загрузить записи",
            downloadRecordsSettings: "Загрузить записи - Настройки",
            recordLimitExceededTooltip: "Достигнут лимит записей. Обновите план для импорта записей.",
            zebraMode: "Режим Zebra",
            viewName: "Имя вида",
            enterViewName: "Введите имя вида",
            enterDesc: "Введите описание",
            viewNameRequired: "Требуется ввести имя вида",
            runWebhookAutomation: "Запустить автоматизацию Webhook",
            downloadAllRecords: "Загрузить все записи",
            deleteRecords: "Удалить записи",
            editRecords: "Обновить записи",
            duplicateRecords: "Дублировать записи",
            selected: "Выбранные",
            sureDeleteRecords: "Вы уверены, что хотите удалить записи?",
            selectedRecordSucs: "Выбранные записи были успешно удалены.",
            errorDeletingRecords: "При удалении записей произошла ошибка.",
            sureCopyRecords: "Вы уверены, что хотите скопировать записи?",
            copyRecords: "Копировать записи",
            recordsCopiedSucs: "Выбранные записи были успешно скопированы",
            recordsCopiedError: "При копировании выбранных записей произошла ошибка.",
            viewSucsCreated: "Представление было создано успешно.",
            editMultipleRecords: "Редактировать несколько записей",
            importRecords: "Импортировать записи",
            importHasStarted: "Импорт начался. Это может занять несколько минут в зависимости от размера ваших данных. Пожалуйста, подождите...",
            anErrorImport: "Во время импорта произошла ошибка.",
            recordCreated: "Создать запись",
            recordUpdated: "Обновить запись",
            recordDeleted: "Удалить запись",
            noAutomationDefined: "Автоматизация еще не определена",
            nameTheAutomationAdd: "Назовите автоматизацию, которая будет выполняться при добавлении записи в эту таблицу:",
            nameTheAutomationUpdate: "Назовите автоматизацию, которая будет запускаться при обновлении записи в этой таблице:",
            nameTheAutomationDelete: "Назовите автоматизацию, которая будет запущена при удалении записи из этой таблицы:",
            editField: "Поле редактирования",
            sort: "Сортировка",
            sortAscending: "Сортировать А-Я",
            sortDescending: "Сортировать Я-А",
            clearSort: "Снять сортировку",
            markAsIdentifierField: "Отметить как поле идентификатора",
            runAI: "Запустить ИИ",
            ascending: "По возрастанию",
            descending: "По убыванию",
            createField: "Создать поле",
            insertBefore: "Вставить до",
            insertAfter: "Вставить после",
            goToRelatedAuto: "Перейти к связанной автоматизации",
            permission: "Разрешение",
            lockField: "Заблокировать поле",
            hideField: "Скрыть поле",
            deleteField: "Удалить поле",
            watchVideo: "Смотреть видео",
            uploadError: "Ошибка при загрузке",
            updateError: "Ошибка обновления",
            invalidValue: "Недопустимое значение. Пожалуйста, используйте правильный формат.",
            errorUpdatingRecord: "При обновлении записи произошла ошибка.",
            errorCreatingView: "При создании представления произошла ошибка.",
            datetimeOptions: "Параметры времени даты",
            numberOptions: "Параметры числа",
            currencyOptions: "Параметры валюты",
            dropdownOptions: "Параметры выпадающего списка",
            automationButtonOptions: "Параметры кнопки автоматизации",
            defaultLabel: "Метка по умолчанию",
            disableWhenClicked: "Отключать при нажатии",
            fieldSucsCreate: "Поле создано успешно",
            fieldCreatingFailed: "При создании поля произошла ошибка",
            fieldSucsUpdate: "Поле успешно обновлено",
            fieldUpdatingFailed: "При обновлении поля произошла ошибка",
            showAll: "Показать все",
            hideAll: "Скрыть все",
            searchFields: "Поля для поиска",
            firstRowHeader: "Первая строка содержит заголовок",
            seperatorCharacter: "Символ разделителя",
            comma: "Запятая",
            semicolan: "Точка с запятой",
            tableFieldOrFileColumns: "Сопоставление полей таблицы / столбцов файла",
            exampleResultPreview: "Предварительный просмотр примера результата",
            newView: "Новый вид",
            createViewaFiltering: "Создайте представления, чтобы продолжить фильтрацию, сортировку и скрытие полей без изменения главной таблицы",
            pleaseUpdateSelected: "Пожалуйста, выберите поле, которое вы хотите обновить для выбранных записей",
            pleaseSelectedNewValue: "Пожалуйста, введите новое значение для выбранного поля.",
            selectedMenuItem: "Выбранный пункт меню:",
            deleteTable: "Удалить таблицу",
            sureDeleteTable: "Вы уверены, что хотите удалить эту таблицу?",
            deleteTableSucs: "Таблица была удалена успешно.",
            deleteTableError: "Ошибка при удалении таблицы:",
            editTable: "Редактировать таблицу",
            createNewField: "Создать новое поле",
            tables: "Таблицы",
            tableName: "Название таблицы",
            description: "Описание",
            createTable: "Создать таблицу",
            createNewTable: "Создать новую таблицу",
            allTables: "Все таблицы",
            myTables: "Мои таблицы",
            myFavorites: "Мои избранные",
            errorCreatingTable: "Ошибка при создании таблицы:",
            customerTable: "Таблица клиентов",
            customerTableDesc: "Таблица клиентов по умолчанию",
            leadTracking: "Отслеживание лидов",
            leadTrackingDesc: "Таблица отслеживания лидов",
            todoList: "Список дел",
            todoListDesc: "Список для отслеживания задач",
            approvalReq: "Запрос на утверждение",
            approvalReqDesc: "Управление запросами на утверждение",
            eventSchedule: "Календарь событий",
            eventScheduleDesc: "Расписание предстоящих событий",
            inventoryList: "Список инвентаря",
            inventoryListDesc: "Следит за запасами продуктов",
            bookingForm: "Форма бронирования",
            bookingFormDesc: "Отслеживание бронирований",
            bugTracker: "Трекер ошибок",
            bugTrackerDesc: "Отслеживание ошибок в программном обеспечении",
            employeeDirectory: "Справочник сотрудников",
            employeeDirectoryDesc: "Содержит информацию о сотрудниках",
            errorPullTable: "Ошибка при извлечении данных из таблицы",
            newRecordSucs: "Новая запись создана успешно",
            failedNewRecord: "Не удалось создать новую запись:",
            newRecordCreateError: "При создании новой записи произошла ошибка.",
            recordCount: "Количество записей",
            increaseLimit: "Лимит увеличения",
            newRecord: "Новая запись",
            imports: "Импорт",
            exports: "Экспорт",
            download: "Загрузка",
            automateYourData: "Автоматизировать ваши данные",
            recordUpdatedSucs: "Запись успешно обновлена",
            failedToUpdateRecord: "Не удалось обновить запись",
            recordUpdatingError: "Ошибка при обновлении записи",
            mainTable: "Главная таблица",
            filter: "Фильтр",
            hideFields: "Скрыть поля",
            saveAsView: "Сохранить как вид",
            search: "Поиск",
            create: "Создать",
            left: "Левый",
            center: "Средний",
            right: "Правый",
            selectTimezone: "Выберите часовой пояс",
            createFieldSucs: "Поле создано успешно.",
            failedCreateField: "Не удалось создать поле:",
            createFieldError: "При создании поля произошла ошибка.",
            addCondition: "Добавить условие",
            applyFilter: "Применить фильтр",
            fieldType: "Тип поля",
            alignment: "Выравнивание",
            blankTable: "Пустая таблица",
            templates: "Шаблоны",
            timezone: "Часовой пояс",
            timeFormat: "Формат времени",
            includeTime: "Включая время",
            decimalFormat: "Десятичный формат",
            currencySymbol: "Символ валюты",
            mode: "Режим",
            statics: "Статический",
            dynamic: "Динамический",
            multipleSelection: "Множественный выбор",
            addOption: "Добавить опцию",
            text: "Текст",
            longText: "Длинный текст",
            number: "Число",
            currency: "Валюта",
            datetime: "Дата и время",
            dropdown: "Выпадающий список",
            checkbox: "Флажок",
            email: "Электронная почта",
            phone: "Телефон",
            file: "Файл",
            image: "Изображение",
            video: "Видео",
            audio: "Аудио",
            color: "Цвет",
            automationButton: "Кнопка автоматизации",
            trashBin: "Корзина",
            pasteInfoDetected: "Обнаружена таблица, скопированная в буфер обмена! Вставьте с помощью Ctrl+V, чтобы создать новую таблицу.",
            addCategory: "Добавить категорию",
            editCategory: "Редактировать категорию",
            deleteCategory: "Удалить категорию",
            moveAllTables: "Переместить все таблицы",
            dragTablesToCategory: "Перетащите таблицы сюда, чтобы добавить их в эту категорию",
            deleteProtectionActive: "Защита от удаления активна",
            copyTable: "Копировать таблицу",
            copyAsJSON: "Копировать как JSON",
            changeCategory: "Изменить категорию",
            turnOffDeleteProtection: "Отключить защиту от удаления",
            turnOnDeleteProtection: "Включить защиту от удаления",
            privacySettings: "Настройки конфиденциальности",
            categoryName: "Название категории",
            categoryNamePlaceholder: "Введите название категории",
            categoryUpdate: "Обновить",
            categoryCreate: "Создать",
            categoryNameRequired: "Название категории не может быть пустым",
            categoryAlreadyExists: "Категория с таким названием уже существует",
            categoryCreated: "Категория создана. Вы можете перетащить таблицы в эту категорию.",
            categorySaveError: "Ошибка при сохранении категории",
            categoryUpdated: "Категория обновлена",
            categoryUpdateError: "Ошибка при обновлении категории",
            deleteCategoryConfirm: "Удалить категорию",
            deleteCategoryConfirmContent: "Вы уверены, что хотите удалить \"{name}\"? Таблицы в этой категории будут перемещены в \"Общие\".",
            categoryDeleted: "Категория удалена",
            categoryDeleteError: "Ошибка при удалении категории",
            tableMovedToCategory: "Таблица перемещена в категорию \"{name}\"",
            tableMoveError: "Ошибка при перемещении таблицы",
            tableProtectedWarning: "Эта таблица защищена от удаления. Сначала снимите защиту.",
            deleteProtectionEnabled: "Защита от удаления включена",
            deleteProtectionDisabled: "Защита от удаления отключена",
            protectionUpdateError: "Ошибка при обновлении статуса защиты",
            tableCopied: "Таблица скопирована",
            tableCopyError: "Ошибка при копировании таблицы",
            tableJsonCopied: "Таблица скопирована в буфер обмена как JSON. Вставьте с помощью Ctrl+V в другой панели клиента.",
            tableJsonCopiedFallback: "Таблица скопирована в буфер обмена как JSON (резервный метод)",
            tableJsonCopyError: "Ошибка при копировании таблицы как JSON",
            clipboardNotSupported: "Доступ к буферу обмена не поддерживается в этом браузере",
            noValidTableJson: "В буфере обмена не найдена действительная таблица JSON",
            noValidSupsisExport: "В буфере обмена не найден действительный экспорт таблицы Supsis",
            tableImported: "Таблица \"{name}\" успешно импортирована",
            tablePasteError: "Ошибка при вставке таблицы",
            noTablesToMove: "Нет таблиц для перемещения",
            tablesMovedToCategory: "{count} таблиц перемещено в категорию \"{name}\"",
            tablesMoveError: "Ошибка при перемещении таблиц",
            noPermissionEditPrivacy: "У вас нет прав на редактирование настроек конфиденциальности этой таблицы",
            sandboxTitle: "Сценарии удалённых таблиц",
            sandboxDesc: "Удалённые таблицы автоматически удаляются окончательно через 30 дней в корзине",
            sandboxEmpty: "Нет удалённых таблиц в корзине",
            unnamedTable: "Таблица без имени",
            restore: "Восстановить",
            permanentlyDelete: "Удалить окончательно",
            unknown: "Неизвестно",
            user: "Пользователь",
            restoreTableConfirm: "Вы уверены, что хотите восстановить эту таблицу?",
            restoreTableContent: "Таблица {name} будет восстановлена.",
            tableRestored: "Таблица восстановлена",
            restoreFailed: "Восстановление не удалось",
            permanentlyDeleteConfirm: "Вы уверены, что хотите окончательно удалить эту таблицу?",
            permanentlyDeleteContent: "Таблица {name} будет окончательно удалена. Это действие нельзя отменить.",
            yesPermanentlyDelete: "Да, удалить окончательно",
            tablePermanentlyDeleted: "Таблица окончательно удалена",
            permanentDeleteFailed: "Окончательное удаление не удалось",
            deletedTablesLoadError: "Ошибка при загрузке удалённых таблиц",
            otherTables: "Другие таблицы",
            noTablesFound: "Таблицы не найдены",
            renameView: "Переименовать представление",
            enterNewViewName: "Введите новое имя представления",
            viewRenamedSuccess: "Представление успешно переименовано.",
            viewRenameError: "Ошибка при переименовании представления.",
            deleteView: "Удалить представление",
            confirmDeleteView: "Вы уверены, что хотите удалить это представление?",
            viewDuplicatedSuccess: "Представление успешно скопировано.",
            viewDuplicateError: "Ошибка при копировании представления.",
            duplicateView: "Дублировать представление",
            confirmDuplicateView: "Вы уверены, что хотите скопировать это представление?",
            viewDeletedSuccess: "Представление успешно удалено.",
            viewDeleteError: "Ошибка при удалении представления.",
            errorProcessingFile: "Ошибка при обработке файла",
            upload: "Загрузить",
            permissions: {
                title: "Настройки доступа к таблице",
                mode: "Режим доступа",
                publicMode: "Публичный",
                customMode: "Пользовательский",
                publicModeDesc: "В этом режиме все пользователи имеют полный доступ к таблице.",
                customModeDesc: "В этом режиме доступ имеют только указанные пользователи и отделы.",
                confirmPublicMode: "Переключить на публичный режим",
                confirmPublicModeDesc: "При переключении на публичный режим все пользовательские права будут удалены. Продолжить?",
                addUser: "Добавить пользователя",
                addDepartment: "Добавить отдел",
                selectUser: "Выберите пользователя",
                selectDepartment: "Выберите отдел",
                add: "Добавить",
                matrixInfo: "Права для пользователей и отделов задаются в матрице ниже. Отмеченные ячейки означают разрешение.",
                targetHeader: "Пользователь / Отдел",
                noTargetsAdded: "Пользователи и отделы ещё не добавлены",
                confirmRemoveTarget: "Удалить",
                confirmRemoveTargetDesc: "Удалить этого пользователя/отдел из списка прав?",
                saveSuccess: "Настройки доступа успешно сохранены",
                saveError: "Ошибка сохранения настроек доступа",
                unknownUser: "Неизвестный пользователь",
                unknownDepartment: "Неизвестный отдел",
                noPermission: "У вас нет прав для этого действия",
                groups: {
                    basic: "Основные права",
                    record: "Права на записи",
                    view: "Права на представления",
                    page: "Права на страницы",
                    field: "Права на поля",
                    widget: "Права на виджеты",
                    importExport: "Импорт/Экспорт"
                },
                scopes: {
                    tableRead: "Просмотр",
                    tableReadDesc: "Просмотр таблицы",
                    tableMetaEdit: "Редактирование таблицы",
                    tableMetaEditDesc: "Редактирование названия, категории и описания таблицы",
                    recordCreate: "Создание записи",
                    recordCreateDesc: "Создавать новые записи",
                    recordUpdate: "Редактирование записей",
                    recordUpdateDesc: "Редактировать существующие записи",
                    recordDelete: "Удаление записей",
                    recordDeleteDesc: "Удалять записи",
                    viewCreate: "Создание представления",
                    viewCreateDesc: "Создавать новые представления",
                    viewUpdate: "Редактирование представлений",
                    viewUpdateDesc: "Редактировать существующие представления",
                    viewDelete: "Удаление представлений",
                    viewDeleteDesc: "Удалять представления",
                    pageRead: "Просмотр страниц",
                    pageReadDesc: "Просмотр специальных страниц",
                    pageCreate: "Создание страницы",
                    pageCreateDesc: "Создавать новые страницы",
                    pageUpdate: "Редактирование страниц",
                    pageUpdateDesc: "Редактировать существующие страницы",
                    pageDelete: "Удаление страниц",
                    pageDeleteDesc: "Удалять страницы",
                    fieldCreate: "Создание поля",
                    fieldCreateDesc: "Создавать новые поля",
                    fieldUpdate: "Редактирование полей",
                    fieldUpdateDesc: "Редактировать существующие поля",
                    fieldDelete: "Удаление полей",
                    fieldDeleteDesc: "Удалять поля",
                    widgetCreate: "Создание виджета",
                    widgetCreateDesc: "Создавать новые виджеты",
                    widgetUpdate: "Редактирование виджетов",
                    widgetUpdateDesc: "Редактировать существующие виджеты",
                    widgetDelete: "Удаление виджетов",
                    widgetDeleteDesc: "Удалять виджеты",
                    bulkImport: "Массовый импорт",
                    bulkImportDesc: "Массовый импорт записей",
                    export: "Экспорт",
                    exportDesc: "Экспорт записей"
                }
            },
            ascendente: "По возрастанию",
            calendarSettings: "Настройки календаря",
            centro: "По центру",
            colore: "Цвет",
            colour: "Цвет",
            company: "Компания",
            destra: "Справа",
            dinamico: "Динамический",
            discendente: "По убыванию",
            dynamisch: "Динамический",
            failCreateField: "Не удалось создать поле:",
            failToUpdateRecord: "Не удалось обновить запись",
            immagine: "Изображение",
            individual: "Индивидуальный",
            izquierda: "Слева",
            rechts: "Справа",
            semicolon: "Точка с запятой",
            separatorCharacter: "Символ разделителя",
            sinistra: "Слева",
            statica: "Статический",
            tabelle: "Таблицы"
        },
        plans: {
            manageWithChatbot: "Управление с помощью чат-бота",
            manageInbox: "Управление входящими",
            commentManagement: "Управление комментариями",
            privateReplyMessage: "Приватные ответы на комментарии",
            mentionTicket: "Преобразование упоминаний в тикеты",
            week: "Неделя",
            readyContents: "Готовое содержимое",
            webhookIntegration: "Интеграция вебхуков",
            businessChannel: "Канал бизнеса WhatsApp",
            confirmationFeature: "Функция подтверждения",
            specialReporting: "Специальная отчетность",
            aiAssistant: "ИИ помощник",
            flexibleBilling: "Гибкая биллинг",
            automaticReservation: "Автоматическое бронирование",
            taskManagement: "Управление задачами",
            calendarIntegration: "Интеграция календаря",
            activeChatbot: "Активный чатбот",
            smsIntegration: "Интеграция SMS",
            mailIntegration: "Интеграция почты",
            startChatWithVisitor: "Начать чат с посетителем",
            whatsappManaging: "Управление Whatsapp",
            automaticChatbotButton: "Автоматическая кнопка/чат-бот",
            personalizedBroadcasts: "Персонализированные рассылки",
            chatWithNonContacts: "Чат с неконтактными лицами",
            broadcastMessaging: "Рассылка сообщений",
            perBroadcast: "За трансляцию",
            extraPricePerMessage: "Дополнительная плата за сообщение",
            smartTrigger: "Умный триггер",
            telegramIntegration: "Интеграция с Telegram",
            instagramIntegration: "Интеграция с Instagram",
            ticketFeature: "Функция билетов",
            storage: "Хранение",
            onePanelManagement: "Управление в одной панели",
            isolatedDatabaseConnection: "Изолированное подключение к базе данных",
            removeLogo: "Удалить логотип Supsis",
            chatBaloonCustomization: "Настройка пузырьков чата",
            chatAndNotifications: "Чат и уведомления",
            unlimited: "Неограниченный",
            specialCustomerSupport: "Специальная клиентская поддержка",
            softwareSupport: "Поддержка программного обеспечения",
            standardSupport: "Стандартная поддержка",
            teamChatIntegration: "Интеграция чата команды",
            fileAndVoiceShare: "Обмен файлами и голосом",
            instantVisitor: "Мгновенное отслеживание посетителей",
            detailedReporting: "Подробная отчетность",
            normalreporting: "Обычная отчетность",
            noExtraCosts: "Без дополнительных расходов",
            accessibleToAllAgents: "Доступно для всех агентов",
            dataSecurity: "Безопасность данных",
            autoTranslate: "Автоматический перевод",
            chatbotVersionHistory: "История версий чатбота",
            chatbotStory: "История чатбота",
            freeAgent: "Бесплатный агент",
            stableAgentCount: "Количество стабильных агентов",
            stableChannelCount: "Количество стабильных каналов",
            chipPlans: "Доступные планы",
            generalPlan: "Общий план",
            specialPlan: "Специальный план",
            currentPlan: "Текущий план",
            selected: "Выбрано",
            popular: "Популярный",
            trialPkg: "Пробный пакет",
            support: "Поддержка 24/7",
            flexiblePricing: "Гибкая ценовая политика",
            rightToCancel: "Право отмены в любое время",
            unlimitedCBScenario: "Неограниченные сценарии чатбота",
            freeFirstScenario: "Бесплатный первый сценарий",
            unlimitedLearn: "Неограниченное обучение чатбота",
            allPlatformIntegration: "Интеграция со всеми платформами",
            detailedReports: "Подробные отчеты",
            aiSupport: "Поддержка искусственного интеллекта",
            creativeAI: "Быстрый и реалистичный чат-ассистент на основе ИИ",
            unlimitedSession: "Неограниченные сеансы одновременно",
            assistantFromWebsite: "Создание помощника с веб-сайта",
            assistantFromDoc: "Создание чат-бота из документа",
            mobileApp: "Мобильное приложение",
            commentManage: "Управление комментариями"
        },
        messenger: {
            channel: "Канал Messenger",
            manageChannel: "Управление каналом",
            channelDetail: "Детали канала",
            integrationTitle: "Интеграция Messenger",
            deleteDesc: "Вы уверены, что хотите удалить канал Messenger?",
            channels: "Каналы Messenger",
            connectMessenger: "Подключиться к Messenger",
            detail: "деталь",
            visibility: "видимость",
            settings_group: "Настройки",
            commentsettings: "Управление комментариями",
            commentSettingsTitle: "Управление комментариями в мессенджере",
            commentSettingsDesc: "Управляйте своими комментариями в Messenger",
            adoptimization: "Оптимизация рекламы"
        },
        instagram: {
            channel: "Канал Instagram",
            detail: "деталь",
            visibility: "видимость",
            settings_group: "Настройки",
            commentsettings: "Управление комментариями",
            commentSettingsTitle: "Управление комментариями в Instagram",
            commentSettingsDesc: "Управляйте своими комментариями в Instagram",
            commentSettingsTicket: "Обеспечивает сохранение входящих комментариев в системе как заявок.",
            commentSettingsChatbot: "Выберите, к какому сценарию чат-бота следует направить входящие комментарии.",
            leads: "Leads",
            forms: "Forms",
            showAllInstagramChannels: "Показать все каналы Instagram",
            brand: "Марка",
            questions: "Вопросы",
            showAllLinkedinChannels: "Показать все каналы LinkedIn",
            showAllTelegramChannels: "Показать все каналы Telegram",
            adoptimization: "Оптимизация рекламы"
        },
        calendar: {
            calendarsDesc: "Избегайте конфликтов расписания",
            generalAvailability: "Общая доступность",
            generalAvailabilityDesc: "Укажите время, когда вы регулярно доступны для встреч.",
            appointDuration: "Продолжительность встречи",
            appointDurationDesc: "Сколько времени должна длиться каждая встреча?",
            customDuration: "Пользовательская продолжительность",
            descriptionDesc: "Добавьте заметку, описывающую вашу услугу. Добавленная вами заметка будет отображаться на странице бронирования и в электронных письмах с подтверждением.",
            resForm: "Форма бронирования",
            resFormDesc: "Настройте форму, которую люди будут использовать для бронирования встречи.",
            addField: "Добавить поле",
            addAnItem: "Добавить элемент",
            saveItem: "Сохранить элемент",
            planningTimeframe: "Временные рамки планирования",
            planningTimeframeDesc: "Ограничить временные рамки, в которые может быть назначена встреча",
            availableAtMoment: "Доступно сейчас",
            startAndEndDate: "Дата начала и окончания",
            maxNumberAppoint: "Максимальное количество дней, через которое можно назначить встречу",
            howLongMinAppoint: "За какое время до встречи можно записаться",
            planningIntervalStartEnd: "Даты начала и окончания интервала планирования",
            startTime: "Время начала",
            done: "Выполнено",
            receivedAppointInterval: "Интервал между полученными назначениями",
            receivedAppointIntervalDesc: "Управление полученными встречами для отображения в вашем календаре.",
            interimTime: "Промежуточное время",
            interimTimeDesc: "Добавить время между интервалами встреч",
            dayMaxRes: "Максимальное количество бронирований в день",
            dayMaxResDesc: "Ограничение количества забронированных встреч, которые могут быть приняты в течение одного дня",
            customise: "Установить пользовательские настройки",
            noAvatar: "Аватара нет",
            organizationName: "Название организации",
            enterFullAdress: "Введите полный адрес",
            noCoverPhoto: "Нет фотографии на обложке",
            enterAboutInfo: "Введите информацию о себе",
            service: "Услуга",
            deleteService: "Удалить услугу",
            enterGoogleMapsUrl: "Введите URL-адрес Google Maps",
            enterLatitude: "Введите широту",
            enterLongitude: "Введите долготу",
            enterNumber: "Введите номер телефона",
            uploadAvatar: "Загрузить аватар",
            teamMemberDeleteError: "Ошибка при удалении члена команды:",
            setupBookingWebsite: "Настройка сайта бронирования",
            bookingLandingPageBuilder: "Конструктор посадочных страниц бронирования",
            coverPhoto: "Фотография обложки",
            enterOrganisationName: "Введите название организации",
            about: "О компании",
            services: "Услуги",
            deleteServices: "Удалить услугу",
            selectReservationPlan: "Выбрать план бронирования",
            addNewService: "Добавить новую услугу",
            addNewMember: "Добавить нового участника",
            fullAddress: "Полный адрес",
            latitude: "Широта",
            longitude: "Долгота",
            contactDetails: "Контактная информация",
            emailAddress: "Адрес электронной почты",
            enterEmail: "Введите адрес электронной почты",
            websiteURL: "URL веб-сайта",
            enterWebsiteURL: "Введите URL веб-сайта",
            reservationPolicy: "Политика резервирования",
            enterResPolicy: "Введите политику бронирования",
            workingHours: "Рабочие часы",
            selectEndHour: "Выберите время окончания",
            addNewHour: "Добавить новый час",
            updateMemberInfo: "Обновить информацию о члене",
            errorRecevingData: "Ошибка при получении данных:",
            anonymService: "Анонимный сервис",
            unknownPlan: "Неизвестный план",
            errorCreatingMockPage: "Ошибка при создании макетной страницы:",
            failedToCreateBookingPage: "Не удалось создать страницу бронирования",
            fileSizeToolLarge: "Слишком большой размер файла",
            errorLoadingTheLogo: "Ошибка при загрузке логотипа:",
            failedToLoadLogo: "Не удалось загрузить логотип",
            errorUpdating: "Ошибка обновления:",
            failedToUpdate: "Не удалось обновить",
            newMember: "Новый участник",
            errorLoadingAvatar: "Ошибка при загрузке аватара:",
            avatarFailedToLoad: "Не удалось загрузить аватар",
            teamMemberSuccessfullyDeleted: "Член команды успешно удален",
            teamMemberNotDelete: "Не удалось удалить члена команды",
            yesDelete: "Да, удалить",
            sureResDelete: "Вы уверены, что хотите удалить это бронирование?",
            resDetails: "Детали бронирования",
            infoPersonMakingRes: "Информация о человеке, сделавшем бронирование",
            appointmentProgram: "Расписание назначений",
            goToAppointSettings: "Перейти к настройкам программы назначений",
            resPlanCreateSuccess: "План резервирования создан успешно",
            pleaseEnterTitle: "Пожалуйста, введите название",
            sureContinueSaving: "Вы уверены, что хотите продолжить без сохранения?",
            appointProgram: "ПРОГРАММА БРОНИРОВАНИЯ",
            everyMonth: "Каждый месяц",
            firstEveryMonth: "Первый день каждого месяца",
            dayOf: "День",
            notRepeat: "Не повторяется",
            daily: "Ежедневно",
            weekly: "Раз в неделю",
            monthly: "Раз в месяц",
            annually: "Раз в год",
            custom: "Особый",
            eventSaved: "Сохранение события",
            createAppoint: "Создать назначение",
            calendarSetting: "Настройки календаря",
            notAuthezord: "Вы не авторизованы для выполнения этой операции",
            notAuthorizedToPerformOperation: "У вас нет прав для выполнения этой операции.",
            reservationWebPage: "Веб-страница бронирования",
            reservationBuilder: "Сайт бронирования",
            reservationPrograms: "Программы бронирования",
            automations: "Автоматизация",
            addReservationProgram: "Добавить программу бронирования",
            resPlanError: "Ошибка при получении планов бронирования:",
            resDeleteSure: "Вы уверены, что хотите удалить эту программу бронирования?",
            resDeleteSuccess: "Программа бронирования была успешно удалена.",
            resDeleteError: "Ошибка при удалении программы бронирования:",
            unkownUser: "Неизвестный пользователь",
            eventNotFound: "Событие не найдено",
            reservations: "Бронирование",
            events: "События",
            upcoming: "ближайшие",
            past: "Прошлое",
            setting: "Настройки",
            delete: "Удалить",
            cancel: "Отмена",
            save: "Сохранить",
            close: "Закрыть",
            deleteRepeatEvent: "Удалить повторяющееся событие",
            thisEvent: "Это событие",
            thisAndOtherEvent: "Это и следующие события",
            allEvent: "Все события",
            ok: "ОК",
            googleCalendarLink: "Добавить в Google Календарь",
            yahooCalendarLink: "Добавить в Yahoo Календарь",
            subject: "Тема",
            visitor: "Посетитель",
            allDay: "Весь день",
            title: "Название",
            deleteEvent: "Удалить событие",
            deleteEvents: "Удалить события",
            deleteEventsSure: "Вы уверены, что хотите удалить события из этого календаря?",
            deleteEventConfirm: "Вы уверены, что хотите удалить это событие?",
            notEmptyTitle: "Название не может быть пустым!",
            tasks: "Задачи",
            googleConnect: "Интеграция с Google",
            googleDisconnect: "Отключить интеграцию с Google",
            sure: "Вы уверены?",
            disconnectGoogleSure: "Вы уверены, что хотите отключить Google?",
            yes: "Да",
            no: "Нет",
            customRepeat: "Настроить повторение",
            recurrenceFrequency: "Частота повторения",
            repeatDays: "Повторять по дням",
            never: "Никогда",
            thisDate: "В эту дату",
            recurrenceCount: "Количество повторений",
            end: "Конец",
            event: "Событие",
            calendars: "Календари",
            newCalendar: "Создать новый календарь",
            changeColor: "Изменить цвет",
            addCalendar: "Добавить календарь",
            nameCalendar: "Название календаря",
            description: "Описание",
            change: "Изменить",
            deleteCalendar: "Удалить календарь",
            deleteCalendarSure: "Вы уверены, что хотите удалить этот календарь?",
            notEmptyCalendarName: "Название календаря не может быть пустым",
            myEvents: "Мои события",
            everyoneEvents: "Все события",
            haveEvent: "события у представителя",
            goCalendar: "Перейти в календарь",
            goReservation: "Создать бронирование",
            agents: "Представители",
            today: "Сегодня",
            month: "Месяц",
            week: "Неделя",
            day: "День",
            list: "Список",
            planingIntervalStartEnd: "Даты начала и окончания интервала планирования",
            customize: "Настроить",
            enterOrganizationName: "Введите название организации",
            weely: "Раз в неделю",
            annualy: "Раз в год",
            appointmentDuration: "Длительность встречи",
            appointmentSchedule: "Расписание встреч",
            calendari: "Календарь",
            goToAppointmentSettings: "Перейти к настройкам расписания",
            infoPersonMakingReservation: "Информация о лице, осуществляющем бронирование",
            reservationDetails: "Детали бронирования",
            sureReservationDelete: "Вы уверены, что хотите удалить это бронирование?",
            teamMemberNotDeleted: "Не удалось удалить участника команды"
        },
        ticimax: {
            segment: "Сегмент",
            settings_group: "Настройки",
            waitDayFromLastSend: "Количество дней ожидания с момента последнего отправленного сообщения",
            automationRuleName: "Название правила автоматизации",
            time: "Время",
            year: "Год",
            month: "Месяц",
            dayOfMonth: "День месяца",
            day: "День",
            bySecond: "По секунде",
            byMinute: "По минуте",
            byHour: "По часу",
            byWeekNo: "По номеру недели",
            byYearDay: "По номеру дня в году",
            byMonthDay: "По номеру дня в месяце",
            byMonth: "По месяцу",
            december: "Декабрь",
            november: "Ноябрь",
            october: "Октябрь",
            september: "Сентябрь",
            august: "Август",
            july: "Июль",
            june: "Июнь",
            may: "Май",
            april: "Апрель",
            march: "Март",
            february: "Февраль",
            january: "Январь",
            byWeekDay: "По дню недели",
            interval: "Интервал",
            seconds: "Секунды",
            minutes: "Минуты",
            hourly: "По часам",
            daily: "По дням",
            weekly: "По неделям",
            monthly: "По месяцам",
            yearly: "По годам",
            frequency: "Частота",
            attributes: {
                vip: "VIP",
                segment: "Сегмент",
                province: "Провинция",
                country: "Страна",
                phone: "Телефон",
                email: "Эл. почта",
                fullname: "Полное имя",
                couponPercent: "% купона",
                lastOrderDate: "Последний заказ",
                firstOrderDate: "Первый заказ",
                county: "Каунти",
                lastSource: "Последний источник",
                firstSource: "Первый источник",
                lastPaymentType: "Последний способ оплаты",
                firstPaymentType: "Первый способ оплаты",
                maxOrderAmount: "Максимальная сумма заказа",
                minOrderAmount: "Минимальная сумма заказа",
                totalOrderAmount: "Общая сумма заказов",
                totalOrderCount: "Общее количество заказов",
                usedCouponAmount: "Сумма использованного купона",
                usedCouponCount: "Количество использованных купонов",
                tookDayFromLastOrder: "Дни с момента последнего заказа",
                isCouponUser: "Пользователь купона"
            },
            createAutomation: "Создать автоматизацию",
            previous: "Предыдущий",
            createAutomationDesc: "Создайте и управляйте автоматизацией сообщений",
            newTicimaxChannel: "Новый канал Ticimax",
            connextToTicimaxXml: "Подключиться к службе Ticimax XML",
            connectTicimax: "Подключиться к Ticimax",
            examplePreview: "Примерный просмотр",
            completeAutomationRule: "Завершите правило автоматизации",
            configureMessage: "Настройка сообщения",
            automationTimer: "Таймер автоматизации",
            findTargetMembers: "Найти целевых участников",
            createAutomationRule: "Создать правило автоматизации",
            action: "Действие",
            status: "Статус",
            triggeredUserCount: "Количество пользователей, сработавших",
            nextScheduled: "Следующее запланированное",
            timerRule: "Правило таймера",
            automationRules: "Правила автоматизации",
            apply: "Применить",
            searchAMember: "Поиск участника",
            segmentedMembersDesc: "Перечислите и автоматизируйте сегментированных участников",
            manageVisibilityDesc: "Управляйте видимостью канала",
            xmlOrderListURL: "URL списка заказов XML",
            manageIntegrationDesc: "Управляйте вашей интеграцией Ticimax",
            detail: "Подробности",
            ticimaxChannelsTitle: "Каналы Ticimax",
            ticimaxDetail: "Детали Ticimax",
            settingsGroup: "Настройки",
            visibility: "Видимость",
            members: "Участники",
            automation: "Автоматизация",
            integrationChannel: "Интеграционный канал",
            channelUpdated: "Канал успешно обновлен",
            channelUpdateFailed: "Ошибка обновления канала"
        },
        notification: {
            taskArchive: "Когда задача архивируется.",
            taskComplet: "Когда закрывается завершенная задача.",
            adjustNow: "Настроить сейчас",
            chatAssignedMe: "Когда чат назначен мне.",
            ticketAssignedMe: "Когда тикет назначен мне.",
            myChatClosed: "Когда закрывается чат, который я веду.",
            contactOwner: "Когда меняется владелец чата, когда назначается или снимается право собственности.",
            tagActionsToVisitor: "Когда тег добавляется или удаляется у посетителя.",
            ticketCreated: "Когда посетитель или чат-бот создает тикет.",
            notesActions: "Когда заметка добавляется или удаляется у клиента.",
            visitorProfileUpdated: "Когда профиль посетителя обновляется.",
            chatStartedByAnyPlatform: "Когда чат начинается с любого канала.",
            userActions: "Когда пользователь создается, обновляется или удаляется.",
            departmentActions: "Когда отдел создается, обновляется или удаляется.",
            settingsActions: "Когда настройки создаются, обновляются или удаляются.",
            integrationsActions: "Когда создается, обновляется или удаляется канал интеграции.",
            loginFormActions: "Когда форма входа обновляется или активируется.",
            bannedWordActions: "Когда запрещенное слово создается, обновляется или удаляется.",
            emailActions: "Когда создается, обновляется или удаляется учетная запись электронной почты.",
            preparedContentActions: "Когда готовый контент создается, обновляется или удаляется.",
            roleActions: "Когда роль создается, обновляется или удаляется.",
            tagActions: "Когда тег создается, обновляется или удаляется.",
            welcomeMessageActions: "Когда сообщение приветствия создается, обновляется или удаляется.",
            webhookActions: "Когда веб-хук создается, обновляется или удаляется.",
            billingEvents: "Когда создается счет или обновляется его статус.",
            systemStatus: "Когда обновляется статус системы живой поддержки.",
            reservationMessageCrud: "Когда резервирование создается, обновляется или удаляется.",
            ipAddressWhiteListEvents: "Когда разрешенный IP-адрес добавляется, обновляется или удаляется.",
            taskAssignedMe: "Когда задача назначена мне.",
            workflowCreated: "Когда создается рабочий процесс.",
            workflowDeleted: "Когда рабочий процесс удаляется.",
            createdTask: "Когда задача создается.",
            deletedTask: "Когда задача удаляется.",
            chatbotStoryCrud: "Когда история чат-бота создается, обновляется или удаляется.",
            chatbotForwardAgent: "Чат-бот перенаправляет чат агенту.",
            userSegmentCrud: "Когда сегмент пользователя создается, обновляется или удаляется.",
            chatbotCreditLow: "Когда кредит чат-бота низкий.",
            wpCreditLow: "Когда кредит WhatsApp падает ниже 100 TL.",
            wpCustomerGroupCrud: "Когда создается, обновляется или удаляется группа клиентов WhatsApp.",
            wpBroadcastMessageStatus: "Когда начинается, завершается или отменяется отправка массового сообщения WhatsApp.",
            wpTemplateMesssageCrud: "Когда создается, обновляется или удаляется шаблон сообщения WhatsApp.",
            whatsappQrChannelStatusUpdated: "Когда обновляется статус подключения канала WhatsApp QR.",
            activityTypeLabels: {
                "chat-assign": "Когда чат назначен мне",
                "ticket-assign": "Когда тикет назначен мне",
                "task-assign": "Когда задача назначена мне",
                "task-complet": "Когда задача завершена",
                "chat-close-own": "Когда чат, которым я владею, закрыт",
                "tag-actions-to-visitor": "Теги добавлены или удалены из контакта",
                "create-ticket": "Тикет создан посетителем или чат-ботом. Также, когда отправлено офлайн-сообщение из окна чата",
                "note-actions-to-visitor": "Заметки добавлены или удалены из контакта",
                "visitor-profile-updates": "Обновления профиля посетителя",
                "chat-start": "Чат запущен на любой платформе контактом или агентом",
                "user-crud": "Пользователь создан, обновлен или удален",
                "department-crud": "Отдел создан, обновлен или удален",
                "settings-crud": "Настройки созданы, обновлены или удалены",
                "integration-channel-crud": "Канал интеграции создан, обновлен или удален",
                "login-form-crud": "Форма входа обновлена, активирована или деактивирована",
                "banned-word-crud": "Запрещенное слово создано, обновлено или удалено",
                "email-account-crud": "Email-аккаунт создан или удален",
                "prepared-content-crud": "Подготовленный контент создан или удален",
                "role-crud": "Роль создана, обновлена или удалена",
                "tag-crud": "Тег создан, обновлен или удален",
                "welcome-message-crud": "Приветственное сообщение создано, обновлено или удалено",
                "webhook-crud": "Webhook создан, обновлен или удален",
                "automation-created": "Автоматизация создана",
                "automation-deleted": "Автоматизация удалена",
                "automation-published": "Автоматизация опубликована",
                "automation-unpublished": "Автоматизация снята с публикации",
                "automation-updated": "Автоматизация обновлена",
                "billing-events": "События биллинга",
                "task-workflow-crud": "Рабочий процесс задачи создан, обновлен или удален",
                "task-crud": "Задача создана, обновлена или удалена",
                "system-status": "Изменения статуса системы онлайн или офлайн",
                "chatbot-story-crud": "История чат-бота создана, обновлена или удалена",
                "chatbot-forward-chat": "Чат-бот пересылает чат агенту",
                "chatbot-user-segment-crud": "Сегмент пользователя создан, обновлен или удален",
                "chatbot-credit-low": "Когда кредит чат-бота низкий",
                "whatsapp-credit-low": "Когда кредит WhatsApp низкий",
                "whatsapp-customer-group-crud": "Когда группа клиентов WhatsApp создана, обновлена или удалена",
                "whatsapp-broadcast-message-crud": "Когда широковещательное сообщение WhatsApp отправлено, завершено или отменено",
                "whatsapp-template-message-crud": "Когда шаблонное сообщение WhatsApp создано, обновлено или удалено",
                "form-created": "Форма создана",
                "form-updated": "Форма обновлена",
                "form-deleted": "Форма удалена",
                "form-restored": "Форма восстановлена",
                "form-downloaded": "Форма загружена",
                "user-role-changed": "Роль пользователя изменена",
                "user-password-changed": "Пароль пользователя изменен",
                "user-email-changed": "Email-адрес пользователя изменен",
                "user-name-changed": "Имя пользователя изменено",
                "user-phone-changed": "Телефон пользователя изменен",
                "user-disabled": "Пользователь отключен/включен",
                "role-updated": "Роль обновлена",
                "task-workflow-updated": "Рабочий процесс задачи обновлен",
                "task-workflow-pipeline-stage-added": "Этап конвейера рабочего процесса задачи добавлен",
                "task-workflow-pipeline-stage-updated": "Этап конвейера рабочего процесса задачи обновлен",
                "task-workflow-pipeline-stage-deleted": "Этап конвейера рабочего процесса задачи удален",
                "drive-folder-created": "Папка Drive создана",
                "drive-folder-deleted": "Папка Drive удалена",
                "drive-folder-renamed": "Папка Drive переименована",
                "drive-file-added": "Файл добавлен в Drive",
                "drive-file-deleted": "Файл удален из Drive",
                "task-module-rules-enabled": "Правила модуля задач включены",
                "task-module-rules-disabled": "Правила модуля задач отключены",
                "task-module-rules-rule-added": "Правило добавлено в рабочий процесс задачи",
                "task-module-rules-rule-deleted": "Правило удалено из рабочего процесса задачи",
                "task-module-rules-rule-updated": "Правило обновлено в рабочем процессе задачи",
                "task-module-rules-rule-enabled": "Правило включено в рабочем процессе задачи",
                "task-module-rules-rule-disabled": "Правило отключено в рабочем процессе задачи",
                "contact-module-rules-enabled": "Правила модуля контактов включены",
                "contact-module-rules-disabled": "Правила модуля контактов отключены",
                "contact-module-rules-rule-added": "Правило добавлено в модуль контактов",
                "contact-module-rules-rule-updated": "Правило обновлено в модуле контактов",
                "contact-module-rules-rule-deleted": "Правило удалено из модуля контактов",
                "contact-module-rules-rule-enabled": "Правило включено в модуле контактов",
                "contact-module-rules-rule-disabled": "Правило отключено в модуле контактов",
                "developer-token-changed": "Токен разработчика обновлен",
                "table-created": "Таблица создана",
                "table-field-added": "Поле добавлено в таблицу",
                "table-field-updated": "Поле обновлено в таблице",
                "table-field-deleted": "Поле удалено из таблицы",
                "table-view-added": "Представление добавлено в таблицу",
                "table-view-updated": "Представление обновлено в таблице",
                "table-view-deleted": "Представление удалено из таблицы",
                "table-page-added": "Страница добавлена в таблицу",
                "table-page-updated": "Страница обновлена в таблице",
                "table-page-deleted": "Страница удалена из таблицы",
                "table-widget-added": "Виджет добавлен на страницу таблицы",
                "table-widget-updated": "Виджет обновлен на странице таблицы",
                "table-widget-deleted": "Виджет удален со страницы таблицы",
                "table-privacy-changed": "Настройки конфиденциальности таблицы обновлены",
                "web-app-created": "Веб-приложение создано",
                "web-app-updated": "Веб-приложение обновлено",
                "web-app-deleted": "Веб-приложение удалено",
                "web-tab-created": "Веб-вкладка создана",
                "web-tab-updated": "Веб-вкладка обновлена",
                "web-tab-deleted": "Веб-вкладка удалена",
                "module-created": "Модуль создан",
                "module-updated": "Модуль обновлен",
                "module-deleted": "Модуль удален",
                "relation-created": "Связь создана",
                "relation-updated": "Связь обновлена",
                "voice-agent-created": "Голосовой агент создан",
                "voice-agent-updated": "Голосовой агент обновлен",
                "voice-agent-deleted": "Голосовой агент удален",
                "voice-agent-phone-number-inbound-agent-changed": "Входящий агент номера телефона изменен",
                "voice-agent-phone-number-outbound-agent-changed": "Исходящий агент номера телефона изменен",
                "voice-agent-batch-call-created": "Пакетный звонок создан",
                "voice-agent-knowledge-base-created": "База знаний создана",
                "voice-agent-knowledge-base-deleted": "База знаний удалена",
                "table-data-downloaded": "Данные таблицы загружены",
                "table-data-imported": "Массовые данные импортированы в таблицу",
                "table-data-batch-updated": "Данные таблицы массово обновлены",
                "table-data-batch-deleted": "Данные таблицы массово удалены",
                "contact-batch-updated": "Контакты массово обновлены",
                "chat-data-downloaded": "История чата загружена",
                "automation-restored": "Когда автоматизация восстановлена из корзины",
                "waba-supsis-partner-remove": "Когда партнёр WhatsApp Business API V2 удалён",
                "waba-supsis-account-deleted": "Когда аккаунт Whatsapp Business API V2 удалён",
                "waba-supsis-account-violation": "При обнаружении нарушения аккаунта WhatsApp Business API V2",
                "waba-supsis-ad-account-linked": "Когда рекламный аккаунт WhatsApp Business API V2 подключён",
                "waba-supsis-auth-intl-price-eligibility-update": "При обновлении международной ценовой пригодности WhatsApp Business API V2",
                "waba-supsis-disabled-update": "При обновлении отключения WhatsApp Business API V2",
                "waba-supsis-mm-lite-terms-signed": "При подписании условий MM Lite WhatsApp Business API V2",
                "waba-supsis-partner-app-installed": "Когда приложение партнёра WhatsApp Business API V2 установлено",
                "waba-supsis-partner-app-uninstalled": "Когда приложение партнёра WhatsApp Business API V2 удалено",
                "waba-supsis-partner-client-certification-status-update": "Когда обновлён статус сертификации партнёра Whatsapp Business API V2",
                "waba-supsis-business-primary-location-country-update": "Когда обновлена страна основного местоположения Whatsapp Business API V2",
                "waba-supsis-volume-based-pricing-tier-update": "Когда обновлён объёмный тариф Whatsapp Business API V2",
                "waba-supsis-message-template-components-update": "Когда обновлены компоненты шаблона сообщения Whatsapp Business API V2",
                "waba-supsis-message-template-status-update": "Когда обновлён статус шаблона сообщения Whatsapp Business API V2",
                waba_supsis_partner_remove: "Партнёр Whatsapp Business API V2 удалён",
                waba_supsis_account_deleted: "Аккаунт Whatsapp Business API V2 удалён",
                waba_supsis_account_violation: "Обнаружено нарушение аккаунта Whatsapp Business API V2",
                waba_supsis_ad_account_linked: "Рекламный аккаунт Whatsapp Business API V2 подключён",
                waba_supsis_auth_intl_price_eligibility_update: "Обновление международной ценовой пригодности Whatsapp Business API V2",
                waba_supsis_disabled_update: "Обновление отключения Whatsapp Business API V2",
                waba_supsis_mm_lite_terms_signed: "Условия MM Lite Whatsapp Business API V2 подписаны",
                waba_supsis_partner_added: "Партнёр Whatsapp Business API V2 добавлен",
                waba_supsis_partner_app_installed: "Партнёрское приложение Whatsapp Business API V2 установлено",
                waba_supsis_partner_app_uninstalled: "Партнёрское приложение Whatsapp Business API V2 удалено",
                waba_supsis_partner_client_certification_status_update: "Обновлён статус сертификации партнёра Whatsapp Business API V2",
                waba_supsis_business_primary_location_country_update: "Обновлена страна основного местоположения Whatsapp Business API V2",
                waba_supsis_volume_based_pricing_tier_update: "Обновлён объёмный тариф Whatsapp Business API V2",
                waba_supsis_message_template_components_update: "Обновлены компоненты шаблона сообщения Whatsapp Business API V2",
                waba_supsis_message_template_status_update: "Обновлён статус шаблона сообщения Whatsapp Business API V2",
                waba_supsis_template_category_update: "Обновлена категория шаблона Whatsapp Business API V2",
                waba_supsis_PARTNER_REMOVE: "Партнёр Whatsapp Business API V2 удалён",
                waba_supsis_ACCOUNT_DELETED: "Аккаунт Whatsapp Business API V2 удалён",
"task-workflow-restored": "Когда рабочий процесс восстановлен из корзины",
            "task-workflow-permanently-deleted": "Когда рабочий процесс окончательно удалён из корзины",
            "table-deleted": "Когда таблица удалена",
            "table-restored": "Когда таблица восстановлена из корзины",
            "table-permanently-deleted": "Когда таблица окончательно удалена из корзины"
            },
            crmActions: "Действия CRM",
            mobileApp: "Мобильное приложение",
            webPanel: "Веб-панель",
            notifications: "Уведомления",
            whatsappActions: "Действия WhatsApp",
            chatbotActions: "Действия чатбота",
            companyActions: "Действия компании",
            basicActions: "Основные действия",
            notificationSettingsDesc: "Выберите, какие уведомления вы хотите получать и где.",
            noNotificationDesc2: "Здесь вы увидите все уведомления, связанные с вакансиями, кандидатами и пулами талантов, которые вы отслеживаете. Вы можете настроить уведомления, изменив настройки.",
            noNotificationTitle2: "Пока нет уведомлений.",
            noNotificationTitle1: "Уведомлений нет. Наслаждайтесь тишиной.",
            adjustSettings: "Настроить параметры",
            showAll: "Показать все",
            showOnlyUnread: "Показать только непрочитанные",
            mailWasSent: "Письмо было отправлено.",
            mailAdressRemoved: "Email адрес был удален.",
            chatbotPublished: "Версия <b>{version}</b> чат-бота была опубликована пользователем <b>{user}</b>.",
            chatbotDeleted: "Чат-бот <b>{chatbot}</b> был удален пользователем <b>{user}</b>.",
            settingsUpdatedWoDetail: "Настройки были обновлены пользователем <b>{user}</b>.",
            noActivityDesc: "В настоящее время в системе нет активности. Несколько событий должны произойти",
            noActivityTitle: "Пока нет действий",
            actionType: "Тип действия",
            dateBetween: "Даты между",
            selectActor: "Выберите пользователя",
            activities: "Мероприятия",
            chatbotCreated: "Чат-бот с именем <b>{chatbot}</b> был создан пользователем <b>{user}</b>.",
            taskAddedTags: "<b>{user}</b> добавил эти теги к задаче (<b>{taskTitle}</b>): <b>{tags}</b>",
            taskStageChanged: "Стадия задачи <b>{task}</b> была изменена с <b>{oldStage}</b> на <b>{newStage}</b> пользователем <b>{user}</b>.",
            taskCreated: "Задача <b>{task}</b> была создана пользователем <b>{user}</b>.",
            contactPropRemoved: "Свойство посетителя <b>{prop}</b> было удалено пользователем <b>{user}</b>.",
            contactPropAdded: "Свойство посетителя <b>{prop}</b> было добавлено пользователем <b>{user}</b>.",
            userRemoved: "Пользователь <b>{oldUser}</b> был удален пользователем <b>{user}</b>.",
            loginFormUpdated: "Форма входа посетителя была обновлена <b>{user}</b>.",
            loginFormDeactivated: "Форма входа пользователя была отключена <b>{user}</b>.",
            loginFormActivated: "Форма входа пользователя была активирована <b>{user}</b>.",
            invoiceRefunded: "Процесс возврата был осуществлен <b>{user}</b>.",
            paymentMethodAdded: "Новый способ оплаты был добавлен пользователем <b>{user}</b>.",
            invoicePaymentFailed: "Оплата счета не была принята пользователем <b>{user}</b>.",
            invoicePaymentReceived: "Оплата счета была принята пользователем <b>{user}</b>.",
            planStarted: "<b>{user}</b> Пользователь начал подписку <b>{title}</b> <b>({altTitle})</b>.",
            PlanCanceled: "<b>{user}</b> Пользователь отменил подписку <b>{title}</b> <b>({altTitle})</b>.",
            invoiceCreated: "Счет был создан пользователем <b>{user}</b>.",
            billingAddressUpdated: "Информация об адресе была обновлена пользователем <b>{user}</b>.",
            taskWorkflowDeleted: "Рабочий процесс <b>{workflow}</b> был удален пользователем <b>{user}</b>.",
            whatsappBroadcastFailed: "Отправка широковещательного сообщения с заголовком <b>{title}</b> не удалась.",
            whatsappBroadcastCancelled: "Отправка широковещательного сообщения с заголовком <b>{title}</b> была отменена.",
            whatsappBroadcastCompleted: "Широковещательное сообщение с заголовком <b>{title}</b> успешно отправлено <b>{numbers}</b> получателям.",
            whatsappBroadcastCreated: "Широковещательное сообщение с заголовком <b>{title}</b> было отправлено <b>{user}</b> <b>{numbers}</b> получателям.",
            ticketAssigned: "<b>{user1}</b> пользователям <b>{user2}</b> назначен билет.",
            userLoggedIn: "<b>{user}</b> вошел в систему SUPSIS.",
            chatJoined: "<b>{agent}</b>, <b>{visitor}</b> с чатом.",
            chatForwarded: "Чат с <b>{visitor}</b> был перенаправлен на <b>{agent}</b> от <b>{user}</b>.",
            chatAssigned: "Чат с <b>{visitor}</b> был назначен <b>{agent}</b> системой.",
            customerGroupUpdated: "Группа <b>{group}</b> была обновлена <b>{user}</b>.",
            customerGroupRemoved: "Группа <b>{group}</b> была удалена <b>{user}</b>.",
            customerGroupAdded: "Группа <b>{group}</b> была создана <b>{user}</b>.",
            contentRemoved: "Готовое содержимое <b>{content}</b> было удалено <b>{user}</b>.",
            contentAdded: "Готовое содержимое <b>{content}</b> было добавлено <b>{user}</b>.",
            channelVisibilityChanged: "Видимость интеграционного канала <b>{channel}</b> была изменена пользователем <b>{user}</b>.",
            taskDeleted: "Задача <b>{task}</b> была удалена пользователем <b>{user}</b>.",
            taskCompleted: "<b>{task}</b> задача была выполн��на <b>{user}</b>.",
            taskArchived: "<b>{user}</b> архивировал задачу <b>{task}</b>.",
            userRemovedToDepartment: "Пользователь <b>{user2}</b> удален из отдела <b>{department}</b> пользователем <b>{user1}</b>.",
            userAddedToDepartment: "Пользователь <b>{user2}</b> добавлен в отдел <b>{department}</b> пользователем <b>{user1}</b>.",
            mailAddressAdded: "<b>{email}</b> адрес электронной почты добавлен <b>{user}</b>",
            settingUpdate: "Обновлено <b>{user}</b>:",
            taskWFlowCreated: "Рабочий процесс <b>{Wflow}</b> создан пользователем <b>{user}</b>.",
            bannedWordRemoved: "Запрещенное слово <b>{bWord}</b> удалено пользователем <b>{user}</b>.",
            bannedWordCreated: "Запрещенное слово <b>{bWord}</b> создано пользователем <b>{user}</b>.",
            taskPriorityUpdated: "<b>{user}</b> изменил приоритет задачи <b>{taskTitle}</b> с <b>{oldPriority}</b> на <b>{newPriority}</b>",
            welcomeMessageRemoved: "Приветственное сообщение <b>{welcome}</b> удалено пользователем <b>{user}</b>.",
            welcomeMessageAdded: "Приветственное сообщение <b>{welcome}</b> создано <b>{user}</b>.",
            tagRemoved: "Тег <b>{tag}</b> удален <b>{user}</b>.",
            tagAdded: "Тег <b>{tag}</b> добавлен <b>{user}</b>.",
            roleRemoved: "Роль <b>{role}</b> удалена <b>{user}</b>.",
            roleAdded: "Роль <b>{role}</b> добавлена <b>{user}</b>.",
            departmentRemoved: "Отдел <b>{department}</b> удален <b>{user}</b>.",
            departmentAdded: "Отдел <b>{department}</b> добавлен <b>{user}</b>.",
            triggerUpdated: "Триггер обновлен <b>{user}</b>.",
            triggerRemoved: "Триггер удален <b>{user}</b>.",
            triggerAdded: "Новый триггер создан <b>{user}</b>.",
            webhookRemoved: "Webhook <b>{user1}</b>, удаленный <b>{user2}</b>",
            webhookAdded: "Webhook добавлен <b>{user1}</b>, добавлен <b>{user2}</b>.",
            chatOpenedByAgent: "<b>{agent}</b> начал чат <b>{platform}</b> с <b>{visitor}</b>.",
            chatOpenedByVisitor: "Чат <b>{platform}</b> был начат <b>{visitor}</b>.",
            channelRemoved: "Канал <b>{channel}</b> был удален <b>{agent}</b>.",
            userAdded: "<b>{agent}</b> создал представителя по имени <b>{newAgent}</b>.",
            visitorUnblocked: "Посетитель <b>{visitor}</b> разблокирован пользователем <b>{agent}</b>.",
            visitorBlocked: "Посетитель <b>{visitor}</b> заблокирован <b>{agent}</b>.",
            userStatusChanged: "Пользователь <b>{name}</b> изменил статус с <b>{oldStatus}</b> на <b>{newStatus}</b>.",
            channelCreated: "Канал <b>{channel}</b> создан пользователем <b>{name}</b>.",
            reservationCreatedPlan: "<b>{name}</b> пользователь запланировал встречу под названием <b>{title}</b> на <b>{date}</b>.",
            reservationUpdatedPlan: "<b>{name}</b> пользователь обновил встречу под названием <b>{title}</b>.",
            reservationDeletedPlan: "<b>{name}</b> пользователь удалил встречу под названием <b>{title}</b>.",
            reservationCreated: "Бронь создана для пользователя <b>{name}</b> и посетителя <b>{visitor}</b> на <b>{date}</b>.",
            reservationDeleted: "Запланированная встреча между пользователем <b>{name}</b> и посетителем <b>{visitor}</b> на <b>{date}</b> отменена.",
            chatOwnerUpdated: "<b>{agent}</b> переназначил <b>{visitor}</b> от <b>{oldOwner}</b> к <b>{newOwner}</b>.",
            customerOwnershipRemoved: "<b>{actor}</b> удалил право собственности на <b>{visitor}</b> у <b>{oldOwner}</b>, оставив его без владельца.",
            customerOwnershipAssigned: "<b>{actor}</b> назначил право собственности на <b>{visitor}</b> от без владельца к <b>{newOwner}</b>.",
            customerOwnershipReassigned: "<b>{actor}</b> переназначил право собственности на <b>{visitor}</b> от <b>{oldOwner}</b> к <b>{newOwner}</b>.",
            taskWorkflowCrud: "Рабочий процесс задачи создан, обновлен или удален",
            taskCrud: "Задача создана, обновлена или удалена",
            taskStatusChanged: "При изменении статуса задачи",
            autoRebalanceEvents: "Когда автопополнение завершено, не удалось или отключено.",
            automationActions: "Действия автоматизации",
            automationCreated: "Пользователь {user} создал автоматизацию «{automation}».",
            automationDeleted: "Пользователь {user} удалил автоматизацию «{automation}».",
            automationRestored: "Пользователь {user} восстановил автоматизацию «{automation}» из корзины.",
            automationPublished: "Пользователь {user} опубликовал автоматизацию «{automation}».",
            automationUnpublished: "Пользователь {user} снял с публикации автоматизацию «{automation}».",
            automationUpdated: "Пользователь {user} обновил автоматизацию «{automation}».",
            automationCreatedNotification: "Когда создаётся автоматизация.",
            automationDeletedNotification: "Когда удаляется автоматизация.",
            automationRestoredNotification: "Когда автоматизация восстановлена из корзины.",
            automationPublishedNotification: "Когда автоматизация публикуется.",
            automationUnpublishedNotification: "Когда автоматизация снимается с публикации.",
            automationUpdatedNotification: "Когда автоматизация обновляется.",
            formDeleted: "Пользователь {user} удалил форму «{formName}» (ID: {formId}).",
            formDeletedPermanent: "Пользователь {user} окончательно удалил форму «{formName}» (ID: {formId}).",
            formRestored: "Пользователь {user} восстановил форму «{formName}» (ID: {formId}) из корзины.",
            formCreated: "Пользователь {user} создал форму «{formName}».",
            formUpdated: "Пользователь {user} обновил форму «{formName}».",
            formDownloaded: "Пользователь {user} загрузил данные формы «{formName}» (ID: {formId}).",
            userRoleChanged: "Пользователь {actor} изменил роль пользователя «{userName}» с «{oldRoleName}» на «{newRoleName}».",
            userPasswordChanged: "Пользователь {actor} изменил пароль пользователя «{userName}».",
            userEmailChanged: "Пользователь {actor} изменил email пользователя «{userName}» с «{oldEmail}» на «{newEmail}».",
            userNameChanged: "Пользователь {actor} изменил имя пользователя «{userName}» с «{oldName}» на «{newName}».",
            userPhoneChanged: "Пользователь {actor} изменил телефон пользователя «{userName}» с «{oldPhone}» на «{newPhone}».",
            userDisabled: "Пользователь {actor} отключил пользователя «{userName}».",
            userEnabled: "Пользователь {actor} активировал пользователя «{userName}».",
            roleUpdated: "Пользователь {actor} обновил роль «{roleName}».",
            taskWorkflowUpdated: "Пользователь {actor} обновил рабочий процесс «{workflowTitle}».",
            taskWorkflowPipelineStageAdded: "Пользователь {actor} добавил этап «{stageName}» в рабочий процесс «{workflowTitle}».",
            taskWorkflowPipelineStageUpdated: "Пользователь {actor} обновил этап «{stageName}» в рабочем процессе «{workflowTitle}».",
            taskWorkflowPipelineStageDeleted: "Пользователь {actor} удалил этап «{stageName}» из рабочего процесса «{workflowTitle}».",
            driveFolderCreated: "Пользователь {actor} создал папку «{folderName}».",
            driveFolderDeleted: "Пользователь {actor} удалил папку «{folderName}».",
            driveFolderRenamed: "Пользователь {actor} переименовал папку «{oldName}» в «{newName}».",
            driveFileAdded: "Пользователь {actor} добавил файл «{fileName}».",
            driveFileDeleted: "Пользователь {actor} удалил файл «{fileName}».",
            taskModuleRulesEnabled: "Пользователь {actor} включил правила задач для рабочего процесса «{workflowTitle}».",
            taskModuleRulesDisabled: "Пользователь {actor} отключил правила задач для рабочего процесса «{workflowTitle}».",
            taskModuleRulesRuleAdded: "Пользователь {actor} добавил правило «{ruleName}» в рабочий процесс «{workflowTitle}».",
            taskModuleRulesRuleDeleted: "Пользователь {actor} удалил правило «{ruleName}» из рабочего процесса «{workflowTitle}».",
            taskModuleRulesRuleUpdated: "Пользователь {actor} обновил правило «{ruleName}» в рабочем процессе «{workflowTitle}».",
            taskModuleRulesRuleEnabled: "Пользователь {actor} включил правило «{ruleName}» в рабочем процессе «{workflowTitle}».",
            taskModuleRulesRuleDisabled: "Пользователь {actor} отключил правило «{ruleName}» в рабочем процессе «{workflowTitle}».",
            contactModuleRulesEnabled: "Пользователь {actor} включил правила модуля контактов.",
            contactModuleRulesDisabled: "Пользователь {actor} отключил правила модуля контактов.",
            contactModuleRulesRuleAdded: "Пользователь {actor} добавил правило «{ruleName}» в модуль контактов.",
            contactModuleRulesRuleUpdated: "Пользователь {actor} обновил правило «{ruleName}» в модуле контактов.",
            contactModuleRulesRuleDeleted: "Пользователь {actor} удалил правило «{ruleName}» из модуля контактов.",
            contactModuleRulesRuleEnabled: "Пользователь {actor} включил правило «{ruleName}» в модуле контактов.",
            contactModuleRulesRuleDisabled: "Пользователь {actor} отключил правило «{ruleName}» в модуле контактов.",
            developerTokenChanged: "Пользователь {actor} обновил токен доступа разработчика.",
            tableCreated: "Пользователь {actor} создал таблицу «{tableName}».",
            tableDeleted: "Пользователь {actor} удалил таблицу «{tableName}».",
            tableRestored: "Пользователь {actor} восстановил таблицу «{tableName}» из корзины.",
            tablePermanentlyDeleted: "Пользователь {actor} окончательно удалил таблицу «{tableName}» из корзины.",
            tableFieldAdded: "Пользователь {actor} добавил поле «{fieldName}» в таблицу «{tableName}».",
            tableFieldUpdated: "Пользователь {actor} обновил поле «{fieldName}» в таблице «{tableName}».",
            tableFieldDeleted: "Пользователь {actor} удалил поле «{fieldName}» из таблицы «{tableName}».",
            tableViewAdded: "Пользователь {actor} добавил представление «{viewName}» в таблицу «{tableName}».",
            tableViewUpdated: "Пользователь {actor} обновил представление «{viewName}» в таблице «{tableName}».",
            tableViewDeleted: "Пользователь {actor} удалил представление «{viewName}» из таблицы «{tableName}».",
            tablePageAdded: "Пользователь {actor} добавил страницу «{pageName}» в таблицу «{tableName}».",
            tablePageUpdated: "Пользователь {actor} обновил страницу «{pageName}» в таблице «{tableName}».",
            tablePageDeleted: "Пользователь {actor} удалил страницу «{pageName}» из таблицы «{tableName}».",
            tableWidgetAdded: "Пользователь {actor} добавил виджет «{widgetTitle}» ({widgetType}) на страницу «{pageName}» таблицы «{tableName}».",
            tableWidgetUpdated: "Пользователь {actor} обновил виджет «{widgetTitle}» ({widgetType}) на странице «{pageName}» таблицы «{tableName}».",
            tableWidgetDeleted: "Пользователь {actor} удалил виджет «{widgetTitle}» ({widgetType}) со страницы «{pageName}» таблицы «{tableName}».",
            tablePermissionChanged: "Пользователь {actor} обновил настройки конфиденциальности таблицы «{tableName}».",
            tableDataDownloaded: "Пользователь {actor} загрузил {recordCount} записей из таблицы «{tableName}».",
            tableDataImported: "Пользователь {actor} импортировал {successCount}/{recordCount} записей в таблицу «{tableName}».",
            tableDataBatchUpdated: "Пользователь {actor} массово обновил поле «{fieldName}» для {recordCount} записей в таблице «{tableName}».",
            tableDataBatchDeleted: "Пользователь {actor} массово удалил {recordCount} записей из таблицы «{tableName}».",
            contactDataDownloaded: "Пользователь {actor} загрузил данные {contactCount} контактов.",
            contactBatchUpdated: "Пользователь {actor} выполнил массовую операцию {action} для {contactCount} контактов.",
            chatDataDownloaded: "Пользователь {actor} загрузил историю {chatCount} чатов.",
            chatDataDownloadedWithVisitor: "Пользователь {actor} загрузил историю чата с «{visitorName}».",
            visitorTagAdded: "{actor} добавил тег {tagNames} контакту {visitorName}.",
            visitorTagRemoved: "{actor} удалил тег {tagNames} у контакта {visitorName}.",
            unknownVisitor: "Неизвестный контакт",
            tagsLabel: "Теги",
            webAppCreated: "Пользователь {actor} создал веб-приложение «{appName}» ({appSlug}).",
            webAppUpdated: "Пользователь {actor} обновил веб-приложение «{appName}» ({appSlug}).",
            webAppDeleted: "Пользователь {actor} удалил веб-приложение «{appName}» ({appSlug}).",
            webTabCreated: "Пользователь {actor} добавил веб-вкладку «{tabName}» в {placement}.",
            webTabUpdated: "Пользователь {actor} обновил веб-вкладку «{tabName}».",
            webTabDeleted: "Пользователь {actor} удалил веб-вкладку «{tabName}» ({placement}).",
            moduleCreated: "Пользователь {actor} создал {moduleType} «{moduleName}».",
            moduleUpdated: "Пользователь {actor} обновил {moduleType} «{moduleName}».",
            moduleDeleted: "Пользователь {actor} удалил {moduleType} «{moduleName}».",
            relationCreated: "Пользователь {actor} создал связь «{relationName}».",
            relationUpdated: "Пользователь {actor} обновил связь «{relationName}».",
            voiceAgentCreated: "Пользователь {actor} создал голосового агента «{agentName}» ({agentId}).",
            voiceAgentUpdated: "Пользователь {actor} обновил голосового агента «{agentName}» ({agentId}).",
            voiceAgentDeleted: "Пользователь {actor} удалил голосового агента «{agentName}» ({agentId}).",
            voiceAgentPhoneNumberInboundAgentChanged: "Пользователь {actor} изменил агента входящих звонков для номера {phoneNumber} на «{agentName}».",
            voiceAgentPhoneNumberOutboundAgentChanged: "Пользователь {actor} изменил агента исходящих звонков для номера {phoneNumber} на «{agentName}».",
            voiceAgentBatchCallCreated: "Пользователь {actor} создал массовый звонок «{batchCallName}» ({taskCount} абонентов).",
            voiceAgentKnowledgeBaseCreated: "Пользователь {actor} создал базу знаний «{knowledgeBaseName}».",
            voiceAgentKnowledgeBaseDeleted: "Пользователь {actor} удалил базу знаний «{knowledgeBaseName}».",
            webTabCreatedNotification: "Когда создаётся веб-вкладка.",
            webTabUpdatedNotification: "Когда обновляется веб-вкладка.",
            webTabDeletedNotification: "Когда удаляется веб-вкладка.",
            moduleCreatedNotification: "Когда создаётся модуль или связь.",
            moduleUpdatedNotification: "Когда обновляется модуль или связь.",
            moduleDeletedNotification: "Когда удаляется модуль или связь.",
            relationCreatedNotification: "Когда создаётся связь.",
            relationUpdatedNotification: "Когда обновляется связь.",
            voiceAgentCreatedNotification: "Когда создаётся голосовой агент.",
            voiceAgentUpdatedNotification: "Когда обновляется голосовой агент.",
            voiceAgentDeletedNotification: "Когда удаляется голосовой агент.",
            voiceAgentPhoneNumberInboundAgentChangedNotification: "Когда изменяется агент входящих звонков для номера.",
            voiceAgentPhoneNumberOutboundAgentChangedNotification: "Когда изменяется агент исходящих звонков для номера.",
            voiceAgentBatchCallCreatedNotification: "Когда создаётся массовый звонок.",
            voiceAgentKnowledgeBaseCreatedNotification: "Когда создаётся база знаний.",
            voiceAgentKnowledgeBaseDeletedNotification: "Когда удаляется база знаний.",
            formDeletedNotification: "Когда форма удаляется.",
            formRestoredNotification: "Когда форма восстанавливается из корзины.",
            formCreatedNotification: "Когда форма создаётся.",
            formUpdatedNotification: "Когда форма обновляется.",
            formDownloadedNotification: "Когда данные формы загружаются.",
            userRoleChangedNotification: "Когда изменяется роль пользователя.",
            userPasswordChangedNotification: "Когда изменяется пароль пользователя.",
            userEmailChangedNotification: "Когда изменяется email пользователя.",
            userNameChangedNotification: "Когда изменяется имя пользователя.",
            userPhoneChangedNotification: "Когда изменяется телефон пользователя.",
            userDisabledNotification: "Когда пользователь отключается или включается.",
            roleUpdatedNotification: "Когда роль обновляется.",
            taskWorkflowUpdatedNotification: "Когда обновляется рабочий процесс.",
            taskWorkflowPermanentlyDeletedNotification: "Когда рабочий процесс окончательно удалён из корзины.",
            taskWorkflowPipelineStageAddedNotification: "Когда в рабочий процесс добавляется новый этап.",
            taskWorkflowPipelineStageUpdatedNotification: "Когда этап рабочего процесса обновляется.",
            taskWorkflowPipelineStageDeletedNotification: "Когда этап удаляется из рабочего процесса.",
            driveFolderCreatedNotification: "Когда создаётся папка Drive.",
            driveFolderDeletedNotification: "Когда папка Drive удаляется.",
            driveFolderRenamedNotification: "Когда папка Drive переименовывается.",
            driveFileAddedNotification: "Когда файл добавляется в Drive.",
            driveFileDeletedNotification: "Когда файл удаляется из Drive.",
            taskModuleRulesEnabledNotification: "Когда правила модуля задач включаются.",
            taskModuleRulesDisabledNotification: "Когда правила модуля задач отключаются.",
            taskModuleRulesRuleAddedNotification: "Когда в рабочий процесс добавляется новое правило.",
            taskModuleRulesRuleDeletedNotification: "Когда правило удаляется из рабочего процесса.",
            taskModuleRulesRuleUpdatedNotification: "Когда правило в рабочем процессе обновляется.",
            taskModuleRulesRuleEnabledNotification: "Когда правило в рабочем процессе включается.",
            taskModuleRulesRuleDisabledNotification: "Когда правило в рабочем процессе отключается.",
            contactModuleRulesEnabledNotification: "Когда правила модуля контактов включаются.",
            contactModuleRulesDisabledNotification: "Когда правила модуля контактов отключаются.",
            contactModuleRulesRuleAddedNotification: "Когда в модуль контактов добавляется новое правило.",
            contactModuleRulesRuleUpdatedNotification: "Когда правило в модуле контактов обновляется.",
            contactModuleRulesRuleDeletedNotification: "Когда правило удаляется из модуля контактов.",
            contactModuleRulesRuleEnabledNotification: "Когда правило в модуле контактов включается.",
            contactModuleRulesRuleDisabledNotification: "Когда правило в модуле контактов отключается.",
            developerTokenChangedNotification: "Когда обновляется токен доступа разработчика.",
            tableCreatedNotification: "Когда создаётся новая таблица.",
            tableDeletedNotification: "Когда таблица удаляется.",
            tableRestoredNotification: "Когда таблица восстанавливается из корзины.",
            tablePermanentlyDeletedNotification: "Когда таблица окончательно удаляется из корзины.",
            tableFieldAddedNotification: "Когда в таблицу добавляется новое поле.",
            tableFieldUpdatedNotification: "Когда поле таблицы обновляется.",
            tableFieldDeletedNotification: "Когда поле удаляется из таблицы.",
            tableViewActionsNotification: "Когда представление таблицы добавляется, обновляется или удаляется.",
            tablePageActionsNotification: "Когда страница таблицы добавляется, обновляется или удаляется.",
            tableWidgetActionsNotification: "Когда виджет добавляется, обновляется или удаляется на странице таблицы.",
            tablePermissionChangedNotification: "Когда обновляются настройки конфиденциальности таблицы.",
            tableDataDownloadedNotification: "Когда данные таблицы загружаются.",
            tableDataImportedNotification: "Когда в таблицу импортируются записи.",
            tableDataBatchUpdatedNotification: "Когда в таблице выполняется массовое обновление.",
            tableDataBatchDeletedNotification: "Когда из таблицы массово удаляются записи.",
            contactBatchUpdatedNotification: "Когда контакты массово обновляются.",
            chatDataDownloadedNotification: "Когда загружается история чата.",
            webAppCreatedNotification: "Когда создаётся веб-приложение.",
            webAppUpdatedNotification: "Когда веб-приложение обновляется.",
            webAppDeletedNotification: "Когда веб-приложение удаляется.",
            formActions: "Когда форма создаётся, обновляется или удаляется.",
            userInfoActions: "Когда изменяются данные пользователя: роль, пароль, email, имя, телефон, статус.",
            driveActions: "Операции с папками и файлами Drive.",
            developerActions: "Когда обновляется токен доступа разработчика.",
            contactModuleRulesActions: "Когда правила модуля контактов включаются/отключаются, добавляется, обновляется или удаляется правило.",
            tableActions: "Когда таблица создаётся, в неё добавляется поле, поле обновляется или удаляется.",
            wabaSupsisPartnerRemove: "Когда партнёр Whatsapp Business API V2 удаляется.",
            wabaSupsisAccountDeleted: "Когда аккаунт Whatsapp Business API V2 удаляется.",
            wabaSupsisAccountViolation: "Когда обнаружено нарушение аккаунта Whatsapp Business API V2.",
            wabaSupsisAdAccountLinked: "Когда рекламный аккаунт Whatsapp Business API V2 подключается.",
            wabaSupsisAuthIntlPriceEligibilityUpdate: "Когда выполняется обновление международной ценовой пригодности Whatsapp Business API V2.",
            wabaSupsisDisabledUpdate: "Когда выполняется обновление отключения Whatsapp Business API V2.",
            wabaSupsisMmLiteTermsSigned: "Когда подписываются условия MM Lite Whatsapp Business API V2.",
            wabaSupsisPartnerAdded: "Когда партнёр Whatsapp Business API V2 добавляется.",
            wabaSupsisPartnerAppInstalled: "Когда партнёрское приложение Whatsapp Business API V2 устанавливается.",
            wabaSupsisPartnerAppUninstalled: "Когда партнёрское приложение Whatsapp Business API V2 удаляется.",
            wabaSupsisPartnerClientCertificationStatusUpdate: "Когда обновляется статус сертификации партнёра Whatsapp Business API V2.",
            wabaSupsisBusinessPrimaryLocationCountryUpdate: "Когда обновляется страна основного местоположения Whatsapp Business API V2.",
            wabaSupsisVolumeBasedPricingTierUpdate: "Когда обновляется объёмный тариф Whatsapp Business API V2.",
            wabaSupsisMessageTemplateComponentsUpdate: "Когда обновляются компоненты шаблона сообщения Whatsapp Business API V2.",
            wabaSupsisMessageTemplateStatusUpdate: "Когда обновляется статус шаблона сообщения Whatsapp Business API V2.",
            wabaSupsisTemplateCategoryUpdate: "Когда обновляется категория шаблона Whatsapp Business API V2.",
            chatbotRestored: "Чат-бот <b>{chatbot}</b> восстановлен из корзины пользователем <b>{user}</b>.",
            planStartedAgent: "<b>{user}</b> оформил подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{details} представителей</b>).",
            planStartedChatbot: "<b>{user}</b> оформил подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} сессий чат-бота</b>).",
            planStartedWhatsapp: "<b>{user}</b> оформил подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} каналов WhatsApp</b>).",
            planStartedWhatsappApi: "<b>{user}</b> оформил подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} каналов WhatsApp Business</b>).",
            planCanceledAgent: "<b>{user}</b> отменил подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{details} представителей</b>).",
            planCanceledChatbot: "<b>{user}</b> отменил подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} сессий чат-бота</b>).",
            planCanceledWhatsapp: "<b>{user}</b> отменил подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} каналов WhatsApp</b>).",
            planCanceledWhatsappApi: "<b>{user}</b> отменил подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} каналов WhatsApp Business</b>).",
            taskWorkflowRestored: "Рабочий процесс <b>{workflow}</b> восстановлен из корзины пользователем <b>{user}</b>.",
            taskWorkflowPermanentlyDeleted: "Рабочий процесс <b>{workflow}</b> окончательно удалён из корзины пользователем <b>{user}</b>.",
            userLoggenIn: "Пользователь <b>{user}</b> вошёл в систему SUPSIS.",
            channelForwardConfigUpdated: "Пользователь {actor} обновил настройки переадресации канала «{channelName}» ({channelType}).",
            channelZohoConfigUpdated: "Пользователь {actor} обновил настройки интеграции Zoho канала «{channelName}» ({channelType}).",
            webhookUpdated: "Пользователь {actor} обновил вебхук «{webhookName}» ({webhookUrl}).",
            chatClosed: "Чат с <b>{visitor}</b> завершён <b>{agent}</b>."
        },
        search: {
            prefix: {
                jump: "Перейти",
                new: "Новый",
                visitor: "Человек",
                dm: "DM",
                chatbot: "чат-бот",
                automation: "автоматизация",
                table: "стол",
                module: "модуль",
                message: "сообщение"
            },
            calendar: "Календарь",
            soundSettings: "Аудиоуведомления",
            allNotificationSettings: "Настройки уведомлений",
            allAuditLogs: "Журналы аудита",
            allNotifications: "Все уведомления",
            allActivities: "Все действия",
            workFlow: "Рабочий процесс",
            editTask: "Редактировать задачу",
            tasks: "Задачи",
            todo: "Дела, которые нужно сделать",
            tapTo: "Нажмите ⇥ для операций \"{префикс}\"",
            newUsers: "Новый ⇥ пользователь",
            newTags: "Новый ⇥ тег",
            newRole: "Новая ⇥ роль",
            newTrigger: "Новый ⇥ триггер",
            newDepartment: "Новый ⇥ департамент",
            newTicket: "Новая ⇥ метка",
            jumpSettings: "Перейти ⇥ настройки",
            jumpIntegrations: "Перейти ⇥ интеграции",
            jumpTeam: "Перейти ⇥ команда",
            jumpUsers: "Перейти ⇥ пользователи",
            jumpReport: "Перейти ⇥ отчет",
            timingSettings: "Настройки времени",
            exampleVisitorMail: "Посетитель@mail.com",
            languageAndRegion: "Язык и регион",
            theme: "Тема",
            appearance: "Внешний вид",
            color: "Цвет",
            background: "Фон",
            smart: "Умный",
            teamChat: "Командный чат",
            chatbot: "Чатбот",
            chatbotTraining: "Обучение чатбота",
            chatbotUserSegments: "Сегменты пользователей чатбота",
            chatbotIntegration: "Интеграция чатбота",
            chatbotEntities: "Сущности чатбота",
            chatbotIntegrationWebHook: "Интеграция вебхука чатбота",
            chatbotArchive: "Архив чатбота",
            chatbotTemplatesAI: "Шаблоны ИИ чатбота",
            chatbotTemplates: "Шаблоны чатботов",
            chatbotReportsOverall: "Общие отчеты чатбота",
            chatbotReportsAllChats: "Отчеты чатбота по всем чатам",
            chatbotReportsRatingDistribution: "Распределение рейтинга отчетов чатбота",
            chatbotReportsPaidChats: "Отчеты чатбота о платных чатах",
            chatbotReportsBusiestPeriod: "Период наибольшей загруженности чатбота",
            chatbotTemplatesAllMessages: "Шаблоны чатбота для всех сообщений",
            chatbotTemplatesAverage: "Среднее значение шаблонов чатбота",
            chatbotTemplatesPopularity: "Популярность шаблонов чатботов",
            chatbotTemplatesAllUser: "Шаблоны чатботов для всех пользователей",
            ticket: "Запросы в службу поддержки",
            archives: "Архив",
            tags: "Теги",
            offlineSupportRequests: "Запросы поддержки в офлайн-режиме",
            roles: "Роли",
            users: "Пользователи",
            departments: "Департаменты",
            content: "Мгновенное содержание",
            welcomeMessages: "Системные сообщения",
            catalog: "Каталог",
            bannedWords: "Запрещенные слова",
            bannedVisitors: "Запрещенные посетители",
            application: "Приложение",
            emails: "Почта",
            visitors: "Посетители",
            integrationsWebhook: "Интеграция Webhook",
            billing: "Счет-фактура",
            reportNew: "Новый отчет",
            integrations: "Интеграции",
            chatbotStory: "Истории чатботов",
            searchPlaceHolder: "Найти, перейти или добавить...",
            searchAreaTitle: "Поиск Supsis",
            searchAreaDesc1: "Вы можете искать что угодно. Только",
            searchAreaDesc2: "или",
            searchAreaDesc3: "введите или ищите что угодно",
            navigateBtn: "Перемещаться",
            selectBtn: "Выбрать",
            cancelBtn: "Отменить",
            integration: {
                shouldByInstaPack: "Вы должны купить Instagram-пакет для создания Instagram-канала. Вы можете сразу приобрести пакеты по доступным ценам.",
                createInstaLimitMax: "Вы достигли лимита создания канала Instagram. Максимум",
                createInstaContinue: "Вы можете создать канал Instagram. Чтобы продолжить, обновите свой пакет или удалите некоторые из ваших Instagram-каналов.",
                privatePolicy: "Частная политика",
                termsAndCondition: "Условия и положения",
                readAndAgree: "Я прочитал и согласен",
                shouldByMessengerPack: "Для создания канала в Messenger необходимо приобрести пакет Messenger. Вы можете получить пакеты по доступным ценам прямо сейчас.",
                createMessengerLimitMax: "Вы достигли предела создания канала Messenger. Максимум",
                createMessengerContinue: "Вы можете создать канал Messenger. Чтобы продолжить, обновите свой пакет или удалите некоторые из ваших каналов Messenger.",
                selectMessengerAccount: "Выберите аккаунт Messenger",
                forwardLiveAgents: "👉 Forward Live Agents",
                allDepartments: "Все отделы",
                deleteAll: "Удалить все",
                wpBusinessAPI: "Интеграции - Whatsapp Business API каналы",
                wpV1: "Интеграции - Мульти Whatsapp каналы",
                instagram: "Интеграции - Instagram",
                instagramContactList: "Интеграции - Список контактов Instagram",
                mail: "Интеграции - Почта",
                whatsapp: "Интеграции - Whatsapp",
                whatsappContactList: "Интеграции - Список контактов Whatsapp",
                wpBCRequests: "Интеграции - Запросы массовых сообщений Whatsapp",
                wpBCCustomerGroups: "Интеграции - Группы клиентов Whatsapp в массовом формате",
                wpBCTemplates: "Интеграции - Шаблоны массовых сообщений Whatsapp",
                chatbot: "Интеграции - ChatBot",
                allSections: "جميع الأقسام",
                createInstaInstaLimitMax: "لقد وصلت إلى الحد الأقصى لإنشاء قناة Instagram. الحد الأقصى.",
                createMessengerMessengerLimitMax: "لقد وصلت إلى الحد الأقصى لإنشاء قناة مسنجر. الحد الأقصى.",
                directClientsForward: "👉 وكلاء مباشرون إلى الأمام",
                shouldByByMessengerPack: "يجب عليك شراء باقة ماسنجر لإنشاء قناة ماسنجر. يمكنك الوصول إلى الباقات بأسعار معقولة على الفور.",
                wpBCRichieste: "Integrazioni - Richieste di messaggi in massa Whatsapp",
                messenger: "Интеграции - Messenger",
                telegram: "Интеграции - Telegram",
                whatsappV3: "Интеграции - WhatsApp V3",
                waba: "Интеграции - WhatsApp Business API V2",
                metaLeads: "Интеграции - Meta Leads",
                linkedin: "Интеграции - LinkedIn",
                youtubeComments: "Интеграции - YouTube Комментарии",
                googleBusinessReviews: "Интеграции - Google Business Отзывы",
                googlePlayReviews: "Интеграции - Google Play Отзывы",
                appstoreReviews: "Интеграции - App Store Отзывы",
                googleDrive: "Интеграции - Google Drive",
                openai: "Интеграции - OpenAI",
                openrouter: "Интеграции - OpenRouter AI",
                ideasoft: "Интеграции - Ideasoft",
                bitrix24: "Интеграции - Bitrix24",
                zoho: "Интеграции - Zoho CRM",
                ticimax: "Интеграции - Ticimax",
                ticimaxV2: "Интеграции - Ticimax V2",
                teamgram: "Интеграции - TeamGram",
                holidayplus: "Интеграции - HolidayPlus",
                trendyol: "Интеграции - Trendyol",
                tSoft: "Интеграции - T-Soft",
                ikas: "Интеграции - Ikas",
                postacell: "Интеграции - PostaCell SMS",
                telnyx: "Интеграции - Telnyx",
                netgsm: "Интеграции - NetGSM",
                webtabs: "Интеграции - Web Tabs",
                webapps: "Интеграции - Web Apps",
                instagramV2: "Интеграции - Instagram V2",
                voiceAgent: "Интеграции - AI Голосовой Агент",
            },
            settings: {
                settings: "Настройки",
                features: "Настройки - Особенности",
                languageAndRegion: "Настройки - Язык и регион",
                bubbleSettings: "Настройки - Настройки пузырьков",
                bubbleActions: "Настройки - Действия пузырька",
                themeSettings: "Настройки - Настройки темы",
                visitorLoginForm: "Настройки - Форма входа посетителя",
                talkSettings: "Настройки - Настройки чата",
                visitorAttribute: "Настройки - Атрибуты посетителя",
                autoAssign: "Настройки - Автоназначение",
                chatTimingSettings: "Настройки - Настройки времени чата",
                availability: "Настройки - Доступность",
                websiteIntegration: "Настройки - Интеграция сайта",
                developer: "Настройки - Разработчик",
                wallet: "Настройки - Кошелек",
                accessControl: "Настройки - Контроль доступа",
                sessions: "Настройки - Управление сеансами",
                contactModuleRules: "Настройки - Правила модуля контактов",
                taskModuleRules: "Настройки - Правила модуля задач",
                notifications: "Настройки - Уведомления",
                billing: "Настройки - Оплата",
                company: "Настройки - Информация о компании",
                companyUsers: "Настройки - Пользователи",
                departments: "Настройки - Отделы",
                roles: "Настройки - Роли",
                systemMessages: "Настройки - Системные сообщения",
                templates: "Настройки - Готовые материалы",
                forbiddenInputs: "Настройки - Запрещенные слова",
                timingsSettings: "Настройки - Настройки времени",
                autoAssignSettings: "Настройки - Автоназначение",
                availabilitySettings: "Настройки - Доступность",
            },
            chatbotTemplatesAvarage: "Средние значения шаблонов чат-ботов",
            subjects: "Темы",
            contents: "Содержимое",
            mails: "Почта",
            applicazione: "Приложение",
            archivi: "Архив",
            audioSettings: "Настройки аудио",
            chatbotArchiv: "Архив чат-ботов",
            contenuti: "Мгновенное содержимое",
            fondo: "Фон",
            forbiddenWords: "Запрещенные слова",
            integraciones: "Integraciones",
            integrationOperations: "Операции интеграции",
            integrazioni: "Интеграции",
            integrazioniWebhook: "Интеграция вебхука",
            intelligent: "Интеллектуальный",
            invoices: "Счета",
            kalender: "Календарь",
            mail: "Почта",
            mailMessages: "Почтовые сообщения",
            navigation: "Навигация",
            newReport: "Новый отчет",
            newSection: "Новый раздел",
            ruoli: "Роли",
            soggetti: "Отделы",
            tag: "Теги",
            topics: "Темы",
            utenti: "Пользователи",
            visitatori: "Посетители",
            webhookIntegration: "Интеграция вебхука",
            workflow: "Рабочий процесс",
            profile: "Профиль",
            chatbotBlockMarket: "Чат-бот Маркет блоков",
            chatbotSandbox: "Чат-бот Песочница",
            allAutomations: "Все автоматизации",
            scheduledAutomations: "Запланированные автоматизации",
            eventBasedAutomations: "Автоматизации на основе событий",
            buttonAutomations: "Кнопочные автоматизации",
            webhookAutomations: "Webhook автоматизации",
            automationInsights: "Статистика автоматизаций",
            automationSandbox: "Песочница автоматизаций",
            mailInbox: "Входящая почта",
            mailTemplates: "Шаблоны почты",
            mailBroadcast: "Массовая рассылка",
            mailCustomerGroups: "Группы клиентов",
            reservation: "Бронирование",
            reservationLandingPage: "Страница бронирования",
            reservationPrograms: "Программы бронирования",
            reservationAutomations: "Автоматизации бронирования",
            calendarEvents: "События календаря",
            calendarReservations: "Бронирования календаря",
        },
        mail: {
            errorStatus: "Статус ошибки",
            mailSendErrorTitle: "Недоставленные письма",
            mailSendErrorDescription: "Общее количество недоставленных писем",
            fixGrammarTitle: "Исправление грамматики",
            expandTextTitle: "Расширение текста",
            summaryTitle: "Резюме",
            changeToneTitle: "Изменение тона",
            translationTitle: "Перевод",
            replyTitle: "Ответ",
            customRequestTitle: "Ответ на специальный запрос",
            viewMode: "Режим просмотра",
            singleView: "Одиночный просмотр",
            splitView: "Разделённый просмотр",
            folders: "Папки",
            sendError: "Произошла ошибка при отправке письма. Пожалуйста, попробуйте позже.",
            visitorCreationError: "Ошибка создания посетителя. Пожалуйста, попробуйте позже.",
            onlyImageAllowed: "Разрешены только изображения.",
            imageFileTooLarge: "Файл изображения слишком большой. Максимальный размер — 10 МБ.",
            imageUploaded: "Изображение успешно загружено.",
            imageUploadError: "Произошла ошибка при загрузке изображения.",
            mailAiAssistant: {
                aiCreateSummarized: "Создать сводку с ИИ",
                aiSentimentAnalysis: "Анализ тональности ИИ",
                contentRequired: "Для использования этой функции необходим текст письма",
                grammarFixed: "Грамматика исправлена",
                aiError: "Ассистент ИИ столкнулся с ошибкой",
                contentExpanded: "Содержимое письма расширено",
                emailSummarized: "Письмо было кратко изложено",
                toneChanged: "Тон изменён на {tone}",
                emailTranslated: "Письмо переведено на {language}",
                replyGenerated: "Автоматический ответ создан",
                contentUpdated: "Содержимое обновлено",
                contentRebuilt: "Содержимое было пересоздано",
                contentRebuildFailed: "Не удалось пересоздать содержимое",
                customRequestEmpty: "Пожалуйста, введите запрос",
                customRequestApplied: "Пользовательский запрос применён",
                loadingText: "ИИ работает",
                loadingDescription: "Анализ текста, пожалуйста, подождите...",
                aiTitle: "ИИ-помощник для почты",
                aiDescription: "Инструменты ИИ для улучшения, редактирования и анализа письма",
                emptyContentTitle: "Содержимое письма не найдено",
                emptyContentDescription: "Для использования функций ИИ необходимо содержимое письма.",
                limitedAccessDescription: "Доступны только ограниченные функции, так как письмо пусто.",
                resultEmotions: "Обнаруженные эмоции",
                analysisDescription: "Описание анализа",
                recommendationsList: "Рекомендации по улучшению",
                mailSummarize: "Сводка письма",
                aiResponse: "Сгенерировано ИИ",
                rebuild: "Пересоздать",
                applyText: "Применить текст",
                specialRequest: "Особый запрос",
                specialRequestPlaceholder: "Введите свои особые инструкции здесь...",
                sendRequest: "Отправить запрос",
                fixGrammarTitle: "Исправить грамматику",
                fixGrammardescription: "Автоматически исправляет орфографические и грамматические ошибки",
                expandTextTitle: "Расширить текст",
                expandTextDescription: "Делает текст более подробным и содержательным",
                changeToneTitle: "Изменить тон",
                changeToneDescription: "Меняет тональность и стиль текста по вашему выбору",
                changeTone_ProfessionalTitle: "Профессиональный",
                changeTone_ProfessionalDescription: "Официальный и деловой стиль для рабочих писем",
                changeTone_FriendlyTitle: "Дружелюбный",
                changeTone_FriendlyDescription: "Тёплый и искренний подход",
                changeTone_CasualTitle: "Неформальный",
                changeTone_CasualDescription: "Простой и разговорный тон",
                changeTone_FormalTitle: "Формальный",
                changeTone_FormalDescription: "Очень официальный и корпоративный стиль",
                changeTone_ConfidentTitle: "Уверенный",
                changeTone_ConfidentDescription: "Сильный и убедительный стиль изложения",
                translateTitle: "Перевести",
                translateDescription: "Переводит текст на другие языки",
                generateReplyTitle: "Создать ответ",
                generateReplyDescription: "Автоматически создаёт ответ на полученное письмо",
                customPromptTitle: "Особый запрос",
                customPromptDescription: "Создаёт содержимое письма по вашим инструкциям"
            },
            searchEmail: "Поиск писем...",
            emailAttachments: "Вложения ({count})",
            signatureMessage: "У вас есть подпись. Добавить её в письмо?",
            emailSubject: "Тема письма",
            takeItBack: "Отменить",
            fastForward: "Повторить",
            addEmoji: "Добавить смайлик",
            addLink: "Добавить ссылку",
            bold: "Жирный",
            italic: "Курсив",
            underline: "Подчёркнутый",
            fontFamily: "Шрифт",
            textColor: "Цвет текста",
            stringFormats: "Форматы текста",
            alignLeft: "Выровнять по левому краю",
            alignRight: "Выровнять по правому краю",
            alignCenter: "По центру",
            normalText: "Обычный текст",
            participantList: "{first}, {second}, {third} +{remaining} других",
            noMailFound: "Писем не найдено",
            selectedMail: "{count} писем выбрано",
            recipientEmailAddress: "Адрес электронной почты получателя",
            CCreceivers: "Копия (CC)",
            BCCreceivers: "Скрытая копия (BCC)",
            emptyStateMessage: "Выберите письмо или создайте новое",
            FromName: "Имя Отправителя",
            broadcastCreatedSuccess: "Трансляция успешно создана",
            confirmArchive: "Вы уверены, что хотите архивировать эту трансляцию?",
            archive: "Архивировать",
            cancel: "Отмена",
            archiveSuccess: "Трансляция успешно архивирована",
            archiveError: "Ошибка при архивировании трансляции",
            empty: "Пусто",
            summerDiscounts: "Летние скидки",
            opportunities: "Возможности",
            newMailTemplateCreated: "Создать новый шаблон электронной почты",
            dateRange: "Диапазон дат",
            templateName: "Имя шаблона",
            category: "Категория",
            templateUpdateSucs: "Шаблон был успешно обновлен.",
            templateUpdateError: "При обновлении шаблона произошла ошибка.",
            marketing: "Маркетинг",
            operational: "Оперативный",
            custom: "Special",
            pleaseEnterTemplateName: "Пожалуйста, введите название шаблона",
            pleaseEnterTemplateSubject: "Пожалуйста, введите тему шаблона",
            pleaseSelectTemplateCategories: "Пожалуйста, выберите категорию шаблона",
            representMails: "Представительские письма",
            otherRepresentMails: "Вы можете отслеживать входящие и исходящие сообщения электронной почты на адреса электронной почты других представителей и с них",
            signatureAutoAdd: "Статус автоматического добавления подписи успешно изменен",
            autoAdd: "Автоматическое добавление",
            forwardEmailAddSucs: "Адрес переадресованной электронной почты успешно добавлен",
            errorAddingForwardEmail: "При добавлении переадресованного адреса электронной почты произошла ошибка.",
            mailAddForward: "Ручное добавление (пересылка завершена)",
            mailAddForwarding: "Ручное добавление (пересылка завершена)",
            broadcast: "Публикации",
            templates: "Шаблоны",
            newMailArrived: "Пришло новое письмо",
            mailSentSucs: "Почта отправлена успешно",
            representativeMails: "Представительская почта",
            composeNewEmail: "Составить новое письмо",
            couldNotUserMail: "Не удалось отправить почту из-за отсутствия пользовательской почты",
            mailAddressReq: "Требуется почтовый адрес.",
            emailAddressInvalid: "Почтовый адрес недействителен",
            departmentIsNotValid: "Отдел недействителен",
            mailSendNotValid: "Почтовый адрес недействителен",
            routingSteps: "Шаги маршрутизации",
            owner: "Владелец",
            whereHeDirected: "Куда он направил",
            forwardingEmailAddress: "Адрес электронной почты для пересылки",
            deleteMailDesc: "Это действие нельзя отменить.",
            deleteMailTitle: "Вы уверены, что хотите удалить этот адрес электронной почты?",
            gmailForwardMail: "Пересылка почты Gmail",
            senderMailAddressDesc: "Пожалуйста, введите адрес электронной почты отправителя",
            verified: "Подтверждено",
            notForwarded: "Не переадресовано",
            notVerified: "Не подтверждено",
            default: "По умолчанию",
            isVerified: "Проверенный",
            forwarding: "Переадресация",
            mailAdress: "Адрес электронной почты",
            addSenderAddress: "Добавить адрес отправителя",
            outlookForward: "Microsoft (Outlook/Exchange) Переадресация",
            gmailForward: "Google (Gmail) Переадресация",
            senderMail: "Адрес отправителя",
            mailDetail: "Детали письма",
            mailNotFound: "Почта не найдена",
            mailSelecting: "Выбор почты",
            newMail: "Новое письмо",
            myMails: "Мои письма",
            inbox: "Входящие",
            sent: "Отправленные",
            departmentMails: "Электронные письма отдела",
            newTemplate: "Новый шаблон",
            unread: "Непрочитанный",
            unreply: "Unanswered",
            reply: "Ответить",
            attachments: "Вложения в письме",
            To: "Кому",
            From: "От кого",
            placeHolders: "Заменители",
            attacheFiles: "Прикрепить файлы",
            replyAll: "Ответить всем",
            forward: "Переслать",
            deleteThread: "Удалить беседу",
            markAsRead: "Отметить как прочитанное",
            markAsAllRead: "Пометить все как прочитанные",
            emailEditor: "Редактор электронной почты",
            integrateYourMail: "Интегрируйте свою почту",
            connect: "Подключить",
            departmentMail: "Почта отдела",
            createMailAddress: "Создать почтовый адрес",
            createNewMail: "Создать новое письмо",
            canNotUserMail: "تعذر إرسال بريد إلكتروني لعدم وجود بريد مستخدم",
            createNewEmail: "إنشاء بريد إلكتروني جديد",
            ly: "الرد",
            operativ: "Operativ",
            ply: "Rispondi"
        },
        visitor: {
            ownership: "Собственность",
            visitors: "Посетители",
            bannedVisitors: "Заблокированные посетители",
            tags: "Теги",
            profileFields: "Поля профиля",
            downloadAll: "Скачать все",
            saveAsCustomerGroup: "Сохранить как группу клиентов",
            saveSearchFavorite: "Сохранить поиск как избранный",
            editOrDeleteFavorite: "Редактировать или удалить избранное",
            mail: "Почта",
            visitorDetail: "Детали посетителя",
            selectedUser: "Выбрано {selectedUser} из {totalUsers} пользователей",
            uncheck: "Снять все отметки",
            checkAll: "Отметить все",
            matchedUsers: "Совпадение с {checkedCount} пользователями",
            more: "Больше",
            exportUsers: "Экспортировать выбранных пользователей",
            exportAllUsers: "Экспортировать всех пользователей",
            addSegment: "Добавить сегмент",
            deleteCheckedUser: "Удалить выбранных пользователей",
            deleteAllUser: "Удалить всех пользователей",
            matchedFilter: "Совпадение всех фильтров",
            visitor: "Посетитель",
            deleteUser: "Удалить пользователя",
            userData: "Данные пользователя",
            lastSession: "Последняя сессия",
            notUserData: "Данные пользователя не найдены",
            segments: "Сегменты",
            addTag: "Добавить тег",
            userChats: "Чаты с пользователем",
            seeAll: "Показать все",
            confirm: "Подтвердить",
            manageSegments: "Управление сегментами",
            search: "Поиск",
            manageTags: "Управление тегами",
            allAttributes: "Показать все атрибуты",
            noData: "Нет данных",
            noEmail: "Нет электронной почты",
            noIpAddress: "IP адрес не найден.",
            noWpNumber: "Номер не найден.",
            filterName: "имя фильтра..",
            matchedContacts: "{chechkedCount} контакты совпадают",
            channelContacts: "Контакты канала",
            searchInAllFields: "Искать во всех полях",
            searchInName: "Искать по имени",
            importContacts: "Импорт контактов",
            addNewContact: "Добавить новый контакт",
            importContactsTitle: "Импорт контактов",
            addSingleContactTitle: "Добавить один контакт",
            downloadRecordsSettings: "Загрузка записей - Настройки",
            excelExport: "Экспорт в Excel",
            exportTotalRecords: "Всего {total} записей",
            exportCancel: "Отмена",
            whatsappContacts: "Контакты WhatsApp",
            instagramContacts: "Контакты Instagram",
            messengerContacts: "Контакты Messenger",
            linkedinContacts: "Контакты LinkedIn",
            telegramContacts: "Контакты Telegram",
            metaLeadsContacts: "Контакты MetaLeads",
            searchPlaceholderAll: "Введите здесь для поиска во всех полях",
            searchPlaceholderFullname: "Введите здесь для поиска по имени",
            searchPlaceholderEmail: "Введите здесь для поиска по email",
            searchPlaceholderPhone: "Введите здесь для поиска по телефону",
            searchPlaceholderWhatsapp: "Введите здесь для поиска по WhatsApp",
            searchPlaceholderDefault: "Поиск",
            searchFieldAll: "Все поля",
            searchFieldName: "Имя",
            searchFieldEmail: "Email",
            searchFieldPhone: "Номер телефона",
            searchFieldWhatsapp: "Номер WhatsApp",
            searchModePhoneDetected: "Обнаружен номер телефона",
            searchModeEmailDetected: "Обнаружен адрес электронной почты",
            searchModeNotPhone: "Не номер телефона",
            searchModeNotEmail: "Не email",
            searchMode: "Режим поиска",
            searchModePhoneMessage: "\"{query}\" распознан как номер телефона. Вы находитесь в поле {field}. Хотите искать в поле номера телефона?",
            searchModeEmailMessage: "\"{query}\" распознан как адрес электронной почты. Вы находитесь в поле {field}. Хотите искать в поле email?",
            searchModeNotPhoneMessage: "\"{query}\" не в формате номера телефона. Хотите искать во всех полях или в поле имени?",
            searchModeNotEmailMessage: "\"{query}\" не в формате email. Хотите искать во всех полях или в поле имени?",
            unknownTag: "Неизвестно",
            noRecordsToDownload: "Нет записей для загрузки",
            excelCreatedSuccess: "Файл Excel успешно создан",
            exportCancelled: "Экспорт отменён",
            excelCreateError: "Произошла ошибка при создании файла Excel",
            yes: "Да",
            no: "Нет",
            unowned: "Не назначено",
            whatsappGroupCreatedSuccess: "Группа клиентов WhatsApp успешно создана.",
            whatsappGroupCreateError: "Произошла ошибка при создании группы клиентов WhatsApp.",
            mailGroupCreatedSuccess: "Группа клиентов почты успешно создана.",
            mailGroupCreateError: "Произошла ошибка при создании группы клиентов почты.",
            messageHistory: "История сообщений",
            pastConversations: "Прошлые разговоры",
            defaultUser: "Пользователь",
            blockManagement: "Управление блокировкой",
            vipCustomer: "VIP-клиент",
            startChat: "Начать чат",
            createEvent: "Создать событие",
            createTask: "Создать задачу",
            selectTask: "Выберите задачу",
            webphoneCall: "Позвонить через Webphone",
            capiEventSend: "Отправить событие CAPI",
            defaultName: "Посетитель",
            notAvailable: "Н/Д",
            relatedList: "Связанный список",
            adReferrals: "Рекламные переходы",
            calls: "Звонки",
            generalInfo: "Общая информация",
            callHistory: "История звонков",
            webTab: "Веб-вкладка",
            widgetUrlError: "Не удалось создать URL виджета",
            deleteSuccess: "Посетитель успешно удален.",
            taskStatusUpdateSuccess: "Статус задачи успешно обновлен",
            taskStatusUpdateError: "Ошибка при обновлении статуса задачи",
            copyToClipboard: "Скопировано в буфер обмена",
            noPhoneNumber: "Нет номера телефона для звонка",
            webphoneCalling: "Звонок {phoneNumber} через Webphone...",
            filterResultMax5000: "Результат фильтра ограничен максимум 5000 контактами",
            onlyContactsPhoneNumber: "В группу будут перенесены только контакты с номером телефона",
            enterGroupName: "Введите название группы",
            showInColumns: "Показать в столбцах",
            sendMailSucs: "Письмо успешно отправлено",
            equal: "Равно",
            notEqual: "Не равно",
            contains: "Содержит",
            notContains: "Не содержит",
            startsWith: "Начинается с",
            endWith: "Заканчивается на",
            deletedCheckedUser: "Удалить выбранных пользователей",
            userMails: "Почта пользователей"
        },
        chatbotv2: {
            Ticket_Actions: "Действия с тикетами",
            Task_Actions: "Действия с задачами",
            Contact_Actions: "Действия с контактами",
            Calendar_Actions: "Действия с календарем",
            "T-Soft_Actions": "Действия T-Soft",
            "Ticimax-V2_Actions": "Действия Ticimax",
            TSOFT_SELECT_ORDER: "ВЫБРАТЬ ЗАКАЗ",
            TSOFT_ORDER_STATUS: "ПОЛУЧИТЬ СТАТУС ЗАКАЗА",
            TICIMAX_V2_SELECT_ORDER: "ВЫБРАТЬ ЗАКАЗ",
            TICIMAX_V2_ORDER_STATUS: "ПОЛУЧИТЬ СТАТУС ЗАКАЗА",
            Ikas_Actions: "Действия Ikas",
            IKAS_GET_MEMBER_INFO: "Получить информацию о пользователе",
            IKAS_SELECT_ORDER: "Выбрать заказ",
            IKAS_ORDER_STATUS: "Получить статус заказа",
            IDEASOFT_PRODUCT_SEARCH: "Поиск продукта",
            privateMessageDescription: "Личное сообщение могут просматривать только представители, и оно остается скрытым от посетителей.",
            AI_RANDOM_TEXT: "Случайный текст ИИ",
            AI_IMAGE: "Изображение ИИ",
            PRIVATE_MESSAGE: "Личное Сообщение",
            aiPrompt: "Запрос ИИ",
            variants: "Варианты",
            Zoho_Actions: "Действия Zoho",
            Table_Actions: "Действия с таблицами",
            Cache_Actions: "Действия с кэшем",
            File_Actions: "Действия с файлами",
            Google_Drive_Actions: "Действия Google Drive",
            Artificial_Intelligence: "Искусственный интеллект",
            Data_Formatters: "Форматировщики данных",
            Loop_Actions: "Действия цикла",
            importSuccess: "Шаблон успешно импортирован",
            importFailed: "Ошибка при импорте шаблона",
            creatingBlank: "Пустой ChatBOT создается...",
            untitledChatbot: "Без названия ChatBOT",
            errorCreating: "Ошибка при создании ChatBOT",
            typeAutomationTitle: "Введите название автоматизации",
            typeStoryTitle: "Напишите название рассказа",
            setUpYourChatbot: "Настройте свой чатбот",
            setUpYourChatbotDesc: "Обучите своего чатбота с помощью данных, используйте наши готовые шаблоны или начните с нуля",
            blankBot: "Пустой бот",
            blankBotDesc: "Создайте пустой чатбот, который вы сможете обучить и настроить позже",
            aiBotDesc: "Создайте AI-чатбот на основе RAG. Добавьте базу знаний и выберите модель LLM.",
            recommended: "Рекомендуется",
            websiteDesc: "Сканируйте содержимое вашего сайта, чтобы получить ответы на популярные вопросы пользователей.",
            yourNeedEnterYourOpenAi: "Вам нужно ввести свой ключ API OpenAI, чтобы создать автоматизированный чатбот, просканировав ваш сайт.",
            createOpenAiKey: "Создать ключ Api",
            aiKnowledge: "Знания об искусственном интеллекте",
            modalUsage: "Модальное использование",
            usedContentSources: "Используемые источники контента",
            websites: "Веб-сайты",
            articles: "Статьи",
            faq: "FAQ",
            files: "Файлы",
            functions: "Функции",
            settings: "Настройки",
            disableAi: "Отключить искусственный интеллект",
            enableAi: "Включить искусственный интеллект",
            lastEdited: "Последнее редактирование",
            state: "Состояние",
            frequentlyAskedQuestions: "Часто задаваемые вопросы (FAQ)",
            faqIsCreated: "FAQ создан",
            selectKnowEnabled: "Включение выбранных баз знаний...",
            selectKnowDisabled: "Выбранные базы знаний отключены...",
            selectKnowNotEnabled: "Выбранные базы знаний не включены...",
            selectKnowNotDisabled: "Выбранные базы знаний не отключены",
            answered: "Answered",
            answer: "Ответ",
            addFile: "Добавить файл",
            fileDeleted: "Файлы удалены",
            fileDeletedFailed: "Возникла проблема с удалением файлов",
            noFileAdded: "Файл не добавлен",
            aiFunctions: "Функции искусственного интеллекта",
            addFunction: "Добавить функцию",
            aiFunctionCreateHint: "Не используйте турецкие символы при создании функций ИИ. Используйте только английские буквы, цифры и подчёркивания в именах функций.",
            builtInFunctionsTitle: "Встроенные функции",
            builtInFunctionsDesc: "Это предопределённые функции, которые могут использоваться искусственным интеллектом.",
            builtInFunctionsOptionButtonsTitle: "ИИ может отправлять сообщения с кнопками",
            builtInFunctionsOptionButtonsDesc: "Позволяет ИИ показывать пользователю нажимаемые кнопки. Когда активно, ИИ может предлагать пользователю кнопки с вариантами.",
            builtInFunctionsCloseConversationTitle: "ИИ может завершить разговор",
            builtInFunctionsCloseConversationDesc: "Позволяет ИИ завершать разговор при необходимости. Когда активно, ИИ может закрыть чат.",
            builtInFunctionsTransferChatTitle: "ИИ может передать в службу поддержки",
            builtInFunctionsTransferChatDesc: "Позволяет ИИ передавать разговор в службу поддержки при необходимости. Когда активно, ИИ может передать разговор человеку-агенту.",
            parameterCount: "Количество параметров",
            auto: "Авто",
            usedByAI: "Используется ИИ",
            addWebhook: "Добавить веб-крючок",
            usedByAi: "Используется искусственным интеллектом",
            notUsed: "Не используется",
            saveAndClose: "Сохранить и закрыть",
            contentPreview: "Предварительный просмотр содержимого",
            addContent: "Добавить содержимое",
            populerUserQuestion: "Сканирование содержимого вашего сайта для получения ответов на популярные вопросы пользователей",
            enterUrlAddress: "Введите URL-адрес",
            sharingYourUrl: "Предоставляя свой URL-адрес, вы подтверждаете, что обладаете необходимыми правами, чтобы делиться его содержимым.",
            pageSelected: "Выбранные страницы",
            trainChatbot: "Обучить чатбота",
            thereAreOnePages: "Внутри находится 1 страница",
            categoryDesc: "Категория. Выберите, какую из них использовать для обучения вашей модели ИИ.",
            scarpOrAddContent: "Сокращайте или добавляйте контент, который AI Assist может использовать для ответа на запросы ваших клиентов.",
            noContentAdded: "Содержание не добавлено",
            howItWorks: "Как это работает",
            editEntries: "Редактировать записи",
            newEntries: "Новые поступления",
            chatbotManagement: "Управление чатбото",
            chatbotScenarioList: "Список чатботов Шенерио",
            exportDiagramToClipboard: "Экспорт диаграммы в буфер обмена",
            selectedStory: "{count} сценарий выбран",
            Meta_Actions: "Действия Meta",
            suppressionRemoved: "Ограничение удалено",
            suppressionAdded: "Ограничение добавлено",
            didntSuppression: "Вы не сделали никаких ограничений.",
            whatsappIntegrationTitle: "WhatsApp V1 и WhatsApp V2 Интеграция",
            whatsappApiIntegrationTitle: "Интеграция WhatsApp Business API",
            ReadyTemplateBadge: "Готовый шаблон",
            readyTemplates: "Готовые шаблоны",
            regex: "Regex",
            regexDescription: "Перехват всего с помощью Regex",
            chatbotLogo: "Логотип чатбота",
            chatbotName: "Имя чатбота",
            allSecnario: "Список сценариев чат-бота",
            ChatbotScenarioList: "Список сценариев чат-бота",
            Scenario: "Сценарий",
            filters: {
                equal: "равно",
                not_equal: "не равно",
                contain: "содержать",
                not_contain: "не содержать",
                starts_with: "начинается с",
                ends_with: "начинается с",
                empty: "пустой",
                non_empty: "не пустой",
                longer_than: "длиннее чем",
                shorter_than: "короче чем",
                less_than: "меньше, чем",
                less_or_equal: "меньше или равно",
                greater_than: "лучше чем",
                greater_or_equal: "больше или равно"
            },
            planRequired: "{integratable} Требуется план",
            noDefaultStoryTitle: "История по умолчанию",
            noDefaultStory: "Нет истории по умолчанию.\nХотите сделать эту историю по умолчанию?",
            noMessage: "Нет сообщений",
            loading: "Загрузка",
            loadMore: "Загрузи больше",
            hostname: "имя хоста",
            goToStory: "перейти к истории",
            noResultFound: "результатов не найдено",
            checkYourFilterCombination: "Проверьте комбинацию фильтров",
            clearYourSearch: "очистите свой поиск",
            andTryAgain: "и попробуй еще раз",
            withBot: "& бот",
            userWithBot: "Пользователь & бот",
            chatDetail: "Детали чата",
            allUserDetail: "Посмотреть все данные о пользователе",
            sessionData: "Данные сеанса",
            supsisChatWidget: "Виджет Supsis Chat",
            integratedWith: "Интегрировано с : ",
            botStory: "История бота",
            integration: "Интеграции",
            Users: "пользователи",
            user_id: "ID пользователя",
            allTemplates: "Все шаблоны",
            allAITemplates: "Все шаблоны ИИ",
            templatesFromTheIndustry: "Шаблоны из отрасли",
            basicTemplate: "Базовый шаблон",
            proTemplate: "Расширенный шаблон",
            categories: "Категории",
            worksWith: "Работает с",
            importBot: "Импорт бота",
            keyFeatures: "Ключевая особенность",
            importing: "импорт",
            comingSoon: "Вскоре",
            cardInfos: "информация о карте",
            pickStory: "Выбери историю",
            conversationId: "Идентификатор беседы",
            integrateStoryWithSupsisWidget: "Интегрируйте виджет Supsis с историей чат-бота",
            integrateStoryWithWhatsapp: "Интегрируйте WhatsApp с историей чат-бота",
            integrateStoryWithInstagram: "Интегрируйте Instagram с историей чат-бота",
            selectIntegratingStory: "Выберите историю, которая будет интегрирована",
            install: "Установить",
            attr: {
                weekday: "Weekday",
                channelId: "Channel",
                email: "Эл. адрес",
                phone: "Phone",
                language: "Язык",
                timezone: "Часовой пояс",
                gender: "Пол",
                country: "Страна",
                department: "Отдел",
                referrer: "Реферер",
                url: "URL-адрес",
                ip: "IP",
                last_seen: "Last Видимый",
                name: "Имя",
                user_id: "ID пользователя",
                message: "Message",
                akinon_brand: "Бренд",
                akinon_order_id: "Номер заказа",
                akinon_product_id: "Код товара",
                akinon_user_id: "ID пользователя",
                akinon_user_name: "Имя пользователя",
                akinon_user_email: "Электронная почта пользователя",
                akinon_invoice_url: "URL счета",
                akinon_order_status: "Статус заказа",
                akinon_order_price: "Стоимость заказа",
                akinon_shipper_name: "Имя грузоотправителя",
                akinon_product_size: "Размер товара",
                akinon_sku: "Артикул",
                akinon_product_url: "URL продукта",
                akinon_product_title: "Название продукта",
                akinon_product_image: "Изображение продукта",
                akinon_product_stock: "Товарный запас",
                akinon_order_date: "Дата заказа",
                akinon_track_number: "Номер дорожки",
                akinon_track_url: "URL отслеживания",
                akinon_latitude: "Широта",
                akinon_longitude: "Долгота",
                idleUserTime: "Последнее действие пользователя (секунд)",
                ai_class_result: "Результат класса ИИ",
                meta_comment_id: "ID комментария Meta",
                meta_comment: "Комментарий Meta",
                meta_post_id: "ID поста Meta",
                last_meta_post_id: "Последний идентификатор поста",
                last_meta_post_caption: "Последний заголовок поста",
                last_meta_post_type: "Последний тип поста",
                visitor_trigger_type: "Тип триггера посетителя",
                visitor_trigger_name: "Имя триггера посетителя",
                ideasoft_user_id: "ID участника",
                ideasoft_invoice_url: "URL счета-фактуры",
                ideasoft_order_id: "Номер заказа",
                ideasoft_order_status: "Статус заказа",
                ideasoft_order_price: "Цена заказа",
                ideasoft_shipper_name: "Имя грузоотправителя",
                ideasoft_product_size: "Размер товара",
                ideasoft_sku: "Артикул (SKU)",
                ideasoft_product_url: "URL товара",
                ideasoft_product_title: "Название товара",
                ideasoft_product_image: "Изображение товара",
                ideasoft_product_stock: "Запас товара",
                ideasoft_order_date: "Дата заказа",
                ideasoft_track_number: "Номер отслеживания",
                ideasoft_track_url: "URL отслеживания",
                offline_mode: "Автономный режим",
                available_agents: "Доступные представитель",
                probel_sube_kodu: "Код филиала",
                probel_brans_adi: "Название отделения",
                probel_brans_kodu: "Код отделения",
                probel_doktor_adi: "Имя врача",
                probel_doktor_kodu: "Код врача",
                probel_poliklinik_adi: "Название поликлиники",
                probel_poliklinik_kodu: "Код поликлиники",
                probel_randevu_tarihi: "Дата записи",
                probel_date: "Дата записи",
                probel_randevu_saati: "Время записи",
                probel_randevu_id: "ID записи",
                probel_hasta_token: "Токен пациента",
                probel_kimlik_tipi: "Тип удостоверения личности",
                probel_kimlik_no: "Номер удостоверения личности",
                probel_hasta_adi: "Имя пациента",
                probel_hasta_soyadi: "Фамилия пациента",
                probel_hasta_cinsiyet: "Пол",
                probel_hasta_dogum_tarihi: "Дата рождения",
                probel_hasta_telefon: "Телефон",
                platform: "Платформа",
                hour: "Час",
                segments: "Сегменты",
                tags: "Теги",
                ticket: "билет",
                metaReferrals: "Мета-рефералы",
                owner: "Владелец",
                trendyol_question: "Вопрос о товаре",
                trendyol_question_id: "ID вопроса о товаре",
                trendyol_product_id: "ID товара",
                trendyol_product: "Данные о товаре",
                id: "ID",
                conversationId: "ID разговора",
                b2cargo_companyCode: "Код компании",
                b2cargo_takipNo: "Номер отслеживания",
                b2cargo_takipseri: "Серия отслеживания",
                b2cargo_evrakdurum: "Статус заказа",
                b2cargo_teslimtar: "Дата доставки",
                b2cargo_gonderen: "Имя отправителя",
                b2cargo_aliciAdi: "Имя получателя",
                b2cargo_cikisIl: "Провинция отправления",
                b2cargo_varisIl: "Провинция прибытия",
                b2cargo_teslim: "Статус товара",
                b2cargo_urun: "Тип товара",
                b2cargo_atfTarih: "Дата ATF товара",
                b2cargo_palet: "Паллета товара",
                b2cargo_koli: "Посылка товара",
                b2cargo_kg: "Вес товара",
                b2cargo_desi: "Деси товара",
                b2cargo_zimmetno: "Номер дебета",
                b2cargo_varissube: "Филиал прибытия",
                b2cargo_atfDurum: "Статус ATF",
                holiday_plus_room_id: "ID номера",
                holiday_plus_room_title: "Название номера",
                holiday_plus_room_description: "Описание номера",
                holiday_plus_room_size: "Размер номера",
                holiday_plus_room_price: "Цена номера",
                holiday_plus_room_price_offer: "Ценовое предложение номера",
                holiday_plus_room_discount_price: "Цена номера со скидкой",
                holiday_plus_selected_hotel_id: "ID выбранного отеля",
                holiday_plus_checkin: "Заезд",
                holiday_plus_checkout: "Выезд",
                holiday_plus_child_count: "Количество детей",
                holiday_plus_adult_count: "Количество взрослых",
                holiday_plus_child_dates: "Даты рождения детей",
                reservation_time: "Время бронирования",
                reservation_day: "День бронирования"
            },
            storyList: "Список историй",
            douYouWannaDeleteItem: "Вы хотите удалить этот элемент?",
            douYouWannaDeleteWithChildren: "Вы хотите удалить этот элемент вместе с его дочерними элементами?",
            stories: "Рассказы",
            templates: "Шаблоны",
            aitemplates: "Шаблоны ИИ",
            integrations: "Интеграции",
            all: "Все",
            installed: "Установлены",
            installationOK: "установлены",
            uninstall: "Удалить",
            remainingMessageDesc: "Осталось бесплатных сообщений : ",
            openAISiteRoutingDescStart: "Вы можете щелкнуть ссылку ",
            openAISiteRoutingDescEnd: " чтобы получить ключ API.",
            integrationOK: "Интегрированный",
            chatWidget: "Supsis Виджет чата",
            artificialIntelligence: "Искусственный интеллект",
            integratePlatform: "Чат-бот может быть интегрирован с {integretable}.",
            integrateOpenAIWithChatbot: "Интеграция чата GPT-4 с чат-ботом",
            integrateChatBotWithChatGPT3: "Интеграция ChatBot с Chat GPT-4",
            integrateStoryWithTelegram: "История интеграции с Telegram",
            webhooks: "вебхуки",
            archive: "Архив",
            reports: "Отчеты",
            uncheckAll: "Снять все",
            userSegments: "Сегменты пользователей",
            sandbox: "Корзина",
            sandboxPage: {
                title: "Удалённые сценарии чат-бота",
                description: "Ваши удалённые сценарии будут автоматически удалены через 30 дней в корзине",
                emptyState: "В корзине нет удалённых сценариев",
                unnamedScenario: "Сценарий без названия",
                restore: "Восстановить",
                permanentlyDelete: "Удалить навсегда",
                unknown: "Неизвестно",
                user: "Пользователь",
                restoreConfirmTitle: "Вы уверены, что хотите восстановить этот сценарий?",
                restoreConfirmContent: "Сценарий {story} будет восстановлен.",
                restoreSuccess: "Сценарий успешно восстановлен",
                restoreError: "Ошибка восстановления",
                permanentDeleteConfirmTitle: "Вы уверены, что хотите навсегда удалить этот сценарий?",
                permanentDeleteConfirmContent: "Это действие нельзя отменить. Сценарий будет удалён навсегда.",
                permanentDeleteSuccess: "Сценарий удалён навсегда",
                permanentDeleteError: "Ошибка операции удаления",
                loadError: "Ошибка загрузки удалённых сценариев"
            },
            customBlocks: "Пользовательские блоки",
            blockMarket: "Рынок блоков",
            browseBlockMarket: "Обзор рынка блоков",
            searchBlocks: "Поиск блоков...",
            unknownBlock: "Неизвестный блок",
            aiModelsComparison: "Сравнение моделей ИИ",
            aiModelsChangeModel: "Изменить модель",
            aiModelsRecommended: "Рекомендуемый",
            aiModelsEconomic: "Экономичный",
            aiModelsCodex: "Codex",
            comingSoonVectorIntro: "С OpenAI Vector Storage вы можете обучить чат-бота своим контентом.",
            comingSoonStep1Title: "Загрузите файлы",
            comingSoonStep1Desc: "Добавьте PDF, Word, Excel, текстовые файлы или другие документы в систему.",
            comingSoonStep2Title: "Автоматическая обработка",
            comingSoonStep2Desc: "Ваши файлы анализируются OpenAI и преобразуются в векторный формат.",
            comingSoonStep3Title: "Умные ответы",
            comingSoonStep3Desc: "Ваш чат-бот даёт точные и осмысленные ответы на основе загруженного контента.",
            comingSoonTip: "Совет: Чем больше контента вы добавляете, тем больше расширяется база знаний чат-бота и тем полнее ответы.",
            comingSoonGotIt: "Понятно",
            imageProcessingSettings: {
                title: "Настройки обработки изображений",
                description: "Определите, как будут обрабатываться изображения, отправленные в чат-бот.",
                processingMode: "Режим обработки",
                processWithBlock: "Обрабатывать блоком",
                processWithBlockDesc: "Направлять изображения в локальный поток блоков",
                processWithAI: "Обрабатывать ИИ",
                processWithAIDesc: "Обрабатывать изображения с помощью искусственного интеллекта",
                fallbackBlock: "Резервный блок",
                fallbackBlockDesc: "Блок для перенаправления при ошибке во время обработки изображений",
                fallbackBlockPlaceholder: "Выберите резервный блок",
                directJumpBlock: "Блок прямого перехода",
                directJumpBlockDesc: "Направлять все изображения напрямую в этот блок",
                directJumpBlockPlaceholder: "Выберите блок прямого перехода (необязательно)",
                aiProcessingMode: "Режим обработки ИИ",
                processIndividual: "Обрабатывать по одному",
                processIndividualDesc: "Отправлять каждое изображение в ИИ отдельно",
                processParallel: "Обрабатывать параллельно",
                processParallelDesc: "Собирать изображения в течение определённого времени и отправлять вместе",
                bufferTime: "Длительность буфера (секунды)",
                bufferTimeDesc: "Время ожидания для сбора изображений",
                saveSuccess: "Настройки обработки изображений успешно обновлены",
                saveError: "Ошибка при сохранении настроек"
            },
            addSegment: "Добавить сегмент",
            addToSegment: "Добавить в сегмент",
            removeFromSegment: "Удалить из сегмента",
            plansVTippyContent: "Оплата за этот пакет будет производиться в начале каждого месяца. В случае отмены использование будет оплачено до начала следующего расчетного месяца, после чего пакет истечет.<br><br>Цена пакета не включает НДС.<br><br>Изменения в пакете отражаются в счете на следующий день.",
            segmentName: "Название сегмента",
            sameSegment: "Сегмент с таким названием уже существует!",
            usersInSegment: "Пользователи в сегменте",
            noUsersAdded: "Пользователи не добавлены",
            updateSegment: "Обновить сегмент",
            newSegment: "Новый сегмент",
            selectAll: "Выбрать все",
            queriesSelected: "выбранные запросы",
            noBlocksFound: "Блоки не найдены!",
            userQuery: "Пользовательский запрос",
            date: "Дата",
            unmatched: "Бесподобный",
            goToChat: "Перейти в чат",
            selectStory: "Выберите историю",
            selectBlock: "Выберите блок",
            training: "Подготовка",
            trainingAlert: "Для внедрения изменений, которые вы внесли на странице обучения бота, вам необходимо опубликовать новую версию сценария, который вы изменили",
            unmatchedPhrases: "Непревзойденные фразы",
            ignored: "Игнорируется",
            story: "История",
            timePeriod: "Временной период",
            wholeTimeSpan: "Весь промежуток времени",
            selectAStory: "Выберите историю",
            searchUserQuery: "Поисковый запрос пользователя",
            time: {
                today: "Сегодня",
                yesterday: "Вчерашний день",
                last7: "Последние 7 дней",
                last30: "Последние 30 дней",
                "this-month": "Этот месяц",
                "last-month": "Прошлый месяц",
                "last-3-month": "Последние 3 месяца",
                "this-year": "В этом году",
                "last-year": "Прошедший год",
                custom: "Выберите другую дату"
            },
            emailProvider: "Провайдер электронной почты",
            triggerFromAnywhere: "Запуск из любого места",
            editBlock: "Редактировать",
            moveBlock: "Шаг",
            copyBlock: "Копировать",
            chatbot: "чат-бот",
            addFilter: "Добавить фильтр",
            addFilterGroup: "Добавить группу фильтров",
            clearFilter: "прозрачный фильтр",
            in: "в",
            and: "а также",
            or: "вейя",
            allStories: "Все истории",
            addBot: "Добавить бота",
            testBot: "Протестируйте бота",
            publish: "Публиковать",
            editName: "Редактировать название",
            search: "Найдите в своей истории…",
            typeMoreThan3Char: "Введите не менее 3 символов",
            expand: "Расширять",
            expandAll: "Расширять все",
            noMatchingItem: "Нет подходящего товара",
            hint: "Намекать",
            select: "Выбрать",
            navigate: "Навигация",
            dismiss: "Увольнять",
            choseAttribute: "Выберите тип атрибута",
            selectReply: "Выберите тип ответа",
            preview: "Предварительный просмотр",
            draft: "Черновик",
            lastUpdate: "Последнее обновление",
            published: "Опубликовано",
            newStory: "Новая история",
            updateStory: "Обновить историю",
            storyDescription: "Описание истории",
            storyTitle: "Название рассказа",
            deleteSingleBlock: "Удалить отдельный блок",
            deleteWithChildren: "Удалить с детьми",
            startTestFromHere: "Начать тест отсюда",
            copyBlockId: "Копировать ID блока",
            gotoLiveLink: "Перейти по прямой ссылке",
            copyBlockIdSuccessfull: "ID блока скопирован в буфер обмена",
            collapse: "Свернуть",
            collapseAll: "Свернуть все",
            snDelay: "{delay} сек задержка",
            blockUpdated: "Блок обновлен",
            addPayload: "Добавить полезную нагрузку",
            previewModeCaution: "Сейчас вы просматриваете одну из версий вашей истории. Вы не можете сохранить изменения в режиме предварительного просмотра!",
            enterText: "Введите текст...",
            trackpad: "Трекпад",
            navigation: "Навигация",
            navigationDesc: "Пожалуйста, выберите режим навигации. Вам решать, будет ли это трекпад или мышь.",
            botSetting: "Настройка бота",
            botSettingDesc: "Пожалуйста, определите уровень доверия. Это процент от 0 до 100. Уровень определяет правильность интерпретаций чат-ботов, связанных с вводом данных пользователем.",
            languageSettingsDesc: "Пожалуйста, убедитесь, что язык бота, на который он отвечает, является вашим предпочтительным языком.",
            mouse: "мышь",
            Interactions: "Взаимодействия",
            Actions: "Действия",
            Supsis_Actions: "Supsis Действия",
            Shopify_Actions: "Shopify Действия",
            Akinon_Actions: "Akinon Действия",
            IdeaSoft_Actions: "Действия Ideasoft",
            START_POINT: "ТОЧКА ОТСЧЕТА",
            AI_ASSISTANT: "ИИ-ПОМОЩНИК",
            BOT_RESPONSE: "ОТВЕТ БОТА",
            AI_BOT_RESPONSE: "ОТВЕТ ИИ (GPT-4o)",
            AI_CLASSIFICATION: "КЛАССИФИКАЦИЯ ИИ",
            Templates: "Блоки шаблонов",
            AI_MENU_FLOW: "ИИ МЕНЮ",
            OTP_WHATSAPP_FLOW: "OTP WhatsApp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP Почта",
            AI_INSTAGRAM_FLOW: "КОММЕНТАРИЙ ИИ INSTAGRAM",
            PLATFORM_FLOW: "ПЛАТФОРМА",
            DEFAULT_FALLBACK: "ВОЗВРАТ ПО УМОЛЧАНИЮ",
            FILTER: "ФИЛЬТР",
            addNewFilter: "Добавить новый фильтр",
            FLOW: "ПОТОК",
            ATTACHMENT_INPUT: "ПРИЛОЖЕНИЕ ВВОД",
            USER_INPUT: "ВВОД ПОЛЬЗОВАТЕЛЯ",
            GO_TO_STEP: "ПЕРЕЙТИ К ШАГУ",
            WEBHOOK: "ВЕБХУК",
            SET_ATTRIBUTE: "УСТАНОВИТЬ АТРИБУТ",
            QUESTION: "ВОПРОС",
            CLOSE_CHAT: "ЗАКРЫТЬ ЧАТ",
            CREATE_TICKET: "СОЗДАТЬ ЗАЯВКУ",
            TRANSFER_CHAT: "ТРАНСФЕРНЫЙ ЧАТ",
            TICKET_UPDATE: "ОБНОВЛЕННЫЙ TICKET",
            TRANSFER_TO_CHATBOT: "ПЕРЕНАПРАВИТЬ В ЧАТ-БОТ",
            TAG_CHAT: "ДОБАВИТЬ ТЕГ",
            REMOVE_TAG: "УДАЛИТЬ ТЕГ",
            SET_DEPARTMENT: "УСТАНОВИТЬ ОТДЕЛ",
            SEND_TRANSCRIPT: "ОТПРАВИТЬ ЗАПИСЬ",
            SEND_SMS: "ОТПРАВИТЬ SMS",
            SEND_MAIL: "ОТПРАВИТЬ ПОЧТУ",
            CREATE_EVENT: "СОЗДАТЬ СОБЫТИЕ",
            CREATE_RESERVATION: "СОЗДАТЬ БРОНИРОВАНИЕ",
            RESERVATION_OPEN_URL: "URL открытия бронирования",
            RESERVATION_SELECT_DAY: "Выберите день бронирования",
            RESERVATION_EVENT_LIST: "Список бронирований посетителя",
            RESERVATION_SELECT_TIME: "Выберите время бронирования",
            CREATE_TASK: "СОЗДАТЬ ЗАДАЧУ",
            SHOPIFY_SHOW_PRODUCTS: "ПОКУПАТЬ ПОКАЗАТЬ ПРОДУКЦИЮ",
            SHOPIFY_PRODUCT_AVAILABILITY: "ПОКУПАЙТЕ НАЛИЧИЕ ПРОДУКТА",
            SHOPIFY_ORDER_STATUS: "ПОКУПАТЬ СТАТУС ЗАКАЗА",
            AKINON_SHOW_PRODUCTS: "АКИНОН ПОКАЗАТЬ ПРОДУКТЫ",
            AKINON_FIND_PRODUCT: "AKINON НАЙТИ ТОВАР",
            AKINON_ORDER_STATUS: "СТАТУС ЗАКАЗА AKINON",
            AKINON_SELECT_ORDER: "AKINON ВЫБРАТЬ ЗАКАЗ",
            AKINON_SELECT_SIZE: "AKINON ВЫБРАТЬ РАЗМЕР",
            AKINON_FIND_NEAREST_STOCK: "ПОКАЗАТЬ ЗАПАСЫ В МАГАЗИНЕ",
            AKINON_FIND_NEAREST_STORES: "ПОКАЗАТЬ БЛИЖАЙШИЕ МАГАЗИНЫ",
            AKINON_SHOW_DISCOUNT_CODES: "ПОКАЗАТЬ КОДЫ СКИДОК",
            IDEASOFT_SELECT_ORDER: "ВЫБРАТЬ ЗАКАЗ",
            IDEASOFT_ORDER_STATUS: "ПОЛУЧИТЬ СТАТУС ЗАКАЗА",
            IDEASOFT_GET_MEMBER_INFO: "ЗАПОЛНИТЬ ИНФО УЧАСТНИКА",
            MESSENGER_SEND_MESSAGE: "ОТПРАВИТЬ СООБЩЕНИЕ MESSENGER",
            INSTAGRAM_SEND_MESSAGE: "ОТПРАВИТЬ СООБЩЕНИЕ INSTAGRAM",
            INSTAGRAM_COMMENT_REPLY: "ОТВЕТИТЬ НА КОММЕНТАРИЙ",
            INSTAGRAM_COMMENT_DELETE: "УДАЛИТЬ КОММЕНТАРИЙ",
            INSTAGRAM_COMMENT_SHOW: "ПОКАЗАТЬ КОММЕНТАРИЙ",
            INSTAGRAM_COMMENT_HIDE: "СКРЫТЬ КОММЕНТАРИЙ",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "ОТВЕТИТЬ В ЛИЧНЫХ СООБЩЕНИЯХ",
            followingAttributesFilled: "Будут заполнены следующие атрибуты.",
            GET_LOCATION: "ПОЛУЧИТЬ МЕСТОПОЛОЖЕНИЕ",
            FALLBACK: "ОТСТУПАТЬ",
            SUCCESS: "УСПЕХ",
            FAILURE: "ОТКАЗ",
            message: "сообщение",
            condition: "условие",
            score: "счет",
            equal: "равный",
            not_equal: "не равный",
            contain: "содержать",
            not_contain: "не содержать",
            starts_with: "начинается с",
            ends_with: "заканчивается",
            empty: "пустой",
            longer_than: "длиннее чем",
            shorter_than: "короче чем",
            less_than: "меньше, чем",
            less_than_equal: "меньше, чем равно",
            greater_than: "лучше чем",
            greater_than_equal: "больше, чем равно",
            value: "ценность",
            failures: "неудачи",
            email: "Эл. адрес",
            name: "имя",
            username: "имя пользователя",
            source: "источник",
            language: "язык",
            timezone: "часовой пояс",
            region: "область, край",
            country: "страна",
            referrer: "реферер",
            url: "URL",
            ip: "IP",
            city: "город",
            lastSeen: "последний раз видели",
            userId: "ID пользователя",
            selectStep: "выберите шаг",
            keywords: "ключевые слова",
            userSays: "пользователи говорят",
            addKeyword: "Добавить слово",
            addUserMessage: "аддусермессаже",
            set: "установлен",
            to: "к",
            gender: "Пол",
            go_to_failure: "Идти к провалу",
            go_to_success: "Идти к успеху",
            untilFilled: "До заполнения",
            time1: "однажды",
            time2: "время 2",
            time3: "время 3",
            time4: "время 4",
            time5: "время 5",
            any: "Любые",
            anytext: "Любой текст",
            anytextDescription: "Соответствует только словам и пробелам",
            alphanumeric: "буквенно-цифровой",
            integer: "Целое число",
            no: "Нет",
            number: "Число",
            phone: "Телефон",
            yes: "Да",
            yesNo: "Да нет",
            anyDescription: "Соответствует всему, что не пусто.",
            alphanumericDescription: "Соответствует буквам и цифрам.",
            integerDescription: "Соответствует целому числу.",
            noDescription: "Нет синонимов.",
            numberDescription: "Соответствует порядковому и количественному числительному.",
            phoneDescription: "Соответствует номеру телефона.",
            yesDescription: "Соответствует да синонимам.",
            yesNoDescription: "Соответствует синонимам 'да' и 'нет'.",
            emailDescription: "Соответствует электронной почте.",
            urlDescription: "Соответствует URL.",
            temperature: "Температура",
            askWhenInvalid: "спросить, когда недействительно",
            applyFilter: "Применение фильтра",
            RANDOM_TEXT: "Случайный текст",
            QUICK_REPLY: "Быстрый ответ",
            FILE: "File",
            notificationMessageStartSuccess: "Блокировать ",
            notificationMessageEndSuccess: " Добавлен",
            notificationMessageStartError: "Произошла ошибка, заблокируйте ",
            notificationMessageEndError: " не удалось добавить",
            blockChangedWannaUpdate: "Я хочу изменить обновление",
            responses: "Ответы",
            TEXT: "текст",
            IMAGE: "Изображение",
            GALLERY: "Галерея",
            BUTTON: "Кнопка",
            flow: "Поток",
            active: "активный",
            passive: "пассивный",
            chooseAttributeType: "Выберите тип функции",
            imageAttachment: "Вложение изображения",
            audioAttachment: "Аудио вложение",
            videoAttachment: "Видео вложение",
            documentAttachment: "Приложение к документу",
            anyAttachment: "Любое вложение",
            typeAttributeValue: "Тип Атрибут Значение",
            typeSearchValue: "Введите значение поиска",
            male: "мужчина",
            addAttribute: "Добавить атрибут",
            addAttributeDescription: "Имя атрибута может содержать только буквенно-цифровые символы, такие как буквы A-Z, цифры 0-9, тире или подчеркивание.",
            USER_DATA: "информация о пользователе",
            CUSTOM_ATTRIBUTES: "ПОЛЬЗОВАТЕЛЬСКИЕ АТРИБУТЫ",
            enterBotResponseHere: "Введите ответ бота здесь...",
            enterPrivateBotResponseHere: "Введите личное сообщение, которое отправит бот ...",
            addCard: "Добавить карту",
            addButton: "Добавить кнопку",
            typeCardTitle: "Заголовок типа этажа",
            typeCardDescription: "Тип карты Содержание",
            dragAndDropBrowse: "Загрузить изображение",
            dragAndDropBrowseFile: "Загрузить файл",
            button: "Кнопка",
            enterYourMessage: "Введите сообщение",
            imageView: "Просмотр изображения",
            imageUploading: "Загрузка изображения...",
            fileUploading: "Загрузка файла...",
            clickToChooseNewImage: "Нажмите, чтобы выбрать новое изображение",
            clickToChooseNewFile: "Нажмите, чтобы выбрать новый файл",
            removeTheExistingOne: "Удалить существующий",
            validateResponseWithEntity: "Подтвердить ответ",
            actionOnFailureInput: "Действия при неудачном входе в систему",
            askNextQuestion: "Задайте следующий вопрос",
            goToSuccessBlock: "Перейти в свой блог успеха",
            goToFailureBlock: "Перейти к неудавшемуся блоку",
            saveResposeToAttribute: "Сохранить ответ",
            selectReplyType: "Выберите тип ответа",
            questionVariants: "Типы вопросов",
            systemEntities: "система Сущности",
            delay: "задерживать",
            retrySectionTextPart: "Спросите ",
            retrySectionText: " , не является ли ответ пользователя недействительным",
            addNextQuestion: "добавить следующий вопрос",
            typeBlockTitle: "введите заголовок блока",
            versionHistory: "история версий",
            restore: "история",
            versionName: "Название версии",
            restoreModalText: "Это действие восстановит выбранную версию. Вы уверены, что хотите восстановить эту версию?",
            restoreVersion: "Восстановить версию",
            newVersion: "Новая версия",
            synonymMustBeUnique: "Синоним должен быть уникальным",
            save: "Сохранять",
            entries: "Записи",
            youHaveNoEntries: "У вас нет записей",
            inputsCantBeEmpty: "Входы не могут быть пустыми",
            entryNamesMustBeUnique: "Имена записей должны быть уникальными",
            entityNameCantBeEmpty: "Сущность не может быть пустой",
            entityNameMustBeUnique: "Имя объекта должно быть уникальным",
            synonyms: "синонимы",
            entities: "Сущности",
            title: "заглавие",
            entryName: "имя_записи",
            entityhasbeenUpdatedSuccessfully: "Сущность успешно обновлена",
            allChats: "все чаты",
            paidChats: "платные чаты",
            busiestPeriod: "Самый загруженный период",
            ratingDistribution: "Распределение рейтинга",
            allMessages: "Все сообщения",
            avarageMessages: "Среднее количество сообщений",
            popularity: "популярность",
            allUsers: "Все пользователи",
            interactionName: "Название взаимодействия",
            numberOfMessage: "Номер сообщения",
            ofAllUsersMessage: "% всех сообщений пользователей",
            totalData: "Всего данных",
            avgData: "Средние данные",
            exportToCsv: "Экспорт в CSV",
            exportToExcel: "Экспорт в Excel",
            inMaintenance: "в обслуживании",
            ADD_TO_SEGMENT: "добавить в сегмент",
            REMOVE_FROM_SEGMENT: "удалить из сегмента",
            users: "пользователи",
            webhookName: "Имя вебхука",
            webHookUrl: "URL вебхука",
            webHookToken: "Token",
            delete: "Удалить",
            basicAuth: "Базовая авторизация",
            requiredFieldsCannotBeLeftBlank: "Обязательные поля нельзя оставлять пустыми",
            yourVerificationToken: "Token",
            yourWebHookName: "Ваше имя вебхука",
            yourWebHookUrl: "URL вашего вебхука",
            enterKey: "Key",
            password: "Пароль",
            headerValue: "Value",
            saveSuccessfully: "ваша транзакция успешно сохранена",
            urlTypeError: "Пожалуйста, заполните поле правильно (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "Требуется ключ OpenAI Chat GPT-4 API.",
                apiKeyDesc: "Для интеграции Chatbot + Chat GPT-4 требуется ключ Api. Пожалуйста, получите ключ API или используйте приведенный ниже ключ API для пробной версии. Вы можете использовать только 20 сообщений для пробной версии.",
                getApiKey: "Получить ключ Openai API",
                typeApiKey: "Введите ключ API",
                ownApiKey: "Собственный ключ API OpenAI",
                trialApiKey: "Пробный ключ API (ограничено 20 сообщениями)",
                useOurTrial: "Воспользуйтесь нашей бесплатной пробной версией",
                twentyMessages: "Вы можете попробовать, используя 20 сообщений бесплатно.",
                enableChatGpt3: "Включить чат GPT-4"
            },
            YouTube_Actions: "Действия YouTube",
            Google_Business_Actions: "Действия Google Business",
            Google_Play_Actions: "Действия Google Play",
            App_Store_Actions: "Действия App Store",
            META_SEND_CAPI_EVENT: "ОТПРАВИТЬ CAPI EVENT",
            META_SEND_CAPI_EVENTDesc: "Отправляет события конверсии для оптимизации рекламы через Meta Conversions API (CAPI). Помогает повысить эффективность рекламы в Instagram и Messenger.",
            CUSTOM_BLOCK: "Пользовательский блок",
            CUSTOM_BLOCKDesc: "Выполнение пользовательского JavaScript-кода с настраиваемыми параметрами. Расширьте чат-бота блоками из маркетплейса.",
            exampleOutput: "Пример вывода",
            outputSchema: "Схема вывода (JSON)",
            FEEDBACK_AI_ASSISTANTDesc: "ИИ-ассистент Supsis AI — решение для оптимизации поддержки клиентов и бизнес-процессов. Обеспечивает круглосуточную поддержку, автоматически отвечает на запросы, поддерживает несколько языков и интеграции с WhatsApp, Instagram и Facebook. Помогает в продажах, маркетинге и записи на приём, повышает удовлетворённость клиентов. Повышает эффективность и снижает затраты за счёт быстрой и точной передачи информации.",
            INSERT_TO_SYSTEM_PROMPTDesc: "Блок «Вставить в системную инструкцию» позволяет чат-боту вставлять сообщение в системную инструкцию (system prompt). Сообщение вставляется в указанную позицию, что позволяет динамически изменять поведение ИИ в ходе диалога.",
            API_REQUESTDesc: "Этот блок определяет структуру и параметры, используемые для отправки запроса к API. URL-адрес запроса API указывает адрес, куда будут отправлены данные, а метод (GET, POST и т. д.) определяет тип запроса. Заголовки включают информацию об аутентификации и типе контента, тип тела определяет формат отправляемых данных, а раздел тела содержит основные данные для отправки в API. Наконец, пример ответа показывает ожидаемый ответ от API. Этот блок упрощает интеграцию API и автоматизирует обмен данными.",
            BOT_RESPONSEDesc: "Блок «Ответ бота» расширяет взаимодействие, отвечая пользователю контентом различных типов: текст, изображения и файлы. Этот блок используется для отправки обычных текстовых сообщений (Text), случайно выбранных вариантов текста (Random Text), изображений (Image) или файлов (File). Он также поддерживает кнопочные ответы: «Галерея» (Gallery) отображает карточки с изображениями и описаниями; «Кнопка» (Button) предлагает варианты, которые сохраняются на всех платформах; «Быстрый ответ» (Quick Reply) позволяет пользователю сделать выбор, после чего кнопки исчезают. Галерея поддерживает неограниченное количество кнопок на веб-сайте, в то время как в WhatsApp можно отправить только одну карточку. В Instagram и Messenger каждая карточка галереи отправляется отдельным сообщением.",
            TAVILY_WEB_SEARCHDesc: "Веб-поиск позволяет получать информацию с различных веб-сайтов через системы на базе ИИ. При вводе поискового запроса сканируются наиболее релевантные результаты на основе указанной глубины поиска, предоставляя информацию, адаптированную к потребностям пользователя. Также могут быть включены необработанный контент, изображения и описания изображений для более комплексной передачи информации. Кроме того, полученные данные могут быть обобщены или представлены в исходном виде. Пользователи могут фильтровать результаты поиска, включая определенные домены, обеспечивая доступ к информации из самых надежных источников. Таким образом, веб-поиск на базе ИИ оптимизирует процесс получения быстрой и точной информации.",
            AI_BOT_RESPONSEDesc: "Эта система позволяет ИИ генерировать персонализированные ответы на основе ввода пользователя и заранее определенных инструкций; она предоставляет точные и исчерпывающие ответы, используя заранее подготовленные шаблоны, и записывает отзывы пользователей для улучшения будущих ответов.",
            AI_CLASSIFICATIONDesc: "Блок классификации ИИ анализирует сообщения пользователей и распределяет их по заранее определенным категориям, автоматически запуская соответствующие действия. Автоматическая классификация обеспечивает правильную маршрутизацию на основе содержания сообщения, а гибкое управление категориями позволяет добавлять или редактировать их. Классифицированные данные фильтруются для принятия наиболее подходящих действий на основе запросов пользователей. Кроме того, через этот блок можно классифицировать сообщения и комментарии Instagram, что позволяет автоматизировать ответы или действия.",
            DEFAULT_TIMEOUTDesc: "Тайм-аут по умолчанию срабатывает в начале сценария и имеет приоритет, если он короче длительности локального тайм-аута; чтобы использовать только локальный тайм-аут, значение по умолчанию необходимо удалить. Длительность тайм-аута не может превышать длительность сессии, и несколько тайм-аутов могут использоваться в сочетании с пользовательским вводом. Эта структура, срабатывающая при отсутствии ответа от пользователя, подходит для отправки напоминаний или перезапуска определенных потоков.",
            FILTERDesc: "Платформа Supsis AI позволяет чат-ботам фильтровать данные пользователей на основе настраиваемых атрибутов, информации о пользователе (имя, почта, телефон, язык, часовой пояс, пол и т. д.) и профиля посетителя (страна, IP, реферер, адрес визита и т. д.). Операции фильтрации позволяют создавать сложные условия с использованием операторов «И» и «ИЛИ»; например, предоставление живой поддержки в рабочее время или специальные ответы для определенных стран. Эти функции анализируют поведение пользователей, позволяя боту давать персонализированные и эффективные ответы.",
            ATTACHMENT_INPUTDesc: "Блок «Ввод файла» позволяет чат-боту безопасно сохранять и генерировать ссылку для скачивания файлов, полученных от пользователей; эта ссылка может быть передана через такие каналы, как электронная почта или WhatsApp. Пользователь может отправлять файлы только в рамках определенного ввода; в противном случае система перенаправляет в стандартный поток «Иначе». Поддерживаются изображения, аудио, видео, документы и другие вложения.",
            USER_INPUTDesc: "Блок «Ввод пользователя» позволяет чат-боту обрабатывать, проверять и сохранять данные, полученные от пользователей. Глобальные ключевые слова действуют везде, а локальные — на конкретных шагах. Ввод можно проверить с помощью регулярных выражений (regex) и сохранить в профиль пользователя. Уровень уверенности определяет, как бот реагирует на ввод. С помощью кнопок «Перейти к блоку» и «Отправить сообщение» пользователи могут направляться по сценарию.",
            GO_TO_STEPDesc: "Действие «Перейти к шагу» — это механизм, который направляет пользователей чат-бота к заранее определенным шагам. Динамическая маршрутизация обеспечивает переход в нужный поток на основе запросов или триггеров. Редактирование имен блоков делает поток понятным, а связи — легко управляемыми. Тип кнопки «Перейти к блоку» работает аналогично, оптимизируя пользовательский опыт.",
            WEBHOOKDesc: "Действие «Вебхук» (Webhook) облегчает обмен данными между чат-ботом и внешними системами. Оно направляет поток пользователя на основе успешного или неудачного сценария. При успехе поток продолжается; при ошибке отображается сообщение об ошибке. Интеграция вебхуков расширяет гибкость бота и обогащает сценарии взаимодействия с вашими API.",
            SET_ATTRIBUTEDesc: "Блок «Установить атрибут» позволяет сохранять данные, полученные от пользователей, в их карточку профиля, классифицируя их как статические, динамические или специальные. Статические данные сохраняют фиксированные значения, динамические — информацию, меняющуюся на основе ввода, а специальные — случайно сгенерированные значения (например, OTP). Это делает данные доступными для будущих взаимодействий и персонализации.",
            ASSIGN_OWNERDesc: "Блок «Назначить владельца» используется для перевода текущего чата на выбранного представителя через чат-бота. Алгоритм распределения определяет наиболее подходящего сотрудника на основе его загрузки и графика. Назначения могут выполняться только на онлайн-представителей. Этот процесс может быть синхронизирован с Zoho CRM для эффективного управления поддержкой.",
            QUESTIONDesc: "Блок «Вопрос» позволяет чат-боту задавать пользователям вопросы, проверять и обрабатывать их ответы. При правильном ответе запускается успешный сценарий. Если ответ неверный, активируется сценарий неудачи, дающий пользователю еще один шанс. Ответы проверяются по параметрам (например, формат email) и сохраняются в карточку профиля.",
            TRANSFER_TO_CHATBOTDesc: "Блок «Перевод на чат-бота» направляет пользователя в другой сценарий чат-бота, предлагая персонализированный опыт. Пользователи могут переходить из одного потока в другой на основе фильтров и тегов, соответствующих их потребностям.",
            TAG_CHATDesc: "Блок «Добавить тег» добавляет теги к профилям на основе взаимодействий, что позволяет сегментировать пользователей и фильтровать их в чат-боте. Теги используются для оптимизации процессов поддержки и продаж.",
            REMOVE_TAGDesc: "Блок «Удалить тег» удаляет ненужные или устаревшие теги из профилей пользователей, обеспечивая актуальность сегментации и точность аналитики.",
            SET_DEPARTMENTDesc: "Блок «Установить отдел» автоматически или вручную направляет пользователей в нужный отдел на основе их потребностей. Подходящий отдел определяется выбором пользователя или системными данными.",
            SEND_TRANSCRIPTDesc: "Блок «Отправить транскрипт» автоматически отправляет запись чата с пользователем на указанный адрес электронной почты. Транскрипт может быть отправлен на email из профиля пользователя или на адрес, введенный вручную.",
            SEND_SMSDesc: "Блок «Отправить SMS» позволяет отправлять автоматические и персонализированные сообщения через интеграцию с Postacell или другими провайдерами. Содержимое SMS динамически формируется с использованием данных из профиля пользователя.",
            SEND_MAILDesc: "Блок «Отправить письмо» позволяет автоматически отправлять электронные письма, используя информацию, собранную чат-ботом. Тема и содержание письма могут быть персонализированы на основе атрибутов пользователя. Модуль интегрируется с существующей почтовой инфраструктурой.",
            CREATE_EVENTDesc: "Блок «Создать событие» автоматически добавляет события в календари пользователей. Название, описание и длительность определяются данными профиля. Участники получают уведомления, а детали управляются через интеграции с Google Calendar или Microsoft Teams.",
            CREATE_RESERVATIONDesc: "Блок «Создать бронирование» автоматически запускает процесс бронирования, используя атрибуты из профиля или данные формы. Этот блок взаимодействует с другими шагами сценария для быстрой и персонализированной записи на услуги.",            RESERVATION_OPEN_URLDesc: "Блок «Экран просмотра бронирования» выводит список доступных встреч для пользователя через заранее определенный календарь бронирования. Пользователь может просматривать доступные встречи в календаре через этот экран. Кроме того, для продолжительности встречи можно выбрать заранее определенные варианты (например, 5 минут, 15 минут, 30 минут). Эта функция работает только в чат-ботах на веб-сайтах и предлагает пользователям удобные варианты бронирования.",
            RESERVATION_SELECT_DAYDesc: "Блок «Выбор дня бронирования» предлагает пользователям выбор дней бронирования на неделю, и выбранный день бронирования сохраняется в системе. Соответствующая информация автоматически извлекается из атрибутов профиля пользователя, и определяется день бронирования. Этот блок предлагает пользователям варианты с помощью кнопок, направляя их на соответствующий день бронирования. Этот процесс персонализируется с использованием информации о пользователе и интегрируется с календарем событий.",
            RESERVATION_EVENT_LISTDesc: "Список бронирований клиентов быстро и эффективно представляет данные о бронировании, связанные с адресом электронной почты пользователя. Этот процесс выполняется с использованием адреса электронной почты конкретного клиента, и для пользователя выводится список всех бронирований, связанных с этим адресом электронной почты.",
            RESERVATION_SELECT_TIMEDesc: "Блок «Выбор времени бронирования» предлагает пользователям доступное время для выбранного дня бронирования. Пользователь выбирает подходящее время из доступных вариантов для ранее выбранного дня. Этот блок выводит список доступного времени для дня на основе данных, полученных из блока «Выбор дня бронирования», и предлагает варианты пользователю. Выбранное время бронирования сохраняется в системе и интегрируется соответствующим образом с использованием информации профиля пользователя и атрибутов.",
            CREATE_TASKDesc: "Блок «Создать задачу» автоматически или вручную добавляет задачи в модуль управления задачами на основе запросов пользователей. Название задачи, описание, уровень срочности, рабочий процесс и колонка определяются и назначаются соответствующим представителям. Задачи, персонализированные с использованием информации из профиля пользователя, доводятся до сведения соответствующих лиц через системные уведомления и уведомления по электронной почте. Интеграция с Google Календарем и Microsoft Teams позволяет легко отслеживать процесс. Например, когда клиент запрашивает дополнительную информацию, чат-бот автоматически создает задачу в колонке «Ожидание контакта» процесса продаж и уведомляет соответствующего представителя.",
            GET_LOCATIONDesc: "Модуль «Получить местоположение» позволяет чат-боту собирать географическую информацию о местоположении пользователей. При запросе информации о местоположении у пользователя отображается специальное сообщение, а широта и долгота местоположения сохраняются в профиле. Пользователь может поделиться своим местоположением вручную, введя адрес или выбрав его на карте. Эта функция особенно полезна в секторах электронной коммерции, логистики и доставки, персонализируя пользовательский опыт. Например, чат-бот электронной коммерции может использовать этот модуль для сбора адреса доставки от пользователя и завершения процесса.",
            SUPPRESSION_ADDDesc: "Блок «Блокировка» блокирует пользователя на указанной платформе (WhatsApp, Веб-посетитель, Instagram, Messenger). Значение пользователя, которого нужно заблокировать, может быть автоматически получено из атрибутов или введено вручную. Блокировка может применяться к входящим (получение сообщений), исходящим (отправка сообщений) или к обоим типам сообщений. Например, чтобы заблокировать пользователя, вызывающего дискомфорт в WhatsApp, в качестве платформы выбирается «WhatsApp», указывается номер телефона пользователя и активируется как входящая, так и исходящая блокировка.",
            SUPPRESSION_REMOVEDesc: "Блок «Снять блокировку» разблокирует ранее заблокированного пользователя на указанной платформе (WhatsApp, Веб, Instagram и т. д.), используя значение, использованное для блокировки (например, номер телефона, ID пользователя). Значение для разблокировки может быть автоматически получено из атрибутов профиля. Это позволяет быстро и автоматически выполнять процесс разблокировки.",
            SEND_WP_BUSINESS_MESSAGEDesc: "Блок «Отправить сообщение WhatsApp» позволяет отправлять персонализированные сообщения пользователям с помощью WhatsApp Business API. При срабатывании этого действия сообщение отправляется через канал WhatsApp с использованием заранее определенного шаблона. Содержимое сообщения может быть персонализировано с помощью атрибутов профиля и ручного ввода. Номер, на который будет отправлено сообщение, может быть введен вручную или автоматически получен из информации о пользователе. Шаблоны — это утвержденные форматы в WhatsApp Business API, и можно выбирать существующие шаблоны или создавать новые. Переменные внутри шаблона можно использовать для создания персонализированных сообщений. Кроме того, к сообщениям можно добавлять медиафайлы (JPEG, PNG и т. д.). Этот блок позволяет автоматизировать отправку сообщений для таких сценариев, как сообщения о кампаниях, запросы на поддержку или специальные уведомления.",
            MESSENGER_SEND_MESSAGEDesc: "Этот блок позволяет ЧАТ-БОТУ отправлять сообщения через Messenger. ЧАТ-БОТ может отправлять сообщения, содержащие текст, изображения или другие типы медиа, конкретному получателю.",
            INSTAGRAM_SEND_MESSAGEDesc: "Этот блок позволяет ЧАТ-БОТУ отправлять прямые сообщения через платформу Instagram. ЧАТ-БОТ может отправлять сообщения, содержащие текст или медиа, конкретному пользователю.",
            INSTAGRAM_COMMENT_REPLYDesc: "Этот блок используется для ответа на комментарий к посту в Instagram. ЧАТ-БОТ может взаимодействовать, отвечая на конкретный комментарий.",
            INSTAGRAM_COMMENT_DELETEDesc: "Этот блок используется для удаления комментария к посту в Instagram. ЧАТ-БОТ может удалять нежелательные или неуместные комментарии.",
            INSTAGRAM_COMMENT_SHOWDesc: "Этот блок используется для просмотра комментария к посту в Instagram. ЧАТ-БОТ может просматривать конкретный комментарий и видеть мнения других пользователей.",
            INSTAGRAM_COMMENT_HIDEDesc: "Этот блок используется для скрытия комментария к посту в Instagram. ЧАТ-БОТ может сделать конкретный комментарий невидимым, не давая подписчикам его увидеть.",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATEDesc: "Этот блок используется для ответа на комментарий к посту в Instagram личным сообщением (DM). ЧАТ-БОТ может отправить частный ответ комментатору, устанавливая более личное общение.",
            TABLE_CREATE_RECORDDesc: "Этот блок добавляет новую запись в конкретную таблицу. Используя информацию, полученную от пользователя, или другие атрибуты в системе, создается новая запись и добавляется в соответствующую таблицу. Добавление новой записи используется для таких процессов, как создание новой информации о клиенте или записей о продуктах.",
            TABLE_DELETE_RECORDDesc: "Этот блок удаляет запись из таблицы данных. Когда пользователь хочет удалить запись, которая больше не действительна или содержит ошибки, срабатывает этот блок. Удаленная запись полностью удаляется из таблицы и не может быть восстановлена. Например, этот процесс используется для удаления записи клиента или недействительного заказа.",
            TABLE_UPDATE_RECORDDesc: "Этот блок обновляет содержимое записи в таблице. Когда пользователь хочет изменить информацию в существующей записи, можно использовать этот блок. Например, этот процесс используется для обновления адреса клиента или цены товара. Эта операция изменяет только указанную запись и не влияет на другие записи в таблице.",
            TABLE_FIND_RECORDDesc: "Этот блок позволяет найти конкретную запись в таблице данных. Когда пользователь хочет найти конкретные данные (например, имя пользователя или ID продукта), записанные в таблице, используется этот блок. Процесс поиска позволяет пользователям быстро получить доступ к конкретной записи.",
            TABLE_FIND_RECORDSDesc: "Этот блок отображает существующие записи в таблице пользователю. Когда пользователь хочет увидеть все записи в таблице или отфильтрованные записи на основе определенных критериев, используется этот блок. Процесс листинга может включать такие операции, как сортировка и фильтрация данных.",
            ADD_TO_SEGMENTDesc: "Действие «Добавить в сегмент» позволяет добавлять пользователей в определенные сегменты после того, как они пройдут определенные шаги. Это действие помогает анализировать поведение пользователей, разделяя их на сегменты и создавая пользовательские отчеты. Пользователи добавляются в соответствующие сегменты через панель выбора сегментов, а новые сегменты можно создавать из меню чат-бота. Например, когда VIP-клиент делает специальный запрос по кампании, действие «Добавить в сегмент» добавляет пользователя в сегмент VIP. Отчеты по сегментам можно просматривать через отчетность, предоставляя подробные данные о том, в какие сегменты добавляются пользователи и их запросы.",
            REMOVE_FROM_SEGMENTDesc: "Действие «Удалить из сегмента» используется для удаления пользователей из определенных сегментов. Это действие обновляет сегменты, позволяя проводить более точный анализ пользователей по сегментам. Пользователи автоматически удаляются из соответствующего сегмента после выбора сегмента для удаления через панель выбора сегментов. Обновление сегментов и анализ удаленных пользователей могут быть выполнены через отчетность, что позволяет более четко отслеживать изменения сегментов и поведение пользователей.",
            Messaging_Actions: "Действия обмена сообщениями",
            exportDiagram: "Экспорт диаграммы",
            exportDiagramDescription: "Выберите компоненты, которые вы хотите экспортировать. Эти данные будут скопированы в буфер обмена и могут быть импортированы в другой сценарий.",
            diagram: "Диаграмма",
            diagramExportDesc: "Диаграмма потока чат-бота (обязательно)",
            aiSettings: "Настройки ИИ",
            aiSettingsExportDesc: "Настройки модели ИИ, промпт и параметры",
            aiFunctionsExportDesc: "Выберите функции ИИ для экспорта",
            knowledgeBase: "База знаний",
            knowledgeBaseExportDesc: "Выберите типы базы знаний для экспорта",
            webPages: "Веб-страницы",
            noKnowledgeBase: "База знаний для экспорта не найдена",
            exportToClipboard: "Копировать в буфер обмена",
            exportSuccess: "Сценарий успешно скопирован в буфер обмена",
            exportError: "Произошла ошибка во время экспорта",
            exportDataFetchError: "Ошибка получения данных для экспорта",
            model: "Модель",
            topP: "Top P",
            toolChoice: "Выбор инструмента",
            prompt: "Промпт",
            B2Cargo_Actions: "Действия B2Cargo",
            Holiday_Plus_Actions: "Действия Holiday+",
            HOLIDAY_PLUS_GET_ROOMS: "СПИСОК НОМЕРОВ",
            HOLIDAY_PLUS_GET_HOTELS: "СПИСОК ОТЕЛЕЙ",
            ZOHO_CREATE_RECORD: "Zoho: Создать запись",
            B2CARGO_LOGIN_USER: "Вход пользователя",
            B2CARGO_PRODUCT_STATUS: "Статус товара",
            createNewBlock: "Создать новый блок",
            marketplace: "Маркетплейс",
            myBlocks: "Мои блоки",
            importedBlocks: "Импортированные блоки",
            pendingApproval: "Ожидает одобрения",
            utility: "Утилита",
            dataTransform: "Трансформация данных",
            custom: "Пользовательский",
            mostUsed: "Самые используемые",
            topRated: "С наивысшим рейтингом",
            newest: "Новейшие",
            uses: "использований",
            import: "Импорт",
            imported: "Импортировано",
            pending: "В ожидании",
            approved: "Одобрено",
            rejected: "Отклонено",
            unlist: "Убрать из списка",
            confirmDeleteBlock: "Вы уверены, что хотите удалить этот блок?",
            noBlocksCreated: "Блоки еще не созданы",
            enterChangelog: "Введите список изменений (необязательно)",
            publishBlock: "Опубликовать блок",
            blockPublished: "Блок успешно опубликован",
            blockUnlisted: "Блок успешно убран из списка",
            blockDeleted: "Блок успешно удален",
            cannotDeleteActiveBlock: "Невозможно удалить блок с активным использованием",
            noImportedBlocks: "Нет импортированных блоков",
            confirmRemoveImport: "Вы уверены, что хотите удалить этот импорт?",
            remove: "Удалить",
            importRemoved: "Импорт успешно удален",
            creator: "Создатель",
            viewDetails: "Просмотр деталей",
            approve: "Одобрить",
            reject: "Отклонить",
            noPendingBlocks: "Нет блоков, ожидающих одобрения",
            enterRejectionReason: "Введите причину отклонения",
            rejectBlock: "Отклонить блок",
            blockApproved: "Блок успешно одобрен",
            blockRejected: "Блок отклонен",
            blockImported: "Блок успешно импортирован",
            parameters: "Параметры",
            noParameters: "Параметры не требуются",
            ratings: "Рейтинги",
            writeReview: "Напишите свой отзыв...",
            selectOrTypeCategory: "Выберите или введите категорию",
            changelogPlaceholder: "Введите список изменений (необязательно)",
            category: "Категория",
            description: "Описание",
            tags: "Теги",
            submitRating: "Опубликовать рейтинг",
            noRatings: "Рейтингов пока нет",
            latest: "Последние",
            pinned: "Закрепленные",
            createBlock: "Создать блок",
            basicInfo: "Основная информация",
            blockName: "Название блока",
            enterBlockName: "Введите название блока",
            enterDescription: "Введите описание",
            icon: "Иконка",
            addTags: "Добавить теги",
            javascriptCode: "Код JavaScript",
            addParameter: "Добавить параметр",
            parameterName: "Имя параметра (переменная)",
            parameterLabel: "Отображаемая метка",
            parameterDescription: "Описание (справка)",
            defaultValue: "Значение по умолчанию",
            allowAutoUpdate: "Автообновление схемы вывода при выполнении",
            visibility: "Видимость",
            allowedSiteIds: "Разрешенные ID сайтов",
            enterSiteIds: "Введите ID сайтов",
            saveDraft: "Сохранить черновик",
            fillRequired: "Пожалуйста, заполните обязательные поля",
            blockCreated: "Блок создан",
            selectCustomBlock: "Выбрать пользовательский блок",
            selectCustomBlockDesc: "Выберите пользовательский блок из импортированных блоков",
            outputPreview: "Предпросмотр вывода",
            blockNotFound: "Блок не найден",
            pleaseSelectRating: "Пожалуйста, выберите рейтинг",
            ratingSubmitted: "Рейтинг опубликован",
            plans: "Планы",
            chatBotPlans: "Планы чат-бота",
            editWebhook: "Редактировать вебхук",
            newWebhook: "Новый вебхук",
            webhookTitle: "Название вебхука",
            webhookUrl: "URL вебхука",
            webhookToken: "Токен вебхука",
            webhookUsername: "Имя пользователя вебхука",
            webhookPassword: "Пароль вебхука",
            allIntegrations: "Все интеграции",
            integrateYourCBwithChatWidget: "Интегрируйте ваш чат-бот с виджетом чата.",
            integrateYourCBwithChatGpt3: "Чат-бот может быть интегрирован с GPT-4o. Требуется API-ключ GPT-4o.",
            integrateYourCBwithWebHook: "Легко передавайте информацию чата между чат-ботом и вашими веб-сервисами.",
            integrateYourCBwithIntegratable: "Легко передавайте информацию чата между чат-ботом и {integratable}.",
            FEEDBACK_AI_ASSISTANT: "ОТЗЫВ ИИ-ПОМОЩНИКА",
            INSERT_TO_SYSTEM_PROMPT: "ВСТАВИТЬ В СИСТЕМНУЮ ИНСТРУКЦИЮ",
            API_REQUEST: "API ЗАПРОС",
            AI_CALL: "ИИ-ЗВОНОК",
            TAVILY_WEB_SEARCH: "ВЕБ-ПОИСК",
            OPENAI_WEB_SEARCH: "ВЕБ-ПОИСК (OPENAI)",
            RUN_JAVASCRIPT: "ЗАПУСТИТЬ JAVASCRIPT",
            DEFAULT_TIMEOUT: "ТАЙМ-АУТ ПО УМОЛЧАНИЮ",
            AI_FUNCTIONS: "ФУНКЦИИ ИИ",
            ASSIGN_OWNER: "Назначить владельца",
            CACHE_WRITE: "ЗАПИСЬ В КЭШ",
            CACHE_READ: "ЧТЕНИЕ ИЗ КЭША",
            CACHE_EXTEND: "ПРОДЛЕНИЕ КЭША",
            CACHE_DELETE: "УДАЛЕНИЕ ИЗ КЭША",
            YOUTUBE_REPLY_COMMENT: "ОТВЕТИТЬ НА КОММЕНТАРИЙ YOUTUBE",
            YOUTUBE_UPDATE_COMMENT_STATUS: "ОБНОВИТЬ СТАТУС КОММЕНТАРИЯ YOUTUBE",
            YOUTUBE_SET_MODERATION_STATUS: "УСТАНОВИТЬ СТАТУС МОДЕРАЦИИ YOUTUBE",
            GOOGLE_BUSINESS_REPLY_REVIEW: "ОТВЕТИТЬ НА ОТЗЫВ GOOGLE BUSINESS",
            GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS: "ОБНОВИТЬ СТАТУС ОТЗЫВА GOOGLE BUSINESS",
            GOOGLE_PLAY_REPLY_REVIEW: "ОТВЕТИТЬ НА ОТЗЫВ GOOGLE PLAY",
            GOOGLE_PLAY_UPDATE_REVIEW_STATUS: "ОБНОВИТЬ СТАТУС ОТЗЫВА GOOGLE PLAY",
            APP_STORE_REPLY_REVIEW: "ОТВЕТИТЬ НА ОТЗЫВ APP STORE",
            APP_STORE_UPDATE_REVIEW_STATUS: "ОБНОВИТЬ СТАТУС ОТЗЫВА APP STORE",
            APP_STORE_DELETE_REVIEW_RESPONSE: "УДАЛИТЬ ОТВЕТ НА ОТЗЫВ APP STORE",
            TIMEOUT: "ТАЙМ-АУТ",
            Probel_Actions: "Действия Probel",
            PROBEL_SELECT_BRANCH: "Выбрать филиал",
            PROBEL_SELECT_CLINIC: "Выбрать поликлинику",
            PROBEL_SELECT_DAY: "Выбрать день приёма",
            PROBEL_SELECT_HOUR: "Выбрать время приёма",
            PROBEL_MAKE_APPOINTMENT: "Создать запись",
            PROBEL_CANCEL_APPOINTMENT: "Отменить запись",
            PROBEL_GET_PATIENT_TOKEN: "Получить токен пациента",
            PROBEL_FILL_INFO: "Получить данные MERNIS",
            PROBEL_SELECT_APPOINTMENT: "Выбрать запись",
            SUPPRESSION_ADD: "ЗАБЛОКИРОВАТЬ КОНТАКТ",
            SUPPRESSION_REMOVE: "РАЗБЛОКИРОВАТЬ КОНТАКТ",
            SEND_WP_BUSINESS_MESSAGE: "ОТПРАВИТЬ СООБЩЕНИЕ WHATSAPP",
            TABLE_CREATE_RECORD: "Создать запись",
            TABLE_DELETE_RECORD: "Удалить запись",
            TABLE_UPDATE_RECORD: "Обновить запись",
            TABLE_FIND_RECORD: "Найти запись",
            TABLE_FIND_RECORDS: "Найти записи",
            emptyError: "Поля не могут быть пустыми",
            OPENAI_WEB_SEARCHDesc: "Поиск в Интернете позволяет получать информацию с различных веб-сайтов с помощью систем на базе ИИ. При вводе поискового запроса сканируются наиболее релевантные результаты на основе заданной глубины поиска, предоставляя информацию, адаптированную к потребностям пользователя. Для более полной передачи информации могут быть включены необработанный контент, изображения и их описания. Кроме того, полученные данные могут быть обобщены или представлены в исходном виде. Пользователи могут фильтровать результаты поиска, включая определенные домены, обеспечивая доступ к информации из самых надежных источников. Таким образом, веб-поиск на базе ИИ оптимизирует процесс получения быстрой и точной информации.",
            b2cargo_login_user: "Вход пользователя",
            b2cargo_product_status: "Статус товара",
            ficheros: "Файлы",
            file: "Файл",
            fileCancellato: "Файл удален",
            impostazioni: "Настройки",
            risposta: "Ответ",
            setUpUpYourChatbot: "Настройте свой чат-бот",
            setUpUpYourChatbotDesc: "Обучите свой чат-бот на основе данных, используйте наши готовые шаблоны или начните с нуля.",
            yourNeedEnterEnterYourOpenAi: "Вам необходимо ввести свой API-ключ OpenAI, чтобы создать чат-бот путем сканирования вашего веб-сайта."
        },
        coupon: {
            code: "Код",
            discount: "Скидка",
            endDate: "Дата окончания",
            name: "Имя",
            email: "Электронное письмо",
            phone: "Телефон",
            add: "Добавить купон",
            coupons: "купоны",
            couponDeleted: "Купон удален",
            limit: "Ограничение",
            visitorBan: "Посетитель заблокирован.",
            visitorUnBlock: "Блокировка снята."
        },
        instagramTitle: "Нажмите кнопку ниже, чтобы включить функции Instagram..",
        instegramFunctionActive: "Включить функцию Instagram",
        ChatBOT: "Чат-бот",
        WhatsappContacts: "WhatsApp Контакты",
        InstagramContacts: "Instagram Контакты",
        MessengerContacts: "Контакты Messenger",
        editWebhook: "Изменить вебхук",
        newWebhook: "Новый вебхук",
        webhookTitle: "Название вебхука",
        webhookUrl: "URL-адрес веб-перехватчика",
        webhookToken: "Токен вебхука",
        webhookUsername: "Имя пользователя вебхука",
        webhookPassword: "Пароль вебхука",
        allIntegrations: "Все интеграции",
        integrateYourCBwithChatWidget: "Интегрируйте своего чат-бота с виджетом чата.",
        integrateYourCBwithChatGpt3: "Чат-бот можно интегрировать с GPT-4. Требуется ключ API GPT-4.",
        integrateYourCBwithWebHook: "С легкостью передавайте информацию чата между ChatBot и вашими веб-службами.",
        integrateYourCBwithIntegratable: "С легкостью передавайте информацию чата между ChatBot и {integratable}.",
        addWebhook: "Добавить вебхук",
        volumeUp: "Увеличить громкость",
        minimize: "Свести к минимуму",
        maximize: "Максимизировать",
        auditLogs: {
            auditLogsTitle: "Журнал аудита",
            auditLogsSub: "Журналы аудита позволяют отслеживать события, произошедшие в вашей компании за последние 30 дней.",
            actor: "Актор",
            actorSelect: "Выберите актора",
            actorSystem: "System (Supsis Ai)",
            actorChatbot: "Chatbot",
            actorApi: "API",
            actorVisitor: "Любой посетитель",
            actorAgent: "Любой агент",
            adminUserSuffix: "(Админ-пользователь)",
            activityType: {
                blocked: "Заблокирован",
                unblocked: "Разблокирован",
                "chat-opened": "Чат открыт",
                "chat-closed": "Чат закрыт",
                "chat-rating": "Чат оценён",
                "chat-assigned-to-user": "Чат назначен пользователю",
                "chat-forwarded-to-user": "Чат переадресован пользователю",
                "contact-owner-updated": "Владелец контакта обновлён",
                "user-joined-to-chat": "Пользователь присоединился к чату",
                "ticket-assigned-to-user": "Заявка назначена пользователю",
                online: "В сети",
                offline: "Не в сети",
                "page-changed": "Страница изменена",
                "create-ticket": "Заявка создана",
                "video-calling-started": "Видеозвонок начат",
                "video-calling-closed": "Видеозвонок завершён",
                "voice-calling-started": "Голосовой звонок начат",
                "voice-calling-closed": "Голосовой звонок завершён",
                "visitor-tag-added": "Тег посетителя добавлен",
                "visitor-tag-removed": "Тег посетителя удалён",
                "note-created": "Заметка создана",
                "note-updated": "Заметка обновлена",
                "visitor-profile-updated": "Профиль посетителя обновлён",
                "user-added": "Пользователь добавлен",
                "user-removed": "Пользователь удалён",
                "user-status-changed": "Статус пользователя изменён",
                "user-logged-in": "Пользователь вошёл в систему",
                "user-added-to-department": "Пользователь добавлен в отдел",
                "user-removed-from-depart": "Пользователь удалён из отдела",
                "user-role-changed": "Роль пользователя изменена",
                "user-password-changed": "Пароль пользователя изменён",
                "user-email-changed": "Email пользователя изменён",
                "user-name-changed": "Имя пользователя изменено",
                "user-phone-changed": "Телефон пользователя изменён",
                "user-disabled": "Пользователь отключён",
                "user-enabled": "Пользователь включён",
                "settings-updated": "Настройки обновлены",
                "whatsapp-broadcast-created": "Рассылка WhatsApp создана",
                "whatsapp-broadcast-completed": "Рассылка WhatsApp завершена",
                "whatsapp-broadcast-canceled": "Рассылка WhatsApp отменена",
                "whatsapp-broadcast-failed": "Рассылка WhatsApp не удалась",
                "whatsapp-v1-bot-state-changed": "Состояние бота WhatsApp v1 изменено",
                "whatsapp-v2-bot-state-changed": "Состояние бота WhatsApp v2 изменено",
                "channel-created": "Канал создан",
                "channel-removed": "Канал удалён",
                "channel-visibility-changed": "Видимость канала изменена",
                "channel-zoho-config-updated": "Конфигурация Zoho для канала обновлена",
                "channel-forward-config-updated": "Настройка переадресации канала обновлена",
                "login-form-activated": "Форма входа активирована",
                "login-form-deactivated": "Форма входа деактивирована",
                "login-form-updated": "Форма входа обновлена",
                "chatbot-created": "Чат-бот создан",
                "chatbot-deleted": "Чат-бот удалён",
                "chatbot-restored": "Чат-бот восстановлен из корзины",
                "chatbot-published": "Чат-бот опубликован",
                "chatbot-webhook-added": "Вебхук чат-бота добавлен",
                "chatbot-webhook-removed": "Вебхук чат-бота удалён",
                "banned-word-added": "Запрещённое слово добавлено",
                "banned-word-removed": "Запрещённое слово удалено",
                "mail-address-added": "Email добавлен",
                "mail-address-removed": "Email удалён",
                "mail-was-sent": "Письмо отправлено",
                "content-added": "Контент добавлен",
                "content-removed": "Контент удалён",
                "role-added": "Роль добавлена",
                "role-removed": "Роль удалена",
                "role-updated": "Роль обновлена",
                "department-added": "Отдел добавлен",
                "department-removed": "Отдел удалён",
                "tags-added": "Теги добавлены",
                "tags-removed": "Теги удалены",
                "trigger-added": "Триггер добавлен",
                "trigger-removed": "Триггер удалён",
                "trigger-updated": "Триггер обновлён",
                "welcome-message-added": "Приветственное сообщение добавлено",
                "welcome-message-removed": "Приветственное сообщение удалено",
                "customer-group-added": "Группа клиентов добавлена",
                "customer-group-removed": "Группа клиентов удалена",
                "customer-group-updated": "Группа клиентов обновлена",
                "webhook-added": "Вебхук добавлен",
                "webhook-removed": "Вебхук удалён",
                "webhook-updated": "Вебхук обновлён",
                "contact-prop-added": "Свойство контакта добавлено",
                "contact-prop-removed": "Свойство контакта удалено",
                "invoice-created": "Счёт создан",
                "invoice-updated": "Счёт обновлён",
                "invoice-payment-received": "Оплата счёта получена",
                "invoice-payment-failed": "Оплата счёта не прошла",
                "invoice-refunded": "По счёту произведён возврат",
                "invoice-deleted": "Счёт удалён",
                "payment-method-added": "Способ оплаты добавлен",
                "billing-address-updated": "Платёжный адрес обновлён",
                "plan-started": "План активирован",
                "plan-canceled": "План отменён",
                "task-workflow-created": "Рабочий процесс задач создан",
                "task-workflow-deleted": "Рабочий процесс задач удалён",
                "task-workflow-restored": "Рабочий процесс задач восстановлен из корзины",
                "task-workflow-permanently-deleted": "Рабочий процесс задач удалён навсегда",
                "task-workflow-updated": "Рабочий процесс задач обновлён",
                "task-workflow-pipeline-stage-added": "Этап воронки задач добавлен",
                "task-workflow-pipeline-stage-updated": "Этап воронки задач обновлён",
                "task-workflow-pipeline-stage-deleted": "Этап воронки задач удалён",
                "task-created": "Задача создана",
                "task-deleted": "Задача удалена",
                "task-stage-changed": "Этап задачи изменён",
                "task-workflow-changed": "Рабочий процесс задачи изменён",
                "task-assigned-to-user": "Задача назначена пользователю",
                "task-update-priority": "Приоритет задачи обновлён",
                "task-added-tags": "К задаче добавлены теги",
                "task-removed-tags": "С задачи удалены теги",
                "task-update-title": "Название задачи обновлено",
                "task-update-description": "Описание задачи обновлено",
                "task-update-start-date": "Дата начала задачи обновлена",
                "task-update-end-date": "Дата окончания задачи обновлена",
                "task-update-owner": "Владелец задачи обновлён",
                "task-added-followers": "К задаче добавлены наблюдатели",
                "task-removed-followers": "С задачи удалены наблюдатели",
                "task-added-collaborators": "К задаче добавлены участники",
                "task-update-checklist": "Чек-лист задачи обновлён",
                "task-added-subtask": "К задаче добавлена подзадача",
                "task-removed-subtask": "С задачи удалена подзадача",
                "task-added-attachment": "К задаче добавлено вложение",
                "task-comment-added": "К задаче добавлен комментарий",
                "task-comment-updated": "Комментарий к задаче обновлён",
                "task-comment-deleted": "Комментарий к задаче удалён",
                "task-completed": "Задача выполнена",
                "task-archived": "Задача архивирована",
                "task-restored": "Задача восстановлена из корзины",
                "task-unarchived": "Задача разархивирована",
                "chatbot-credit-low": "Низкий баланс чат-бота",
                "chatbot-credit-done": "Баланс чат-бота исчерпан",
                "system-status": "Статус системы",
                "whatsapp-credit-low": "Низкий баланс WhatsApp",
                "reservation-created-plan": "План бронирования создан",
                "reservation-updated-plan": "План бронирования обновлён",
                "reservation-deleted-plan": "План бронирования удалён",
                "reservation-created": "Бронирование создано",
                "reservation-updated": "Бронирование обновлено",
                "reservation-deleted": "Бронирование удалено",
                "white-list-added": "Белый список добавлен",
                "white-list-removed": "Белый список удалён",
                "site-suspended": "Сайт приостановлен",
                "site-dead": "Сайт отключён",
                "site-enabled": "Сайт включён",
                custom: "Пользовательское действие",
                "auto-rebalance-success": "Автобалансировка выполнена успешно",
                "auto-rebalance-failed": "Автобалансировка не удалась",
                "auto-rebalance-disabled": "Автобалансировка отключена",
                "automation-created": "Автоматизация создана",
                "automation-deleted": "Автоматизация удалена",
                "automation-restored": "Автоматизация восстановлена из корзины",
                "automation-published": "Автоматизация опубликована",
                "automation-unpublished": "Автоматизация снята с публикации",
                "automation-updated": "Автоматизация обновлена",
                "form-created": "Форма создана",
                "form-updated": "Форма обновлена",
                "form-deleted": "Форма удалена",
                "form-restored": "Форма восстановлена из корзины",
                "form-downloaded": "Данные формы загружены",
                "table-created": "Таблица создана",
                "table-deleted": "Таблица удалена",
                "table-restored": "Таблица восстановлена из корзины",
                "table-permanently-deleted": "Таблица удалена навсегда",
                "table-field-added": "Поле таблицы добавлено",
                "table-field-updated": "Поле таблицы обновлено",
                "table-field-deleted": "Поле таблицы удалено",
                "table-view-added": "Представление таблицы добавлено",
                "table-view-updated": "Представление таблицы обновлено",
                "table-view-deleted": "Представление таблицы удалено",
                "table-page-added": "Страница таблицы добавлена",
                "table-page-updated": "Страница таблицы обновлена",
                "table-page-deleted": "Страница таблицы удалена",
                "table-widget-added": "Виджет таблицы добавлен",
                "table-widget-updated": "Виджет таблицы обновлён",
                "table-widget-deleted": "Виджет таблицы удалён",
                "table-permission-changed": "Права доступа к таблице изменены",
                "table-data-downloaded": "Данные таблицы загружены",
                "table-data-imported": "Данные таблицы импортированы",
                "table-data-batch-updated": "Массовое обновление данных таблицы",
                "table-data-batch-deleted": "Массовое удаление данных таблицы",
                "contact-data-downloaded": "Данные контактов загружены",
                "contact-batch-updated": "Массовое обновление данных контактов",
                "chat-data-downloaded": "Данные чата загружены",
                "voice-agent-created": "Голосовой агент создан",
                "voice-agent-updated": "Голосовой агент обновлен",
                "voice-agent-deleted": "Голосовой агент удален",
                "voice-agent-phone-number-inbound-agent-changed": "Агент входящих звонков изменен",
                "voice-agent-phone-number-outbound-agent-changed": "Агент исходящих звонков изменен",
                "voice-agent-batch-call-created": "Массовый звонок голосового агента создан",
                "voice-agent-knowledge-base-created": "База знаний голосового агента создана",
                "voice-agent-knowledge-base-updated": "База знаний голосового агента обновлена",
                "drive-folder-created": "Папка на Диске создана",
                "drive-folder-deleted": "Папка на Диске удалена",
                "drive-folder-renamed": "Папка на Диске переименована",
                "drive-file-added": "Файл на Диск добавлен",
                "drive-file-deleted": "Файл на Диске удален",
                "task-module-rules-rule-added": "Правило модуля задач добавлено",
                "task-module-rules-rule-updated": "Правило модуля задач обновлено",
                "task-module-rules-rule-deleted": "Правило модуля задач удалено",
                "task-module-rules-rule-enabled": "Правило модуля задач включено",
                "task-module-rules-rule-disabled": "Правило модуля задач отключено",
                "task-module-rules-enabled": "Правила модуля задач включены",
                "task-module-rules-disabled": "Правила модуля задач отключены",
                "contact-module-rules-rule-added": "Правило модуля контактов добавлено",
                "contact-module-rules-rule-updated": "Правило модуля контактов обновлено",
                "contact-module-rules-rule-deleted": "Правило модуля контактов удалено",
                "contact-module-rules-rule-enabled": "Правило модуля контактов включено",
                "contact-module-rules-rule-disabled": "Правило модуля контактов отключено",
                "contact-module-rules-enabled": "Правила модуля контактов включены",
                "contact-module-rules-disabled": "Правила модуля контактов отключены",
                "module-created": "Модуль создан",
                "module-updated": "Модуль обновлен",
                "module-deleted": "Модуль удален",
                "relation-created": "Связь создана",
                "relation-updated": "Связь обновлена",
                "relation-deleted": "Связь удалена",
                "web-app-created": "Веб-приложение создано",
                "web-app-updated": "Веб-приложение обновлено",
                "web-app-deleted": "Веб-приложение удалено",
                "web-tab-created": "Веб-вкладка создана",
                "web-tab-updated": "Веб-вкладка обновлена",
                "web-tab-deleted": "Веб-вкладка удалена",
                "developer-token-created": "Токен разработчика создан",
                "developer-token-changed": "Токен разработчика изменен"
            },
            activityTypeSelect: "Выберите тип активности",
            dateRange: "Диапазон дат",
            startDate: "Дата начала",
            endDate: "Дата окончания",
            reset: "Сбросить",
            filter: "Фильтр",
            activeFilters: "Активные фильтры:",
            auditLogsTable: "Журнал аудита",
            noActivityYet: "Пока нет активности",
            ipAddress: "IP-адрес",
            tablePagination: {
                goto: "Перейти",
                pagePer: " / стр.",
                total: "Всего",
                prev5: "Предыдущие 5 страниц",
                next5: "Следующие 5 страниц",
                cut: "Вырезать",
                copy: "Копировать",
                insertRowAbove: "Вставить строку выше",
                insertRowBelow: "Вставить строку ниже",
                removeRow: "удалить строку(и)",
                emptyRow: "очистить строку(и)",
                emptyColumn: "очистить столбец(ы)",
                emptyCell: "Очистить ячейку",
                leftFixedColumnTo: "Закрепить столбец слева",
                cancelLeftFixedColumnTo: "Отменить закрепление слева",
                rightFixedColumnTo: "Закрепить столбец справа",
                cancelRightFixedColumnTo: "Отменить закрепление справа"
            }
        },
        task: {
            taskID: "ID задачи",
            completeTask: "Завершить задачу",
            closedTasks: "Закрытые задачи",
            moveToArchive: "Переместить в архив",
            changeWorkflow: "Переместить в Другой Рабочий Процесс",
            selectWorkflow: "Выберите рабочий процесс",
            taskNumber: "Задача #",
            workflowActions: "Действия рабочего процесса",
            workflowTitle: "Заголовок рабочего процесса",
            deleteTask: "Удалить задачу",
            selectOption: "Выберите вариант",
            notAuthorisedCreateTask: "Вы не уполномочены создавать задачу",
            notAuthorisedCreateTaskDesc: "Вы не уполномочены выполнять эту задачу",
            goToMessage: "Перейти к сообщению",
            goToChat: "Перейти к чату",
            showVisitor: "Показать посетителя",
            closeTheTask: "Закрыть задачу",
            sureAddCompletedList: "Вы уверены, что хотите добавить задачу в список выполненных?",
            success: "Успех",
            successDesc: "Новое поле успешно добавлено.",
            moveAndDeleteTask: "Перемещение и удаление задач",
            justDelete: "Просто удалить",
            selectColumnMoveTask: "Выберите столбец, в который вы хотите переместить задачи",
            todos: "Дела, которые нужно сделать",
            inProgress: "В работе",
            approval: "Одобрено",
            addAComment: "Добавить комментарий...",
            deleteComment: "Вы уверены, что хотите удалить комментарий?",
            edited: "Отредактировано",
            comments: "Комментарии",
            addComment: "Добавить комментарий",
            workflow: "Рабочий процесс",
            workflowDetail: "Детали рабочего процесса",
            workflowPerm: "Разрешения рабочего процесса",
            perm: "Разрешения",
            detail: "Детали",
            userPerm: "Пользовательские разрешения",
            deleteCard: "Удалить карточку",
            createCard: "Создать карточку",
            editCard: "Редактировать карточку",
            dragCard: "Перетащить карточку",
            allWorkflow: "Все рабочие процессы",
            createworkflow: "Создать рабочий процесс",
            editDragActive: "Редактирование активно",
            editSortOrder: "Изменить порядок",
            deleteWorkflow: "Вы уверены, что хотите удалить этот рабочий процесс?",
            permEditTask: "У вас нет разрешения на редактирование этой задачи",
            permEditTaskDes: "Обратитесь к администратору для получения разрешений на редактирование.",
            createTaskError: "У вас нет разрешения на создание задач",
            createTaskErrorDesc: "Обратитесь к администратору для получения разрешений на создание задач.",
            moveTaskError: "У вас нет разрешения на изменение статуса задачи",
            moveTaskErrorDesc: "Обратитесь к администратору для получения разрешений на изменение статуса задачи.",
            deleteTaskError: "У вас нет разрешения на удаление задач",
            deleteTaskErrorDesc: "Обратитесь к администратору для получения разрешений на удаление задач.",
            permissionError: "У вас нет прав на создание задач",
            permissionErrorDesc: "Пожалуйста, свяжитесь с вашим администратором для получения разрешения на создание задач",
            whatsappContactProfileTitle: "Профиль {name} / {number}",
            createTaskVisitor: "Создать задачу (посетитель)",
            editWorkflow: "Редактировать рабочий процесс",
            visitor: "Профиль посетителя",
            createTaskMessage: "Создать задачу (Сообщение)",
            createStage: "Создать этап",
            stagesAndStatuses: "Этапы и статусы",
            workflowCreateDesc: "Описание рабочего процесса",
            subTasks: "Подзадачи",
            followers: "Подписчики",
            collaborators: "Совместные работники",
            addRelations: "Добавить отношения",
            relations: "отношения",
            main: "Главная вкладка",
            name: "имя",
            completedOfCheck: "{completed} из {total} задач выполнено",
            workflowUpdateMs: "Рабочий процесс успешно обновлен",
            taskUpdateMs: "Задача успешно обновлена",
            workflowCreatedMs: "Рабочий процесс успешно создан",
            workflowCreateError: "Не удалось создать рабочий процесс",
            taskCreatedMs: "Задача успешно создана",
            settingsDesc3: "Кроме того, модуль задач Supsis позволяет создавать собственный рабочий процесс с настраиваемой автоматизацией, что позволяет управлять задачами более эффективно и улучшать сотрудничество в команде.",
            settingsDesc4: "Таким образом, вы можете подробно отслеживать каждую из ваших задач, назначать задачи членам команды и общим образом управлять вашими бизнес-процессами более эффективно. Модуль задач Supsis предоставляет вам комплексное решение для управления задачами и координации команды.",
            settingsDesc2: "Модуль задач Supsis позволяет не упускать ни одной задачи. Вы можете фильтровать задачи по любому параметру, отслеживать нагрузку на каждом этапе рабочего процесса и организовывать свой календарь в соответствии с вашим графиком.",
            settingsDesc1: "Модуль задач позволяет организовывать совместную работу, делегировать задачи и отслеживать прогресс вашей команды. Вы можете настроить ваши задачи в соответствии с вашими потребностями, выбрав любое представление, и создать собственные рабочие процессы с помощью автоматизации.",
            taskModuleSettingsTitle: "Настройки модуля задачи",
            high: "Высокий",
            medium: "Средний",
            low: "Низкий",
            priority: "Приоритет",
            addExistsSubtask: "Добавить существующую подзадачу",
            addSubtask: "Добавить подзадачу",
            add: "Добавить",
            newCheckList: "Новый список дел",
            subtaskTitle: "Заголовок подзадачи",
            view: "Посмотреть",
            attachFiles: "Прикрепить файлы",
            createTaskDesc: "Описание задачи",
            title: "заглавие",
            createWorkflow: "Создать рабочий процесс",
            editTask: "Редактировать задачу",
            createTask: "Создать задачу",
            deleteColumnCont: "Вы уверены, что хотите удалить этот столбец?",
            changeStage: "Изменить стадию",
            filterBar: {
                searchTasksPlaceholder: "Поиск в задачах...",
                otherUsers: "Другие пользователи",
                searchUserPlaceholder: "Поиск пользователя...",
                filter: "Фильтр",
                clearFilters: "Очистить фильтры",
                apply: "Применить",
                prioritySelection: "Выбор приоритета задачи",
                priorityDescription: "Вы можете фильтровать задачи по уровню приоритета. Выберите уровни приоритета для фильтрации.",
                aboutPriorityLevels: "О уровнях приоритета",
                priorityInfoText: "Уровни приоритета указывают на важность задач. Задачи с высоким приоритетом показывают работу, на которой вашей команде следует сосредоточиться в первую очередь, а задачи с низким приоритетом указывают на менее срочную работу.",
                userSelection: "Выбор пользователя",
                assigneesDescription: "Вы можете фильтровать по назначенным пользователям. Выберите пользователей, чтобы видеть только назначенные им задачи.",
                unassigned: "Не назначено",
                ownerSelection: "Выбор владельца задачи",
                ownerDescription: "Вы можете фильтровать по владельцам задач. Выберите пользователей, чтобы видеть только их задачи.",
                searchOwnerPlaceholder: "Поиск владельца задачи...",
                followersSelection: "Выбор подписчиков задачи",
                followersDescription: "Вы можете фильтровать по подписчикам задач. Выберите пользователей, чтобы видеть только задачи, на которые они подписаны.",
                searchFollowerPlaceholder: "Поиск подписчика...",
                creatorSelection: "Выбор создателя задачи",
                creatorDescription: "Вы можете фильтровать по создателю задачи или системе. Выберите пользователей или типы системы для фильтрации задач.",
                createdBySystem: "Создано системой",
                createdByUsers: "Создано пользователями",
                searchCreatorPlaceholder: "Поиск пользователя...",
                filterByCreatedDate: "Фильтр по дате создания",
                today: "Сегодня",
                thisWeek: "На этой неделе",
                thisMonth: "В этом месяце",
                startDate: "Дата начала",
                endDate: "Дата окончания",
                aboutDateFilter: "О фильтре даты",
                filterByStartDate: "Фильтр по дате начала",
                filterByEndDate: "Фильтр по дате окончания",
                overdueTasks: "Просроченные задачи",
                showOverdueTasks: "Показать просроченные задачи",
                importantInfo: "Важная информация",
                filterByUpdateDate: "Фильтр по дате обновления",
                taskTags: "Теги задач",
                searchTagPlaceholder: "Поиск тега...",
                tagsLoading: "Загрузка тегов...",
                noTagsMatchingSearch: "Нет тегов, соответствующих критериям поиска.",
                noTagsCreated: "Теги пока не созданы.",
                aboutTags: "О тегах",
                pipelineSelection: "Выбор статуса пайплайна",
                searchPipelinePlaceholder: "Поиск пайплайна...",
                order: "Порядок",
                pipelinesLoading: "Загрузка пайплайнов...",
                noPipelinesMatchingSearch: "Нет пайплайнов, соответствующих критериям поиска.",
                noPipelinesCreated: "Пайплайны пока не созданы.",
                aboutPipelines: "О пайплайнах",
                selected: "выбрано",
                closeTask: "Закрыть задачу",
                tabPriorities: "Приоритет",
                tabOwners: "Владелец задачи",
                tabFollowers: "Подписчики задачи",
                tabCreatedBy: "Создатель",
                tabCreatedDate: "Дата создания",
                tabUpdateDate: "Дата обновления",
                tabStartDate: "Дата начала",
                tabEndDate: "Дата окончания",
                tabTags: "Теги",
                tabOverdue: "Просроченные задачи",
                tabStatus: "Статус",
                tabSortBy: "Сортировка",
                sortBySelection: "Выбор сортировки",
                sortByDescription: "Выберите порядок отображения задач. Самые новые задачи отображаются первыми.",
                sortByCreatedAt: "По дате создания",
                sortByCreatedAtDescription: "Задачи сортируются от новейшей к старейшей по дате создания.",
                sortByUpdatedAt: "По дате обновления",
                sortByUpdatedAtDescription: "Задачи сортируются от последнего обновления к старейшему.",
                sortByEndDate: "По дате окончания",
                sortByEndDateDescription: "Задачи сортируются по дате окончания от ближайшей к дальнейшей.",
                aboutSortBy: "О сортировке",
                sortByInfoText: "Без выбранной сортировки в канбан-представлении используется порядок перетаскивания, в списке — дата создания.",
                priorityLowest: "Самый низкий приоритет",
                priorityLow: "Низкий приоритет",
                priorityMedium: "Средний приоритет",
                priorityHigh: "Высокий приоритет",
                priorityHighest: "Самый высокий приоритет",
                createdByApi: "Задачи, созданные через API",
                createdByChatbot: "Задачи, созданные Chatbot",
                createdByAutomation: "Задачи, созданные автоматизацией",
                dateRangeCreatedDescription: "Установите даты начала и окончания для фильтрации задач, созданных в выбранном диапазоне дат. Этот фильтр фильтрует задачи по дате создания (createdAt).",
                dateInfoCreatedText: "Фильтр даты ограничивает результаты по дате создания задач. Таким образом вы можете легко найти задачи, созданные в определённый период времени.",
                dateRangeStartDescription: "Установите дату начала для фильтрации задач, созданных в выбранном диапазоне дат. Этот фильтр фильтрует задачи по дате начала (startDate).",
                dateInfoStartText: "Фильтр даты ограничивает результаты по дате начала задач. Таким образом вы можете легко найти задачи, которые начнутся в определённый период времени.",
                dateRangeEndDescription: "Установите дату окончания для фильтрации задач, созданных в выбранном диапазоне дат. Этот фильтр фильтрует задачи по дате окончания (endDate).",
                dateInfoEndText: "Фильтр даты ограничивает результаты по дате окончания задач. Таким образом вы можете легко найти задачи, которые закончатся в определённый период времени.",
                dateRangeUpdateDescription: "Установите даты начала и окончания для фильтрации задач, обновлённых в выбранном диапазоне дат. Этот фильтр фильтрует задачи по дате обновления (updatedAt).",
                dateInfoUpdateText: "Фильтр даты ограничивает результаты по дате последнего обновления задач. Таким образом вы можете легко найти задачи, обновлённые в определённый период времени.",
                overdueDescription: "Вы можете фильтровать задачи, срок выполнения которых истёк и которые ещё не завершены. Когда этот фильтр активен, будут отображаться только просроченные задачи.",
                overdueDetail: "Задачи, срок выполнения которых истёк и которые ещё не завершены, будут отображаться при активном фильтре. Обычно это задачи, с которыми вашей команде нужно разобраться как можно скорее.",
                overdueInfoText: "Просроченные задачи — это задачи, срок выполнения которых истёк, но они ещё не завершены. Эти задачи указывают на важную работу, требующую внимания вашей команды.",
                tagsDescription: "Вы можете фильтровать задачи по их тегам. Будут отображаться задачи с выбранными вами тегами.",
                tagsInfoText: "Теги помогают категоризировать задачи и находить их легче. Если вы выберете несколько тегов, будут отображаться задачи с любым из выбранных тегов.",
                pipelineDescription: "Вы можете фильтровать задачи по статусу пайплайна. Выбрав нужные пайплайны, вы можете видеть только задачи на этих этапах.",
                pipelinesInfoText: "Пайплайны показывают, на каком этапе находятся задачи. Если вы выберете несколько пайплайнов, будут отображаться задачи в любом из выбранных пайплайнов."
            },
            assignees: "Назначенные лица",
            owner: "Владелец",
            stage: "Стадия",
            writeSomething: "Напишите что-нибудь",
            selectAssginee: "Выберите исполнителя",
            assignee: "Исполнитель",
            enterNewTaskDesc: "Введите описание новой задачи",
            enterNewTaskTitle: "Введите заголовок новой задачи",
            task: "Задача",
            deleteTaskCont: "Вы уверены, что хотите удалить эти задачи?",
            deleteWorkFlowCont: "Вы уверены, что хотите удалить этот рабочий процесс?",
            completed: "Завершено",
            todo: "Дела",
            kanbanBoard: "Доска Канбан",
            listView: "Список",
            taskNotifications: "Уведомления о задачах",
            reports: "Отчёты",
            workflowSettings: "Настройки рабочего процесса",
            trashBin: "Корзина",
            taskReports: {
                title: "Отчёты по задачам",
                selectWorkflow: "Выберите рабочий процесс",
                filters: "Фильтры",
                clear: "Очистить",
                dateRange: "Диапазон дат:",
                dateRangePlaceholder: "Начало - Конец",
                assignees: "Назначенные:",
                selectUser: "Выберите пользователя",
                unassigned: "Не назначено",
                priority: "Приоритет:",
                selectPriority: "Выберите приоритет",
                emptyTitle: "Выберите рабочий процесс для просмотра отчётов",
                emptyDescription: "Выберите рабочий процесс выше для просмотра отчётов по задачам.",
                loadingTitle: "Подготовка отчёта",
                loadingSubtitle: "Анализ данных задач...",
                tasksClosed: "задач закрыто",
                tasksUpdated: "задач обновлено",
                tasksCreated: "задач создано",
                upcomingDeadlines: "Предстоящие сроки",
                statusOverview: "Обзор статуса",
                statusOverviewSubtitle: "Просматривайте статус ваших тикетов с первого взгляда.",
                totalTickets: "Всего тикетов",
                priorityDistribution: "Распределение приоритетов",
                teamWorkload: "Нагрузка команды",
                tooltipTasks: "{name}: {count} задач ({percentage}%)",
                errorTitle: "Ошибка при загрузке отчёта",
                retry: "Попробовать снова",
                last7Days: "За последние 7 дней",
                dateRangeIn: "между {start} - {end}",
                upcomingCount: "{count} элементов имеют предстоящие сроки (следующие 7 дней)",
                upcomingCountZero: "0 элементов имеют предстоящие сроки (следующие 7 дней)",
                upcomingInRange: "{count} элементов имеют сроки ({start} - {end})",
                upcomingInRangeZero: "0 элементов имеют сроки ({start} - {end})",
                invalidWorkflowId: "Неверный формат ID рабочего процесса: {id}",
                loadSuccess: "Данные отчёта успешно загружены.",
                unknownError: "Произошла неизвестная ошибка",
                error: "Ошибка"
            },
            taskNotification: {
                title: "Настройки уведомлений о задачах",
                description: "Вы можете управлять настройками уведомлений о задачах здесь."
            },
            workflowSandbox: {
                title: "Удалённые рабочие процессы",
                description: "Рабочие процессы, не используемые в течение 30 дней, автоматически удаляются системой",
                emptyState: "Нет удалённых рабочих процессов в корзине",
                unnamedWorkflow: "Рабочий процесс без названия",
                restore: "Восстановить",
                permanentlyDelete: "Удалить навсегда",
                unknown: "Неизвестно",
                user: "Пользователь",
                restoreConfirmTitle: "Вы уверены, что хотите восстановить этот рабочий процесс?",
                restoreConfirmContent: "Рабочий процесс {title} будет восстановлен.",
                restoreSuccess: "Рабочий процесс успешно восстановлен",
                restoreFailed: "Восстановление не удалось",
                deleteConfirmTitle: "Вы уверены, что хотите навсегда удалить этот рабочий процесс?",
                deleteConfirmContent: "Рабочий процесс {title} будет удалён навсегда. Это действие нельзя отменить.",
                deleteOkText: "Да, удалить навсегда",
                cancel: "Отмена",
                deleteSuccess: "Рабочий процесс удалён навсегда",
                deleteFailed: "Окончательное удаление не удалось",
                loadError: "Ошибка при загрузке удалённых рабочих процессов"
            },
            priority_lowest: "Lowest",
            priority_low: "Low",
            priority_medium: "Medium",
            priority_high: "High",
            priority_highest: "Highest",
            archivingDate: "Дата архивирования",
            notAuthorizedCreateTask: "У вас нет прав на создание задачи",
            notAuthorizedCreateTaskDesc: "У вас нет прав на выполнение этого действия.",
            taskDesc: "Описание задачи",
            archiveAndTrash: "Архив и корзина",
            trash: "Корзина",
            loading: "Загрузка...",
            startDate: "Дата начала",
            endDate: "Дата окончания",
            clearFilter: "Очистить фильтр",
            noArchivedTasks: "Архивных задач не найдено",
            noDeletedTasks: "В корзине задач не найдено",
            total: "Всего",
            error: "Ошибка",
            moveToBoard: "Переместить на доску",
            unarchive: "Восстановить из архива",
            taskMovedToBoard: "Задача перемещена на доску",
            taskMoveError: "При перемещении задачи на доску произошла ошибка",
            taskDeleted: "Задача удалена",
            taskDeleteError: "При удалении задачи произошла ошибка",
            taskUnarchived: "Задача восстановлена из архива",
            taskUnarchiveError: "При восстановлении задачи из архива произошла ошибка",
            aprobado: "Aprobado",
            kanbanSettings: {
                cancel: "إلغاء",
                card: "إعدادات البطاقة",
                column: "إعدادات العمود",
                kanban: "إعدادات كانبان",
                save: "حفظ",
                selectField: "اختر حقلًا",
                selectFieldPlaceholder: "اختر حقلًا",
                selectFields: "اختر الحقول التي ستظهر في البطاقة",
                title: "الإعدادات"
            }
        },
        permissionErrors: {
            userCreate: "У вас нет разрешения на добавление пользователей. Пожалуйста, проконсультируйтесь с администратором.",
            userRead: "У вас нет разрешения на просмотр пользователей. Пожалуйста, проконсультируйтесь с администратором.",
            userUpdate: "У вас нет разрешения на обновление пользователей. Пожалуйста, проконсультируйтесь с администратором.",
            userDelete: "У вас нет разрешения на удаление пользователей. Пожалуйста, проконсультируйтесь с администратором.",
            visitorBlock: "У вас нет разрешения на блокировку посетителей. Пожалуйста, проконсультируйтесь с администратором.",
            visitorUnblock: "У вас нет разрешения на разблокировку посетителей. Пожалуйста, проконсультируйтесь с администратором.",
            visitorDetailRead: "У вас нет разрешения на просмотр сведений о посетителях. Пожалуйста, проконсультируйтесь с администратором.",
            visitorListRead: "У вас нет разрешения на просмотр списка посетителей. Пожалуйста, проконсультируйтесь с администратором.",
            visitorDelete: "У вас нет разрешения на удаление посетителей. Пожалуйста, проконсультируйтесь с администратором.",
            visitorExcel: "У вас нет разрешения на получение Excel-вывода. Пожалуйста, проконсультируйтесь с администратором.",
            visitorUpdate: "У вас нет разрешения на обновление посетителей. Пожалуйста, проконсультируйтесь с администратором.",
            bannedVisitorRead: "У вас нет разрешения на просмотр списка заблокированных посетителей. Пожалуйста, проконсультируйтесь с администратором.",
            bannedWordCreate: "У вас нет разрешения на добавление запрещенных слов. Пожалуйста, проконсультируйтесь с администратором.",
            bannedWordRead: "У вас нет разрешения на просмотр запрещенных слов. Пожалуйста, проконсультируйтесь с администратором.",
            bannedWordDelete: "У вас нет разрешения на удаление запрещенных слов. Пожалуйста, проконсультируйтесь с администратором.",
            chatRead: "У вас нет разрешения на просмотр чатов. Пожалуйста, проконсультируйтесь с администратором.",
            chatUpdate: "У вас нет разрешения на редактирование чатов. Пожалуйста, обратитесь к вашему администратору.",
            archiveRead: "У вас нет разрешения на просмотр архивов. Пожалуйста, обратитесь к вашему администратору.",
            roleCreate: "У вас нет разрешения на добавление ролей. Пожалуйста, обратитесь к вашему администратору.",
            roleRead: "У вас нет разрешения на просмотр ролей. Пожалуйста, обратитесь к вашему администратору.",
            roleUpdate: "У вас нет разрешения на обновление ролей. Пожалуйста, обратитесь к вашему администратору.",
            roleDelete: "У вас нет разрешения на удаление ролей. Пожалуйста, обратитесь к вашему администратору.",
            departmentCreate: "У вас нет разрешения на добавление отделов. Пожалуйста, обратитесь к вашему администратору.",
            departmentRead: "У вас нет разрешения на просмотр отделов. Пожалуйста, обратитесь к вашему администратору.",
            departmentUpdate: "У вас нет разрешения на обновление отделов. Пожалуйста, обратитесь к вашему администратору.",
            departmentDelete: "У вас нет разрешения на удаление отделов. Пожалуйста, обратитесь к вашему администратору.",
            preparedContentCreate: "У вас нет разрешения на создание готового контента. Пожалуйста, обратитесь к вашему администратору.",
            preparedContentRead: "У вас нет разрешения на просмотр готового контента. Пожалуйста, обратитесь к вашему администратору.",
            preparedContentUpdate: "У вас нет разрешения на обновление готового контента. Пожалуйста, обратитесь к вашему администратору.",
            preparedContentDelete: "У вас нет разрешения на удаление готового контента. Пожалуйста, обратитесь к вашему администратору.",
            welcomeCreate: "У вас нет разрешения на создание приветственных сообщений. Пожалуйста, обратитесь к вашему администратору.",
            welcomeRead: "У вас нет разрешения на просмотр приветственных сообщений. Пожалуйста, обратитесь к вашему администратору.",
            welcomeUpdate: "У вас нет разрешения на обновление приветственных сообщений. Пожалуйста, обратитесь к вашему администратору.",
            welcomeDelete: "У вас нет разрешения на удаление приветственных сообщений. Пожалуйста, обратитесь к вашему администратору.",
            settingCreate: "У вас нет разрешения на создание настроек. Пожалуйста, обратитесь к администратору.",
            settingRead: "У вас нет разрешения на просмотр настроек. Пожалуйста, обратитесь к администратору.",
            settingUpdate: "У вас нет разрешения на обновление настроек. Пожалуйста, обратитесь к администратору.",
            settingDelete: "У вас нет разрешения на удаление настроек. Пожалуйста, обратитесь к администратору.",
            reportCreate: "У вас нет разрешения на создание отчетов. Пожалуйста, обратитесь к администратору.",
            reportRead: "У вас нет разрешения на просмотр отчетов. Пожалуйста, обратитесь к администратору.",
            reportUpdate: "У вас нет разрешения на обновление отчетов. Пожалуйста, обратитесь к администратору.",
            reportDelete: "У вас нет разрешения на удаление отчетов. Пожалуйста, обратитесь к администратору.",
            offlineSupportRequestCreate: "У вас нет разрешения на создание запросов в офлайн-поддержку. Пожалуйста, обратитесь к администратору.",
            offlineSupportRequestRead: "У вас нет разрешения на просмотр запросов в офлайн-поддержку. Пожалуйста, обратитесь к администратору.",
            offlineSupportRequestUpdate: "У вас нет разрешения на ответ на запросы в офлайн-поддержку. Пожалуйста, обратитесь к администратору.",
            offlineSupportRequestDelete: "У вас нет разрешения на удаление запросов в офлайн-поддержку. Пожалуйста, обратитесь к администратору.",
            catalogCreate: "У вас нет разрешения на создание каталогов. Пожалуйста, обратитесь к администратору.",
            catalogRead: "У вас нет разрешения на просмотр каталогов. Пожалуйста, обратитесь к администратору.",
            catalogUpdate: "У вас нет разрешения на обновление каталогов. Пожалуйста, обратитесь к администратору.",
            catalogDelete: "У вас нет разрешения на удаление каталогов. Пожалуйста, обратитесь к администратору.",
            chatbotStoryCreate: "У вас нет разрешения на создание историй чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotStoryRead: "У вас нет разрешения на просмотр историй чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotStoryUpdate: "У вас нет разрешения на обновление историй чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotStoryDelete: "У вас нет разрешения на удаление историй чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotTemplateRead: "У вас нет разрешения на просмотр шаблонов чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotTemplateAiRead: "У вас нет разрешения на просмотр шаблонов искусственного интеллекта чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotIntegrationsRead: "У вас нет разрешения на просмотр интеграций чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotArchiveRead: "У вас нет разрешения на просмотр архивов чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotEntitiesRead: "У вас нет разрешения на просмотр сущностей чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotEntitiesCreate: "У вас нет разрешения на создание сущностей чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotEntitiesUpdate: "У вас нет разрешения на обновление сущностей чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotEntitiesDelete: "У вас нет разрешения на удаление сущностей чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotReportRead: "У вас нет прав на просмотр отчетов чатбота. Пожалуйста, обратитесь к администратору.",
            chatbotTrainRead: "У вас нет прав на просмотр обучения чатбота. Пожалуйста, обратитесь к администратору.",
            chatbotSegmentCreate: "У вас нет прав на создание сегментов пользователей чатбота. Пожалуйста, обратитесь к администратору.",
            chatbotSegmentRead: "У вас нет прав на просмотр сегментов пользователей чатбота. Пожалуйста, обратитесь к администратору.",
            chatbotSegmentUpdate: "У вас нет прав на обновление сегментов пользователей чатбота. Пожалуйста, обратитесь к администратору.",
            chatbotSegmentDelete: "У вас нет прав на удаление сегментов пользователей чатбота. Пожалуйста, обратитесь к администратору.",
            integrationsRead: "У вас нет прав на просмотр страницы интеграций. Пожалуйста, обратитесь к администратору.",
            whatsappIntegrationRead: "У вас нет прав на просмотр страницы интеграции WhatsApp. Пожалуйста, обратитесь к администратору.",
            instagramIntegrationRead: "У вас нет прав на просмотр страницы интеграции Instagram. Пожалуйста, обратитесь к администратору.",
            telegramIntegrationRead: "У вас нет прав на просмотр страницы интеграции Telegram. Пожалуйста, обратитесь к администратору.",
            integrationCreate: "У вас нет прав на активацию интеграций. Пожалуйста, обратитесь к администратору.",
            triggerCreate: "У вас нет прав на создание триггеров. Пожалуйста, обратитесь к администратору.",
            triggerRead: "У вас нет прав на просмотр триггеров. Пожалуйста, обратитесь к администратору.",
            triggerUpdate: "У вас нет прав на обновление триггеров. Пожалуйста, обратитесь к администратору.",
            triggerDelete: "У вас нет прав на удаление триггеров. Пожалуйста, обратитесь к администратору.",
            billingRead: "У вас нет разрешения на просмотр счетов. Пожалуйста, свяжитесь с вашим администратором.",
            taskCreate: "У вас нет разрешения на создание задач. Пожалуйста, свяжитесь с вашим администратором.",
            taskRead: "У вас нет разрешения на просмотр задач. Пожалуйста, свяжитесь с вашим администратором.",
            taskUpdate: "У вас нет разрешения на обновление задач. Пожалуйста, свяжитесь с вашим администратором.",
            taskDelete: "У вас нет разрешения на удаление задач. Пожалуйста, свяжитесь с вашим администратором.",
            calendarCreate: "У вас нет разрешения на создание календаря/бронирования. Пожалуйста, свяжитесь с вашим администратором.",
            calendarRead: "У вас нет разрешения на просмотр календаря/бронирования. Пожалуйста, свяжитесь с вашим администратором.",
            calendarUpdate: "У вас нет разрешения на обновление календаря/бронирования. Пожалуйста, свяжитесь с вашим администратором.",
            calendarDelete: "У вас нет разрешения на удаление календаря/бронирования. Пожалуйста, свяжитесь с вашим администратором.",
            mailCreate: "У вас нет разрешения на создание писем. Пожалуйста, свяжитесь с вашим администратором.",
            mailRead: "У вас нет разрешения на просмотр писем. Пожалуйста, свяжитесь с вашим администратором.",
            mailUpdate: "У вас нет разрешения на обновление писем. Пожалуйста, свяжитесь с вашим администратором.",
            mailDelete: "У вас нет разрешения на удаление писем. Пожалуйста, свяжитесь с вашим администратором."
        },
        message: {
            artificialIntelligence: "Искусственный интеллект",
            appBreadcrumb: {
                tasks: "Задачи",
                broadcastLabel: "Массовое сообщение",
                walletBalanceTooltip: "Баланс кошелька: {amount}₺",
                broadcastStatusCreated: "Создано",
                broadcastStatusScheduled: "Запланировано",
                broadcastStatusQueued: "В очереди",
                broadcastStatusRunning: "Отправка",
                broadcastStatus: "Статус",
                broadcastProgress: "Прогресс"
            },
            confirmDeleteRedStationIntegration: "Вы уверены, что хотите удалить этот канал Кызыл Сантраль?",
            enterRedStationIntegration: "Введите учётные данные API Кызыл Сантраль",
            redStationIntegration: "Интеграция Кызыл Сантраль",
            copyChannelID: "Копировать ID канала",
            redStationChannels: "Каналы Кызыл Сантраль",
            bannedUserError: "Произошла ошибка при добавлении блокировки.",
            bannedUserSuccess: "Блокировка успешно добавлена.",
            selectAtLeastOneOption: "Пожалуйста, выберите хотя бы один вариант.",
            enterValidValue: "Пожалуйста, введите действительное значение.",
            enterValidIpAddress: "Пожалуйста, введите действительный IP-адрес.",
            enterValidVisitorId: "Пожалуйста, введите действительный ID посетителя.",
            enterValidWhatsappNumber: "Пожалуйста, введите действительный номер WhatsApp.",
            invalidEmailAddress: "Пожалуйста, введите действительный email адрес.",
            bannedUser: "Заблокирован",
            unbannedUser: "Не заблокирован",
            banModalDescription: "Введите платформу и значение для блокировки пользователя.",
            exampleNumber: "Пример номера: 905551111111",
            clearSelectedFiltersTooltip: "Очищает выбранные значения фильтров на странице",
            minutesText: "{count} минут",
            secondsText: "{count} секунд",
            downloadCooldownWarning: "Пожалуйста, подождите {time} для создания нового запроса на загрузку.",
            excelExportReceiveQuestion: "Как вы хотели бы получить файл Excel?",
            sendToMe: "Отправить мне",
            sendToSomeoneElse: "Отправить кому-то еще",
            enterEmailAddress: "Введите email адрес",
            exportRequestSuccess: "Ваш запрос создан, мы отправим его вам по электронной почте как можно скорее",
            maxDateRangeWarning: "Выбранный диапазон дат может быть максимум 45 дней",
            ticketOnlyMail: "Этот запрос можно ответить только по электронной почте. Сообщения, отправленные через WhatsApp, не могут быть переадресованы.",
            cardInfoUpdateError: "Произошла ошибка при обновлении информации о карте",
            billingInfoSavedSuccessfully: "Ваша платежная информация успешно сохранена",
            billingInfoSaveError: "Ошибка при сохранении платежной информации:",
            paymentInfoSavedSuccessfully: "Ваша платежная информация успешно сохранена",
            annualDiscount: "Получите 20% скидку на годовые покупки",
            annualDiscountDescription: "Вы можете значительно сэкономить, выбрав годовую подписку.",
            payOnlyForUsedFeatures: "Платите только за то, что используете",
            payOnlyForUsedFeaturesDescription: "Платите только за функции, которые вы используете, не платите за лишнее.",
            cancelAnytime: "Отменяйте в любое время",
            cancelAnytimeDescription: "Нет необходимости в долгосрочных контрактах, вы можете отменить в любое время.",
            noPermissionDescription: "У вас нет разрешения на выполнение этого действия.",
            creditCardRequired: "Требуется информация о кредитной карте",
            creditCardRequiredDescription: "У вас есть платные подписки. Вы можете продолжить, введя информацию о кредитной карте или отменив подписки.",
            creditCardRequiredDescription2: "Вам необходимо ввести информацию о кредитной карте, так как у вас есть платные подписки в вашем аккаунте.",
            subscriptionManagement: "Управление подписками",
            addCreditCard: "Добавить информацию о кредитной карте",
            transferOwnership: "Передать Владение и Перенаправить",
            errorLoadingAgents: "Произошла ошибка при загрузке агентов",
            pleaseFillRequiredFields: "Пожалуйста, заполните обязательные поля",
            callStartedSuccessfully: "Звонок успешно начат",
            errorStartingCall: "Произошла ошибка при начале звонка",
            errorLoadingData: "Произошла ошибка при загрузке данных",
            errorLoadingDataPhoneNumbers: "Произошла ошибка при загрузке номеров телефонов",
            noVariablesFound: "В промпте не найдено переменных. Переменные должны быть в формате <code v-pre>{{ имя_переменной }}</code>.",
            aiVoiceAgentSpecialVariables: "Значения Специальных Переменных",
            addAiVoiceAgentChannel: "Добавить Канал",
            multiLanguageSupport: "Поддержка нескольких языков",
            customerService247: "Обслуживание клиентов 24/7",
            autoCallAnswer: "Автоматический ответ на звонки",
            aiVoiceAgentChannelRequired: "Требуется Канал ИИ Голосового Агента",
            aiVoiceAgentChannelRequiredDescription: "Вам необходимо добавить канал ИИ Голосового Агента для использования этой функции.",
            aiVoiceAgentChannelRequiredDescription2: "ИИ Голосовой Агент - это помощник на базе искусственного интеллекта, который может совершать телефонные звонки с вашими клиентами.",
            startCall: "Начать Звонок",
            selectContactFieldPlaceholder: "Выберите контактную информацию",
            aiVoiceAgentVariableValuePlaceholder: "Введите значение",
            aiVoiceAgentVariables: "Информация о Переменных Агента",
            aiVoiceAgentVariableManual: "Вручную",
            aiVoiceAgentVariableContact: "Контактная Информация",
            toNumberHelpText: "Должен быть в формате E.164. Пример: +905321234567",
            toNumber: "Номер для Звонка",
            selectAiVoiceAgentHelpText: "Если не выбран, будет использован исходящий агент номера по умолчанию",
            selectAiVoiceAgent: "Выберите агента (необязательно)",
            aiVoiceAgent: "Агент",
            selectFromNumber: "Выберите номер звонящего",
            fromNumber: "Номер Звонящего",
            startAiCall: "Начать Звонок с ИИ Голосовым Агентом",
            aiCall: "Совершить Звонок с ИИ Голосовым Агентом",
            groupByNone: "Группировка не применяется",
            groupByAgent: "Группировать контакты по агентам из их последней сессии",
            groupByDepartment: "Группировать контакты по отделу, выбранному в их последней сессии",
            groupByChannel: "Группировать контакты по каналу, откуда они пришли",
            groupByPlatform: "Группировать контакты по платформе, откуда они пришли",
            groupByWebsite: "Группировать контакты по веб-сайту, откуда они пришли",
            groupByTag: "Группировать контакты по их тегам",
            groupByAnswerStatus: "Группировать контакты по статусу ответа из их последней сессии",
            groupByOwner: "Группировать контакты по их владельцам",
            changeGroupBy: "Изменить Режим Группировки",
            changeSortMode: "Изменить Режим Сортировки",
            selectIcon: "Выбрать Иконку",
            iconPickerTitle: "Выбор Иконки",
            searchIconPlaceholder: "Поиск иконки...",
            profileFieldsDescriptionChat: "Нажмите, чтобы настроить поля профиля",
            createCommentSuccess: "Комментарий успешно создан",
            createCommentError: "Произошла ошибка при создании комментария",
            updateCommentSuccess: "Комментарий успешно обновлен",
            updateCommentError: "Произошла ошибка при обновлении комментария",
            deleteCommentSuccess: "Комментарий успешно удален",
            deleteCommentError: "Произошла ошибка при удалении комментария",
            formSubmission: "Отправка формы",
            selectForm: "Выберите форму",
            updateOwnerUsers: "Обновить владельцев",
            updateOwnerUsersDesc: "Вы хотите обновить владельцев этого пользователя? Вы можете передать их другому пользователю или оставить без владельца.",
            deposit: "Депозит",
            creditUsage: "Использование кредита",
            businessMarketing: "Маркетинг",
            businessUtility: "Полезность",
            businessAuthentication: "Аутентификация",
            businessService: "Сервис",
            incomingSessionMessage: "Входящее сообщение",
            outgoingSessionMessage: "Исходящее сообщение",
            freeTierConversation: "Бесплатный разговор (FTC)",
            chatStart: "Начать чат",
            wpMessage: "Массовое сообщение в Whatsapp QR",
            pin: "Закрепить",
            rename: "Переименовать",
            browserSpeechRecognitionNotSupported: "Ваш браузер не поддерживает распознавание речи. Мы рекомендуем использовать браузер Chrome.",
            spaceKeyReleaseToSave: "Он будет сохранен, когда вы отпустите клавишу пробела",
            spaceKeyHint: "Вы можете говорить, удерживая клавишу пробела",
            listeningInProgress: "Прослушивание...",
            speakNow: "Говорите сейчас...",
            toggleAllPermissions: "Включить/Выключить все права роли",
            rolePermissions: "Права роли",
            roleSaved: "Роль успешно сохранена",
            creatingRole: "Создание роли...",
            savingRole: "Сохранение роли...",
            editRole: "Редактировать роль",
            newRoleCreate: "Создать новый роль",
            descriptionEmail: "Автоматически добавляет адрес электронной почты посетителя в чате в поле сообщения и позволяет его отправить",
            exampleEmail: "Пример: @email привет",
            nameDescription: "Автоматически добавляет имя посетителя в чате в поле сообщения и позволяет его отправить",
            exampleName: "Пример: @name привет",
            pmDescription: "Позволяет отправить личное сообщение. Эти сообщения могут видеть только другие представители службы поддержки, посетители их не видят.",
            examplePm: "Пример: pm: Это личное сообщение",
            chatShortcuts: "Горячие клавиши чата",
            showSystemStatus: "Показать состояние системы",
            endChatWizard: "Мастер завершения сеанса",
            terminationError: "Произошла ошибка",
            profileFieldsUpdateError: "Произошла ошибка при обновлении полей профиля",
            profileFieldsUpdated: "Поля профиля обновлены",
            aiSuggestionError: "Предложения искусственного интеллекта не могут быть получены",
            profileFieldsDescription: "Вы можете заполнить персонализированные поля профиля для этого человека, чтобы предоставить своей команде больше информации.",
            categoryTags: "Вы можете добавить теги к этому человеку, чтобы быстро его классифицировать.",
            manageTags: "Управление тегами",
            enterNote: "Введите заметку",
            noteDescription: "Вы можете добавить заметки о этом человеке. Эти заметки также будут видны после разговора.",
            suggestedProfileFields: "Предложенные поля профиля:",
            suggestedTags: "Предложенные теги",
            suggestedNote: "Предложенная заметка:",
            applyAll: "Применить все",
            aiSuggestionTitle: "Предложения искусственного интеллекта",
            aiSuggestion: "Предложения ассистента Supsis",
            searchItem: "Поиск элемента",
            makeSelection: "Сделать Выбор",
            channel: "Канал",
            FromName: "Имя Отправителя",
            taskClosingDate: "Дата Закрытия Задачи",
            deleteOperation: "Операция Удаления",
            confirmDeleteTask: "Вы уверены, что хотите удалить эту задачу?",
            taskDeletedSuccess: "Задача успешно удалена",
            taskDeleteError: "Ошибка при удалении задачи",
            selectColumns: "Выберите Столбцы, Которые Вы Хотите Видеть в Таблице",
            linkedinChannels: "Каналы LinkedIn",
            updateLinkedinChannelDesc: "Обновите ваш канал LinkedIn",
            deleteLinkedinChannel: "Удалить Канал LinkedIn",
            confirmDeleteLinkedinChannel: "Вы уверены, что хотите удалить этот канал LinkedIn?",
            contactIdPlaceholder: "ID контакта",
            contactId: "ID контакта",
            enterOwnerId: "Введите ID владельца",
            selectOwner: "Выберите владельца",
            dynamic: "Динамический",
            owner: "Владелец",
            addCollaborator: "Добавить соисполнителя",
            dynamicValue: "Динамическое значение",
            selectCollaborator: "Выберите соисполнителя",
            collaborator: "Соисполнитель",
            collaborators: "Соисполнители",
            addFollower: "Добавить наблюдателя",
            selectFollower: "Выберите наблюдателя",
            followers: "Наблюдатели",
            follower: "Наблюдатель",
            addAssignee: "Добавить исполнителя",
            selectUser: "Выберите пользователя",
            assignees: "Исполнители",
            assignee: "Исполнитель",
            pipelineStage: "Этап воронки",
            selectPipelineStage: "Выберите этап воронки",
            title: "Заголовок",
            taskTitle: "Заголовок задачи",
            description: "Описание",
            taskDescription: "Описание задачи",
            priority: "Приоритет",
            selectPriority: "Выберите приоритет",
            workflow: "Рабочий процесс",
            selectWorkflow: "Выберите рабочий процесс",
            packagePurchase: "Покупка пакета",
            upcomingInvoice: "Предстоящий счет",
            invoiceUpdated: "Счет обновлен",
            invoiceMarkedInvalid: "Счет помечен как недействительный.",
            invoiceUpdateError: "Ошибка обновления счета",
            invoiceMarkInvalidError: "Произошла ошибка при отметке счета как недействительного.",
            refunded: "Возвращено",
            paid: "Оплачено",
            pending: "Ожидается",
            unpaid: "Не оплачено",
            paymentFailed: "Ошибка оплаты",
            paymentProcessError: "Произошла ошибка во время процесса оплаты.",
            paymentSuccessful: "Оплата успешна",
            paymentProcessSuccessful: "Процесс оплаты успешно завершен.",
            invoiceRefund: "Возврат по счету",
            invoiceRefundedSuccessfully: "Возврат по счету успешно выполнен.",
            invoicePaymentError: "Ошибка оплаты счета",
            invoicePaymentProcessError: "Произошла ошибка при оплате счета.",
            invoicePaid: "Счет оплачен",
            invoiceMarkedAsPaid: "Счет успешно помечен как оплаченный.",
            invoicePriceUpdateError: "Произошла ошибка при обновлении цены счета.",
            invoicePriceUpdatedSuccessfully: "Цена счета успешно обновлена.",
            invoicePdf: "PDF счета",
            viewInvoice: "Просмотреть счет",
            makePayment: "Оплатить",
            autoForwardToOwnerForceDescription: "Во всех случаях контакты с владельцем автоматически перенаправляются своему владельцу. Они не остаются в очереди и не передаются чат-боту. Даже если эта настройка отключена, если чат-бот не активен в системе, они все равно будут перенаправлены своему владельцу.",
            autoForwardToOwnerForce: "Автоматическая переадресация владельцу (даже при активном чат-боте)",
            socialMedia: "Социальные сети",
            sms: "СМС",
            crm: "CRM",
            ecommerce: "Электронная коммерция",
            utilities: "Утилиты",
            advertising: "Реклама",
            cancelPlanTitle: "Отмена плана",
            cancelPlanDescription: "После отмены плана пакет будет использоваться до конца срока действия.",
            voteSuccess: "Голос успешно сохранен",
            voteSuccessDescription: "Получен ваш запрос на добавление интеграции {integrationName} в Supsis",
            companyName: "Название компании",
            company: "Компания",
            languageTitle1: "Язык панели по умолчанию",
            languageTitle2: "Язык сообщений по умолчанию",
            languageTitle3: "Регион и часовой пояс",
            languageTitle4: "Автоматическая настройка языка клиента",
            languageTitle5: "Выбор языка сообщений клиента в WebChat",
            languageDesc1: "Устанавливает язык панели Supsis AI",
            languageDesc2: "Вы можете изменить язык сообщений по умолчанию отсюда.",
            languageDesc3: "Устанавливает регион и часовой пояс",
            languageDesc4: "Обеспечивает автоматическое определение языка сообщений клиента с поддержкой ИИ.",
            languageDesc5: "Активирует возможность выбора языка общения клиентом в канале WebChat.",
            featuresTitle1: "Выбор отдела",
            featuresTitle2: "Показать количество клиентов, ожидающих в очереди",
            featuresTitle3: "Ограничение запрещенных слов",
            featuresTitle4: "Разрешить клиентам создавать тикеты",
            featuresTitle5: "Голосовой вызов",
            featuresTitle6: "Видеозвонок",
            featuresTitle7: "Отправка голосовых сообщений (агент)",
            featuresTitle8: "Отправка голосовых сообщений (клиент)",
            featuresTitle9: "Автоматическая передача вызовов",
            featuresTitle10: "Показать чат между представителями",
            featuresTitle11: "Отправка файлов (агент)",
            featuresTitle12: "Отправка файлов в WebChat (клиент)",
            featuresTitle13: "Разрешить отправку сообщений до подключения представителя",
            featuresTitle14: "Скрыть системные сообщения от представителей",
            featuresTitle15: "Разрешить клиенту удалять личную информацию",
            featuresTitle16: "Уведомление о том, что клиент в сети",
            featuresTitle17: "Автоматический перевод",
            featuresTitle18: "Автоматический вход посетителя",
            featuresTitle19: "Совместное использование местоположения в WebChat (клиент)",
            featuresTitle20: "Совместное использование местоположения (представитель)",
            featuresTitle21: "AI помощник чата",
            featuresTitle22: "Очередь для разговоров без владельца",
            featuresTitle23: "Скрыть контактную информацию",
            featuresDesc1: "Обязательная маршрутизация в отделы на основе выбранных клиентом тем.",
            featuresDesc2: "Показывает клиентам их позицию в очереди, когда представители заняты.",
            featuresDesc3: "Предотвращает отправку представителями запрещенных слов, определенных в системе, клиентам, когда активировано ограничение запрещенных слов.",
            featuresDesc4: "Активирует возможность создания тикета в окне WebChat.",
            featuresDesc5: "Активирует функцию голосового вызова в окне WebChat.",
            featuresDesc6: "Активирует функцию видеозвонка в окне WebChat.",
            featuresDesc7: "Позволяет представителям отправлять голосовые сообщения.",
            featuresDesc8: "Позволяет клиентам отправлять голосовые сообщения в канале WebChat.",
            featuresDesc9: "Автоматически назначает ожидающие вызовы доступным представителям.",
            featuresDesc10: "Отображает панель разговора между представителями.",
            featuresDesc11: "Позволяет представителям отправлять файлы.",
            featuresDesc12: "Позволяет клиентам отправлять файлы в канале WebChat.",
            featuresDesc13: "Позволяет клиентам отправлять сообщения до подключения представителя.",
            featuresDesc14: "Скрывает системные сообщения от представителей, предотвращая их просмотр клиентами.",
            featuresDesc15: "Позволяет клиентам удалять свою личную информацию одним нажатием кнопки в окне WebChat.",
            featuresDesc16: "Уведомляет представителей с помощью системного сообщения, когда клиент покидает или возвращается в канал WebChat.",
            featuresDesc17: "Автоматически переводит сообщения от клиентов на язык представителя.",
            featuresDesc18: "Начинает разговор, как только посетитель нажимает на окно.",
            featuresDesc19: "Позволяет клиентам делиться своим местоположением в канале WebChat.",
            featuresDesc20: "Позволяет представителям делиться своим местоположением.",
            featuresDesc21: "Позволяет представителям использовать AI-помощь для исправления опечаток, изменения тона сообщений и генерации ответов с поддержкой AI.",
            featuresDesc22: "Включает эту функцию, чтобы держать людей без владельца в очереди.",
            featuresDesc23: "Предотвращает просмотр номеров телефонов и адресов электронной почты клиентов представителями.",
            featuresTitle24: "Мастер завершения сессии",
            featuresDesc24: "Показывает мастер завершения сессии представителям перед закрытием разговора",
            groupBy: "Группировать",
            privacyPolicyAndTerms: "Политика конфиденциальности / Условия обслуживания",
            privacyPolicyTitle: "Политика конфиденциальности для систем поддержки и чат-ботов Supsis",
            privacyPolicyDescription: "Данная Политика конфиденциальности описывает, как Softcand Yazılım Hizmetleri A.S. (“Softcand,” “мы,” “нас” или “наш”) собирает, использует и раскрывает информацию о пользователях (“вы” или “ваш”) веб-приложения Supsis (“Supsis”). Эта Политика конфиденциальности применяется к информации, которую мы собираем, когда вы используете Supsis; эта информация действительна, когда доступна через наш веб-сайт, мобильные приложения или другие платформы, на которых опубликована Политика конфиденциальности.",
            informationWeCollect: "Информация, которую мы собираем",
            weCollectFollowingInformation: "Мы собираем следующую информацию",
            customerAccountInformation: "Информация о клиентском аккаунте",
            customerAccountData: "При создании аккаунта Supsis мы собираем следующие данные: имя, фамилия, номер телефона и адрес электронной почты.",
            userInformation: "Информация о пользователе",
            userProvidedInformation: "Информация, предоставленная пользователями приложения, включая имя, фамилию и адрес электронной почты.",
            dataDeletionProcess: "Процесс удаления данных",
            dataDeletionProcedures: "Мы следуем этим процедурам для удаления данных",
            automaticDeletion: "Автоматическое удаление",
            automaticDeletionInfo: "Аккаунты клиентов автоматически удаляются при закрытии или после шести месяцев неактивности.",
            directRequest: "Прямой запрос",
            directRequestInfo: "Клиенты могут запросить удаление всех своих данных, связавшись с нами напрямую.",
            websiteVisitorDataDeletion: "Удаление данных посетителей веб-сайта",
            websiteVisitorDataDeletionInfo: "Посетители веб-сайта могут удалить свои данные, включая историю чата, сообщения и файлы, напрямую через интерфейс веб-чата.",
            howToContactUs: "Как с нами связаться",
            contactChannels: "Вы можете связаться с нами через следующие каналы",
            dataProcessingAndSharing: "Обработка и передача данных",
            handleCustomerData: "Мы обрабатываем данные клиентов следующим образом",
            noThirdPartySharing: "Нет передачи третьим лицам",
            noThirdPartySharingInfo: "Supsis не передает данные клиентов никаким третьим лицам, организациям или индивидуумам.",
            promotionalEmails: "Рекламные электронные письма",
            promotionalEmailsInfo: "Мы можем отправлять клиентам рекламные электронные письма; они могут отказаться от этих писем.",
            visitorAndConversationData: "Данные посетителей и разговоров",
            noSharingVisitorData: "Мы не делимся и не используем информацию о посетителях и чатах клиентов.",
            thirdPartyServices: "Сервисы третьих лиц",
            googleOAuth: "Google OAuth",
            googleCalendar: "Google Календарь",
            googleCalendarInfo: "Supsis использует Google Календарь для активации функций, связанных с календарем, в приложении. Данные, синхронизированные из календарей, не передаются никому и видны только пользователю. Когда Google OAuth прекращает действие, все события, синхронизированные из Supsis и Google Календаря, автоматически удаляются.",
            googleAccountPublicProfile: "Публичный профиль Google-аккаунта",
            googleAccountPublicProfileInfo: "Supsis собирает информацию о имени и адресе электронной почты для проверки и аутентификации пользователей во время входа. Эта информация не хранится после проверки.",
            changesToPrivacyPolicy: "Изменения в этой Политике конфиденциальности",
            privacyPolicyUpdateInfo: "Мы можем время от времени обновлять эту Политику конфиденциальности. Если мы внесем существенные изменения, мы уведомим вас через наш веб-сайт или другие каналы связи.",
            privacyPolicyContactInfo: "Если у вас есть вопросы по этой Политике конфиденциальности, пожалуйста, свяжитесь с нами по адресу m@softcand.com.",
            termsOfServiceTitle: "Условия обслуживания для систем поддержки и чат-ботов Supsis",
            lastUpdated: "Последнее обновление",
            inEffect: "В силе",
            importantTerms: "Важно: Эти Условия обслуживания, которые включают нашу Политику конфиденциальности, формируют обязательный контракт между лицом, указанным в процессе 'Регистрации' как пользователь Сервиса (“вы”), и Softcand Yazılım Hizmetleri Anonim Şirketi (торгующая под названием Supsis или Supsis Live Support или Supsis Live Support and Chatbot Systems) (“мы”) и регулируют ваше использование наших веб-сайтов, расположенных на supsis.com (страница продукта), softcand.com (веб-сайт компании) или supsis.live (приложение продукта) или beta.supsis.live (бета-версия приложения продукта). По этой причине эти Условия важны, и вы должны убедиться, что прочитали их внимательно и связались с нами с любыми вопросами перед использованием Сервиса.",
            termsDescription: "Эти Условия обслуживания регулируют ваше использование наших веб-сайтов, расположенных на supsis.com (страница продукта), softcand.com (веб-сайт компании) или supsis.live (приложение продукта) или beta.supsis.live (бета-версия приложения продукта).",
            applicationOfTerms: "Применение условий",
            termsApplyToAllUsers: "Эти Условия применяются ко всем пользователям Сервиса, независимо от того, используете ли вы Сервис от своего имени или от имени другого лица или организации.",
            termsUpdateNotice: "Мы можем обновлять или изменять Условия в любое время по своему усмотрению. Если мы изменим Условия, мы уведомим вас, предупредив через нашу веб-платформу и по электронной почте.",
            termsDisagreementNotice: "Вы должны согласиться с обновленными Условиями, нажав на ваше согласие в уведомлении, представленном вам, прежде чем продолжить использование Сервиса.",
            consumerRightsNotice: "Если вы классифицируетесь как 'потребитель' в соответствии с применимым законодательством, у вас могут быть законные права в соответствии с местным законодательством, которые запрещают все или части некоторых ограничений и исключений, изложенных в этих Условиях, применяться к вам, и в случае запрета они не будут применяться к вам.",
            theService: "Сервис",
            serviceGrant: "Мы предоставляем вам неисключительное, всемирное, непередаваемое, отзывное право использовать Сервис в соответствии с этими Условиями.",
            serviceAccess: "Вы можете получить доступ и использовать Сервис (включая любое случайное копирование, которое происходит в рамках этого использования) в соответствии с этими Условиями.",
            serviceAgentAppointment: "Когда вы входите в Сервис и подключаете аккаунт в социальной сети к Сервису, вы назначаете нас своим агентом в отношении этого Аккаунта для выполнения действий от вашего имени, по вашему указанию (например, ответ на прямое сообщение в Instagram или другой Платформе) при предоставлении вам Сервиса.",
            additionalAccountsAppointment: "Когда вы подключаете дополнительные Аккаунты к Сервису, вы также назначаете нас своим агентом в отношении этих аккаунтов для выполнения действий в рамках Агентства.",
            accountControl: "Вы гарантируете, что контролируете каждый Аккаунт и что вы уполномочены назначить нас своим агентом с полномочиями выполнять действия в рамках Агентства от вашего имени для каждого Аккаунта.",
            serviceAffiliation: "Вы признаете и соглашаетесь с тем, что Сервис не связан и не уполномочен Instagram, Facebook, Twitter или любым другим сервисом социальной сети, для которого мы предоставляем Сервис, и что любой доступ к каждой Платформе (включая через Сервис) регулируется Условиями использования соответствующей Платформы.",
            serviceLinks: "Сервис содержит ссылки на другие веб-сайты, а также Контент, добавленный людьми, отличными от нас. Мы не одобряем, не спонсируем и не утверждаем такой пользовательский Контент или любой Контент, доступный на любом связанном веб-сайте.",
            contentMonitoring: "У нас нет никаких обязательств по мониторингу, редактированию или удалению Контента, загруженного или размещенного нашими пользователями в Сервис и затем размещенного на Аккаунте на любой из Платформ.",
            serviceControl: "Вы признаете и соглашаетесь с тем, что: (1) мы сохраняем контроль над Сервисом и можем изменять, дополнять или прекращать работу Сервиса в любое время по своему усмотрению (мы уведомим вас о любом изменении, которое существенно негативно влияет на функциональность Сервиса); (2) Сервис может быть недоступен время от времени (включая для технического обслуживания), и, насколько это возможно, мы уведомим вас о любом запланированном времени простоя; и (3) мы можем отказать в публикации Контента, который вы добавляете в Сервис, который мы считаем, действуя разумно, не соответствующим разделу 3 этих Условий.",
            yourRightsAndObligations: "Ваши права и обязательства",
            contentAdditionRestriction: "Вы не должны добавлять никакой Контент в Сервис: (1) если у вас нет всех необходимых прав, лицензий и согласий на это; (2) который может привести к нарушению вами или нами любого закона или регулирования или любого другого юридически обязательного правила, кодекса или другого обязательства; (3) который является или который мы, действуя разумно, считаем спамом, непристойным, неподобающим, клеветническим, уничижительным, неприличным, подстрекательским, оскорбительным, порнографическим, угрожающим, оскорбительным, способным разжечь расовую ненависть, незаконным, дискриминационным, богохульным, нарушающим конфиденциальность или нарушающим любое законодательство о конфиденциальности; (4) который может опорочить нас или Сервис; или (5) который нарушает интеллектуальную собственность или другие права любого лица.",
            restrictionsOnServiceUse: "Вы не должны: (1) пытаться дублировать или воспроизводить, или изменять, модифицировать или подготавливать производные работы Сервиса, Контента, который мы публикуем в отношении Сервиса, или любого другого материала, который вы не владеете или на который у вас нет соответствующей лицензии; (2) распространять вирусы или код, который является злонамеренным; (3) использовать Сервис для публикации информации, которая является вводящей в заблуждение или обманчивой; (4) получать доступ к аккаунту другого человека на нашем Сервисе без его разрешения; (5) изменять, отключать, вмешиваться или обходить любой аспект Сервиса или тестировать или реверс-инженерить Сервис, чтобы найти ограничения, уязвимости или избежать возможностей фильтрации; или (6) делать что-либо, что может повлиять на доступ или целостность Сервиса.",
            payments: "Платежи",
            paymentAcknowledgment: "Вы признаете и соглашаетесь с тем, что:",
            paymentMethodDebit: "Мы будем списывать средства с вашего указанного метода оплаты в указанный день выставления счета (день, когда заканчивается ваш пробный период) каждый месяц, год или другой период выставления счета (по мере необходимости) за следующий период выставления счета заранее, если вы не отмените Сервис до этой даты; и",
            cancellationPolicy: "Если вы отмените Сервис, вы продолжите иметь доступ к Сервису до следующей даты выставления счета, и любой возврат любых средств, уплаченных за текущий период выставления счета, осуществляется по нашему усмотрению (то есть, платежи не подлежат возврату, кроме как по нашему усмотрению).",
            intellectualProperty: "Интеллектуальная собственность",
            contentDefinition: "В этих Условиях 'Контент' включает материалы в текстовой, аудио, графической, изображенческой и видеоформе или любую комбинацию материалов в любой форме.",
            intellectualPropertyRightsTransfer: "Ничто в этих Условиях не является передачей каких-либо прав на интеллектуальную собственность. Вы признаете и соглашаетесь с тем, что, между вами и нами, все права на интеллектуальную собственность в Сервисе принадлежат нам (то есть, мы владеем правами на приложения, которые мы предоставляем вам – мы не владеем правами на интеллектуальную собственность на ваш Контент – см. ниже в 5(3)).",
            userContentRights: "Мы признаем, что между вами и нами вы обладаете или имеете лицензию на все права на интеллектуальную собственность в Контенте, который вы предоставляете Сервису или иным образом предоставляете нам с целью предоставления Сервиса.",
            grantLicense: "Вы предоставляете нам бессрочное, неисключительное, безвозмездное, безотзывное, всемирное и передаваемое право и лицензию использовать любым способом (включая размещение на Аккаунте на любой Платформе по вашему указанию): (a) Контент, который вы добавляете в Сервис; и (b) контент профиля на платформах социальных сетей, связанных с вашим Аккаунтом (включая, без ограничения, воспроизведение, изменение или адаптацию и сообщение этого Контента общественности) с целью предоставления вам Сервиса.",
            subLicense: "Мы можем предоставить сублицензию на лицензию в пункте 5(4) третьим лицам, которые помогают нам в предоставлении Сервиса.",
            moralRights: "В некоторых странах, где работает Сервис, местное законодательство признает, что авторы Контента могут иметь 'моральные права' в отношении Контента. Примеры моральных прав могут включать право быть указанным как автор Контента, право возражать против ложного указания авторства контента и право возражать против уничижительного обращения с Контентом в некоторых обстоятельствах.",
            licenseSurvival: "Лицензия в пункте 5(4) будет действовать после прекращения этих Условий.",
            rightsRepresentation: "Вы заявляете и гарантируете нам, что у вас есть все необходимые права для предоставления лицензий и других обязательств, изложенных в этом пункте 5.",
            warranties: "Гарантии",
            warrantiesAcknowledgment: "Вы заявляете и гарантируете нам, что:",
            accountOwnership: "Все Аккаунты, на любой Платформе, добавленные в Сервис, принадлежат или контролируются вами;",
            serviceUsageAgreement: "Вы будете использовать Сервис в соответствии с этими Условиями; и",
            legalCapacity: "У вас есть юридическая способность и полномочия для заключения этих Условий.",
            liability: "Ответственность",
            liabilityForLoss: "Вы несете ответственность за любые убытки или ущерб, причиненные, если вы нарушаете свои обязательства по этим Условиям или не проявляете разумную осторожность при использовании Сервиса. Ваша ответственность будет уменьшена в той степени, в которой мы вызываем или способствуем этим убыткам или ущербу своим собственным нарушением этих Условий или своей неосторожностью при предоставлении Сервиса.",
            indemnification: "Вы освобождаете нас от любой ответственности за любые убытки или ущерб, которые мы понесли в результате вашего нарушения этих Условий (включая гарантии, которые вы даете нам в соответствии с этими Условиями), или любого умышленного проступка, незаконных действий или небрежности при использовании или неправильном использовании вами Сервиса.",
            exclusionOfLiability: "В максимальной степени, разрешенной законом, и с учетом, где это применимо, пунктов 7(5) и 7(6) этих Условий, мы исключаем всю ответственность за все требования, расходы, убытки, ущерб и затраты, предъявленные против вас или понесенные вами непосредственно или косвенно, возникающие из или в связи с вашим использованием Сервиса или вашей неспособностью использовать Сервис, включая в отношении экономических убытков, потери данных, прерывания бизнеса или любых последующих или случайных убытков.",
            totalLiabilityLimit: "В максимальной степени, разрешенной законом, и с учетом, где это применимо, пунктов 7(5) и 7(6) этих Условий, наша общая ответственность перед вами за нарушение контракта в соответствии с этими Условиями, за деликт (включая небрежность) или по любой другой причине ограничивается суммой, равной общей сумме, уплаченной или подлежащей уплате вами за Сервис за один месяц, непосредственно предшествующий дню, когда возникла наша ответственность.",
            exclusionOfTerms: "В максимальной степени, разрешенной законом, и с учетом, где это применимо, пунктов 7(6) и 7(7) этих Условий, мы исключаем все условия, представления, гарантии, условия, гарантии или обязательства (явные или подразумеваемые), кроме тех, которые прямо изложены в этих Условиях.",
            statutoryObligations: "В некоторых юрисдикциях законодательство может требовать, чтобы определенные гарантии, условия, гарантии или обязательства, относящиеся к Сервису, были подразумеваемыми в этих Условиях или накладывались на нашу поставку Сервиса ('статутные обязательства'). Кроме того, законодательство может запрещать или делать недействительными другие условия, которые имеют эффект исключения, ограничения или изменения наложенных условий, или осуществления прав и средств правовой защиты, или возмещения убытков, которые в противном случае доступны вам, если мы нарушаем наложенное условие ('статутный запрет').",
            statuteProhibition: "Если законодательство, упомянутое в пункте 7(6), применяется к этим Условиям, как они приняты вами, или к Сервису, предоставляемому вам, ничто в этих Условиях не предназначено для того, чтобы быть или действовать как статутный запрет. В частности, никакая часть этих Условий не предназначена для ограничения нашей ответственности, где эта часть будет статутным запретом.",
            termination: "Прекращение",
            terminationAutomatic: "Эти Условия автоматически прекращаются, если по какой-либо причине мы прекращаем работу Сервиса.",
            terminationNotice: "Мы можем в противном случае немедленно прекратить или приостановить ваш доступ к Сервису, уведомив вас, если, по нашему разумному мнению, вы каким-либо образом нарушили эти Условия.",
            cancelService: "Вы можете отменить Сервис в любое время, уведомив нас, и вы можете продолжать получать доступ к Сервису до конца текущего расчетного периода.",
            terminationRights: "Все права, предоставленные вам в этих Условиях, прекращаются при прекращении.",
            assignmentRestriction: "Вы не должны передавать, предоставлять сублицензии или иным образом распоряжаться любыми вашими правами в соответствии с этими Условиями.",
            invalidProvision: "Если какое-либо положение этих Условий недействительно или не подлежит исполнению, оно должно быть прочитано с учетом необходимых изменений, не затрагивая действительность или исполнимость оставшихся положений.",
            expenseResponsibility: "Каждая сторона должна за свой счет сделать все разумно необходимое для полного выполнения этого Соглашения и событий, предусмотренных им.",
            governingLaw: "Эти Условия регулируются законами Турции, и каждая сторона подчиняется юрисдикции судов Турции.",
            privacyPolicyTab: "Политика конфиденциальности",
            termsAndConditionsTab: "Условия и положения",
            placeholders: "Заполнители",
            deleteConfirmationMessage: "Вы уверены, что хотите удалить этот фильтр?",
            deleteSuccess: "Фильтр успешно удален",
            filterSavedSuccessfully: "Фильтр успешно сохранен",
            filterCreatedMessage: "Фильтр, который вы только что создали, {filterName}, теперь доступен здесь и может быть использован в любое время.",
            copyImage: "Копировать изображение",
            copyText: "Копировать текст",
            translateVisitorMessage: "Перевести сообщение",
            replyMessage: "Ответить",
            downloading: "Загрузка файла...",
            downloadSuccess: "Файл успешно загружен",
            downloadFailed: "Не удалось загрузить файл",
            filterName: "Имя фильтра",
            enterFilterName: "Введите имя фильтра",
            selectVisibility: "Выберите видимость",
            public: "Публичный",
            private: "Приватный",
            includeExistingFilters: "Включить существующие фильтры",
            includeSearchTerm: "Включить поисковый запрос",
            includeSortOrder: "Включить порядок сортировки",
            includeGroupingSelection: "Включить выбор группировки",
            saveFilter: "Сохранить фильтр",
            ban: "Заблокировать",
            forwardToDepartmentAndAssign: "Перевести в отдел и назначить",
            storageSpace: "Объем хранилища",
            completed: "Завершено",
            failed: "Не удалось",
            cancelled: "Отменено",
            running: "В процессе",
            paused: "Приостановлено",
            queued: "В очереди",
            scheduled: "Запланировано",
            metaLead: "Метаданные клиента",
            agent: "Агент",
            invoice: "Счет",
            whatsapp: "WhatsApp",
            reservation: "Резервирование",
            chatbot: "Чат-бот",
            webhook: "Webhook",
            table: "Таблица",
            tag: "Тег",
            low: "Низкий",
            lowest: "Самый низкий",
            medium: "Средний",
            high: "Высокий",
            highest: "Самый высокий",
            createDepartment: "Создать отдел",
            goToLink: "Перейти по ссылке",
            emailAddressYouProvide: "Учётная запись с указанным адресом электронной почты уже существует.",
            channelPrivacyPolicyNotMet: "Политика конфиденциальности канала не соблюдена",
            userIsNotInDepartment: "Пользователь не в этом отделе",
            currentDepartment: "Текущий отдел",
            validDepartment: "Действительный отдел",
            youCanForwardToThisDepartment: "Вы можете перенаправить этот разговор в этот отдел",
            goToSettings: "Перейти к настройкам",
            changeDepartmentAndForward: "Изменить отделение и перенаправить",
            selectDepartmentToForwardAgent: "Пожалуйста, выберите, через какой отдел вы хотите направить разговор для агента по имени {selectAgentName}.",
            selectDepartmentToForward: "Пожалуйста, выберите отделение, к которому вы хотите перенаправить",
            packageConfirmationMessage: "Вы уверены, что хотите купить пакет? Приобретенный вами пакет подлежит оплате в реальном времени. Вы можете продолжать использовать его в течение одного года после отмены. Цена этого продукта указана без НДС 20%.",
            packagePurchaseConfirmation: "Вы уверены, что хотите купить пакет? Ежемесячные пакеты будут списаны в начале каждого месяца. Использование пакета закончится после даты отмены. Цена этого продукта указана без НДС 20%.",
            annualPurchaseDiscount: "Поймайте предложение скидки 30% на ежегодные покупки!",
            customerTables: "Таблицы клиентов",
            formIntegration: "Интеграция формы",
            automationIntegration: "Интеграция автоматизации",
            remainingAutomationTask: "Осталось автоматизаций",
            createUserError: "Произошла ошибка при создании пользователя",
            sendTemplateMessage: "Отправить шаблон сообщения",
            startChatWithDifferentChannel: "Начать чат с другим каналом",
            whatsappChatStarter: "Запуск чата WhatsApp",
            pressEnterToJoin: "Нажмите Enter, чтобы присоединиться к чату",
            pressEnterToStartChat: "Нажмите Enter, чтобы начать чат",
            cannotSendMessage: "Вы не можете отправить сообщение этому человеку",
            cannotSendSessionMessage: "Вы не можете отправить сессионное сообщение этому человеку",
            conversationNotInYourDepartments: "Этот разговор не принадлежит ни одному из ваших отделов",
            customizeImage: "Если вы хотите настроить изображение",
            clickToUpload: "Нажмите здесь, чтобы загрузить изображение",
            uploadNote: "Ниже приведены форматы файлов и их размеры, которые принимаются для загрузки",
            imageSize: "Изображение не может быть загружено, так как оно превышает 2 МБ",
            videoSize: "Видео не может быть загружено, так как оно превышает 20 МБ",
            documentSize: "Документ не может быть загружен, так как он превышает 2 МБ",
            uploading: "Загрузка изображения, пожалуйста, подождите...",
            uploadSuccess: "Изображение успешно загружено",
            note: "Примечание",
            gridView: "Колоночный вид",
            completedTasks: "Завершенные задачи",
            system: "Система",
            destroyedBy: "Уничтожен",
            brand: "Марка",
            channelCreatedSuccess: "Канал успешно создан",
            channelCreatedError: "Не удалось создать канал",
            plans: {
                types: {
                    supsis: "Пакеты Представителей",
                    chatbot: "Чат-бот",
                    automation: "Автоматизация",
                    customer_tables: "Таблица Клиентов",
                    mail: "Электронная почта",
                    tasks: "Задачи",
                    form: "Форма",
                    whatsapp: "WhatsApp Web (QR)",
                    whatsapp_business: "WhatsApp Business API",
                    instagram: "Instagram",
                    messenger: "Messenger",
                    meta_lead: "Лид Meta",
                    trendyol: "Trendyol",
                    artificial_intelligence: "Искусственный интеллект",
                    webhook: "Вебхук",
                    telegram: "Telegram",
                    webphone: "Веб-телефон"
                }
            },
            vipCustomerDescription: "Отметка этого человека как VIP-клиента перемещает его на верх очереди и обеспечивает приоритетное обслуживание.",
            switchOn: "Включено",
            switchOff: "Выключено",
            ownerDescription: "Эта функция указывает владельца чата. Независимо от статуса владельца (в сети или оффлайн), чаты всегда назначаются владельцу. Владельцы чатов могут просматривать их только сами и не могут отвечать на них чат-бот.",
            permissionError: "У вас нет разрешения на выполнение этого действия!",
            copySuccess: "Содержимое успешно скопировано!",
            unowned: "Без владельца",
            add: "Добавить",
            copy: " Копировать ",
            cancel: "Отмена",
            edit: " Редактировать ",
            update: "Обновить",
            search: "Начать поиск",
            save: "Сохранить",
            jsonPreview: "Предварительный просмотр JSON",
            enterNewValue: "Введите новое значение",
            updatePreferredLanguage: "Обновить предпочитаемый язык",
            updateTags: "Обновить теги",
            updateEmail: "Обновить электронную почту",
            enterNewEmail: "Введите новый адрес электронной почты",
            deleteConfirmation: "Подтверждение удаления",
            confirmDelete: "Вы уверены, что хотите удалить эту функцию?",
            yesDelete: "Да, удалить",
            vipCustomer: "★ VIP-клиент",
            takeControlFromChatbot: "Взять контроль от чат-бота",
            enterJoin: "Вы можете присоединиться к чату, нажав клавишу Enter",
            watchChat: "Смотреть чат",
            untitledAutomation: "👉 Автоматизация нажатия на профиль без названия",
            event: "Событие",
            chatbotSettings: "Настройки маршрутизации чат-бота",
            chatbotScenarioNotFound: "Сценарий чат-бота не найден",
            noChatbotScenario: "В системе не найден сценарий чат-бота.",
            scenarioNotFound: "Сценарий не найден",
            descNotAvailable: "Описание недоступно",
            lastRegulation: "Последнее регулирование",
            taskCreator: "Создатель задачи",
            noPermission: "У вас нет разрешения на создание задач.",
            notAppointed: "Не назначен",
            changeStage: "Изменить стадию",
            selectedCandidates: "1 выбранный кандидат(ы)",
            coverPhotoRemove: "Удалить обложку",
            coverPhotoSet: "Установить в качестве обложки",
            autoTransfer: "Автоматически передать ваши контакты в Zoho",
            autoTransferDescription: "Контакты, поступающие в этот канал, автоматически передаются в модуль контактов Zoho CRM. Те, кто передан в Zoho, активируют виджеты Zoho.",
            zohoChannelRequiredTitle: "Требуется канал Zoho CRM",
            zohoChannelRequiredContent: "У вас нет канала Zoho CRM. Нажмите здесь, чтобы добавить его немедленно.",
            okText: "Добавить канал Zoho CRM",
            cancelText: "Отмена",
            forceQueueForNoOwnerContacts: "Принудить безвладельцев ждать в очереди",
            forceQueueDescription: "Только владельцы контактов автоматически назначаются, принуждая безвладельцев ждать в очереди.",
            showNoOwnerContactsToAdmins: "Показать безвладельцев только администраторам",
            showNoOwnerContactsDescription: "Безвладельцы видны только администраторам.",
            autoAssignOwner: "Автоматическое присвоение владельца контакта",
            autoAssignOwnerDescription: "Когда чат автоматически назначается представителю, он также назначается как владелец.",
            creator: "Создатель",
            hideShow: "Скрыть / Показать",
            url: "URL",
            cannedMessages: "Готовые сообщения",
            templateMessages: "Шаблонные сообщения",
            chatbots: "Чат-боты",
            noCannedMessages: "Готовых сообщений не найдено",
            filterToFindMore: "Вы можете найти больше готовых сообщений, изменив свои фильтры.",
            runPrompt: "Запустить Промпт",
            noLeadsFound: "Нет лидов для этого человека",
            deals: "Сделки",
            noDealsFound: "Сделки не найдены для этого человека",
            loadingDeals: "Загрузка сделок",
            zohoCRM: "Zoho CRM",
            viewContact: "Просмотреть контакт",
            noNotesAdded: "Заметок еще не добавлено",
            attachments: "Вложения",
            addNewNote: "Добавить новую заметку",
            saving: "Сохранение...",
            warningFillFields: "Пожалуйста, заполните поля заголовка и содержания.",
            successNoteAdded: "Заметка успешно добавлена.",
            errorAddingNote: "Произошла ошибка при добавлении заметки.",
            noteTitle: "Заголовок заметки",
            noteContent: "Содержание заметки",
            selectPreferredAgent: "Выберите предпочтительного агента, которого хотите назначить посетителю.",
            postOperations: "Пост операции",
            loadingPostOperations: "Загрузка пост операций",
            noPostOperations: "Пост операций не найдено для этого человека",
            postOperationDetails: "Детали пост операции",
            noMediaDocuments: "Нет доступных медиа или документов для этого человека.",
            selectionLimitError: "Вы можете выбрать максимум 30 элементов.",
            showNote: "Показать заметку всем",
            hideNote: "Скрыть заметку",
            updateNote: "Обновить заметку",
            addUserNote: "Добавить заметку о пользователе",
            privateNote: "Личная заметка",
            metaReferrals: "Meta Рекомендации",
            noMetaReferrals: "Не найдено взаимодействий с рекламой Meta.",
            searchPrompt: "Поиск чего-либо.",
            noRecentResults: "Недавние результаты не найдены.",
            contactInfo: "Информация о контакте",
            noPropertiesAdded: "Пока нет добавленных свойств.",
            propertyAddedUpdated: "Свойство успешно добавлено/обновлено.",
            propertyError: "Произошла ошибка при добавлении/обновлении свойства.",
            propertyDeleted: "Свойство успешно удалено.",
            propertyDeleteError: "Произошла ошибка при удалении свойства.",
            zohoSynchronization: "Синхронизация Zoho",
            zohoSyncConfirmation: "Вы хотите внести изменения в человека в Zoho?",
            hideOtherInfo: "Скрыть другую информацию",
            showOtherInfo: "Показать другую информацию",
            whatsappChatStart: "Начать чат в WhatsApp",
            ownership: "Право собственности клиента",
            countryAndLanguage: "Страна, Язык",
            calendarEvent: "Календарное событие",
            contact: "Контакт",
            user: "Пользователь",
            customerOwnership: "Владение клиентом",
            ownerless: "Без владельца",
            preferredDepartment: "Предпочитаемый отдел",
            flowluTransfer: "Передать в Flowlu",
            mergeSuccess: "Операция слияния успешно завершена.",
            visitorOwnershipWarning: "Этот посетитель принадлежит другому пользователю.",
            newAutomation: "Новая автоматизация",
            automations: "Автоматизации",
            createProfileAutomation: "Создать автоматизацию профиля",
            profileButtonClicked: "Кнопка профиля нажата",
            profileButtonDescription: "Эта автоматизация будет запущена, когда нажата кнопка профиля.",
            automationName: "Название автоматизации",
            create: "Создать",
            dayRange: "Диапазон дней",
            hourRange: "Диапазон часов",
            last24Hours: "Последние 24 часа",
            today: "Сегодня",
            yesterday: "Вчера",
            thisWeek: "На этой неделе",
            lastWeek: "На прошлой неделе",
            last7Days: "Последние 7 дней",
            last30Days: "Последние 30 дней",
            thisMonth: "В этом месяце",
            lastMonth: "В прошлом месяце",
            startDateTime: "Дата и время начала",
            endDateTime: "Дата и время окончания",
            complaint: "Жалоба",
            opens: "Открытия",
            clicks: "Клики",
            mockData: "(Тестовые данные)",
            preferredRepresentative: "Выберите предпочтительного представителя",
            forwardToDepartment: "Переслать в отдел",
            toMobileAgents: "К мобильным агентам",
            noMediaAndDocuments: "У этого пользователя нет медиа или документов",
            reportBug: "Сообщить об ошибке",
            waitingForReply: "Ожидание ответа",
            memorySize: "Размер памяти",
            usedMemory: "Используемая память",
            availableMemory: "Доступная память",
            memoryLimit: "Ограничение памяти",
            memoryLimitPrice: "Цена за дополнительную память",
            pieView: "Круговая диаграмма",
            chartView: "График",
            tableView: "Таблица",
            lastUpdate: "последнее обновление",
            task: "задача",
            filterBy: "По фильтру",
            watchAllLive: "Смотреть все прямые трансляции",
            sessionsUnique: "Сессии (уникальные пользователи)",
            sessionsAll: "Сессии (все пользователи)",
            moreFeaturesDesc: "Больше функций, больше интеграций, больше агентов! Действуйте прямо сейчас, чтобы лучше управлять своей командой и раскрыть весь потенциал вашего бизнеса!",
            metaLeadForms: "Формы лидов Meta",
            metaLeadsConnectedSucs: "Meta Leads успешно подключены",
            failedToConnectMetaLeads: "Не удалось подключиться к Meta Leads",
            forbiddenChannel: "Запрещённый канал",
            forbiddenChannelDesc: "У вас нет доступа к просмотру этого канала",
            firstContact: "Первый контакт",
            needsAnalysis: "Анализ потребностей",
            offerSent: "Предложение отправлено",
            offerReview: "Рассмотрение предложения",
            decisionPhase: "Фаза принятия решения",
            personDeleted: "Человек удалён",
            metaLeadsIntegration: "Интеграция Meta Leads",
            phoneNumberIsInvalid: "Номер телефона недействителен",
            addAnItem: "Добавить элемент",
            saveItem: "Сохранить элемент",
            customItem: "Пользовательский элемент",
            backgroundPhoto: "Фоновое изображение",
            whenYouActivateFeature: "Когда вы активируете эту функцию, она не будет отображаться на странице бронирования",
            logo: "Логотип",
            noLogo: "Без логотипа",
            addTeamMember: "Добавить члена команды",
            timezone: "Часовой пояс",
            selectDayys: "Выберите день(и)",
            selectStartHour: "Выберите время начала",
            selectEndHour: "Выберите время окончания",
            moveLeft: "Переместить влево",
            moveRight: "Переместить вправо",
            reply: "Ответить",
            replyToAll: "Ответить всем",
            deleteThreadMessage: "Удалить сообщение темы",
            totalEmailsBounced: "Всего писем отклонено",
            totalEmailsComplained: "Всего писем, на которые поступили жалобы",
            untilNowTotalEmailOpens: "Общее количество открытий писем на данный момент",
            untilNowTotalEmailLinkClicks: "Общее количество кликов по ссылкам электронной почты на данный момент",
            uniqueClicks: "Уникальные клики",
            untilNowTotalUniqueEmail: "Общее количество уникальных кликов по ссылке электронной почты (на одного получателя)",
            emailCampaignTimeline: "Временная шкала кампании электронной почты",
            receivedBroadcasts: "Полученные рассылки",
            groupDeletedSuccessfully: "Группа успешно удалена",
            verify: "Проверить",
            done: "Выполнено",
            pleaseSelectAnEmailAddress: "Пожалуйста, выберите адрес электронной почты",
            goBack: "Вернуться",
            show: "Показать",
            vueEmailEditor: "Редактор электронной почты Vue (демо)",
            saveDesign: "Сохранить дизайн",
            exportHTML: "Экспортировать HTML",
            saveAsEmailCustomerGroup: "Сохранить как группу клиентов по электронной почте",
            saveAsWhatsappCustomerGroup: "Сохранить как группу клиентов Whatsapp",
            deleteModalFormDesc: "Если вы удалите эту форму, все данные для нее будут безвозвратно удалены. Вы уверены, что хотите продолжить?",
            todo: "Дела, которые нужно сделать",
            inProgress: "В процессе",
            approval: "Одобрение",
            transactionType: "Тип транзакции",
            previousBalance: "Предыдущий баланс",
            nextBalance: "Следующий баланс",
            amount: "Сумма",
            wpIntegrationChannelRequired: "Требуется канал веб-интеграции Whatsapp",
            wpIntegrationChannelRequiredDesc: "Для интеграции Chatbot + Whatsapp Web требуется Whatsapp Web Channel. Пожалуйста, создайте новый канал.",
            wabaIntegrationChannelRequired: "Требуется канал бизнес-интеграции Whatsapp",
            wabaIntegrationChannelRequiredDesc: "Для интеграции Chatbot + Whatsapp Business API требуется веб-канал Whatsapp. Пожалуйста, создайте новый канал.",
            instaIntegrationChannelRequired: "Требуется канал интеграции Instagram.",
            instaIntegrationChannelRequiredDesc: "Для интеграции Chatbot + Instagram требуется канал Instagram. Пожалуйста, создайте новый канал.",
            createWpChannel: "Создать веб-канал Whatsapp",
            createWabaChannel: "Создать канал Whatsapp Business API",
            createInstaChannel: "Создать канал Instagram",
            failedToDeleteGroup: "Не удалось удалить группу",
            failedToDeleteGroups: "Не удалось удалить группы",
            failedToFetchGroupContacts: "Не удалось получить контакты группы",
            mailAddressDeletedSuccessfully: "Почтовый адрес успешно удален",
            defaultMailAddressChangedSuccessfully: "Почтовый адрес по умолчанию успешно изменен",
            mailAddressAlreadyRegistered: "Почтовый адрес не может быть уже зарегистрирован или пуст.",
            pleaseVerifyByClicking: "Пожалуйста, проверьте, нажав на ссылку, отправленную на ваш адрес электронной почты.",
            signSucsRegistered: "Подпись успешно зарегистрирована",
            myContacts: "Мои контакты",
            unanswered: "Пропущено",
            emailBroadcasts: "Рассылки по электронной почте",
            monthlyLimit: "Ежемесячный лимит",
            totalShipments: "Общее количество отправлений",
            shippingStatus: "Статус отгрузки",
            lastAction: "Последнее действие",
            receiver: "Получатель",
            delivered: "Доставлено",
            opened: "Открыто",
            clicked: "Нажато",
            bounced: "Он вернулся",
            clickedLinks: "Нажатые ссылки",
            reason: "Причина",
            timer: "Таймер",
            implemented: "Реализовано?",
            module: "Модуль",
            excelDownload: "Загрузка Excel",
            serviceFeatures: "Особенности сервиса",
            mailAddressDeletedSucs: "Почтовый адрес удален успешно",
            inputSearchText: "Введите текст для поиска",
            createRecord: "Создать запись",
            separatorCharacter: "Символ-разделитель",
            exampleResultPreview: "Предварительный просмотр результатов",
            importRecords: "Импортировать записи",
            equals: "Равно",
            notEquals: "Не равно",
            startsWith: "Начинается с",
            endsWith: "Заканчивается с",
            greaterThan: "Больше",
            lessThan: "Меньше",
            before: "До",
            after: "После",
            is: "О",
            isNot: "Нет",
            empty: "Пустой",
            notEmpty: "Не пустой",
            isOneOff: "Один раз",
            field: "Поле",
            records: "Запись",
            addIntegration: "Добавить интеграцию",
            chatbotScenarioReleased: "Сценарий чатбота выпущен",
            chatbotScenarioHasBeenCancelled: "Сценарий чатбота был отменен",
            titleAndDesc: "Название и описание",
            templateAndMailSelection: "Выбор шаблона и почты",
            peopleToSend: "Люди, которым нужно отправить",
            submissionPlans: "План отправки",
            summary: "Резюме",
            broadcastTitle: "Заголовок трансляции",
            sentByEmail: "Отправленное электронное письмо",
            emailTemplate: "Шаблон электронной почты",
            onlyPeopleWithEmail: "Для отправки подходят только люди с адресом электронной почты",
            sendNow: "Отправить сейчас",
            plan: "План",
            senderEmail: "Электронная почта отправителя",
            totalBuyer: "Общее количество покупателей",
            estimatedDuration: "Предполагаемая продолжительность",
            person: "Человек",
            shippingIsNowComplete: "Доставка завершена!",
            back: "Назад",
            customerName: "Имя клиента",
            customerEmail: "Электронная почта клиента",
            customValue: "Пользовательское значение",
            selectMailTemplate: "Вы должны выбрать почтовый шаблон.",
            youMustSelectSendingMailAddress: "Вы должны выбрать почтовый адрес отправки.",
            youMustSelectCustomerGroupSend: "Вы должны выбрать группу клиентов для отправки",
            createBroadcast: "Создать трансляцию",
            broadcastDetails: "Детали трансляции",
            youCanCheckYourEmailStatus: "Вы можете проверить состояние своей электронной почты, повысив тарифный план. Вы можете проверить состояние своей электронной почты, повысив тарифный план.",
            sentDetails: "Подробности отправки",
            total: "Всего",
            totalEmailsProcessed: "Всего обработано писем",
            totalEmailsDelivered: "Всего отправленных писем",
            toAvailableAgents: "Для доступных агентов",
            toAvailableDepartments: "Для доступных отделов",
            toWithAgentAndDepartment: "С агентом и отделом",
            toMobilAgents: "Мобильным агентам",
            toPreferredAgents: "Предпочитаемым агентам",
            searchAgent: "Агент по поиску",
            searchDepartment: "Отдел поиска",
            searchMobileAgent: "Мобильный агент по поиску",
            searchAgentOrDepartment: "Агент или отдел поиска",
            searchPreferredAgent: "Поиск предпочтительного агента",
            noAgentsAvailableToForward: "Нет агентов, доступных для пересылки",
            noDepartmentsAvailableToForward: "Нет департаментов, доступных для пересылки",
            checkChannelVisibilityTitle: "Проверьте настройки видимости канала",
            checkChannelVisibilityDescription: "Если вы не видите некоторые отделы, проверьте настройки видимости канала",
            goToChannelSettings: "Перейти к настройкам канала",
            noMobileAgentsAvailableToForward: "Нет мобильных агентов, доступных для пересылки",
            noPreferredAgentsAvailableToForward: "Нет предпочтительных агентов, доступных для пересылки",
            ifYouSendThisConversationToTheQue: "Если вы отправите этот разговор в очередь, это удалит вас из чата и поместит разговор в очередь. Если включено автоматическое назначение чата, разговор будет назначен соответствующему агенту и может быть передан вам обратно.",
            ifAutomaticChatAssignmentIsDisabled: "Если автоматическое назначение чата отключено, звонок останется в очереди. Уполномоченные сотрудники могут принять звонок из очереди.",
            sendQueue: "Отправить в очередь",
            agentName: "Имя агента",
            departmentName: "Название отдела",
            toQueue: "Очередь",
            usageLimitExceeded: "Превышен лимит использования",
            featureIsNotAvailable: "функция недоступна.",
            web: "Web",
            mobile: "Mobile",
            noGrouping: "Нет группировки",
            groupByThis: "Группировать по этому",
            selectGroupingCriteria: "Выбрать критерии группировки",
            activeUsers: "Активные пользователи",
            passiveUsers: "Пассивные пользователи",
            noPlatform: "Платформа не указана",
            noRole: "Роль не указана",
            noDepartment: "Отдел не указан",
            noLanguage: "Язык не указан",
            group2: "Группа",
            groupedByStatus: "Сгруппировано по статусу",
            grouping: "Группировка",
            activeSubjects: "Активные субъекты",
            passiveSubjects: "Пассивные субъекты",
            groupSubjects: "Групповые субъекты",
            showAll: "Показать все",
            onlyActive: "Только активные",
            onlyPassive: "Только пассивные",
            selectTimezone: "Выберите часовой пояс",
            userFilter: "Пользовательский фильтр",
            confidenceScore: "Показатель уверенности",
            chatbotLanguage: "Язык чатбота",
            botScenerio: "Сценарий бота",
            selectTemplate: "Выбрать шаблон",
            importFromReadyTemplates: "Импорт из готовых шаблонов",
            classification: "Классификация",
            addClassification: "Добавить классификацию",
            expressionClassified: "Выражение для классификации",
            zohoModuleName: "Имя модуля Zoho",
            selectModule: "Выбрать модуль",
            standardFields: "Стандартные поля",
            selectStandardField: "Выбрать стандартное поле",
            customFields: "Пользовательские поля",
            selectCustomFields: "Выбрать пользовательское поле",
            aiFunction: "Функция искусственного интеллекта",
            aiFunctionDesc: "Управление функцией искусственного интеллекта для выполнения действий на основе вводимых пользователем данных",
            functionName: "Имя функции",
            functionDesc: "Описание функции",
            addParameter: "Добавить параметр",
            chooseAiStory: "Выбрать историю ИИ",
            chatbotAiPromptDesc: "Искусственный интеллект обучается и определяет, как ему следует себя вести, получая инструкции по конкретной задаче или проблеме с помощью функции «подсказки».",
            enterPrompt: "Введите подсказку",
            aiParameterTunings: "Настройка параметров ИИ",
            aiParameterTuningsDesc: "Вы можете настраивать параметры ИИ, чтобы сделать его более отзывчивым и точным. Эти параметры используются для управления поведением ИИ и его реакцией на ввод данных пользователем.",
            temperature: "Температура",
            temperatureDesc: "Какая температура выборки используется, от 0 до 2. Более высокие значения, такие как 0,8, сделают вывод более случайным, а более низкие, такие как 0,2, сделают его более целенаправленным и детерминированным.",
            topDesc: "В качестве альтернативы выборке по температуре, так называемой выборке ядра, модель рассматривает результаты токенов с массой вероятности top_p. Таким образом, 0,1 означает, что рассматриваются только токены с массой вероятности top 10 %. Обычно мы рекомендуем изменить этот параметр или температуру, но не оба.",
            toolChoices: "Опции инструмента",
            noneDesc: "None означает, что модель не будет вызывать никаких инструментов и вместо этого выдаст сообщение",
            autoDesc: "Автоматический режим является значением по умолчанию и означает, что модель может выбирать между генерацией сообщения и вызовом одного или нескольких агентов",
            requiredDesc: "Режим Required означает, что модель должна вызвать одного или нескольких агентов, прежде чем ответить пользователю",
            createArticles: "Создать статью",
            createArticlesDesc: "Создавайте статьи, чтобы помочь вашим пользователям найти ответы на их вопросы.",
            articlesTitle: "Название статьи",
            articlesContent: "Содержание статьи",
            createFaq: "Создать часто задаваемые вопросы (FAQ)",
            createFaqDesc: "Создайте новый FAQ для вашего чатбота. Это поможет вашему чатботу отвечать на вопросы пользователей.",
            question: "Вопрос",
            saveAndClose: "Сохранить и закрыть",
            contentPreview: "Предварительный просмотр содержимого",
            upgradePackageTitle: "Обновите свой пакет и избегайте ограничений",
            upgradePackageDescription: "Больше функций, больше интеграций, больше агентов! Примите меры прямо сейчас, чтобы лучше управлять своей командой и максимально увеличить потенциал своего бизнеса!",
            upgradePackage: "Обновление",
            deleteSelected: "Удаление выбранных файлов",
            newFolder: "Новая папка",
            newFile: "Новый файл",
            noFilesFound: "В этой папке не найдено ни одного файла",
            uploadFile: "Загрузить файл",
            enterFolderName: "Пожалуйста, введите имя папки",
            folderName: "Имя папки",
            dropFileHere: "Бросить файлы сюда",
            createFolder: "Создать папку",
            fileUploadingError: "При загрузке файла произошла ошибка",
            fileUploadingSucs: "Папка успешно создана",
            folderNameNotEmpty: "Имя папки не может быть пустым",
            deleteFolder: "Удалить папку",
            sureDeleteFolder: "Вы уверены, что хотите удалить эту папку и все файлы в ней?",
            deletionSucs: "Удаление прошло успешно",
            deleteFile: "Удалить файл",
            sureDeleteFile: "Вы уверены, что хотите удалить этот файл?",
            deletionError: "В процессе удаления произошла ошибка",
            selectFile: "Выбрать файл",
            moreThanOneSelect: "Вы можете выбрать более одного файла",
            selectAnFile: "Выберите файл",
            bulkSms: "Массовые SMS",
            sendBulkSmsCustomers: "Отправлять массовые SMS своим клиентам",
            writeYourMessage: "Напишите ваше сообщение здесь",
            sendSms: "Отправить SMS",
            sendSmsYourCustomers: "Отправить SMS своим клиентам",
            manageChannelDetail: "Управлять информацией о канале",
            details: "Детали",
            teamGramChannels: "Каналы TeamGram",
            newTeamGramIntegration: "Новая интеграция TeamGram",
            teamGramIntegration: "Интеграция TeamGram",
            notMoreThanOneTeamGramChannels: "Вы не можете создать более одного канала TeamGram",
            teamGramDetail: "Детали TeamGram",
            manageYourTeamGramIntegration: "Управление интеграцией TeamGram",
            trendyolChannels: "Каналы Trendyol",
            trendyolStoreIntegration: "Интеграция с магазином Trendyol",
            trendyolStoreConnection: "Подключите свой магазин Trendyol",
            deleteTrendyolIntegration: "Удалить интеграцию Trendyol",
            sureDeleteTrendyolIntegration: "Вы уверены, что хотите удалить интеграцию Trendyol? Это действие необратимо",
            trendyolStoreChannel: "Канал магазина Trendyol",
            deleteTrendyolChannel: "Удалить канал Trendyol",
            channelUpdatedSucs: "Канал успешно обновлен.",
            failedUpdateChannel: "Не удалось обновить канал",
            trendyolStoreIntegrationDetail: "Деталь интеграции магазина Trendyol",
            configureTrendyolStoreIntegrationDetail: "Настроить интеграцию с магазином Trendyol",
            trenyolStoreProductQuestManage: "Trendyol Store - Управление запросами продуктов",
            trendyolStoreDesc: "Вы можете использовать следующие настройки для управления запросами к продуктам магазина Trendyol.",
            zohoCrmChannels: "Каналы Zoho CRM",
            zohoPersonalChannel: "Личные каналы Zoho",
            connectZoho: "Подключиться к Zoho CRM",
            updateChannelDesc5: "Обновить канал Zoho CRM",
            zohoCrmIntegration: "Интеграция Zoho CRM",
            sureDeleteZohoChannel: "Вы уверены, что хотите удалить канал Zoho CRM?",
            createNotMoreThanOneZohoChannels: "Вы не можете создать более одного канала Zoho",
            removeZohoLink: "Удалить ссылку Zoho",
            connectToZoho: "Подключиться к Zoho",
            chatClosed: "Чат закрыт",
            scoreChat: "Чат забит",
            createdTicket: "Билет создан",
            updatedTicket: "Билет обновлен",
            newUserCreated: "Создан новый пользователь",
            updateUser: "Обновленный пользователь",
            deleteUsers: "Пользователь удален",
            changeStatusRepresent: "Статус представителя изменился",
            incomingMessage: "Входящее сообщение",
            outgoingMessage: "Исходящее сообщение",
            createdNewTicket: "Создан новый тикет",
            bitrix24Channels: "Каналы Битрикс24",
            sureDeleteBitrixChannel: "Вы уверены, что хотите удалить канал Битрикс24?",
            bitrix24Integrations: "Интеграции Битрикс24",
            notCreateMoreThenOneChannel: "Вы не можете создать более одного канала Ideasoft",
            connectToBitrix24: "Подключиться к Битрикс24",
            connectToBitrix24Api: "Подключиться к Битрикс24 Api",
            updateChannel: "Канал обновления",
            updateChannelDesc: "Обновить канал Битрикс24 Api",
            yourBitrix24Domain: "Ваше доменное имя Битрикс24",
            bitrix24ConnectedSucs: "Битрикс24 подключился успешно",
            failedToConnectBitrix24: "Не удалось подключиться к Битрикс24",
            channelCreatedSuccessfully: "Канал создан успешно",
            failedToCreateChannel: "Не удалось создать канал",
            holidayPlusChannels: "Каналы „Праздник+“",
            newHolidayPlusIntegration: "Новая интеграция Holiday+",
            holidayPlusIntegrations: "Интеграция Holiday+",
            notCreateMoreThanOneHolidayChannel: "Вы не можете создать более одного канала Holiday+",
            holidayPlusDetail: "Детализация Holiday+",
            manageHolidayPlusIntegration: "Управление интеграцией Holiday+",
            ideasoftChannels: "Каналы Ideasoft",
            connectToIdeasoft: "Подключиться к Ideasoft",
            connectToIdeasoftApi: "Подключиться к Ideasoft api",
            updateChannelDesc2: "Обновить канал Whatsapp business api",
            ideasoftIntegration: "Интеграция с Ideasoft",
            sureDeleteIdeasoftChannel: "Вы уверены, что хотите удалить канал Ideasoft?",
            moreThanOneChannelError: "Вы не можете создать более одного канала Ideasoft",
            websiteAddress: "Адрес веб-сайта",
            ideasoftConnectedSucs: "Ideasoft подключен успешно",
            failedToConnectIdeasoft: "Не удалось подключиться к Ideasoft",
            redirectURLcopiedToClipboard: "URL перенаправления скопирован в буфер обмена",
            openAIChannels: "Открыть каналыAI",
            newOpenAiChannel: "Новый канал OpenAI",
            createNewChannelOpenAi: "Создать новый канал для OpenAI",
            updateChannelDesc3: "Обновить Whatsapp business api канал",
            openAiIntegration: "Интеграция OpenAI",
            sureDeleteOpenAiChannel: "Вы уверены, что хотите удалить канал OpenAI?",
            createMoreThenOneOpenAiChannel: "Вы не можете создать более одного канала OpenAI",
            postaCellChannels: "PostaCell Channels",
            newPostaCellChannel: "Новые каналы PostaCell",
            createNewPostaCellChannel: "Создать новый канал для смс-провайдера PostaCell",
            updateChannelDesc4: "Обновить канал Whatsapp business api",
            accessControl: "Контроль доступа",
            leads: "Лиды",
            ensureFacebookAccount: "Убедитесь, что у него есть аккаунт и страница Facebook",
            ensureAdAccount: "Убедитесь, что у него есть рекламный аккаунт",
            page: "Страница",
            questions: "Вопросы",
            leadCount: "Количество лидов",
            showLeads: "Показывать лиды",
            syncLeeds: "Синхронизировать Лидс",
            wpStartChat: "Запуск чата Whatsapp",
            archivedIn: "Архивировано?",
            makeSelect: "Сделать выбор",
            newLead: "Новый Лид",
            initalContact: "Первый контакт",
            needsAssessnment: "Анализ потребностей",
            proposalSent: "Предложение отправлено",
            proposalReview: "Рассмотрение предложения",
            negotiation: "Переговоры",
            decisionStage: "Стадия принятия решения",
            closure: "Закрытие",
            followUp: "Следовать",
            campagin: "Кампания",
            adSet: "Набор объявлений",
            ad: "Реклама",
            inArchived: "Архивировано",
            deletedSelectedPerson: "Удалить выбранных людей",
            sureDelSelectedPerson: "Вы уверены, что хотите удалить выбранных людей?",
            deletePerson: "Удалить человека",
            sureDeletePerson: "Вы уверены, что хотите удалить человека?",
            phoneNumberNotAvailable: "Номер телефона недоступен",
            statusSucsUpdated: "Статус успешно обновлен",
            statusUpdatedFailed: "При обновлении статуса произошла ошибка",
            archivedContact: "Архивный контакт",
            sureWantArchivePerson: "Вы уверены, что хотите заархивировать этого человека?",
            personArchived: "Персона заархивирована",
            personArchivedHead: "Операция архивации не удалась",
            metaLeadChannels: "Каналы Meta Lead Channels",
            wpStartSpeech: "Запуск речи Whatsapp",
            pleaseSelectStartChat: "Пожалуйста, выберите канал, на котором вы хотите начать чат:",
            phoneNumber: "Номер телефона",
            phoneNumberDesc: "Код страны, содержащий только цифры без пробелов",
            channelDesc: "На каком канале вы хотите начать чат",
            pleaseSelectStartChatOn: "Пожалуйста, выберите канал, на котором вы хотите начать чат",
            notAuthorisedChannel: "Вы не авторизованы для доступа к этому каналу.",
            phoneNumberError: "Неверный номер телефона",
            chatStartError: "Произошла ошибка при запуске чата. Пожалуйста, попробуйте еще раз.",
            noRecordFailed: "Запись не найдена",
            metaLeadsChannel: "Канал Meta Leads",
            mlChannelDetails: "Подробная информация о канале Meta Leads",
            manageMlChannel: "Управление вашими Мета-лидами",
            deleteMetaLeadsChannelInfo: "Вы уверены, что хотите удалить канал Meta Leads?",
            contactPage: "Контактная страница",
            addRouted: "Добавить маршрутизацию",
            otherEmailProviders: "Другие поставщики электронной почты",
            visitorScreenNaming: "Именование экрана посетителя",
            enterCatalogTitle: "Введите название каталога...",
            passwordUpdate: "Обновить пароль",
            showCenterScreen: "Отображение в центре экрана",
            skipNow: "Перейти сейчас",
            confirm: "Подтвердите",
            newTable: "Новая таблица",
            actions: "Транзакции",
            integrationsTrendyol: "Подключите свой магазин Trendyol и автоматически отвечайте на вопросы клиентов.",
            integrationsHoliday: "Интегрируйте Holiday+, чтобы предоставлять отели и номера через чат-бот!",
            integrationsTeamgram: "Перенесите своих клиентов с Supsis на Teamgram, чтобы оптимизировать управление клиентами!",
            integrationsTicimax: "Отправьте автоматическое сообщение сегментированным участникам Ticimax.",
            integrationsBitrix24: "Активируйте API Bitrix24 для улучшенного опыта работы с чат-ботом для ваших клиентов.",
            integrationsIdeasoft: "Активируйте API Ideasoft для улучшенного опыта работы с чат-ботом для ваших клиентов.",
            integrationsOpenAI: "Активировать службы OpenAI, Ответ Chatbot AI, AI Ассистент CoPilot, База знаний Chatbot AI.",
            integrationsSMSPostacell: "Активируйте отправку SMS через провайдера PostaCELL SMS.",
            integrationsMetaLeads: "Управляйте потенциальными клиентами Meta через Supsis. Подключите лиды к тикетам, чат-боту или живой поддержке.",
            integrationsZoho: "Интегрируйте свои бизнес-процессы в Zoho CRM с помощью Supsis.",
            forward: "вперед",
            packUpRequired: "Требуется обновление пакета",
            upgradePack: "Пакет обновления",
            supsisMobilApp: "SUPSIS МОБИЛЬНОЕ ПРИЛОЖЕНИЕ",
            supsisMobilAppDesc: "Приложение для IOS и Android на рынке!",
            sendEmail: "Отправить электронное письмо",
            jumpToMessage: "Нажмите, чтобы перейти к сообщению",
            doesntMatter: "Неважно.",
            events: "События календаря",
            reservations: "Бронирование",
            designer: "Дизайнер",
            targetContacts: "Целевые контакты",
            scheduler: "Планировщик",
            planAndTask: "План и задачи",
            insights: "Инсайты",
            createRole: "Создать роль",
            createSubject: "Создать тему",
            createUser: "Создать пользователя",
            blockManuel: "Блок Мануэль",
            showHide: "показать/скрыть",
            contactSearch: "Контактный поиск",
            favorites: "избранное",
            downloadAllData: "загрузить все данные",
            downloadThePage: "страница загрузки",
            choosePoints: "выберите очки",
            createdAt: "Созданный на",
            action: "Действие",
            searchChannel: "Канал поиска",
            activeChannels: "Активные каналы",
            deleteChannels: "Удаленные каналы",
            selectChannel: "Выберите канал",
            channelFilter: "Канальный фильтр",
            noConversationDesc: "Здесь вы можете увидеть активные чаты и чаты, назначенные вам.",
            forMe: "Для меня",
            unAssigned: "Не назначено",
            agentDetails: "Детали агента",
            contactProperties: "Контактные данные",
            goToProfile: "Перейти к профилю",
            addNote: "Добавить заметку",
            noPreferredAgent: "Пока нет предпочтительного агента",
            toPrefer: "Предпочитать",
            inChat: "В чате",
            watching: "Смотрит",
            chatsTitle: "Чаты",
            dealyTimeMaxValueError: "Время задержки может быть максимум 15",
            dealyTimeTypeError: "Значение времени задержки должно быть числом",
            passedTimeHm: "{hour} Часов {min} Минут",
            passedTimeMs: "{min} Минут {sec} секунд",
            passedTimeSc: "{sec} секунд",
            translateMessage: "Ваше сообщение было переведено искусственным интеллектом.",
            toneChanged: "Тон сообщения изменен на {tone}",
            aiResponseAdded: "Ответ ИИ добавлен в сообщение",
            messageLonger: "Сообщение сделано длиннее",
            grammarFixed: "Грамматика исправлена",
            aiTranslate: "Перевод",
            other: "Другое",
            yourLanguage: "Ваш язык",
            contactLanguage: "язык клиента",
            myLanguage: "Мой язык",
            forwardToChatbot: "Переслать Чатботу",
            friendly: "Дружелюбный",
            confident: "Уверенный",
            straightForward: "Прямолинейный",
            casual: "Повседневный",
            professional: "Профессиональный",
            longSentence: "Длинное Предложение",
            changeTone: "Изменить Тон",
            fixGrammar: "Исправить Грамматику",
            aiResponse: "Ответ ИИ",
            templateButtonNote: "Для запрета контакта используйте следующие тексты на кнопке запрета. Независимо от заглавных или строчных букв",
            templateButtonTags: "#Отправить сообщение# | #Отписаться# | #Запретить# | #Заблокировать#",
            dashboard: "Панель инструментов",
            calendarModule: "Модуль календаря",
            taskModule: "Модуль управления задачами",
            maxUrlButtonMessage: "Можно добавить не более 2 URL-кнопок.",
            searchForDepartment: "Поиск по отделу",
            assignPreferredDepartment: "Назначить предпочтительный отдел",
            smsChannel: "Канал SMS: ",
            whatsappv2Channel: "Канал Whatsapp V2: ",
            whatsappv1Channel: "Канал Whatsapp V1: ",
            wBChannel: "Канал Whatsapp Business: ",
            messengerChannel: "Канал Messenger: ",
            instagramChannel: "Канал Instagram: ",
            allPlatforms: "Все платформы",
            cbStartMessage: "Сообщение запуска чатбота",
            cbStartMessageDesc: "Первое сообщение, введенное пользователем, автоматически обрабатывается чатботом и направляется на соответствующий адрес.",
            messengerUserProfile: "Профиль пользователя Messenger",
            instagramUserProfile: "Профиль пользователя Instagram",
            noEventFound: "Событие не найдено",
            visitorMails: "Почта посетителя",
            visitorActions: "Действия посетителя",
            notVerified: "Не верифицировано",
            visitorEvents: "События посетителей",
            assignedTasks: "Назначенные задачи",
            mails: "Почта",
            prefferedAgents: "Предпочитаемые агенты",
            createEvent: "Создать событие",
            blockManagement: "Управление блокировкой",
            deleteUser: "Удалить пользователя",
            blocked: "Заблокированный",
            profiles: "Профили",
            similiarProfiles: "Найдены похожие профили",
            ReplyAsAPm: "Ответить как личное сообщение и закрыть",
            replyAsAComment: "Ответить как комментарий и закрыть",
            messengerAddDesc: "Нажмите на кнопку Подключить ниже и войдите в свою учетную запись Facebook.",
            instaAddPrivacyCheckDesc: "Я прочитал и согласен с {Privacy} и {Terms and Conditions}",
            instaAddDesc5: "Нажмите на кнопку Подключить ниже и войдите в свою учетную запись Facebook.",
            instaAddDesc4: "Зарегистрируйтесь в качестве разработчика Facebook",
            instaAddDesc3: "Убедитесь, что переключатель <b>'Разрешить доступ к сообщениям'</b> включен",
            instaAddDesc2: "Убедитесь, что ваш профессиональный аккаунт Instagram подключен к вашей странице Facebook",
            instaAddDesc1: "Убедитесь, что ваш аккаунт Instagram является профессиональным (бизнес) аккаунтом.",
            selectedDepartment: "Выбранный отдел",
            departmentForwardEnable: "Включено правило переадресации отдела",
            departmentForwardRule: "Правило переадресации отдела",
            departmentForwardDesc: "Выберите, в какой департамент будут направляться входящие чаты в канал.",
            channelName: "Название канала",
            forwardToLiveAgents: "👉 Переадресовать живым агентам",
            manageIgChannel: "Управление вашим Instagram каналом",
            igDetail: "Детали Instagram",
            manageVisibilityDesc: "Управление тем, кто может видеть этот канал",
            selectAnIgAccount: "Выберите аккаунт Instagram",
            connectToInsta: "Подключиться к Instagram",
            connectToMetaLeads: "Подключить к Meta Leads",
            deleteInstaChannelInfo: "Вы уверены, что хотите удалить канал Instagram?",
            instagramChannels: "Каналы Instagram",
            suspendedDescription: "Ваш аккаунт заблокирован из-за неоплаченных счетов",
            onlyChatbot: "Только чатбот",
            onlyAgents: "Только агенты",
            checkboxWarning: "Это поле должно быть обязательно отмечено",
            sendingAllow: "Отправка",
            receiving: "Получение",
            platform: "Платформа",
            banModalTitle: "Модальное окно запрета посетителя",
            selectDepartmentDesc: "Выберите отделы, для которых вы хотите изменить видимость",
            selectAgentDesc: "Выберите агентов, для которых вы хотите изменить видимость",
            selectDepartment: "Выберите отдел",
            selectAgent: "Выберите агента",
            visibleDepartments: "Видимые отделы",
            visibleAgents: "Видимые агенты",
            visibilityInfoCont: "Все агенты и отделы могут видеть этот канал",
            editDepartmentVisibility: "Изменить разрешения отдела",
            editAgentVisibility: "Изменить разрешения агента",
            typeSTToSearch: "Введите что-нибудь для поиска пользователей",
            exportToCSV: "Экспорт в CSV",
            clear: "Очистить",
            usedSessionCount: "Количество использованных сеансов",
            maxSessionCount: "Максимальное количество сеансов",
            leftSessionCount: "Оставшееся количество сеансов",
            planManagement: "Управление планом",
            maxAutomationTask: "Максимальное количество автоматизированных задач",
            teamChat: "Чат команды",
            templateNameIsNotValid: "Имя шаблона недействительно",
            relatedAdvertisement: "связанная реклама",
            whatsappNumber: "Номер WhatsApp",
            integrationsWhatsappV1: "Для беспроблемного взаимодействия между Supsis и WhatsApp требуется план WhatsApp.",
            integrationsWhatsappV2: "Вы можете легко передавать информацию о чате между Supsis и WhatsApp.",
            integrationsWhatsappBusiness: "Вы можете быстро и удобно передавать информацию о чате между Supsis и WhatsApp.",
            selectDays: "Выберите дни",
            addTime: "Выберите время",
            instagramContactList: "Список контактов Instagram",
            archiveAllRated: "Получить все разговоры с любыми оценками.",
            allChannels: "все каналы",
            comment: "комментарий",
            news: "что нового",
            conversation: "командный разговор",
            speechTermination: "закончить разговор",
            noSystemMessage: "Сообщений в системе пока нет!",
            supsisCustomerService: "Услуги для клиентов, предоставляемые Supsis,",
            supsisClickExperience: "Вы можете попробовать опыт, нажав.",
            customerPage: "Перейти на страницу клиента",
            buttonTitle: "Название кнопки",
            buttonType: "Тип кнопки",
            buttonSendMessage: "Отправить сообщение",
            buttonGoToBlock: "перейти в блог",
            buttonOpenUrl: "Открыть URL",
            buttonPhoneCall: "Телефонный звонок",
            buttonOpenMoment: "Открытый момент",
            buttonCloseChat: "Закрыть чат",
            buttonTransferChat: "Трансферный чат",
            buttonCreateTicket: "Создать тикет",
            deleteVisitor: "Вы уверены, что хотите удалить пользователя? Это действие не может быть отменено.",
            userProfile: "Профиль",
            addCalendarEvent: "Добавить +",
            apiIntegration: "разработчик",
            generateToken: "Создать токен",
            copyToken: "Копирование токена",
            dndBlocked: "Настройки отправки файлов отключены.",
            labels: "Этикетки",
            noData: "Нет данных",
            color: "Цвет",
            titleColor: "Цвет заголовка",
            secondTitleColor: "Цвет второго заголовка",
            tag_name_indicator: "Название этикетки",
            sendMessage: "Отправить сообщение",
            removeFromG: "Удалить из группы",
            delChannel: "Вы уверены, что хотите удалить этот канал?",
            new_name: "Новое имя",
            set_group_info: "Редактировать информацию о группе",
            shortcut_desc_num: "Переключение между активными разговорами с использованием цифровых цифр",
            copilot_desc_num: "Позволяет открыть Copilot на экране чата.",
            typing_w_chat: "пишет...",
            edit_group_info: "Редактировать информацию о группе",
            notif_sound: "Включить звук уведомлений",
            notif_mute: "Отключить уведомления",
            leave: "Уйти",
            group: "Группа",
            updateTag: "Обновить метку",
            ordered_desc: "Распределяет чаты сотрудникам по порядку.",
            random_desc: "Распределяет чаты сотрудникам случайным образом.",
            Rrobin_desc: "Распределяет чаты сотрудникам круговым методом. (Приоритет у наименее занятых сотрудников)",
            RrobinRev_desc: "Распределяет чаты сотрудникам круговым методом в обратном порядке. (Приоритет у наиболее занятых сотрудников)",
            algo_desc: "Выберите алгоритм для автоматического распределения чатов",
            algorithm: "Алгоритм",
            os_browser: "Операционная система и браузер",
            addTag: "Добавить тег",
            tags: "Теги",
            searchRepresentative: "Поиск представителя",
            voting: "Голосование",
            CHAT: "Чат",
            chatWidget: "Supsis Виджет чата",
            webhooks: "вебхуки",
            selectHooks: "Выберите веб-хуки",
            planRequired: "{integratable} Требуется план",
            allIntegrations: "Все интеграции",
            disableAgentSystemMessages: "Скрыть системные сообщения агента",
            disableAgentSystemMessagesDesc: "Скрыть системные сообщения агента.",
            disableAutoTranslate: "Автоматический перевод",
            disableAutoTranslateDesc: "Автоматически переводит сообщения с разных языков. Это позволяет вам легче общаться с клиентами.",
            shouldAddMethod: "Вы должны заполнить поля «Способ оплаты» и «Платежный адрес»! \nДеньги не будут сняты с вашего счета.\nВ конце месяца будет выставлен счет в соответствии с суммой использования.",
            approveSelection: "Утвердить выбор",
            trialDaysEndSelectPlan: "Подтвердить выбор плана",
            trialDaysEndSelectPlanDesc: "Ваша пробная версия закончилась. Вам необходимо подтвердить, выбрав план ниже.",
            infoAboutAnnouncement: "Краткая информация об объявлении",
            announcement: "Объявление",
            languageSelection: "Выбор языка",
            newAnnouncementForm: "Новая форма объявления",
            newAnnouncement: "Новое объявление",
            announcements: "Объявления",
            infinitePlay: "Играть непрерывно",
            vtippyHideBubbleOnMobile: "Чат Bubble скрыт от мобильных пользователей.",
            hideBubbleOnMobile: "Скрыть на мобильном",
            deleteSystemLanguage: "Удалить язык {code} из системы",
            assignedChat: "Назначенный чат",
            check: "Флажок",
            newTicketSound: "Новый билет",
            vtippyDepartmentNotification: "Настройки уведомлений для сообщений из департаментского разговора",
            vtippyGroupNotification: "Настройки уведомлений для сообщений из созданных групп",
            vtippyAnnouncemenNotification: "Настройки уведомлений для новых объявлений",
            warning: "Предупреждение",
            billingAddress: "Адрес для выставления счета",
            addNewAddress: "Добавить новый адрес",
            adressTitle: "адрес Название",
            address: "адрес",
            systemStatus: "Статус системы",
            chatAssignedToUser: "Чат назначен новому пользователю",
            inactiveThresholdTime: "Время неактивного чата (минуты)",
            tippyInactiveThresholdTime: "Если в течение указанного времени не будет отправлено ни одного сообщения, разговор считается неактивным. Введите значение (минуты). Должно быть в диапазоне от 1 до 120 минут.",
            inactiveTerminateTime: "Время завершения неактивного чата (минуты)",
            tippyInactiveTerminateTime: "Неактивный чат будет завершен, если он не перейдет в активный режим в течение определенного времени. Введите значение (минуты). Должно быть в диапазоне от 1 до 120 минут.",
            removePendingMessage: "Отменить отправку сообщения",
            disconnected: "Отключено",
            visitorWriteEmptyChatTippy: "Клиент может писать в беседу до подключения агента.",
            visitorWriteEmptyChat: "Клиент может писать без подключения агента.",
            visitorConnectionEventSystemMessageEnabled: "Системные сообщения о состоянии соединения с посетителями Включить",
            visitorConnectionEventSystemMessageEnabledTippy: "Системные сообщения «Посетитель ушел» и «Посетитель вернулся» позволяют",
            openBubble: "Открыть пузырь",
            showHeaderImage: "Показать изображение заголовка",
            askQuestion: "Задайте вопрос",
            locationPermsNeeded: "Необходимые разрешения на местоположение",
            useMyLocation: "Использовать мою локацию ",
            acceptingChat: "Прием чатов",
            notAcceptingChat: "Не принимает чаты",
            loggedOut: "Вышли из",
            websiteChatWidgetIntegration: "страница Реализация",
            hideInactiveAgents: "Скрыть неактивных агентов",
            hideMinorValues: "Скрыть малые значения",
            agentActivities: "Деятельность агента",
            listStatuses: "Статусы",
            newHASHContent: "#Добавить метку",
            changeLogo: "Изменить логотип",
            changePhoto: "Изменить фотографию",
            addPhoto: "Добавить фотографию",
            seePhoto: "См. фото",
            deletePhoto: "Удалить фотографию",
            languageRemovalQuestion: "Вы собираетесь удалить язык {code} из системы!",
            hash: "Хэштег",
            hashText: "Хэш-текст",
            updateCompleted: "обновление завершено",
            CatalogUpdatedSuccessfully: "Каталог успешно обновлен",
            integrateSupsiswithIntegratable: "С легкостью передавайте информацию чата между Supsis и {integratable}.",
            installationOK: "установлены",
            exampleHash: "отслеживание заказа",
            notValidHash: "Не должно содержать пробелов.",
            videoCallEnabledDesc: "Активируйте, чтобы включить функцию видеозвонка.",
            videoCallEnabled: "Функция видеозвонка",
            audioCallDesc: "Активируйте, чтобы включить функцию голосового поиска.",
            audioCallEnabled: "Функция голосового поиска",
            assignPreferredAgent: "Назначить предпочтительного агента",
            representativeAssignedToTheVisitor: "Выберите предпочитаемого агента, которого хотите назначить посетителю.",
            agentFileSendEnabledDesc: "Позволяет отправлять файлы делегатам",
            agentFileSendEnabled: "Представители могут отправлять файлы",
            visitorFileSendEnabledDesc: "Позволяет включать и выключать функцию отправки файлов посетителям.",
            visitorFileSendEnabled: "Посетители могут отправлять файлы",
            visitorAutoLogin: "Автоматический вход посетителя",
            visitorAutoLoginDesc: "Автоматический запуск разговора, когда посетитель нажимает на всплывающее окно чата",
            agentVoiceRecordEnabledDesc: "Позволяет агентам записывать звук",
            agentVoiceRecordEnabled: "Агенты могут записывать аудио",
            visitorVoiceRecordEnabledDesc: "Позволяет посетителям записывать аудио",
            visitorVoiceRecordEnabled: "Посетители могут записывать аудио",
            startVideoCall: "Видеозвонок",
            startAudioCall: "Голосовой звонок",
            visitorGDPRDeleteEnabledDesc: "Позволяет включить/выключить возможность удаления всей информации о посетителях.",
            visitorGDPRDeleteEnabled: "Посетители могут удалить всю свою информацию",
            visitorLocationEnabled: "Посетители могут делиться местоположением",
            visitorLocationEnabledDesc: "Позволяет посетителям включать или выключать совместное использование местоположения",
            customerLocationEnabled: "Пользователи могут делиться местоположением",
            customerAutoMergeEnabled: "Автоматически объединяет одних и тех же людей",
            customerAutoMergeEnabledDesc: "Эта функция выполняет автоматическое объединение, эффективно собирая данные, относящиеся к одним и тем же людям. Это обеспечивает более последовательное и упорядоченное представление пользователей с похожими профилями в наборах данных.",
            chatAiCopilot: "Чат ИИ Копилот",
            chatAiCopilotDesc: "Автоматически отвечайте на вопросы ваших клиентов, используя Чат ИИ Копилот",
            customerLocationEnabledDesc: "Позволяет пользователям включать или выключать совместное использование местоположения",
            thoesNotOwners: "Держать в очереди тех, кто не является владельцем беседы",
            thoesNotOwnersDesc: "Вы включаете эту функцию, чтобы держать в очереди людей, которые не являются владельцами беседы",
            hideContactInfo: "Скрывать контактную информацию",
            hideContactInfoDesc: "Когда вы включаете эту функцию, номера и электронные адреса ваших клиентов будут скрыты от агентов",
            triggerAlreadyExists: "Триггер уже существует.",
            ticketStatusForm: "Форма статуса билета",
            statusFormTitle: "Название статуса заявки",
            allStatus: "Все статусы",
            triggers: "Триггеры",
            trigger: "Курок",
            noTrigger: "Вы еще не добавили ни одного триггера",
            triggerSkipLoginForm: "Форма входа",
            triggerSkipLoginFormTrue: "Показать форму входа",
            triggerSkipLoginFormFalse: "Пропустить форму входа и перейти к сообщению",
            noContent: "нет содержания",
            toCreate: "Создать",
            clickTheButton: "нажмите кнопку",
            noLiveSupportFoundWithDepartment: "Нет речи, принадлежащей отделу",
            triggerContent: "Введите описание, которое вы хотите отобразить в открывшемся модальном окне. Вам нужно только писать на одном языке, а перевод на другие языки выполняется автоматически.",
            triggerDrag: "Вы можете настроить продолжительность сообщения, перетащив или щелкнув полосу.",
            triggerNewCondition: "Вы можете добавить новое условие с помощью кнопки.",
            triggerNoConditionDescription1: "Вы можете создать нужные условия из опций. Если вы не создадите никаких условий ни для одного триггера, активным будет первый триггер.",
            triggerNoConditionDescription2: "На странице посетителя отображается только один из триггеров с одинаковыми условиями.",
            triggerShowAndHide: "Вы можете показать или скрыть триггеры, когда захотите.",
            countryLanguage: "Страна/Язык",
            addTrigger: "Добавить триггер",
            saveSystemCardInfo: "Ваша карта будет сохранена в нашей системе и оплачена автоматически, когда наступит срок оплаты.",
            cardNumber: "Номер карты",
            cardType: "Тип карты",
            skt: "сг",
            cvv: "CVV",
            saveCard: "Сохранить карту",
            cardNameSurname: "Имя и фамилия держателя карты",
            confidentialityAgreementCheck: "Я принимаю соглашение о конфиденциальности",
            confidentialityAgreement: "соглашение о конфиденциальности",
            yesPlease: "Да, пожалуйста!",
            noThanks: "Спасибо, не надо.",
            firstAnswer: "Вопрос Диалог Подтвердить Ответ",
            secondAnswer: "Вопрос Диалог Отклонить Ответ",
            noTitle: "Без названия",
            sumChat_MediaFile: "Медиа и документы",
            importantWarning: "ВАЖНОЕ ПРЕДУПРЕЖДЕНИЕ!",
            images: "Изображения",
            URLS: "Ссылки",
            files: "Файлы",
            noCondition: "Нет условий! Вы можете добавить Условия, щелкнув значок плюса.",
            showTriggers: "Нажмите, чтобы показать триггеры",
            showThisTrigger: "Нажмите, чтобы показать этот триггер",
            hideTriggers: "Нажмите, чтобы скрыть триггеры",
            hideThisTrigger: "Нажмите, чтобы скрыть этот триггер",
            updateTrigger: "Триггер обновления",
            conditions: "Условия",
            messageDurationPerRow: "Длительность сообщения в строке",
            vtippyTicketNotification: "Настройки уведомлений для каждого нового билета, который вы получаете",
            dayTime: "Час",
            weekDay: "День недели",
            spendTimePage: "Время, проведенное на странице",
            spendTimeSite: "Проведенное время на сайте",
            pageUrl: "URL-адрес страницы",
            pageTitle: "Заголовок страницы",
            vtippyNewVisitorNotification: "Звуковое оповещение о каждом новом посетителе вашего сайта",
            vtippyTranslateButton: "Переводит выбранный язык на другие языки",
            vtippyTranslateClearButton: "Очищает контент на других языках.",
            vtippySelectnotification: "Вы можете выбрать звук уведомления.",
            vtippyVoiceLevel: "вы можете регулировать громкость",
            vtippyStartVoice: "Слушать",
            vtippyInfiniteNotification: "Если вы не активны на новой панели чатов, она продолжит играть. Вы можете редактировать актив-пассив, нажав.",
            vtippyNewChatNotification: "Вы можете выбрать звуковое оповещение о новых разговорах, поступающих в систему, и отрегулировать громкость.",
            vtippyNewConversationNotification: "Вы можете выбрать звуковое уведомление и отрегулировать громкость, когда новые входящие разговоры назначаются вам.",
            vtippyNewMessageNotification: "Вы можете выбрать уведомления о входящих сообщениях в свои разговоры и настроить громкость.",
            vtippyPrivateMessageNotification: "Вы можете выбрать уведомление о входящем сообщении в командный разговор.",
            equal: "Равный",
            not_equal: "Не равный",
            less_than: "Меньше, чем",
            greater_than: "Лучше чем",
            less_than_or_equal: "Меньше или равно",
            greater_than_or_equal: "Больше или равно",
            visitorName: "Имя посетителя",
            seconds10: "10 секунд",
            seconds30: "30 секунд",
            minute1: "1 минута",
            minutes5: "5 минут",
            minutes10: "10 минут",
            minutes30: "30 минут",
            hour1: "1 час",
            hours2: "два часа",
            hours4: "4 часа",
            hours8: "8 часов",
            hours12: "12 часов",
            hours24: "24 часа",
            maxCondition: "Максимальное состояние",
            doYouWishToDeleteTrigger: "Вы хотите удалить триггер",
            contains: "Содержит",
            not_contains: "Не содержит",
            chatLanguage: "Язык чата",
            translating: "Идет перевод",
            buyWhatsapp: "Приобрести интеграцию с WhatsApp",
            liveSupportStartingWait: "Запуск поддержки в режиме реального времени, пожалуйста, подождите",
            noConnection: "Нет соединения!",
            integrations: "Интеграции",
            refundInvoiceSure: "Вы уверены, что хотите вернуть счет?",
            invoiceMarkedAsPaidSuccess: "Счет отмечен как успешно оплаченный",
            invoiceMarkedAsPaidError: "Ошибка, счет не помечен как оплаченный",
            deleteConfirm: "Вы хотите удалить этот {object}?",
            markPaidConfirm: "Вы уверены, что пометите этот счет как оплаченный?",
            startChatDesc: "Начать разговор",
            addLink: "Ссылка на сайт",
            selectStep: "Выберите шаг:",
            addGOTO: "Перейти к",
            sendFastLink: "Отправить Fast Link",
            or: "или",
            allTags: "Все теги",
            showDetail: "Показать детали",
            hideDetail: "Скрыть детали",
            weLlSendPhone: "Мы отправим на ваш телефон",
            weLlSendEmail: "Мы отправим на Ваш e-mail",
            linkSentToPhone: "Ссылка отправлена в смс",
            offerlinkSendToPhone: "Мы вышлем вам ссылку для скачивания нашего приложения в SMS.",
            offerlinkSendToMail: "Мы вышлем вам ссылку для скачивания нашего приложения в Почта.",
            theEmail: "Моя зарегистрированная электронная почта",
            differentEmail: "Другое электронное письмо",
            linkSentToMailBox: "Ссылка отправлена на ваш почтовый адрес",
            errorOccurred: "Произошла ошибка !",
            clickStoreIcon: "Вы можете получить доступ к мобильному приложению, нажав на значок, подходящий для вашего телефона.",
            meetWithSupsis: "Хотите познакомиться с нашим мобильным приложением SUPSIS?",
            downloadMobileApps: "Скачать мобильное приложение",
            getApps: "Получить приложения",
            info: "Информация",
            conversationHistory: "История разговоров",
            planInfoHeader: "Информация о плане",
            planInformation: "Ваш тарифный {selectedPlan} план ({detailMaxAgentCount} агент) ({freeAgent} свободный агент)",
            creditAvailable: "Ваш агентский кредит доступен в вашем плане: ",
            upDownGradePlan: "Если вы хотите повысить / понизить свой тарифный план, пожалуйста",
            click: "Нажмите",
            autoStartChat: "Автоматический запуск чата",
            bubbleColor: "Цвет пузыря чата",
            openFolder: "Открыть папку",
            preDefined: "Темы",
            customIcon: "Установить со своего компьютера",
            theme: "Тема",
            themeSettings: "Настройки темы",
            chatThemeSettings: "Настройки темы чата",
            bubbleSettings: "Настройки пузыря чата",
            inputHeightOfBubble: "Размер пузыря",
            inputPixelsOfChatBubble: "Нажмите, чтобы изменить расстояние от пузыря чата до краев",
            modalTitleIsMarginAsPixelInfo: "Расстояния от чат-пузыря до краев : ",
            inputPxOfXaxis: "Горизонтальное положение",
            inputPxOfYaxis: "Вертикальное положение",
            inputPxOfMobileXaxis: "(Mobil) Horizontal Position",
            inputPxOfMobileYaxis: "(Mobil) Vertical Position",
            animations: "Анимации",
            preferredAnimation: "Предпочтительная анимация",
            selectAnAnimation: "Выберите анимацию",
            inputOfBubbleMessage: "Добавляйте контент в большие пузыри чата.\n{contentOfChatBubble}",
            showChatBubbleOnlyLoggedUserToolTip: "Это настройка для скрытия всплывающей подсказки чата в зависимости от статуса входа в систему.Показывается всем посетителям в случае Off.",
            showChatBubbleOnlyLoggedUser: "Показывать всплывающую подсказку только авторизованному пользователю. (ideasoft)",
            helloDoUNeedHelp: "Привет, тебе нужна помощь?",
            bubbleIcon: "Изображение пузыря чата",
            overrideMargins: "Настроить поля",
            autoHideBubble: "Скрыть пузырь чата",
            vtippyAutoHideBubble: "Скрывает всплывающее окно чата, когда агенты не в сети",
            hideBubble: "Отключить чат-пузырь",
            vtippyHideBubble: "Отключает пузырь чата.",
            overrideMobileMargin: "Настроить отступы для мобильных",
            vtippyMobileMargin: "Настроить отступы для мобильных",
            isFabsActive: "Показать плавающую кнопку действия",
            isAlwaysActive: "Меню всегда открыто",
            isAlwaysActiveDesc: "Хотите, чтобы меню чат-окна всегда оставалось открытым в веб-версии?",
            bubbleOpenableMenu: "Выпадающее меню чата",
            vtippyIsFabsActive: "Настройка отображения/скрытия плавающей кнопки действия",
            vtippyIsFabsAsIcon: "Это настройка того, будут ли значки отображаться в раскрывающемся меню.",
            isFabsAsIcon: "Показать значки меню.",
            setMarginAsPixel: "Установить как пиксель",
            returnDefaultMargins: "Настройки поля по умолчанию",
            deleteSite: "Вы хотите удалить сайт \" {siteName} \" ?",
            deleteThisSite: "Удалить сайт",
            assetOversizeWithExt: "Размер файла должен быть менее 10 МБ и в формате png, jpg.",
            all: "Все",
            allDepartments: "Все отделы",
            preferredLanguage: "предпочтительный язык",
            kmkAutoDepartmentBind: "KMK Поиск автоотдела",
            kmkAutoDepartmentBindDesc: "Найдите продавца на сайтах клиентов KMK и настройте страницу входа в качестве отдела",
            chatBot: "Чат-бот",
            ticketResponse: "Представительский ответ:",
            archived: "Архив",
            chatbotChatCount: "ЧАТБОТ",
            visitorEmailUpdated: "Электронная почта посетителя обновлена",
            visitorEmailIsNotValid: "Электронная почта посетителя недействительна",
            visitorNameUpdated: "Имя посетителя обновлено",
            clickToEdit: "Нажмите, чтобы изменить",
            addEmail: "+ Добавить электронную почту",
            addFullname: "+ Добавить полное имя",
            partner: "Ref?",
            isIntegrated: "Интеграция?",
            agentCount: "Количество агентов",
            closePreviewColors: "Закрыть предварительный просмотр темы",
            previewColors: "Открыть предварительный просмотр темы",
            videoCalls: "Видеозвонки",
            filterLost: "Потерянные чаты",
            vtipyCustomLogin: "Вы можете настроить информацию, которая будет запрашиваться в форме входа, когда ваши посетители подключаются к системе.",
            vtipyLoginlessChat: "Форма входа посетителя будет скрыта. Посетитель может подключиться к чату напрямую.",
            loginlessChat: "Форма входа посетителя видна",
            imageUrl: "URL изображения",
            replied: "Ответил",
            solved: "Решено",
            openImage: "Открыть изображение",
            writeFeedback: "Вы можете написать свой отзыв о SUPSIS здесь.",
            feedbackFailed: "Ошибка при отправке отзыва.",
            feedbackSuccessful: "Отзыв отправлен.",
            sendFeedback: "Отправить отзыв",
            errorReport: "Вы можете сообщить нам о своих проблемах с SUPSIS.",
            sendErrorFeedBack: "Поделитесь с нами своим мнением о проблеме, с которой вы столкнулись.",
            successImgUpload: "Ваше изображение было успешно загружено.",
            successImgDelete: "Изображение успешно удалено.",
            errorImgUpload: "Произошла ошибка при загрузке вашего изображения.",
            errorImgDelete: "При удалении изображения произошла ошибка",
            chatBotEndStatics: "Коэффициент успешности разговора с чат-ботом",
            videoCallDist: "Распределение видеозвонков",
            departmentInfo: "Информация об отделе",
            infoAboutDepartment: "Дайте краткую информацию об отделении",
            deleteDepartmentQuestion: "Вы действительно хотите удалить этот отдел?",
            departmentDeleted: "Отдел удален",
            departmentTitle: "Название отдела",
            updateDepartmentForm: "Форма обновления отдела",
            newDepartmentForm: "Форма нового отдела",
            department: "отделение",
            newDepartment: "Новый отдел",
            departmentSaved: "Отдел сохранен",
            selectAll: "Выбрать все",
            collapseAll: "Свернуть все",
            expandAll: "Развернуть все",
            addUsersToDepartment: "Добавить пользователей в отдел",
            removeFromDepartment: "Удалить из отдела",
            moveToDepartment: "Переместить в другой отдел",
            noUsersInDepartment: "В этом отделе нет пользователей",
            selectAtLeastOneUser: "Выберите хотя бы одного пользователя",
            departmentUsersUpdated: "Пользователи обновлены",
            copyToDepartment: "Также добавить в отдел",
            userAlreadyInDepartment: "Пользователь уже в этом отделе",
            removeUserFromDepartmentConfirm: "Вы уверены, что хотите удалить этого пользователя из отдела?",
            bulkUpdateProgress: "Массовое обновление",
            usersUpdated: "обновлено",
            moveToAllDepartments: "Переместить во все отделы",
            copyToAllDepartments: "Также добавить во все отделы",
            deselectAll: "Снять все выделения",
            sameDepartment: "Существует отдел с таким же названием",
            sameValue: "Существует значение с таким же именем!",
            sameTag: "Существует тег с таким именем!",
            departments: "Отделы",
            chatTimingSettings: "Настройки времени чата",
            assetOversize: "Размер отправляемого файла не должен превышать 2 МБ.",
            assetOversizeMB: "Размер файла, который вы хотите отправить, не должен превышать {mb}МБ.",
            messageDeleted: "Это сообщение удалено",
            filterVideoCall: "Фильтр видеозвонков",
            filterLostChat: "Фильтры Потерянные чаты",
            filterClosedByAgent: "Фильтр закрыт агентом",
            notificationText: " Супсису нужно разрешение на",
            notificationTitle: "Уведомления отключены",
            deniedText: "Ваши уведомления закрыты, вам нужно включить свои уведомления, чтобы не пропустить своих клиентов.",
            deniedTitle: "Нажмите, чтобы открыть свои уведомления!",
            deniedHeader: "Чтобы не упустить своих клиентов, вам необходимо включить свои уведомления!",
            showNotificationGuide: "Нажми для деталей",
            howToEnableNotification: "Как я могу включить уведомления",
            notificationOK: "Ok",
            notificationUnderstood: "Понял!",
            notificationCancel: "Отмена",
            howToEnableNotificationInstruction1: "Нажмите на значок замка в адресной строке браузера",
            howToEnableNotificationInstruction2: "Если «Уведомления» отключены в разделе «Разрешения», включите их.",
            howToEnableNotificationInstruction3: "Если «Уведомления» не отображаются в разделе «Разрешения», нажмите «Настройки сайта».",
            howToEnableNotificationInstruction4: "Включите разрешение «Уведомления» в разделе «Разрешения» на странице настроек сайта.",
            checkPaymentMethod: "Пожалуйста, проверьте способ оплаты",
            pushNotificationEnabled: "Отлично, Push-уведомление включено",
            pushNotificationDenied: "Вы отказали в разрешении на уведомление",
            suspendedMessage: "Ваша учетная запись была приостановлена",
            enableNotification: "Включите уведомления на рабочем столе.",
            languageSettings: "выбранный язык",
            problemsSound: "Если у вас возникли проблемы с уведомлениями, вы можете щелкнуть изображение блокировки в окне поиска браузера (показано на рисунке), щелкнуть «Настройки сайта» и изменить «Звук» на «Разрешить».",
            betweenRepresentative: "Есть новое сообщение от представителя",
            desktopNotifications: "Уведомления на рабочем столе",
            notificationEnabled: "Уведомления на рабочем столе SUPSIS включены.",
            newMessageAlert: "У вас есть новое сообщение.",
            notificationDisable: "Вы можете отключить уведомление в настройках представителя",
            newConversationAlert: "У вас новый посетитель.",
            autoLoadIframe: "Живой трафик",
            autoLoadIframeDesc: "Автоматически загружать iframe, пропускать весь трафик посетителей",
            enableState: "Активный?",
            requiredFieldField: "Это поле обязательно к заполнению",
            catalogCategoryMenu: "Добавить меню категории каталога",
            catalogCategoryLeaf: "Добавить подменю категории каталога",
            closeChat: "Завершить обмен сообщениями",
            ticket: "Билет",
            formStep: "Шаг формы",
            menuStep: "Шаг меню",
            contentStep: "Шаг содержания",
            menuTitle: "Заголовок меню",
            messageContent: "Содержание сообщения",
            goToLive: "Передача представителю",
            prevStep: "Вернуться к предыдущему шагу",
            button: "Кнопка",
            addImage: "Изображение",
            addText: "Текст",
            stepTitle: "Название шага",
            addTicket: "Проездной билет",
            formDescription: "Вопрос",
            addInput: "Вопрос",
            addRandomText: "Случайный текст",
            changeTitle: "Изменить заголовок",
            changeVisitorTitle: "Изменить заголовок посетителя",
            catalog: "Название каталога",
            openTheCatalog: "Открытый каталог",
            catalogNotOpen: "Функция каталога отключена. Вы можете включить функцию каталога, чтобы поддерживать своих клиентов заранее подготовленным контентом. ",
            showCatalogCategories: "Измените способ отображения меню каталога в пузыре чата. ",
            showChatBot: "Измените статус меню чат-бота, чтобы он отображался в пузыре чата.",
            openCatalog: " Каталог ",
            unreadMessages: " Непрочитанные сообщения ",
            personalFirstMsg: "Среднее время первого ответа агента (сек)",
            personalRating: " Средний балл персонала",
            soundSettings: " Настройки звука ",
            newPrivateMessage: " Личное сообщение ",
            addNewGroup: "Создать новую группу",
            newMessage: " Новое сообщение ",
            newConversation: "новый чат ",
            newVisitor: " Новый посетитель ",
            chatPosition: " Расположение чата ",
            bottomLeftCorner: "нижний левый угол",
            leftDocked: "оставил в пристыкованном виде",
            bottomRightCorner: "нижний правый угол",
            rightDocked: "справа закреплено",
            chatPositionSelect: " Выберите место ",
            teamChatGroup: "Групповые сообщения",
            teamChatDepartment: "Сообщения отдела",
            teamChatTeam: "Сообщения команды",
            teamChatDm: "Личные сообщения",
            bottomLeft: " Внизу слева ",
            left: "Слева",
            bottomRight: "Внизу справа ",
            right: "Справа",
            mailorname: " Электронная почта или имя ",
            breaksByTime: " Количество перерывов по времени ",
            clPlaceholder: " Имя, которое будет отображаться в форме клиента ",
            fieldName: " Имя ключа ",
            value: "Значение",
            addSetting: " Добавить новую настройку ",
            globalSettings: "Общие настройки",
            target: " Адрес нагрузочного теста ",
            duration: " Время нагрузочного теста(сек)",
            arrivalCount: " Количество ботов(шт)",
            bootMaxLife: "Время жизни бота(сек)",
            startLoadTest: " Начать нагрузочный тест ",
            noClusterInstanceFound: "Сервер не найден",
            stopLoadTest: " Завершить нагрузочный тест ",
            integrationDesc: "Просто добавьте на свой сайт приведенный ниже однострочный код.",
            integrationDemoCode: " Пример демо кода интеграции ",
            integrationWindow: " Как мне интегрировать мой сайт?",
            notIntegrated: "интеграции",
            help: " Помощь",
            notIntegratedDesc: " Мы поняли, что вы не добавляли чат на свой сайт. Когда вы интегрируете его на свой сайт и начнете первый разговор, вы завершите интеграцию. Нажмите, чтобы увидеть СЦЕНАРИЙ ИНТЕГРАЦИИ ",
            backToLogin: " Войдите снова",
            passwordlessLoginUnsuccessful: " Ошибка входа. Возможно, срок действия ссылки для входа истек или она использовалась ранее.",
            passwordlessLogin: " Вход без пароля ",
            loginWithEmail: "Войти по электронной почте",
            loginWithPassword: "Войти с паролем",
            enteringPasswordless: " Войти без пароля ...",
            toMainPath: " Перенаправить на домашнюю страницу ",
            userRoleChanged: " Ваши права доступа изменились. Вы попадете на главную страницу, чтобы продолжить.",
            passwordChangeSuccess: " Ваш пароль успешно изменен ...",
            feedback: " Обратная связь ",
            showFeedbackHistory: " Показать сообщения, на которые были отправлены отзывы.",
            newSelfServiceSite: " Новый сайт самообслуживания ",
            subdomain: "Субдоменное имя",
            rootUserEmail: "Электронная почта пользователя",
            rootUserName: "Ваше имя",
            newVersion: "Доступна новая версия",
            closeLiveSupport: "Закрыть онлайн-поддержку",
            newVersionShort: "новая версия",
            bannedWordRestrict: " Блокировка запрещенных слов ",
            ticketShow: "Разрешить клиентам создавать заявки",
            ticketShowDesc: "Включить опцию создания заявок в меню чата",
            bannedWordRestrictDesc: " Когда включена блокировка запрещенных слов, представителям запрещается вводить посетителям запрещенные слова, определенные в системе. ",
            agentDown: " Представитель отлючился",
            delayChat: " Отложенный чат ",
            tableSettingTippy: "Здесь вы можете изменить информацию, которая будет отображаться в таблице.",
            tableSettings: " Настройки таблицы",
            tableSettingsInfo: " Здесь вы можете изменить информацию, которая будет отображаться в таблице. Вы можете выбрать до 7 столбцов ",
            privateParametry: "Индивидуальные параметры пользователя",
            systemOperetor: "Системная информация",
            cityAndDistrict: " Город / Район ",
            general: " Общий ",
            availability: "Доступность",
            home: "Главная",
            successful: " Успешно ",
            forgetPasswordSent: " Письмо для сброса пароля отправлено, проверьте свою электронную почту.",
            saturday: " Суббота ",
            friday: " Пятница ",
            thursday: " Четверг ",
            wednesday: "Среда ",
            tuesday: " Вторник ",
            monday: " Понедельник ",
            sunday: " Воскресенье ",
            download: " Скачать",
            calendarPassedTimeHour: "{час} время {имя}",
            calendarPassedTime: "{час} время {мин} мин {имя}",
            calendarPassedTimeMinSec: "{мин}час{сек}сек{имя}",
            calendarPassedTimeMin: "{значение} мин {имя}",
            calendarPassedTimeSec: "{час} часы {мин} мин {сек} сек {имя}",
            workScheduleOneDay: "График работы на {sDate} день пользователя по имени {name} ",
            workSchedule: "График работы с {sDate} - {eDate} от {name} ",
            calendar: "Календарь",
            noRating: " Нет подсчета оценок ",
            rateDist: " Диаграмма распределения оценок ",
            distConversation: "Распределение выступлений по представителям",
            distributionConversa: "Распределение очков",
            distChatbotAgent: "Каналы связи",
            distAgent: "Чат-бот и агент",
            distFugitive: "Пропущенная речь и полученная речь",
            distLive: "Живой чат",
            distChatbot: "Чат-бот",
            distComplex: "Чат-бот + Живой чат",
            distHandled: "ответил в чате",
            distMissed: "речь без ответа",
            distWeb: "Веб-сайт",
            distWhatsapp: "Whatsapp",
            distTelegram: "Телеграмма",
            distInstagram: "Инстаграм",
            totalWhatsappChatCount: "чатов в Whatsapp",
            statsByTime: " Количество диалогов по времени",
            selectRep: " Выберите представителя ",
            allRepresentatives: "Все представители",
            avgRating: " Распределение оценок ({оценка}) ({count} оценка)",
            avgFirstMessageTime: " Среднее время первого ответа ",
            totalBreakTime: "Время перерыва системы",
            totalBreakNum: "Количество перерывов",
            averageConTime: "Среднее время разговора",
            multiWpReportTitle: "Количество разговоров в WhatsApp",
            multiWpReport: "Количество нескольких чатов WhatsApp",
            multiWpReportExplanation: "Вы можете увидеть количество чатов на ваших нескольких каналах WhatsApp.",
            longestConTime: " Самое долгое время разговора",
            shortestConTime: " Наименьшее время разговора",
            refresh: "Обновить",
            waitingReply: "В ожидании ответа",
            organizationName: " Название организации",
            companySlogan: "Полное название организации",
            messageSentErr: "Сообщение не может быть отправлено, попробуйте еще раз.",
            messageSent: " Сообщение отправлено.",
            openPrivateChat: "Открыть межпользовательский диалог ",
            escKey: " Скрыть активный диалог ",
            archiveChatKey: "Позволяет присоединиться к чату в нижней части страницы архива.",
            chatCopilot: "Включает Chat CoPilot",
            privateChat: " Межпредставительская дискуссионная панель ",
            multiModeAlertDesc: " SUPSIS открыт в другом окне. Нажмите «Использовать здесь», чтобы использовать SUPSIS в этом окне. ",
            useHereText: " Используйте здесь",
            brandVisibility: "Тег бренда SUPSIS появляется в иконке чата",
            focusInput: " Наведите курсор на область письма активного диалога",
            send: "Отправить",
            notYet: "Еще нет",
            sending: "Отправка",
            onlyRepresentative: "Ваше сообщение увидят только агенты.",
            yourMessage: "Ваше сообщение",
            liveFabListDescription: "Живая поддержка",
            messengerIntegrationDesc: "Общайтесь со своими клиентами через страницу Facebook, отправляйте автоматические сообщения с помощью чат-бота.",
            checkDepartmentToAgent: "Проверить отдел на наличие онлайн-агента",
            ifAllOfflineStory: "Сюжет для направления, если все в оффлайне",
            AssignMessagesToAgents: "Назначить все сообщения агентам",
            firstChatbotAndAssign: "Сначала чатбот отвечает, а затем назначает агенту",
            hybridAssign: "Система проверяет отдел, чтобы увидеть, есть ли онлайн-агент, и если онлайн-агента нет, она назначает его чатботу.",
            ticketFabListDescription: "Проездной билет",
            whatsappFabListDescription: "WhatsApp",
            phoneFabListDescription: "Телефон",
            emailFabListDescription: "Эл. адрес",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Twitter",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "YouTube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "Введите в это поле ссылку на свой канал {channelLink}.",
            typeYourAccountLink: "Введите в это поле ссылку на свой аккаунт в {accountLink}.",
            typeYourMessage: "Пишите ваше сообщение здесь",
            typeYourMessageMail: "Сообщение, введенное в это поле, будет отправлено Клиентом на указанный выше почтовый адрес в качестве первого сообщения.",
            typeYourMessageDesc: "Сообщение, введенное в это поле, будет отправлено Клиентом на указанный выше номер телефона в качестве первого сообщения.",
            sendNumber: "Номер телефона для отправки сообщения: {path}",
            callNumber: "Номер телефона, по которому должен звонить ваш клиент: {phoneNumber}",
            numberIsNotCorrect: "Введен пропущенный номер!!",
            emailIsNotCorrect: "Электронная почта неверна!",
            selectFab: "Выберите Фаб",
            notValid: "Вы можете вводить только буквы (один символ). Буквы e, d, f, z, a, x, c, v, w, t, n недействительны ",
            forMacUsers: " Пользователи Mac могут использовать клавишу Control (⌃) ",
            basePriceValue: "Базисная цена",
            basePriceDiscount: "Скидка",
            basePriceCurrency: "Валюта",
            customerDBEnabled: " Выбор базы данных: используйте собственный сервер базы данных клиента",
            customerDBDisabled: " Выбор базы данных: используйте базу данных Supsis сервер ",
            mongoConnectionString: " Подключение Мongo ",
            whatsappBasePriceValue: "Базовая цена WhatsApp",
            whatsappPlusBasePriceValue: "Базовая цена WhatsApp Plus",
            instagramBasePriceValue: "Базовая цена Instagram",
            instagramPlusBasePriceValue: "Базовая цена Instagram Plus",
            clientAddress: " Адрес клиента",
            customerClientAddress: "Клиентский адрес посетителя ",
            apiAddress: " Адрес API",
            socketAddress: "Soket адрес ",
            backendAddress: "BackEnd Адрес",
            panelLogoUrl: " Адрес логотипа панели",
            panelCustomCssUrl: " Адрес пользовательской панели Css ",
            customerLogoUrl: " Адрес логотипа клиента ",
            customerCssUrl: " Адрес CSS клиента ",
            siteAlias: " Название сайта",
            language: "Язык",
            features: "Функции",
            interactionPopularity: "Популярность взаимодействий",
            interactionCount: "Количество взаимодействий",
            uniqueUserCount: "Количество уникальных пользователей",
            allUserPercentage: "(%) Процент всех пользователей",
            represantativeSettings: "Настройки представителя",
            documentTitle: "Форма вспомогательного документа",
            supsisDocument: "Дополнительный документ",
            ApiDoc: "Документация по API",
            chatBalloonTehemeSettings: "Настройки иконки чата и темы",
            customLoginFormSettingsTitle: "Специальная форма входа",
            addNewField: "Добавить новый вопрос",
            editField: " Редактировать вопрос",
            typeHere: " Введите здесь",
            pco: "СРП",
            perPage: "/страница",
            perPageInFilter: "Кусок",
            noUserInfoFound: "Информация о пользователе не найдена",
            startFilter: "Начать поиск",
            showMyChats: " Показать мои чаты",
            showOnlineAgents: " Показать только онлайн",
            showWaitingChats: " Показать ожидающих представителя",
            addNewStatus: "добавить статус",
            newTitleContent: " Добавить заголовок ",
            roleName: "Название должности",
            error: " Ошибка ",
            contentType: " Тип содержимого",
            contentTitle: " Заголовок содержимого ",
            newSiteForm: " Форма регистрации нового сайта ",
            updateSiteForm: " Форма обновления сайта",
            newBannedWordForm: " Новая форма регистрации запрещенных слов",
            updateBannedWordForm: "Форма обновления запрещенного слова",
            newWelcomeMessageForm: "Новая регистрационная форма приветственного сообщения",
            updateWelcomeMessageForm: "Форма обновления системных сообщений",
            newDefaultContentForm: "Новая форма регистрации содержимого по умолчанию",
            updateDefaultContentForm: "Форма обновления контента по умолчанию",
            newSubjectForm: " Форма регистрации новой темы ",
            updateSubjectForm: " Форма обновления темы ",
            showIntro: " Показать презентацию ",
            showChatColorMeaning: " Цвета чата ",
            options: " Опции ",
            resetPassword: " Сброс пароля ",
            audioLevel: " Громкость звукового предупреждения ",
            privateChatNotificationSound: " Звук уведомления",
            continue: " Продолжить",
            newRoleForm: " Форма регистрации новой должности",
            updateRoleForm: " Форма обновления должности ",
            newUserForm: " Форма регистрации нового пользователя",
            updateUserForm: " Обновить форму пользователя ",
            changeOSRForm: " Изменить офлайн-сообщение ",
            tooltipOSRForm: " Вы можете изменить офлайн-сообщение.",
            newOSRForm: " Форма офлайн-поддержки ",
            newOSRMessages: " Добавить автономное сообщение ",
            updateOSRForm: " Форма офлайн-обновления",
            osrTitle: " Заголовок ",
            osrTitleDescription: " Вы можете добавить заголовок в форму офлайн- поддержки ",
            osrContent: " Содержание",
            osrContentDescription: " Вы можете добавить содержание в форму офлайн-поддержки ",
            hello: "Привет",
            cantProceedPayment: "Потому что нам не заплатили",
            and: "а также",
            suspendedPlan: " ваш план был приостановлен",
            payNow: "ЗАПЛАТИТЬ СЕЙЧАС!",
            KeepUsingFeatures: "Продолжайте использовать функции",
            date: " История ",
            startDate: " Дата начала ",
            finish: "Закончить",
            start: "Начать",
            endDate: " Дата окончания",
            representative: " Представители",
            representative_: " Представитель",
            star: "Оценка",
            filter: "Фильтр",
            reset: "Сброс настроек",
            dailyChatList: " Список ежедневных диалогов",
            dailyChatDuration: " Ежедневное время диалогов",
            chatDuration: " Время диалогов",
            dailyChatGraph: " Таблица ежедневных диалогов",
            ok: "Ок",
            chatCount: "Количество диалогов",
            shortest: " Самый быстрый",
            longest: "Самый долгий",
            average: " В среднем",
            count: "Количество",
            averagePoint: "Средняя оценка",
            pointDist: "Распределение оценок",
            point: "Оценка",
            filters: " Фильтры",
            totalCustomer: " Всего клиентов",
            avResponseTime: "Среднее время первого ответа",
            breakDuration: " Перерыв",
            breakCount: " Количество перерывов ",
            lastLoginPlatform: "Platform",
            active: "Активный",
            passive: "Пассивный",
            userForm: " Форма пользователя ",
            sender: "отправитель",
            profile: "Профиль",
            name: "Имя",
            number: "Число",
            username: "Имя пользователя",
            updateUserName: "Обновить имя пользователя",
            email: "Эл. адрес",
            password: "Пароль",
            oldPassword: "Старый пароль",
            newPassword: "Новый пароль",
            passwordAtLeast: "Пароль (не менее {num} символов)",
            passwordRepeat: " Пароль снова ",
            changePassword: " Изменить пароль ",
            status: "Статус",
            douYouWishToDeleteUser: " Вы действительно хотите удалить этого пользователя?",
            userDeleted: " Пользователь удален ",
            userSaved: " Пользователь зарегистрирован.",
            oldPasswordError: " Старый пароль неверен.",
            chooseAnOption: "Пожалуйста, выберите звук уведомления.",
            userVolumeUpdated: " Настройки звука обновлены.",
            addNewMenu: " Добавить новое меню ",
            addNewContent: " Добавить новый контент ",
            pleaseTitleEnter: "Пожалуйста, введите заголовок",
            like: "Рейтинг",
            disLike: "Не нравится ",
            users: "Представители",
            visitor: "Посетители",
            allContacts: "Все контакты",
            allUsers: "Все представители",
            allSites: " Все сайты ",
            newUser: "Новый представитель",
            noNewUser: " Представителя пока нет.",
            noNewAdminUser: " Еще нет представителя с правами администратора.",
            noRoleFound: "Должности ещё нет.",
            noBannedWordFound: " Запрещенных слов пока нет.",
            noWelcomeMessageFound: "Системного сообщения пока нет.",
            noSubjectFound: " Пока нет тем.",
            noVisitorFound: " Посетителей не найдено.",
            noContactFound: "Нет контакта",
            sendResponse: " Напишите ответ.",
            delete: " Удалить",
            duplicate: "Дублировать",
            makeDefault: "Использовать по умолчанию",
            checkMore: "Проверить больше",
            useReadyTemplates: "Используйте готовые шаблоны",
            noRePresentativeFound: " Представитель не найден.",
            noLiveSupportFound: " Пока нет записи о живой поддержке.",
            noBannedVisitorFound: "Забаненных посетителей пока нет.",
            removeBanDescription: " Снять запрет ",
            editThisItem: " Обновить эту запись",
            removeThisItem: " Удалить эту запись ",
            role: "Должность",
            newRolePlaceHolder: " Щелкните, чтобы добавить новую должность...",
            autoChatAssignLimit: " Предел автоматического присвоения речи ",
            chatAssignInfo: "-1 = Системное значение по умолчанию, 0 = Нет назначения,> 0 = Назначить столько, сколько заданное значение.",
            relatedDepartments: "Связанные отделы",
            subjectInfo: " Если тема не выбрана, будут разрешены все темы..",
            archive: "Архив",
            offlineSupportRequests: " Офлайн-поддержка ",
            offlineModeMessage: " Автономное сообщение ",
            offlineMode: " Автономный режим ",
            first: " Первый ",
            last: "Последний",
            query: " Начать поиск ",
            clean: "Очистить",
            loading: " Загрузка ",
            loadMore: " Загрузи больше",
            noMessage: " Нет сообщений...",
            selectChat: " Выбрать чат",
            noMessageInChat: " В этом чате сообщений не найдено ",
            noMediaToShow: "Нет средств массовой информации для показа",
            firstSeen: "Впервые увидено",
            userInfo: " Информация о пользователе ",
            chatId: " ID чата",
            visitorId: "ID посетителя",
            visitingPage: " Посещение страницы",
            osAndBrowser: " Операционная система и браузер ",
            customerClientVersion: " Клиентская версия",
            visitorFeedback: " Обратная связь с клиентами ",
            notes: "Заметки",
            nameSurname: " Имя Фамилия ",
            chats: "Чаты",
            bannedVisitors: " Запрещенные посетители ",
            country: " Страна ",
            city: " Город ",
            cityDistrict: " Район ",
            browser: "Браузер",
            os: " Операционные системы ",
            ipAddress: "IP Адрес",
            connectionDate: " Время подключения ",
            transaction: " обработка ",
            banRemoved: " Блокировка снята.",
            bannedWords: " Запрещенные слова ",
            newBannedWord: " Новое запрещённое слово ",
            noBannedWord: "Нет запрещённых слов.",
            bannedWordForm: " Запрещенная форма слова ",
            word: " Слово",
            bannedWordAndWordGroup: " Запрещенное слово / фраза ",
            doYouWishToDeleteBannedWord: " Вы действительно хотите удалить это запрещенное слово?",
            doYouWishToOfflineSupportRequest: " Вы хотите удалить это сообщение?",
            bannedWordSaved: " Запрещенное слово было записано ",
            deletedSuccessfully: " Успешно удалено ",
            deleteErrorMsg: " Не удалось удалить, попробуйте еще раз. ",
            socketError: " Sockete Проблема с подключением. Обновите страницу и попробуйте еще раз. ",
            socketConnecting: " Связь с сервером ",
            offlineModeDescription: " Система не работает, клиенты не смогут получить доступ к поддержке в реальном времени.",
            offlineModeSettingsDescription: " Проверьте функцию 'Автономный режим' в меню настроек..",
            offlineModeUser: " В системе должен быть хотя бы один онлайн-представитель.",
            adminCannotConnectSocket: "Администраторы не могут подключиться к soket.",
            liveSupport: " Живая поддержка ",
            siteVisitors: " Посетители сайта ",
            visitors: " Посетители ",
            thoseConnectedToLiveSupport: " Подключено к Live Support ",
            visitorHistory: " История посетителей ",
            visitorHistoryDescription: "Вы можете просматривать и загружать историю чатов посетителей.",
            privateMessage: " Личное сообщение ",
            addRepresentative: " Добавить представителя ",
            forwardRepresentative: " Обратитесь к представителю ",
            keyboardShortcuts: " Горячие клавиши ",
            chatColorMeanings: "Значение цвета чата",
            connLostCheckInternet: " Ваше соединение потеряно. Убедитесь, что у вас есть подключение к Интернету.",
            wishToEndThisChat: " Вы хотите закончить этот разговор?",
            defaultContents: "Контент по умолчанию",
            contents: "Содержание",
            newDefaultContent: "Новый контент по умолчанию",
            newCTRLContent: "CTRL Добавить содержание ",
            newALTContent: "ALT Добавить содержание ",
            newTABContent: "TAB Добавить содержание ",
            shortcutChar: " Ярлык",
            pickOne: " Выберите один ",
            writeSomething: " Введите символ (a-z | 0-9)",
            letterSequence: "Последовательность букв",
            exampleText: " Пример: фут - > футбол ",
            anyChar: "anyChar",
            shorcutKey: " Быстрая клавиша ",
            content: " Содержание ",
            shortcutName: " Название ярлыка ",
            type: "тип",
            shortcut: "Ярлык",
            deleteContentQuestion: "Вы действительно хотите удалить это содержимое по умолчанию?",
            defaultContentDeleted: "Контент по умолчанию удален",
            defaultContentSaved: "Контент по умолчанию сохранен.",
            defaultContentForm: "Форма содержимого по умолчанию",
            titleContentForm: "Готовый контент Заголовок",
            contentMoved: " Системное сообщение перемещено.",
            cannotMoveFullParent: "Вы не можете переместить этот элемент",
            yourEmail: " Адрес электронной почты ",
            yourName: "Ваше имя и фамилия",
            lostPassword: " я забыл мой пароль ",
            login: "Авторизоваться",
            forgotPassword: "Забыл мой пароль",
            multipleSession: "Вы вошли в систему где-то еще.",
            notAuthorizedToDisplayPage: " У вас нет разрешения на просмотр этой страницы!",
            permissions: "Разрешения",
            newPermission: " Новое Разрешение ",
            permissionForm: "Форма разрешения",
            displayTitle: " Отображать заголовок ",
            key: "ключ",
            keyToUseInSystem: "Значение ключа для использования в системе",
            deletePermissionQuestion: " Вы действительно хотите удалить это разрешение?",
            permissionDeleted: " Разрешение удалено.",
            permissionSaved: "Разрешение сохранено.",
            newRole: "Новая должность",
            selectARole: " Выберите должность ",
            yes: "Да",
            no: "Нет",
            fullAuth: " Полные полномочия ",
            roleDeleted: " Должность удалена.",
            sameRole: "Существует роль с таким же именем.",
            roleForm: " Должностная форма ",
            roles: "Должности",
            settings: " Настройки ",
            selectTopic: " Выбор темы ",
            autoCallTransfer: " Автоматический перевод вызова ",
            customerTyping: " Типы пользователей ",
            typing: "печатание",
            agentTyping: " Представитель пишет ",
            disconnectTime: "Конец разговора (сек)",
            tippyDissconnectTime: " Устанавливает количество секунд, по истечении которых стационарный разговор будет отключен. ",
            queueNumberVisibleFeature: " Показать количество посетителей в очереди ",
            privateChatEnabled: " Показать чат между представителями ",
            delayedTalkTime: " Время задержки (сек)",
            employeeAverageChatCount: " Среднее количество разговоров в чате персонала ",
            customerDownTimeWhenRepExit: " Время ожидания клиента при выходе представителя (сек.)",
            autoAssignLimit: "Предел автоматического назначения",
            wasted: "потрачено (сек)",
            settingsSaved: " Настройки сохранены.",
            settingsCannotSaved: "Настройки не могут быть сохранены",
            noAuthorization: "нет авторизации",
            warningBadInput: "Рекомендуется вводить число от 0 до 70.",
            warningBadInputMarginY: "Предупреждение о вводе вертикального поля ⚠️",
            warningBadInputMarginX: "Предупреждение о вводе горизонтального поля ⚠️",
            warningBadInputBubbleSize: "Предупреждение о вводе всплывающих окон чата ⚠️",
            settingFormWrong: " Введенные вами данные неверны, проверьте и попробуйте еще раз.",
            delayTime: " Время задержки (сек.)",
            sites: " Сайты ",
            newSite: " Новый сайт ",
            noSiteYet: " Сайта пока нет.",
            siteAddress: " Адрес сайта ",
            turnBack: "Вернуться Назад",
            customerRepLimit: "Лимит представителя клиента",
            siteSaved: " Сайт зарегистрирован.",
            siteSaveError: " Произошла ошибка при создании сайта.",
            subjects: " Темы ",
            newSubject: " Новая тема ",
            noSubject: " Темы пока нет.",
            subject: " Тема ",
            subjectTitle: " Заголовок темы ",
            infoAboutSubject: " Краткая информация по теме ",
            deleteSubjectQuestion: " Вы действительно хотите удалить эту тему?",
            subjectDeleted: " Тема удалена ",
            subjectSaved: " Тема сохранена.",
            osrFromMessageSaved: " Автономное сообщение записано.",
            welcomeMessages: "Системные сообщения",
            newWelcomeMessages: "Новое приветственное сообщение",
            noWelcomeMessage: "Нет системного сообщения.",
            welcomeMessageContent: "Содержание системного сообщения",
            makeChoice: " Сделайте выбор...",
            welcomeMessage: "Приветственное сообщение",
            repLoggedIn: " Представитель вошел в систему ",
            loginMessage: " Сообщение о выходе ",
            message: " Сообщение ",
            deleteWelcomeMessageQuestion: "Вы действительно хотите удалить это системное сообщение?",
            welcomeMessageDeleted: "Системное сообщение удалено",
            welcomeMessageSaved: "Системное сообщение сохранено.",
            welcomeMessageForm: "Форма системного сообщения ",
            noRep: " Пока нет представителя.",
            addChat: " Добавить в разговор ",
            forwardChat: "переадресовать чат кому-нибудь",
            ago: "тому назад",
            repName: " Имя представителя ",
            lastOnline: " Последнее подключение / время в сети ",
            lastStatusChange: " Последнее изменение статуса ",
            activeChat: " Активная беседа ",
            userMaxCapacity: " Максимальная емкость чата ",
            noActiveChat: " Нет активного разговора.",
            watch: " СМОТРЕТЬ ",
            join: " ПРИСОЕДИНИТЬСЯ ",
            open: " ОТКРЫТО ДЛЯ ДИАЛОГА ",
            directMessage: " ЛИЧНОЕ СООБЩЕНИЕ ",
            block: " ЗАБЛОКИРОВАТЬ ",
            transactions: " Операции ",
            informations: " Информация ",
            visitStart: " Начало визита ",
            fullName: " Имя и фамилия ",
            waitChatTime: " Время ожидания / время разговора ",
            blockUserConfirm: " Вы действительно хотите заблокировать этого пользователя ?",
            messaging: " Обмен сообщениями ",
            hideChat: " Скрыть диалог",
            block_: " Заблокировать ",
            privateMessage_: " Секретное сообщение ",
            assignRep: " Назначить представителя ",
            joinChat: "Присоединиться к чату",
            forwardRep: " Перенаправить ",
            leaveChat: "Выйти из разговора",
            endChat: " Завершить разговор ",
            translatedTextDescription: "Амазонка перевел это сообщение {from} -> {to}.",
            autoTranslate: "Автоматический перевод",
            translateThisMessage: "Перевести это сообщение",
            autoTranslateDetectedDesc: "Язык посетителя: {visitorLanguage}. Нажмите здесь, чтобы активировать автоматический перевод",
            on: "вкл",
            off: "выкл",
            prevChats: " Предыдущие диалоги ",
            noShortCut: " Нет ярлыка ",
            leaveChartConfirm: " Вы уверены, что хотите выйти из разговора?",
            endChatConfirm: " Вы хотите закончить этот разговор?",
            chatBar: " Панель разговора ",
            endConversation: " Завершить разговор ",
            onlyOneRep: " Вы единственный представитель в этом разговоре!",
            chatList: " Список диалогов",
            unreadTitle: " Непрочитанные",
            visitorLeftTitle: " Выход посетителя ",
            activeChatTitle: " Активный диалог",
            autoAssignedTitle: " Назначено автоматически ",
            watchModeTitle: " Режим просмотра",
            lostChat: " Соединение представителя прервано ",
            repLostConn: " Фон диалога становится розовым, если представитель отключен от диалога.",
            chatWidthDelay: "Отложенный чат",
            repChatWidthDelay: " Когда в системе нет активного представителя или когда нет посетителей из-за плотности, фон речи становится зеленым. ",
            unreadMsg: " Если есть непрочитанное сообщение, фон будет голубым.",
            visitorLeftChat: " Если посетитель покидает беседу, фон становится темно-серым..",
            activeChatMsg: " Если разговор активен, фон будет зеленым ",
            autoAssignMsg: " Если назначено автоматическим назначением и разговор еще не просматривался, фон будет горчичным",
            watchModeMsg: " Фон становится красным, когда чат открыт в режиме просмотра ",
            online: " В сети ",
            beRightBack: "Скоро вернусь",
            away: " Скоро вернусь",
            busy: " Занят",
            offline: " Не в сети ",
            logout: " Выйти",
            forWindows: " Для Windows ",
            forMac: "Для Mac",
            nextChatFromActive: " Переключиться с активного разговора на следующий разговор ",
            previousChatFromActive: " Перейти от активного разговора к предыдущему разговору ",
            hideActiveChat: " Скрыть активную беседу ",
            closeActiveChat: " Остановить активный разговор ",
            firsthiddenChat: " Подключиться к чату самого ожидающего клиента ",
            firstChatWaiting: " Переключиться на ожидающий разговор ",
            previousOpenedChat: " Перейти к первому открытому разговору вне зависимости от порядка ",
            historyDetails: " Подробности истории",
            chat: "Чат",
            chatNotFound: "Речь не найдена.",
            dataNotFound: "Данные не найдены.",
            visitorInfo: " Информация для посетителей ",
            timeSpent: "Время вышло",
            noActiveVisitors: " Нет активных посетителей ",
            select: " Всплывающее меню ",
            fullname: " ФИО",
            text: " Текст ",
            numeric: "Числовой",
            phone: " Телефон",
            optionsPlaceholder: "Значение параметра",
            selectField: " Щелкните, если хотите добавить раскрывающееся меню ",
            fullnameField: "Нажмите, если хотите добавить поле Полное имя.",
            textField: " Щелкните, если хотите добавить текстовое поле.",
            labelField: "Щелкните, если хотите добавить поле описания.",
            numericField: " Щелкните, если хотите добавить числовое поле.",
            phoneField: " Нажмите, если хотите добавить поле телефона.",
            departmentField: "Щелкните, если вы хотите добавить поле отдела.",
            emailField: " Нажмите, если хотите добавить домен электронной почты.",
            visible: " Видимый ",
            required: " Обязательство ",
            label: "Описание",
            totalConnected: "Количество диалогов",
            missedChat: " Количество пропущенных диалогов",
            workTime: " Рабочее время ",
            closedChatCount: " Закрытые диалоги",
            activeConvo: "Активные диалоги",
            notAnswered: "Ещё не ответили",
            delayedConvo: " Отложенные диалоги",
            leavingRep: " Выделенный представитель",
            staffRate: " Уровень занятости сотрудников ",
            customLoginAlert: "Ваша форма входа должна содержать хотя бы одно поле.",
            atLeastOneLanguage: " Должно быть хотя бы одно языковое описание.",
            requiredField: " Это поле обязательно к заполнению.",
            notRequiredField: " Это поле не обязательно.",
            visibleField: "Это поле видно.",
            notVisibleField: "Это поле не отображается.",
            connectServer: " Вы подключены к серверу ",
            disconnectServer: " Ваше соединение с сервером было потеряно ",
            liveChatOff: " Живая поддержка отключена ",
            visitorScreen: " Отображение посетителей ",
            viewOnTheSite: "Посмотреть на странице",
            viewOnTheSiteTippy: "Нажмите здесь, чтобы посмотреть, как выглядят ваши изменения на сайте.",
            showHint: " Показать подсказку ",
            dontShowHint: " Показать подсказку",
            liveChatOn: " Онлайн-поддержка открыта ",
            nightModeOff: " Ночной режим выключен ",
            nightModeOn: " Ночной режим включен ",
            deleteField: " Удалить ",
            arrow_upward: " Переместить вверх ",
            arrow_downward: " Переместить вниз ",
            doubleClickEdit: " Дважды щелкните или нажмите «Редактировать», чтобы отредактировать.",
            newCatalogCategory: "Новая категория каталога",
            childCreate: " Нажмите, чтобы создать дополнительный контент ",
            updateCatalogCategoryFrom: "Форма обновления категории каталога",
            newCatalogCategoryFrom: "Форма новой категории каталога",
            catalogMenu: " Меню ",
            catalogContent: " Содержание ",
            catalogCategoryName: " Название категории каталога ",
            newCatalogContentFrom: "Форма содержания нового каталога",
            catalogContentName: " Название содержимого каталога ",
            catalogCategorySaved: " Категория каталога сохранена ",
            catalogCategoryDeleted: " Категория каталога удалена.",
            catalogCategoryRate: " Оценка содержания ",
            catalogContentFeature: "Каталог Особенности",
            vtipyAudioLevel: " Используется для отключения или включения звуков уведомлений.",
            vtipyOrganizationName: " Вы можете изменить название организации и обновить его.",
            vtipyBrandVisibility: " Supsis - это настройка отображения тега в пузыре чата.",
            vtipyBrandVisibilityForced: "Только пользователи ProPlan могут изменять!!",
            vtipyClientDefault: " Здесь вы можете изменить язык страницы представителя.",
            vtipyCustomerClientDefault: " Здесь вы можете изменить язык страницы клиента (чата).",
            vtipyVisitorPreferredLang: "Клиент может выбрать разговорный язык на странице (Чат).",
            vtipyCustomerClientLanguageDetect: " Вы можете автоматически определять язык страницы клиента (чат).",
            vtipySelectTopic: "Происходят автоматические назначения существующим представителям в выбранном отделе.",
            vtipyAutoCallTransfer: " Автоматически назначает ожидающие вызовы доступным операторам.",
            vtipyCustomerTyping: " Позволяет вам видеть, что написал клиент на экране чата на экране чата агента.",
            vtipyAgentTyping: " Показывает статус записи представителя в пузыре клиента.",
            vtipyQueueNumberVisibleFeature: " Когда представители заняты, это показывает клиентам, которые хотят подключиться, в каком порядке они находятся.",
            vtipyPrivateChatEnabled: " Показывает панель разговора между агентами.",
            vtipyDelayedTalkTime: " Ярлык \"Отложенная речь \", если в это время к разговору не подключены агенты.",
            vtipyOfflineMode: " Позволяет перевести систему в автономный режим.",
            vtipyAutoAssignLimit: " Определяет, сколько клиентов (чатов) будет автоматически назначено представителю..",
            vtipyCustomerDownTimeWhenRepExit: " Время ожидания клиента (сек.)",
            tippyDisconnectTime: " Время закрытия чата после отключения клиента (сек.).",
            changeSettings: " Изменить глобальную настройку ",
            totalBg: "ВСЕГО ЧАТОВ",
            activeBg: "АКТИВНЫЕ ЧАТЫ",
            watchBg: "ОТСЛЕЖИВАНИЕ",
            waitingBg: "ОЖИДАЮЩИЕ РАЗГОВОРЫ",
            lateBg: " проходящие чаты",
            freeBg: "праздный",
            maxCapacityBg: "МАКС МОЩНОСТЬ",
            addNewSettings: " Добавить новую глобальную настройку",
            darkMode: "Ночной режим",
            clientDefault: "Язык панели по умолчанию",
            customerClientDefault: "Язык по умолчанию для клиентской части",
            customerClientLanguageDetect: "Автоматическое определение языка клиентской части",
            visitorPreferredLang: "Позвольте клиенту выбрать разговорный язык",
            preferredThemeColor: " Настройка темы разговорного экрана ",
            detail: "Рассмотрение",
            supportUs: "Свяжитесь с нами (Живая поддержка)",
            langSetting: "Настройка языка",
            changeLang: "изменение языка",
            fontSizeSetting: "Настройка увеличения экрана",
            changeLangDesc: "Устанавливает язык приложения на {code}.",
            trLang: "Турецкий",
            enLang: "Английский",
            fieldRequired: "{field} Поле, обязательное для заполнения.",
            selectALanguage: "Выберите язык",
            selectATheme: "Выберите тему",
            responseForm: "Форма ответа",
            clientRequestInfo: "Информация о запросе клиента ",
            createdDate: "Дата создания",
            descMessage: "Сообщение",
            new: "Новое",
            selectAllPermission: "Выбрать все",
            catalogCategories: "Каталог",
            copiedClipboard: "Скопировано в буфер обмена",
            organizationLogo: "Логотип организации",
            changePlan: "Изменить план",
            close: "Закрывать",
            vtipyUploadLogo: "Загрузив логотип своей компании из этой области, вы можете использовать свой собственный логотип в электронных письмах клиентов и на страницах клиентов.",
            tagName: "Название тэга",
            tagDescription: "Метка Описание",
            tagColor: "Цвет этикетки",
            userInformations: "информация о пользователе",
            incomingChat: "Входящий чат",
            support: "Поддерживать",
            team: "Набор",
            groups: "Группы",
            newConversationStarted: "Новый разговор начался",
            allHistoryLoaded: "Вся история загружена",
            chatCreator: "Создатель чата",
            enterGroupTitle: "Введите название группы",
            requiredTitle: "Нельзя оставлять поле заголовка пустым",
            requiredChannel: "Имя канала не может быть пустым",
            next: "Подтверждать",
            selectPeople: "Выберите людей",
            textLimitAlertMessage: "Ограничение на количество символов в WhatsApp составляет 19 символов, за пределами этого ограничения оно отображаться не будет. Однако в Интернете тексты, длина которых превышает лимит в 19 символов, автоматически перемещаются на следующую строку и отображаются.",
            artificialIntelligence: "Искусственный интеллект",
            channelSettings: "Настройки канала",
            apiKeyMode: "Режим API-ключа",
            byokTitle: "Использовать свой API-ключ (BYOK)",
            byokDesc: "Использовать API-ключ из вашего аккаунта OpenRouter",
            supsisKeyTitle: "Использовать API-ключ Supsis AI",
            supsisKeyDesc: "Использовать API-ключ, предоставленный Supsis",
            openrouterApiKey: "API-ключ OpenRouter",
            openrouterApiKeyHint: "Получить API-ключ можно в панели OpenRouter.",
            noChannels: "Пока нет каналов",
            createFirstChannel: "Нажмите «Добавить канал», чтобы создать первый канал.",
            createChannel: "Создать канал",
            providerInfo: "Информация о провайдере",
            channels: "Channels",
            channelUpdatedSuccessfully: "Канал успешно обновлён",
            channelDeletedSuccessfully: "Канал успешно удалён",
            failedToSaveChannel: "Не удалось сохранить канал",
            failedToDeleteChannel: "Не удалось удалить канал",
            apiKeyRequired: "Требуется API-ключ",
            deleteChannelConfirm: "Вы уверены, что хотите удалить этот канал?",
            copiedToClipboard: "Скопировано в буфер обмена",
            showMore: "Показать больше",
            showLess: "Показать меньше",
            dropdown: "Выпадающий список",
            selectRepresentativeChatbot: "Выбрать представителя/чат-бота",
            selectDomain: "Выбрать домен",
            salesOrders: "Заказы",
            noSalesOrdersFound: "Заказы для этого контакта не найдены",
            loadingSalesOrders: "Загрузка заказов",
            contacts: "Контакты",
            noContactsFound: "Контакты по этому номеру не найдены",
            loadingContacts: "Загрузка контактов",
            savingg: "Сохранение...",
            telegramBotIsReachable: "Подключение к сервису Telegram Bot",
            telegramBotIsHealthy: "Сервис Telegram Bot работает",
            telegramBotIsUnhealthy: "Ошибка сервиса Telegram Bot",
            isOneOf: "Один из",
            between: "Между",
            chatbotScenarioHasBeenCanceled: "Сценарий чат-бота отменён",
            ifYouSendThisConversationToTheQueue: "При отправке чата в очередь вы будете отключены от чата, а чат попадёт в очередь. При включённом автоназначении чат будет назначен подходящему агенту и может быть передан обратно вам.",
            aiClassificationTextMode: "Классификация текста",
            aiClassificationImageMode: "Классификация изображений",
            aiClassificationImageUrlLabel: "Изображение для классификации (URL)",
            aiClassificationImageUrlPlaceholder: "Введите адрес изображения в формате https://...",
            updateChannelDesc6: "Обновить канал WhatsApp Business API",
            newWabaChannel: "Новый канал WhatsApp Business",
            newWabaChannelDesc: "Создать новый канал для WhatsApp Business API",
            deleteFiles: "Удалить файлы",
            sureDeleteMultipleFiles: "Вы уверены, что хотите удалить выбранные файлы?",
            cancelSelection: "Отменить выбор",
            trenyolStoreConnection: "Подключите ваш магазин Trendyol.",
            notAuthorizedChannel: "У вас нет доступа к этому каналу.",
            integrationsYouTubeComments: "Управляйте комментариями YouTube из одной панели и общайтесь с клиентами.",
            integrationsGoogleBusinessReviews: "Управляйте отзывами Google Business из одной панели и общайтесь с клиентами.",
            integrationsGooglePlayReviews: "Управляйте отзывами приложений в Google Play из одной панели и общайтесь с пользователями.",
            integrationsAppStoreReviews: "Управляйте отзывами приложений в App Store из одной панели и общайтесь с пользователями.",
            integrationsGoogleDrive: "Управляйте файлами Google Drive в Supsis и делитесь ими в диалогах.",
            integrationsPage: {
                compare: "Сравнить",
                dead: "Неактивен",
                whatsappV2Web: "WhatsApp V2 (Web)",
                whatsappV3QR: "WhatsApp V3 (QR Code)",
                whatsappBusinessAPI: "WhatsApp Business API",
                whatsappBusinessAPIv2: "WhatsApp Business API v2",
                instagram: "Instagram",
                instagramV2: "Instagram V2",
                instagramV2Desc: "Прямое подключение через Instagram Login. Аккаунт Facebook не требуется.",
                messenger: "Messenger",
                linkedin: "LinkedIn",
                telegramQR: "Telegram (QR Code)",
                telegramBotFather: "Telegram (Bot Father)",
                youtubeComments: "Комментарии YouTube",
                googleBusinessReviews: "Отзывы Google Business",
                googlePlayReviews: "Отзывы Google Play",
                appStoreReviews: "Отзывы App Store",
                googleDrive: "Google Drive",
                webTabs: "Веб-вкладки",
                webTabsDesc: "Открывайте внешние приложения в Supsis, добавляя пользовательские вкладки в боковое меню",
                webApps: "Веб-приложения",
                webAppsDesc: "Загружайте и управляйте своими веб-приложениями",
                mail: "Mail",
                smsPostacell: "SMS - Postacell",
                zohoCRM: "Zoho CRM",
                teamgram: "Teamgram",
                ideasoft: "Ideasoft",
                ticimax: "Ticimax",
                ticimaxV2: "Ticimax-V2",
                ticimaxV2Desc: "Управляйте магазином Ticimax и отвечайте клиентам в реальном времени через Supsis.",
                tsoft: "T-SOFT",
                tsoftDesc: "Управляйте заказами и доставкой T-SOFT с SUPSIS AI.",
                ikas: "IKAS",
                ikasDesc: "Управляйте заказами и доставкой Ikas с SUPSIS AI.",
                cacheManager: "Менеджер кэша",
                cacheManagerDesc: "Управление кэшем для обмена данными между автоматизацией и чат-ботами",
                openai: "OpenAI",
                slack: "Slack",
                pushover: "Pushover",
                metaLeads: "Лиды Meta",
                voice: "Голос",
                webphoneRedsantral: "Webphone (Red Central)",
                webphoneRedsantralDesc: "Интеграция веб-телефонии",
                webphoneTelnyx: "Webphone (Telnyx)",
                webphoneTelnyxDesc: "Интеграция Telnyx для международных звонков",
                webphoneNetgsm: "Webphone (NetGSM)",
                webphoneNetgsmDesc: "Веб-телефония с АТС NetGSM",
                aiVoiceAgent: "Голосовой ИИ-агент",
                aiVoiceAgentDesc: "Управляйте телефонами с голосовым ИИ-ассистентом. Также можно интегрировать голосового ассистента на сайт.",
                artificialIntelligenceFallback: "Искусственный интеллект",
                openRouter: "OpenRouter",
                openRouterDesc: "Доступ ко всем LLM-моделям через единый API",
                openAIDesc: "Модели GPT-4, GPT-4o и ChatGPT",
                googleAIStudio: "Google AI Studio",
                googleAIStudioDesc: "Модели Gemini",
                anthropic: "Anthropic",
                anthropicDesc: "Модели Claude 3.5 Sonnet и Claude",
                mistral: "Mistral",
                mistralDesc: "Mistral Large и другие модели",
                microsoftAzure: "Microsoft Azure",
                microsoftAzureDesc: "Сервисы Azure OpenAI",
                amazonBedrock: "Amazon Bedrock",
                amazonBedrockDesc: "Платформа LLM AWS",
                cohere: "Cohere",
                cohereDesc: "Модели Command R+ и NLP",
                xai: "xAI",
                xaiDesc: "Модели Grok",
                deepInfra: "DeepInfra",
                deepInfraDesc: "Инфраструктура LLM-инференса",
                together: "Together",
                togetherDesc: "Сервисы LLM с открытым исходным кодом",
                fireworks: "Fireworks",
                fireworksDesc: "Быстрый LLM-инференс",
                siliconFlow: "SiliconFlow",
                siliconFlowDesc: "Платформа ИИ-моделей",
                parasail: "Parasail",
                parasailDesc: "Сервис LLM API",
                nebius: "Nebius",
                nebiusDesc: "Облачная ИИ-инфраструктура",
                alibabaCloud: "Alibaba Cloud",
                alibabaCloudDesc: "Модели Qwen",
                xiaomi: "Xiaomi",
                xiaomiDesc: "Модели MiLM",
                sambaNova: "SambaNova",
                sambaNovaDesc: "ИИ-оборудование и ПО",
                moonshotAI: "Moonshot AI",
                moonshotAIDesc: "Модели Kimi",
                minimax: "Minimax",
                minimaxDesc: "Модели Abab",
                nvidia: "NVIDIA",
                nvidiaDesc: "Модели NVIDIA NIM",
                whatsappComparisonTitle: "Сравнение решений WhatsApp",
            },
            trendyol: "Trendyol",
            addUserToRole: "Добавить пользователя в роль",
            moveToRole: "Переместить в роль",
            noUsersInRole: "В этой роли нет пользователей",
            removeUserFromRole: "Удалить пользователя из роли",
            removeUserFromRoleConfirm: "Вы уверены, что хотите удалить этого пользователя из роли?",
            selectNewRole: "Выберите новую роль",
            selectRole: "Выберите роль",
            roleUsersUpdated: "Пользователи обновлены",
            userNotFound: "Пользователь не найден",
            unnamed: "Без имени",
            adminReports: "Отчёты администратора",
            noPreferredDepartment: "Предпочтительный отдел не выбран",
            departmentAssignedToTheVisitor: "Выберите отдел для назначения посетителю.",
            whatsappv3Channel: "Канал WhatsApp V3: ",
            linkedinChannel: "Linkedin Channel: ",
            telegramChannel: "Telegram Channel: ",
            linkedinUserProfile: "Профиль пользователя LinkedIn",
            telegramUserProfile: "Профиль пользователя Telegram",
            createTask: "Создать задачу",
            integrationsInstagram: "Управляйте сообщениями Instagram из одной панели, обеспечивайте непрерывную коммуникацию с клиентами в соцсетях.",
            integrationsLinkedin: "Управляйте сообщениями и комментариями LinkedIn, налаживайте быстрый контакт с клиентами с помощью автоответов.",
            integrationsTelegram: "Управляйте каналом Telegram с одной платформы, легко контролируйте все сообщения.",
            integrationsWebchat: "Повышайте конверсию с круглосуточным чат-ботом на сайте, ответами на FAQ и отслеживанием лидов.",
            you: "Вы",
            deleteThread: "Вы уверены, что хотите удалить все письма? Это действие нельзя отменить.",
            deleteMail: "Вы уверены, что хотите удалить письмо? Это действие нельзя отменить.",
            tokenCopied: "Токен доступа скопирован.",
            blockBy: "Заблокировал",
            cardInfos: "Информация карточки",
            announcementInfo: "Информация об объявлении",
            deleteAnnouncementQuestion: "Вы действительно хотите удалить это объявление?",
            announcementDeleted: "Объявление удалено",
            announcementTitle: "Заголовок объявления",
            updateAnnouncementForm: "Форма обновления объявления",
            announcementSaved: "Объявление сохранено.",
            newOsrMessageTitle: "Заголовок офлайн-сообщения",
            startChat: "Начать чат",
            douYouWishToDeleteAnnouncement: "Вы действительно хотите удалить это объявление?",
            noNewAnnouncement: "Объявлений пока нет.",
            useAITemplates: "Использовать шаблоны GPT-4 AI",
            mail: "Почта",
            messageTitle: "Заголовок",
            hashHintMessage: "Хэштеги можно быстро вводить с помощью {shortcut}",
            pmHintMessage: "Личное сообщение по ключевому слову: например pm: Привет",
            shortcutHintMessage: "Сообщения можно отправлять быстрее с помощью быстрых сообщений.",
            switchBetweenConversations: "Между чатами можно быстро переключаться с помощью сочетаний abc.",
            atNameHintMessage: "Имя посетителя можно быстро ввести с помощью {shortcut}.",
            dndHintMessage: "Файлы можно загружать перетаскиванием.",
            pasteFile: "Файлы можно отправить: {shortcut}",
            atEmailHintMessage: "Email посетителя можно быстро ввести с помощью {email}.",
            pastePlainText: "Вставить из буфера как обычный текст: {shortcut}",
            pressAndTalk: "Нажмите и говорите",
            contactUs: "Связаться с нами",
            Aufgabe: "Aufgabe",
            ImportFromReadyTemplates: "الاستيراد من القوالب الجاهزة",
            anWarteschlange: "Warteschlange",
            aprobado: "Aprobado",
            beginsWith: "Inizia con",
            campaign: "Campaign",
            chatbotTickets: "تذاكر الدردشة الآلية",
            completado: "Completado",
            configureTrendyolStoreStoreIntegrationDetail: "تكوين تكامل متجر ترينديول الخاص بك",
            connectZohoZoho: "الاتصال بـ Zoho CRM",
            createMoreThanOneOpenAiChannel: "لا يمكنك إنشاء أكثر من قناة OpenAI واحدة",
            deleteModalModalFormDesc: "إذا قمت بحذف هذا النموذج، فسيتم حذف جميع بيانات النموذج نهائيًا. هل أنت متأكد من رغبتك في المتابعة؟",
            deleteZohoLinkbulkSms: "SMS masivos",
            failToDeleteGroup: "فشل حذف المجموعة",
            failToDeleteGroups: "فشل في حذف المجموعات",
            failToFetchGroupContacts: "فشل في جلب جهات اتصال المجموعة",
            favorite: "preferiti",
            initialContact: "Первичный контакт",
            manageYourYourTeamGramIntegration: "إدارة تكامل TeamGram الخاص بك",
            needsAssessment: "Оценка потребностей",
            notCreateMoreThanOneChannel: "لا يمكنك إنشاء أكثر من قناة واحدة من قنوات Ideasoft",
            offlineTickets: "تذاكر غير متصلة بالإنترنت",
            removeZohoLinkbulkSms: "إرسال رسائل نصية قصيرة مجمعة",
            saveAsAsEmailCustomerGroup: "الحفظ كمجموعة عملاء البريد الإلكتروني",
            saveAsAsWhatsAppCustomerGroup: "حفظ كمجموعة عملاء واتساب",
            sendBulkBulkSmsCustomers: "إرسال رسائل نصية قصيرة مجمعة إلى عملائك",
            supprimerZohoLinkbulkSms: "Bulk SMS",
            sureDeleteDeleteZohoChannel: "هل أنت متأكد من رغبتك في حذف قناة Zoho CRM؟",
            temperatura: "Temperatura",
            ticketSettings: "إعدادات التذاكر",
            utoForwardToOwnerForce: "Автоматическая переадресация владельцу (даже при активном чат-боте)",
            visitorScreenLabel: "تسمية شاشة الزائر"
        },
        telegram: {
            typeInTelegramToken: "Введите токен Telegram",
            token: "Token",
            telegram: "Telegram",
            telegramTokenTitle: "Интеграция с Telegram",
            telegramAlertForm: "Вы можете получить токен бота Telegram от",
            telegramAlertTitle: "Вы действительно хотите удалить токен?",
            telegramAlertText: "Токен исчезнет навсегда!"
        },
        wp: {
            sendingStatus: "Отправляется",
            sent: "Отправлено",
            allErrors: "Все ошибки",
            inProcess: "В процессе",
            sendingStatuses: "Статусы отправки",
            downloadCSV: "Скачать CSV",
            errorMessage: "Сообщение об ошибке",
            noNumbersAdded: "Номера не добавлены",
            downloadDetails: "Скачать детали",
            broadcastFound: "Найдено рассылок: {count}",
            resendForFailedNumbersTooltip: "Повторная отправка оставшимся",
            date: "Дата",
            walletBalanceInsufficient: "Недостаточный баланс кошелька.",
            broadcastCreatedSuccess: "Рассылка успешно создана.",
            broadcastCreateFailed: "Не удалось создать рассылку.",
            resendTitlePrefix: "Повтор ({count} получателей): ",
            duplicateTitlePrefix: "Копия: ",
            broadcastClonedSuccess: "Рассылка успешно склонирована.",
            broadcastCloneFailed: "Не удалось склонировать рассылку.",
            broadcastCancelRequestSent: "Запрос на отмену отправлен. Подождите...",
            broadcastCancelledSuccess: "Рассылка успешно отменена.",
            downloadError: "Ошибка при загрузке!",
            progressTooltipFormat: "{percent}% ({sent} отправлено/{total} контактов)",
            successRatioTooltipFormat: "Всего отправлено = {total} \n Успешных = {success} \n Неудачных = {failed}",
            notAvailable: "Н/Д",
            fieldRequired: "Поле {field} обязательно.",
            defaultBroadcastMessageText: "Здравствуйте, {{name}}, благодарим за то, что выбрали нас.",
            sendAgain: "Отправить снова",
            shippingDetails: "Детали доставки",
            whatsapp: "Whatsapp",
            importContactsFromFile: "Импорт Контактов из Файла",
            chatStarted: "Чат начался",
            chatNotStarted: "Чат не запущен",
            contactSelected: "контакт выбран",
            startChatWithAnyNo: "Начать чат с любым номером",
            toLittleChar: "Отсутствует номер !",
            typeInANumberDesc: "Введите номер, чтобы начать чат с:",
            wpPlusAndLicenceRequired: "Требуется план Whatsapp Plus и лицензия.",
            wpPlusAndLicenceRequiredDesc: "Прежде чем вы сможете начать чаты с номерами, которые не зарегистрированы в ваших контактах, вы должны обновить свой план WhatsApp и получить лицензию.",
            chatStartingWait: "Разговор начинается, пожалуйста, подождите",
            agreement: "Соглашение",
            purchase: "Покупка",
            activating: "Активация сервиса WhatsApp",
            authenticating: "Аутентификация по QR-коду",
            ready: "Готовый",
            activationTitle: "Чтобы активировать интеграцию с WhatsApp на Supsis:",
            wpIntegrationInstruction1: "Откройте WhatsApp на своём телефоне",
            wpIntegrationInstruction2: "Нажмите «Меню» или «Настройки». Щелкните Связанные устройства.",
            wpIntegrationInstruction3: "Наведите свой телефон на этот экран, чтобы считать код",
            qrGeneratingWait: "Генерируется QR-код, пожалуйста, подождите...",
            pleaseContinueToWaitUntilCompleted: "После проверки QR-кода он автоматически переключится на заполненное поле. Пожалуйста подождите...",
            authenticatingWait: "Аутентификация, пожалуйста, подождите...",
            enableFeature: "Включить функцию WhatsApp",
            readAndAgree: "Я подтверждаю прочитал",
            subscribe: "Подписаться",
            subscribed: "Подписан",
            toEnableWpDescription: "Чтобы включить функции WhatsApp, нажмите кнопку ниже.",
            waitForWpActivationDescription: "Служба вашей учетной записи WhatsApp активируется. Пожалуйста, подожди минутку. Это занимает около 10-30 секунд.",
            greatWpActivatedDescription: "Отлично, услуга «Ваша учетная запись WhatsApp» активирована!",
            unsubscribe: "Отписаться",
            planDetails: "Детали интеграции",
            sendReceiveMessage: "Отправка и получение текстовых сообщений",
            sendReceiveImage: "Отправка и получение файлов изображений",
            sendReceiveAudio: "Отправка и получение аудиофайлов",
            sendReceiveGif: "Отправка и получение файлов GIF",
            startChat: "Начать чат на Supsis",
            supsisFunctionality: "Полезный функционал Supsis Chat",
            onePhoneMultiAgent: "Один телефон и несколько агентов",
            basicIntegration: "Базовая интеграция и нулевая конфигурация",
            unsubscribeWpInetgration: "Отписаться от WhatsApp",
            unsubscribeIGIntegration: "Отключить интеграцию Instagram",
            wpBack: "назад",
            terminatelWpInetgration: "При нажатии кнопки «Отписаться» ваша интеграция с WhatsApp прекратится.",
            cancelWpInetgration: "Вы хотите отменить интеграцию WhatsApp?",
            terminatelIGIntegration: "При нажатии кнопки «Отписаться» интеграция Instagram будет отключена.",
            cancelIGIntegration: "Вы хотите отключить интеграцию Instagram?",
            startChatWp: "Начать Чат",
            purchaseHeader: "Покупка интеграции Supsis-Whatsapp",
            wpServices: "Служба WhatsApp",
            wpServicesIntegrationCompleted: "Ваша интеграция WhatsApp завершена. Теперь вы можете пользоваться сервисом.",
            purchasePaymentDescription: "Функция WhatsApp оплачивается ежемесячно. Ваша служба WhatsApp будет активирована после того, как вы примете подписку.",
            wpIntegrationFeatures: "Возможности интеграции WhatsApp",
            saveChanges: "Сохранить изменения",
            contactList: "Список контактов",
            broadcast: {
                broadcast: "Транслировать",
                detail: "Деталь",
                customer: "Покупатель",
                phoneNumbers: "Контактные телефоны",
                showMore: "Показать больше",
                showLess: "Показывай меньше",
                groupName: "Название группы",
                messages: "Сообщения",
                status: "Статус",
                usageCost: "Стоимость использования",
                sendingTime: "Время отправки",
                progress: "Прогресс",
                groupDetail: "Подробная информация о группе",
                messagesPerContact: "Сообщений на контакт",
                successRatio: "Коэффициент успеха",
                message: "Mesaj"
            },
            messages: "Сообщения",
            broadcastRequests: "Запросы трансляции",
            customerGroups: "Группы клиентов",
            messageTemplates: "Шаблоны сообщений",
            plans: "Планы",
            wpIntegrationRequired: "Требуется интеграция с WhatsApp",
            wpRequiredIntegrationDescription: "Извините, страница, которую вы посетили, будет активирована при интеграции вашего WhatsApp.",
            integrateWp: "Поехали, интегрируем WhatsApp",
            active: "Активный",
            archived: "В архиве",
            createBroadcastMessage: "Создать широковещательное сообщение",
            title: "Заголовок",
            description: "Описание",
            createdAt: "Создано на",
            numbers: "Числа",
            actions: "Действия",
            action: "Действие",
            createCustomerGroup: "Создайте пользовательскую группу клиентов",
            search: "Поиск",
            name: "ИМЯ",
            contacts: "Контакты",
            noContactFound: "Контакт не найден",
            broadcastTitle: "Дайте название вашей трансляции.",
            recipients: "Получатели",
            selectRecipients: "Выберите получателей",
            writeYourMessage: "Напишите свое сообщение.",
            schedule: "Расписание",
            scheduleNowOrLater: "Запланируйте сейчас или позже",
            summary: "Резюме",
            cancel: "Отмена",
            send: "Отправлять",
            sending: "Отправка",
            deleteCustomerGroup: "Вы уверены, что хотите удалить эту группу клиентов? {name}",
            customerGroupDeleting: "Удаление группы клиентов ...",
            customerGroupDeletingSuccess: "Группа клиентов успешно удалена",
            customerGroupDeletingError: "Ошибка при удалении группы клиентов",
            wpPlusRequired: "Требуется план Whatsapp Plus.",
            broadcastMessageArchived: "Широковещательное сообщение как заархивированное",
            broadcastMessageNotArchived: "Широковещательное сообщение не архивируется",
            groupNameSearch: "Введите имя группы клиентов",
            groupNameDesc: "Название группы клиентов идентифицирует ваши группы клиентов",
            save: "Сохранять",
            number: "КОЛИЧЕСТВО",
            addColumn: "Добавить столбец",
            addColumnDesc: "Добавить столбец в таблицу",
            addNewContact: "Добавить новый контакт",
            addNewContactDesc: "Добавить контакт в таблицу",
            importFile: "Импорт из файла",
            importFileDesc: "Импорт контактов из файла excel или csv",
            contactAdded: "Контакт добавлен",
            updateCustomerGroup: "Обновление группы клиентов...",
            updateCustomerGroupSuccess: "Группа клиентов успешно обновлена",
            sendBroadcastMessage: "Отправить широковещательное сообщение",
            columnName: "Имя столбца",
            columnType: "Тип столбца",
            defaultValue: "Значение по умолчанию",
            setDefaultValue: "Установите значение по умолчанию для существующих контактов",
            age: "Возраст",
            location: "Расположение",
            gender: "Пол",
            selectContactFile: "Выберите контактный файл",
            selectContactCsvOrExcel: "Выберите файл CSV или EXCEL.",
            importConfiguration: "Импорт конфигурации",
            customizeFile: "Настройте конфигурацию импорта.",
            sendMessageTo: "Кому вы хотите отправить сообщение?",
            allContact: "Все контакты",
            messageTypes: "Типы сообщений",
            whenSendMessage: "Когда вы хотите отправить сообщение?",
            instantlyRightNow: "Мгновенно прямо сейчас",
            completed: "Завершенный",
            scheduleFuture: "Расписание на будущую дату",
            messageDesc: "Ваше сообщение будет отправлено мгновенно всем получателям",
            messageSendAt: "Ваше сообщение будет отправлено всем получателям на",
            estimatedPrice: "Ориентировочная цена",
            estimatedTime: "Расчетное время",
            now: "в настоящее время",
            tenMinute: "10 минут",
            cancelled: "Отменено",
            failed: "Не удалось",
            running: "Бег",
            queued: "В очереди",
            scheduled: "Запланированное",
            noNumberAdded: "Номера не добавлены",
            csvOrExcelFile: "CSV или файл Excel",
            broadcastMessagesToContactFile: "Рассылка сообщений в список контактов",
            broadcastMessageTemplates: "Шаблоны широковещательных сообщений",
            messageFlow: "Поток сообщений",
            textMessageSupport: "Поддержка текстовых сообщений",
            imageMessageSupport: "Поддержка графических сообщений",
            spamPreventions: "Защита от спама",
            includesAllBasicPlans: "Включает все в базовом плане",
            chatbotIntegration: "Интеграция с чат-ботом",
            messageToNewNumbers: "Сообщение на новые номера",
            broadcastMessageToEveryone: "Рассылка сообщений всем",
            personalizedBroadcastMessage: "Персонализированные широковещательные сообщения",
            customerGroupSegmentation: "Сегментация групп клиентов",
            scheduleBroadcastMessage: "Запланировать широковещательное сообщение",
            locationMessageSupport: "Поддержка сообщений о местоположении",
            advancedSpamPreventions: "Усовершенствованная защита от спама",
            whatsappPlans: "WhatsApp планы",
            selectBestPlan: "Выберите план, который вам подходит",
            comingSoon: "Вскоре...",
            selectFile: "Выберите файл",
            created: "Созданный",
            message: "Сообщение",
            cancelIGIntgeration: "Вы уверены, что хотите отключить интеграцию Instagram?",
            uploadFromComputer: "Загрузить с компьютера"
        },
        ig: {
            instagram: "Instagram"
        },
        ticket: {
            trendyolQandA: "Трендйол Вопросы и Ответы",
            instagramComments: "Комментарии Instagram",
            messengerComments: "Комментарии Messenger",
            trendyolComments: "Комментарии Trendyol",
            facebookComments: "Фейсбук комментарии",
            offlineTickets: "Офлайн Билеты",
            chatbotTickets: "Билеты чат-бота",
            ticketSettings: "Настройки билетов",
            ticketSelection: "Тикет Выбран",
            bulkClose: "Массовое Закрытие",
            igComment: "Комментарий в Instagram",
            igMentioned: "Упоминания в Instagram",
            incomingReqChatbot: "Входящие запросы с чатботом",
            incomingReqWebForm: "Запросы из веб-формы",
            incomingReqAutomation: "Запросы от автоматики",
            thisPersonEmailAnswered: "Этот человек хочет получить ответ по электронной почте",
            thisPersonWpAnswered: "Этот человек ожидает ответа по WhatsApp",
            clickStartWpChat: "Нажмите, чтобы начать чат WhatsApp",
            requestProgress: "Прогресс запроса",
            requestMessage: "Запрос сообщения",
            clickAddMailAddress: "Нажмите, чтобы добавить почтовый адрес",
            sendReplyCloseTicket: "Отправить ответ и закрыть билет",
            closeTicket: "Закрыть билет",
            selectEmailSender: "Выбрать отправителя электронной почты",
            withEmailWillNotRecievice: "Вы не сможете получать ответы на письма при отправке с этим почтовым адресом!",
            deleteCommentAndClose: "Удалить и закрыть комментарий",
            sendReplyAndClose: "Отправить ответ и закрыть",
            startChatWp: "Начать чат WhatsApp",
            sureWantToDeleteTicket: "Вы уверены, что хотите удалить билет?",
            bulkDeleteConfirmation: "Подтверждение массового удаления",
            selectedTicketSucsDelete: "Выбранные билеты были успешно удалены.",
            thereErrorDeletingTicket: "При удалении билетов произошла ошибка.",
            deleteConfirm: "Подтвердите удаление",
            sureDeleteTicket: "Вы уверены, что хотите удалить этот билет?",
            ticketSucsDelete: "Билет успешно удален",
            represantiveSucsAppoint: "Агент был успешно назначен",
            ticketClosedSucs: "Билет успешно закрыт",
            ticketCloureFailed: "Не удалось закрыть билет",
            unprocessed: "Не обработано",
            pleaseSelectValidStatus: "Пожалуйста, выберите действительный статус",
            ticketStatusBeenUpdated: "Статус билета был обновлен.",
            doYouWantCloseTicket: "Вы хотите закрыть билет?",
            ticketWillMarkedClosed: "Тикет будет помечен как закрытый и заархивирован.",
            errorUpdatingTicketFailed: "Произошла ошибка при обновлении статуса тикета.",
            igCommentDeleteIgPost: "Комментарий Instagram был удален из вашего поста IG.",
            igCommentHideChange: "Статус скрытия комментария в Instagram был изменен.",
            pleaseChooseRepresent: "Пожалуйста, выберите представителя",
            selectedTicketSucsDelegated: "Выбранные билеты были успешно делегированы.",
            errorOccuredDuringDelegation: "Во время процесса делегирования произошла ошибка.",
            bulkTicketClosing: "Массовое закрытие билетов",
            sureWantCloseTicket: "Вы уверены, что хотите закрыть билет?",
            selectedTicketSucsClosed: "Выбранные билеты были успешно закрыты.",
            thereErrorClosingTicket: "При закрытии билетов произошла ошибка.",
            changeFilterTicketPage: "Изменить фильтры на странице билетов",
            nameOfFilter: "Имя фильтра",
            filterValue: "Значение фильтра",
            deletesSelectedTickets: "Удаляет выбранные билеты",
            idTicketBeDelete: "Идентификаторы билетов, которые нужно удалить (идентификаторы выбранных билетов или идентификаторы всех перечисленных билетов)",
            assignsAgentSelectedTickets: "Назначает представителя на выбранные билеты",
            idTicketBeAssigned: "Идентификаторы билетов, которые нужно назначить (идентификаторы выбранных билетов или идентификаторы всех перечисленных билетов)",
            idAgentAssigned: "Идентификатор представителя, который будет назначен",
            changesStatusSelectedTicket: "Изменяет статус выбранных билетов",
            idTicketWhoseStatus: "Идентификаторы билетов, статус которых будет изменен (идентификаторы выбранных билетов или идентификаторы всех перечисленных билетов)",
            newStatus: "Новый статус",
            selectedTicketsSucsUpdated: "Статус выбранных билетов успешно обновлен.",
            errorWhileChangingStatus: "Произошла ошибка при изменении статуса билетов.",
            thisPageVoiceAssistant: "На этой странице есть голосовой помощник",
            hello: "Здравствуйте!",
            voiceAssistantContent: "Знаете ли вы, что на этой странице есть <strong>Искусственный Интеллект Ассистент</strong>, который может помочь вам?\n                Вы можете попробовать следующие методы, чтобы использовать ассистента:",
            commandHoldingDownTheKey: "Вы можете дать команду, удерживая комбинацию клавиш и говоря.",
            topRightContent: "в верхнем правом углу",
            clickOnTheIcon: "вы можете запустить ассистента, нажав на иконку.",
            sampleVoiceCommands: "Образцы голосовых команд:",
            showMyTickets: "Показать мои билеты",
            showMeZeynepsOpenTicket: "Показать открытые билеты Зейнеп на сегодня",
            deleteTicketsScreen: "Удалить билеты на экране",
            assigntLastTicketAli: "Назначить последний билет Али",
            changeStatusAllTicket: "Изменить статус всех билетов на выполненный",
            setStatusTicketsScreen: "Установить статус билетов на экране на .......",
            assigntUserTicketScreen: "Назначить билеты на экране пользователю .....",
            assigntFirstTicket: "Назначить первый билет мне",
            showIgTickets: "Показать билеты из Instagram за прошлый месяц",
            makeChoice: "Сделать выбор",
            makeAssignment: "Сделать назначение",
            tickets: "Билеты",
            instagramTickets: "Билеты Instagram",
            facebookTickets: "Билеты Facebook",
            trendyolTickets: "Билеты Trendyol",
            automationTickets: "Билеты автоматизации",
            supsisFormTickets: "Билеты Supsis Form",
            columnSettings: "Настройки колонок",
            ticketField: "Билетная зона",
            contactPropertyFields: "Достичь территории объекта",
            ticketFilterList: {
                archivedRequests: "Архивные запросы",
                comingFromFacebook: "Из Facebook",
                comingFromInstagram: "Из Instagram",
                unassignedOpenRequests: "Нераспределенные открытые заявки",
                openRequests: "Открытые запросы",
                requestsOpenedThisWeek: "Заявки открыты на этой неделе",
                specialList: "Специальный список",
                creationDate: "Дата создания",
                supsisFromTheForm: "Супсис из формы",
                fromTrendyol: "От Trendyol",
                comesWithAutomation: "Происходит от автоматизации",
                label: "Этикетка",
                status: "Статус",
                subject: "Тема",
                email: "Электронная почта",
                name: "Имя",
                phone: "Телефон",
                type: "Тип",
                assignedUser: "Назначенный пользователь"
            },
            appointingRepresentative: "Назначьте представителя",
            ticketTagFilter: "Тег фильтра билетов",
            ticketEmails: "Список рассылки для пересылки билетов",
            save: "Сохранить",
            delete: "Удалить",
            transactions: "Параметры",
            noEmailTicketNotifications: "Нет данных",
            emailIsNotValid: "Email не является допустимым",
            emailNotificationDeleted: "Товар удален успешно",
            emailNotificationDeleteError: "Произошла ошибка",
            tagFilterRequired: "Требуется тег фильтра заявки, используйте тег * (подстановочный знак) для всех заявок",
            emailsRequired: "Пересылка писем не должна быть нулевой",
            emailNotificationCreated: "Создано правило пересылки билетов",
            emailNotificationCreateError: "Произошла ошибка",
            ticketForwarding: "Пересылка билетов по электронной почте",
            ticketTagFilterDesc: "Он использует темы тикетов, которые вы использовали в дизайне чат-бота, для фильтрации тикетов. Вы можете написать другой тег и нажать Enter, чтобы добавить его. Если вы выберете тег '*', он выберет все билеты",
            ticketEmailsDesc: "Список адресов электронной почты, на которые будут отправлены билеты. Вы можете добавить адреса представителей в систему, выбрав их. Вы также можете добавить несистемные адреса электронной почты.",
            ticketList: "Правила пересылки билетов",
            ticketTagFilterPlaceHolder: "Фильтр билетов, выберите '*' для всех",
            ticketEmailsPlaceHolder: "Список рассылки для пересылки",
            ticketStatusBeenUpdatd: "Статус заявки обновлён.",
            assignFirstTicket: "Назначить мне первую заявку.",
            assignLastTicketAli: "Назначить последнюю заявку Али.",
            assignUserTicketScreen: "Назначить заявки на экране пользователю …",
            placeholders: "Подстановки"
        },
        theme: {
            opacity: "Непрозрачность",
            headerColor1: "Секция Хадера, цвет 1",
            headerColor1A: "Непрозрачность раздела Хадера 1",
            headerColor2: "Цвет раздела заголовка 2",
            headerColor2A: "Непрозрачность раздела заголовка 2",
            backgroundColor: "Цвет фона 1",
            backgroundColorA: "Прозрачность фона 1",
            backgroundColor2: "Цвет фона 2",
            backgroundColor2A: "Прозрачность фона 2",
            textColor: "Цвет текста",
            errorTheme: "Цвет ошибки",
            selectCustom: "Выберите настраиваемую тему",
            bubbleBackground: "Репрезентативный цвет пузыря",
            bubbleVisitorBackground: "Цвет кружка клиента",
            bubbleBackgroundA: "Репрезентативная непрозрачность пузырька",
            bubbleVisitorBackgroundA: "Непрозрачность пузырька клиента",
            bubbleText: "Репрезентативный цвет текста",
            bubbleVisitorText: "Цвет текста клиента",
            textFormColor: "Цвет формы",
            headerColorSecond: "Цвет верхней части заголовка",
            headerColorFirst: "Нижний цвет заголовка",
            backgroundColorFirst: "Фон Верхний цвет",
            formColor: "Цвет текста формы",
            buttonColor: "Цвет кнопки",
            backgroundColorSecond: "Цвет фона снизу",
            chatBotButtonText: "Цвет шрифта чат-бота",
            chatBotButtonColor: "Цвет кнопки чат-бота",
            font: "Font"
        },
        billing: {
            paymentId: "ID платежа",
            billType: "Тип счета",
            invoiceAmount: "Сумма счета",
            invoiceDate: "Дата счета",
            invoiceStatus: "Статус счета",
            invalidBill: "Недействительный счет",
            invalidBillNotPossible: "Этот счет еще не был создан, поэтому не может быть помечен как недействительный.",
            myInvoices: "Мои счета",
            allInvoices: "Все счета",
            manualInvoices: "Ручные счета",
            endOfPeriodInvoices: "Счета за период",
            purchaseInvoices: "Счета за покупки",
            paidInvoices: "Оплаченные счета",
            unpaidInvoices: "Неоплаченные счета",
            walletDeposit: "Пополнение кошелька",
            updateBillingInfo: "Обновить информацию о счете",
            notFoundSavedBillingAddress: "Карточная информация не добавлена",
            notFoundSavedCard: "Карточная информация не добавлена",
            cardInfoIsStoredSecurelyByIyzico: "Карточная информация хранится в Iyzico в безопасности",
            paymentMethodAndInvoiceAddress: "Способ оплаты и адрес счета",
            unpaidInvoiceBannerMessage: "У вас есть неоплаченный счет. Пожалуйста, оплатите счет, чтобы избежать прерывания обслуживания.",
            unpaidInvoiceBannerMessageWithDate: "У вас есть неоплаченный счет. Если вы не оплатите до {date}, ваш аккаунт будет приостановлен.",
            clickToPay: "Перейти на страницу оплаты",
            packageDescriptions: {
                whatsapp: "Интегрируйте свой обычный аккаунт WhatsApp, чтобы отвечать клиентам по всем каналам.",
                whatsappBusiness: "Интегрируйте свой аккаунт WhatsApp Business, чтобы отвечать клиентам по всем каналам.",
                supsis: "С увеличенным числом представителей вы сможете быстрее и эффективнее отвечать клиентам.",
                chatbot: "Интеграция чат-бота позволит вам обслуживать клиентов 24/7.",
                instagram: "Интегрируйте свой аккаунт Instagram, чтобы отвечать клиентам по всем каналам.",
                telegram: "Интегрируйте свой аккаунт Telegram, чтобы отвечать клиентам по всем каналам.",
                custom: "Выберите один из наших индивидуальных планов и получите персонализированные решения для вашего бизнеса.",
                messenger: "Интегрируйте свой аккаунт Messenger, чтобы отвечать клиентам по всем каналам.",
                trendyol: "Интегрируйте свой аккаунт Trendyol, чтобы быстро отвечать на вопросы клиентов.",
                metaLead: "Интегрируйте свой аккаунт Meta Lead, чтобы управлять лидами прямо из панели управления.",
                customerTables: "Создавайте динамические таблицы для управления данными клиентов, заказами и многим другим.",
                form: "Создавайте формы, собирайте информацию от клиентов и анализируйте данные.",
                automation: "Настраивайте автоматизацию, чтобы ускорить рабочие процессы и повысить эффективность обслуживания.",
                mail: "Интеграция с электронной почтой позволит вам отправлять и получать письма от клиентов.",
                tasks: "Создавайте задачи для планирования и управления своими рабочими процессами.",
                artificialIntelligence: "Интеграция искусственного интеллекта поможет вам быстрее и эффективнее отвечать клиентам.",
                webhook: "Интегрируйте свои приложения с Supsis с помощью вебхуков.",
                default: "Изучите наши пакеты, чтобы получить более подробную информацию."
            },
            autoRenew: "Автоматическое продление",
            purchased: "Куплено",
            currentPlans: "Мои планы",
            individual: "Индивидуум",
            expirationDate: "Действ",
            yourNameSurname: "Ваше имя и фамилия",
            editCardInformation: "Редактировать данные карты",
            billingContactInfo: "Контактная информация биллинга успешно обновлена.",
            defaultRootEmail: "По умолчанию: Основной адрес электронной почты",
            invoiceEmailAddress: "Адрес электронной почты счета",
            invoiceSettings: "Настройки счета",
            updateChannelDesc6: "Обновить канал Whatsapp business api",
            newWabaChannel: "Новый бизнес-канал Whatsapp",
            newWabaChannelDesc: "Создать новый канал для Whatsapp business api",
            popular: "Популярный",
            selectedPlan: "Выбранный план",
            editPlan: "Редактировать план",
            removePlan: "Удалить план",
            showPlan: "Показать план",
            hiddenPlan: "Скрыть план",
            contactSales: "Контактные продажи",
            showLess: "Показать меньше",
            more: "Больше",
            selectTransactionType: "Тип транзакции",
            walletLogs: "Журналы кошелька",
            addBalance: "Пополнить баланс",
            availableBalance: "Доступный баланс",
            walletTransactions: "Операции кошелька",
            autoReload: "Автопополнение",
            transactionTypes: "Типы операций:",
            transactionTypesHint: "(Клик для одиночного выбора, Ctrl+клик для множественного выбора)",
            importantInfo: "Важная информация",
            walletImportantPoint1: "Если оплата с вашей карты не может быть получена, система автоматически отключится; вы должны активировать её самостоятельно.",
            walletImportantPoint2: "Только 1 пополнение каждые 10 минут. Держите целевой баланс высоким для интенсивного использования.",
            walletImportantPoint3: "Вы можете включить больше уведомлений в Настройках уведомлений.",
            walletImportantPoint3Before: "Вы можете включить больше уведомлений в ",
            walletImportantPoint3After: ".",
            walletImportantPoint4: "Вы можете просматривать автопополнения на вкладке \"Операции кошелька\".",
            walletImportantPoint5: "Нет ограничений на количество или сумму пополнений; убедитесь, что вводите правильные настройки.",
            autoBalanceReload: "Автопополнение баланса",
            autoBalanceReloadDesc: "Автоматически пополняет баланс, когда баланс кошелька падает ниже установленного порога.",
            autoReloadToggle: "Автопополнение",
            autoReloadToggleDesc: "Вы можете включить/отключить эту функцию",
            disabledDueToFailure: "Отключено из-за сбоя",
            thresholdValue: "Пороговое значение (TL)",
            thresholdValueDesc: "Автопополнение выполняется, когда баланс падает ниже этого значения",
            reloadMode: "Режим пополнения",
            reloadModeDesc: "Что должно происходить, когда баланс падает ниже порога?",
            addFixedAmount: "Добавить фиксированную сумму",
            fixBalance: "Зафиксировать баланс",
            modeAddDesc: "Когда баланс падает ниже порога, добавляется указанная сумма. Напр.: Порог 50 TL, Баланс 30 TL → 200 TL добавлено → Баланс 230 TL.",
            modeFixedDesc: "Когда баланс падает ниже порога, он дополняется до указанной суммы. Напр.: Порог 50 TL, Баланс 30 TL → 170 TL добавлено → Баланс 200 TL.",
            amountToAdd: "Сумма к добавлению (TL)",
            targetBalance: "Целевой баланс (TL)",
            amountToAddDesc: "Эта сумма будет добавлена, когда баланс упадёт ниже порога",
            targetBalanceDesc: "Баланс будет дополнен до этой суммы, когда упадёт ниже порога (должен быть больше порога)",
            panelNotifications: "Уведомления панели",
            panelNotificationsDesc: "В каких случаях вы хотите получать уведомления?",
            notifyOnRecharge: "Уведомление об успешном пополнении",
            notifyOnFailure: "Уведомление о сбое",
            notifyOnDisabled: "Уведомление об отключении",
            emailNotifications: "Email уведомления",
            emailNotificationsDesc: "Кто должен получать email уведомления (опционально)",
            emailPlaceholder: "Введите email адреса (разделяйте запятой)",
            emailHint: "Если оставить пустым, email будет отправлен только владельцу сайта",
            lastTrigger: "Последний запуск:",
            neverTriggered: "Ещё не запускалось",
            failedAttempt: "Неудачная попытка:",
            saveSettings: "Сохранить настройки",
            tabAll: "Все",
            tabAiUsage: "Использование ИИ",
            tabVoiceAgent: "Голосовой агент",
            tabAutomation: "Автоматизация",
            balanceAddedSuccess: "{price}TL добавлено на ваш аккаунт WhatsApp",
            balanceAddFailed: "Не удалось добавить баланс на ваш аккаунт.",
            autoRebalanceLoadError: "Не удалось загрузить настройки автопополнения",
            thresholdMinError: "Пороговое значение должно быть 0 или больше",
            targetBalanceMinError: "Целевой баланс должен быть больше 0",
            targetBalanceThresholdError: "Целевой баланс должен быть больше порога",
            autoRebalanceSaveSuccess: "Настройки автопополнения успешно сохранены",
            settingsSaveFailed: "Не удалось сохранить настройки",
            testFailed: "Тест не пройден",
            creditCardRequiredForAutoReload: "Сначала добавьте информацию о кредитной карте для автопополнения",
            notificationSettings: "Настройки уведомлений",
            appsumoPack: "Appsumo Pack",
            updatePlan: "Обновить план",
            createPlan: "Создать план",
            freePack: "Бесплатный пакет",
            instantFee: "Будет взиматься мгновенная плата",
            planSequence: "Последовательность плана",
            requiredCodes: "Необходимое количество кодов",
            subHeading: "Подзаголовок",
            featureKey: "Ключ характеристики",
            customerKey: "Ключ клиента",
            monthlyPrice: "Месячная цена",
            monthlyNonDiscounted: "Ежемесячная недисконтированная цена (нефункциональное отображение)",
            twoYearDiscount: "Скидка на 2 года",
            yearDisccount: "Годовая скидка",
            sixMonthDiscount: "Скидка на 6 месяцев",
            threeMonthDiscount: "Скидка на 3 месяца",
            features: "Характеристики",
            sessionCount: "Количество сеансов",
            subType: "Тип подписки",
            skipTrialVersion: "Пропустить пробную версию",
            skipTrialVersionDesc: "Вы можете пропустить пробную версию и продолжить, выбрав подходящий пакет для вашего бизнеса. Если вы пропустите пробную версию, это действие нельзя будет отменить.",
            skipStep: "Пропустить этот шаг",
            switchToPay: "Переключиться на оплату",
            forward: "Вперед",
            pleaseFillInCard: "Пожалуйста, заполните данные карты!",
            fillInTheBillingAddress: "Пожалуйста, заполните информацию о платёжном адресе!",
            cardNumberWrong: "Номер карты неверен!",
            pleaseConfirmTheUser: "Пожалуйста, подтвердите пользовательское соглашение.",
            pleaseCheckYourCard: "Пожалуйста, проверьте вашу карту и ваши данные.",
            site: "Сайт",
            period: "Период",
            billStatus: "Статус счета",
            totalPrice: "Общая цена + НДС",
            depotMoneyWallet: "Пополнение кошелька",
            threeMonthly: "Каждые 3 месяца",
            sixMonthly: "Каждые 6 месяцев",
            twoYearly: "2 года",
            forever: "Навсегда",
            extraPackage: "Дополнительный пакет",
            teamPackage: "Командные пакеты",
            adventPackage: "Выгодные пакеты",
            cupponError: "Код ваучера неверен или истек.",
            enterYourCard: "Пожалуйста, введите вашу кредитную карту",
            invalidCard: "Недействительная кредитная карта, платеж не получен",
            calculateThis: "Рассчитать для:",
            adventageousPackage: "Выгодные скидки на пакеты!",
            cuponApplied: "Купон успешно применен",
            subStart: "Подписка начата",
            subSuccessStart: "Ваша подписка успешно начата",
            success: "Успешно",
            succesDesc: "Подписка успешно создана",
            successDesc: "Ваша функция была успешно активирована.",
            maxNumber: "Максимальное количество представителей для выступления",
            currentAmountDetails: "Сведения о текущей сумме",
            endOfMonthForecastDetails: "Сведения о прогнозе на конец месяца",
            totalAmount: "Общая сумма",
            vatAmount: "Сумма НДС (20%)",
            totalAmountIncludingVAT: "Общая сумма с учетом НДС",
            hideDetails: "Скрыть детали",
            createInvoice: "Создать счет-фактуру",
            reimbursementMade: "Произведено возмещение",
            invalidInvoice: "Недействительный счет-фактура",
            balanceTopUp: "Пополнение баланса WhatsApp",
            paidSuccesfully: "Счет-фактура был успешно оплачен",
            paymentFailed: "Процесс оплаты счета завершился неудачно",
            areYouSurePaid: "Вы уверены, что хотите, чтобы этот счет был отмечен как оплаченный?",
            invoiceMarkedPaid: "Счет-фактура был отмечен как оплаченный.",
            invoiceMarkedFailed: "Произошла ошибка, и счет-фактуру не удалось пометить как оплаченный.",
            areYouSoreRefundInvoice: "Вы уверены, что хотите обработать возврат для этого счета?",
            copied: "Скопировано",
            copiedToClipboard: "Содержимое скопировано в буфер обмена.",
            copyFailed: "Ошибка операции копирования.",
            invoiceGenerated: "Счет выставлен",
            invoiceNotGenerated: "Счет не выставлен",
            notAvailable: "Н/Д",
            estimated: "Оценочно",
            dueDate: "Дата платежа",
            markAsPaid: "Отметить как оплаченный",
            refundPayment: "Оформить возврат",
            editInvoice: "Редактировать счет",
            deleteInvoice: "Удалить счет",
            adminGroup: "Админ",
            billTypeNone: "Нет",
            billTypeManual: "Ручной",
            billTypeMonthly3: "3 месяца",
            billTypeMonthly6: "6 месяцев",
            billTypeAnnual: "Годовой",
            billTypeAnnual2: "2 года",
            billTypeEducation: "Образование",
            billTypeConsultancy: "Консультация",
            billTypeInstallation: "Установка",
            billTypeOther: "Другое",
            paymentNotPossible: "Оплата невозможна",
            saveCardFirst: "Пожалуйста, сначала сохраните кредитную карту для совершения платежа.",
            youMustFillInEmpty: "Вы должны заполнить все пустые места.",
            createdNewInvoice: "Новый счет-фактура был создан успешно",
            createdNewInvoiceFailed: "При создании счета-фактуры произошла ошибка.",
            invoiceUpdated: "Сумма счета-фактуры успешно обновлена...",
            invoiceUpdatedFailed: "При обновлении счета-фактуры возникла проблема.",
            plans: "Планы",
            companyName: "Название компании",
            compony: "Компания",
            person: "Человек",
            invoiceAddressInfo: "Информация об адресе счета-фактуры",
            idNo: "Турецкий идентификатор",
            taxOffice: "Налоговая инспекция",
            taxNumber: "Налоговый номер",
            packageCanNotDownSupsis: "Ваш пакет не может быть понижен. Пожалуйста, удалите или деактивируйте несколько ваших Агентов, чтобы понизить уровень вашего пакета.",
            packageCanNotDownWp: "Ваш пакет не может быть понижен. Пожалуйста, удалите несколько ваших каналов Whatsapp, чтобы понизить рейтинг вашего пакета.",
            packageCanNotDownWPBussiness: "Ваш пакет не может быть понижен. Чтобы понизить статус пакета, удалите несколько своих бизнес-каналов Whatsapp.",
            chooseYourPlan: "Выберите план",
            numberOfRepresentatives: "Количество представителей",
            numberOfChannels: "Количество каналов",
            wpNumberOfChannels: "Количество каналов Whatsapp",
            igNumberOfChannels: "Количество каналов Instagram",
            msNumberOfChannels: "Количество каналов Messenger",
            cancelIt: "Отмена",
            activePlan: "Активный план",
            activate: "Активировать",
            noTransition: "Без перехода",
            daysLater: "дня спустя",
            payBack: "Оплатить",
            paid: "Оплаченный",
            unPaid: "Неоплачиваемый",
            editPrice: "Редактировать цену",
            payNow: "заплатить сейчас",
            youAreCurrentlyOnTrial: "В настоящее время вы находитесь на испытательном сроке. Вы можете пропустить испытательный срок, чтобы увидеть эксклюзивные пакеты.",
            youAreCurrentlyLimited: "В настоящее время вы ограничены системой, поскольку ваши пакеты не соответствуют условиям.",
            youHaveOneRepresentative: "У вас есть один представитель.",
            deactivateOrDeleteYourPiece: "Деактивируйте или удалите своего представителя Piece или купите представителя.",
            youHaveOneWhatsappQRChannel: "У вас есть один QR-канал Whatsapp.",
            deleteYourWhatsAppQR: "Удалить свой Whatsapp QR-канал или купить канал.",
            youHaveAWhatsappBusiness: "У вас есть один канал Whatsapp Business.",
            deleteYourWhatsapp: "Удалить свой канал Whatsapp Business или купить канал.",
            youHaveAnInstagram: "У вас есть канал Instagram.",
            deleteYourInstagram: "Удалить свой канал Instagram или купить канал.",
            youHaveAMessenger: "У вас есть канал Messenger.",
            deleteYourMessenger: "Удалите свой канал Messenger или купите канал.",
            additionalPackages: "Дополнительные пакеты",
            availablePackages: "Доступные пакеты",
            buyNow: "Купить сейчас",
            invoiceInformation: "Информация о счете",
            invoiceAddress: "Адрес для счета",
            invoiceType: "Тип счета",
            review: "Обзор",
            viewDetails: "Просмотреть детали",
            addNewAddress: "Добавить новый адрес",
            enterYourBillingAddress: "Введите адрес для выставления счета",
            selectPlan: "Выберите план",
            paymentStatus: "Статус оплаты",
            amount: "Сумма",
            invoiceID: "Идентификатор счета",
            expected: "Ожидается..",
            currentAmount: "Текущая сумма",
            monthlyEstimatedAmount: "Ежемесячная примерная сумма",
            creationDate: "Дата создания",
            invoicePeriod: "Период выставления счета",
            newPaymentMethod: "Новый способ оплаты",
            channelCount: "Количество каналов",
            remainingTime: "Оставшееся время",
            chatbotLimit: "Лимит чатбота",
            free: "Бесплатно",
            maxChatbotSession: "Максимальное количество сеансов чатбота",
            buyIt: "Купить",
            renewalDate: "Дата обновления",
            monthly: "Ежемесячно",
            yearly: "Ежегодно",
            packagePeriod: "Период пакета",
            packageType: "Тип пакета",
            packageManagement: "Управление пакетами",
            invoiceManagement: "Управление счетами",
            futureInvoice: "Будущий счет",
            pastInvoices: "Прошлые счета",
            creditCard: "Кредитная карта",
            invoice: "Инвойс",
            mustBeUpgradePlanForChatBot: "Чтобы активировать функцию ChatBot, вы должны перейти на тариф Pro!",
            incorrect: "Неправильно",
            cardInfo: "Информация о карте",
            billingDetails: "Платежные реквизиты",
            firstPreferredCard: "Сделать основной картой",
            primary: "Начальный",
            addCardIyzico: "У вас нет зарегистрированной карты. Чтобы оплачивать ежемесячную плату за использование, вам необходимо добавить карту. Платежная система предоставляется iyzico.",
            billingPlanSettings: "Биллинг и счет-фактура",
            startWith: "Карточка {cardFamily} начинается с {binNumber}",
            paymentMethod: "Способ оплаты",
            billingDate: "Дата оплаты",
            isPaid: "Платеж получен?",
            billingHistory: "История счетов",
            markPaid: "Отметить как оплаченное",
            paymentDate: "Дата платежа",
            pay: "Платить",
            newInvoice: "Создать счет-фактуру",
            updateBilling: "Обновить платежную информацию",
            updateCard: "Сменить кредитную карту",
            paymentBilling: "Метод Paymnet и платежные реквизиты",
            price: "Цена",
            billingAddress: "Платежный адрес",
            billingCity: "Город",
            billingCountry: "Страна",
            contactName: "Имя контактного лица по счетам",
            expireMonth: "Срок действия месяца",
            expireYear: "Год истечения",
            expireDate: "Дата истечения",
            cardNumber: "Номер карты",
            cardHolderName: "Имя владельца карты",
            cardAlias: "Псевдоним карты",
            identityNumber: "Идентификационный номер",
            name: "Имя",
            surname: "Фамилия",
            email: "Эл. адрес",
            addCard: "Добавить карту",
            update: "Обновлять",
            cancel: "Отмена",
            save: "Сохранить",
            saving: "Экономия",
            noInvoiceFound: "Нет счета",
            year: "Год",
            updating: "Обновление...",
            newInvoiceForm: "Форма создания нового счета",
            error: "Ошибка",
            transactions: "Параметры",
            paymentMethodAdded: "Способ оплаты успешно добавлен",
            paymentMethodAddError: "Способ оплаты не добавлен, произошла ошибка",
            creditCardChanged: "Кредитная карта успешно изменена",
            errorOccurred: "Произошла ошибка, попробуйте еще раз",
            billingDetailUpdated: "Платежная информация успешно обновлена",
            invoiceCreated: "Счет-фактура успешно создана",
            paymentSuccess: "Оплата прошла успешно, спасибо",
            paymentFail: "Платеж не прошел, попробуйте еще раз",
            billingAddressChanged: "Платежный адрес успешно изменен",
            hidePlan: "Скрыть план",
            informationShopping: "Ваша платежная информация, платежная информация, информация о кредитной карте контролируются Shopify.",
            trialTimeInformation: "Пробная версия заканчивается через {dayCount} дней после. Если вы не укажете способ оплаты до истечения этого периода, система автоматически переключит вас на БЕСПЛАТНЫЙ ПЛАН.",
            trialTimeInformationShort: "Последний {dayCount} День",
            currentPlanLabel: "Текущий план: {planName} ({agentCount} Агент )",
            changeCancelPlan: "Изменить / отменить тарифный план",
            oneAgent: "Агент",
            agent: "Агент",
            yourCurrentPlan: "Текущий план",
            month: "Месяц",
            billedMonthToMonth: "(выставляется счет от месяца к месяцу)",
            selectAgentCount: "Выберите количество агентов",
            selectFreePlan: "Выберите бесплатный план",
            planDetails: "Детали плана",
            multiAgent: "(Мультиагент)",
            selectProPlan: "Выберите план Pro",
            foreverFree: "Вечно свободный",
            websiteIntegration: "интеграция с сайтом",
            websiteIntegrationUnlimited: "интеграция с сайтом (неограниченный)",
            ChatBotUnlimited: "ChatBot (неограниченный)",
            videoCallUnlimited: " видеозвонок (неограниченный)",
            multiAgentUpTo: "Мультиагент (до {agentCount} агентов)",
            audioCallUnlimited: "Аудиовызов (неограниченный)",
            screenSharingUnlimited: "Совместное использование экрана(неограниченный)",
            fileTransferUnlimited: "Передача файлов (неограниченный)",
            autoChatAssignerUnlimited: "Автоматическое назначение чата (неограниченный)",
            multiLanguageTranslationUnlimited: "Многоязычный перевод (неограниченный)",
            detailedReporting: "Подробная отчетность",
            days30TrialsAvailable: "Доступны 30-дневные пробные версии",
            fullCustomizationUnlimited: "Полная настройка (неограниченный)",
            limitedArchiveLookupLastMo: "Ограниченный архив Поиск (Последний {monthCount}-мес)",
            planUpdated: "Отлично, ваш план обновлен.",
            planUpdating: "Ваш план обновляется...",
            planUpdatingDescription: "Подождите, пока ваш план обновится",
            done: "Выполнено",
            freePlanUpdated: "Ваш план обновлен как бесплатный (1 Агент)",
            proPlanUpdated: "Ваш план обновлен как план PRO {agentCount} Агент ",
            canNotDwnGrade: "Невозможно понизить ваш тарифный план с PRO {agentCountFirst} Агент до {valNewPlnToUppr} {agentCountSecond}.  ",
            deleteWarning: "Вы должны удалить или отключить {valDif} Агент.",
            warnMessage: "Выбранный план должен отличаться от текущего.",
            add: "Добавлять",
            cancelYourPlan: "Отменить тарифный план",
            upgradeYourPlan: "Обновите свой план",
            downgradeYourPlan: "Понизьте свой план",
            agree: "ДАТЬ СОГЛАСИЕ",
            disagree: "Не согласен",
            invoices: "Счета",
            priceIntervals: "Ценовой интервал",
            selectSiteAlias: "Выберите или введите название сайта",
            selectPriceInterval: "Выберите или введите ценовой интервал",
            isRefunded: "Возврат сделан?",
            invoiceId: "Счет №",
            siteId: "Сайт №",
            createdDate: "Дата создания",
            failCount: "Количество неудачных попыток получения платежа",
            failDate: "Неудачная дата платежа",
            Dashboard: "Панель приборов",
            Agents: "Агенты",
            Integration: "Интеграция",
            Settings: "Настройки",
            Contacts: "Контакты",
            Domain: "Домен",
            lastActivity: "Последняя активность",
            basePrice: "Базисная цена",
            packagePrice: "Базисная цена",
            whatsappPrice: "WhatsApp Цена",
            realtimeVisitorCount: "Посетитель в реƒжиме реального времени",
            suspend: "Приостановить",
            partner: "Партнер",
            plan: "Строить планы",
            trialDay: "Пробные дни",
            mobile: "Мобильный",
            webSite: "Веб-сайт",
            websiteOrigins: "Происхождение веб-сайта",
            ownerName: "Имя владельца",
            ownerEmailAddress: "Электронная почта владельца",
            discount: "Скидка",
            daysLeft: "Осталось дней",
            newTrialPopUp: "Сколько дней должен длиться новый пробный период?",
            newWpPricePopUp: "Сколько стоит новый тариф WhatsApp?",
            newIGPricePopUp: "Сколько стоит новый тариф Instagram?",
            newBasePricePopUp: "Сколько стоит новая базовая цена?",
            siteInfoUpdated: "Информация о сайте обновлена",
            siteInfoNotUpdated: "Информация о сайте не обновлена",
            siteInfoNotUpdatedErr: "Произошла ошибка! Информация о сайте не обновлена.",
            depositMoneyWallet: "Пополнить кошелёк",
            couponError: "Код купона неверен или истёк.",
            cupponApplied: "Купон успешно применён",
            paidSuccessfully: "Счёт успешно оплачен.",
            areYouSureRefundInvoice: "Вы уверены, что хотите выполнить возврат по этому счёту?",
            company: "Компания",
            deleteYourWhatsApp: "احذف قناة واتساب للأعمال أو اشترِ قناة.",
            packageCanotDownSupsis: "Votre paquet ne peut pas être déclassé. Veuillez supprimer ou désactiver plusieurs de vos agents pour rétrograder votre paquet.",
            packageCanotDownWPBussiness: "Votre forfait ne peut pas être déclassé. Veuillez supprimer plusieurs de vos canaux professionnels Whatsapp pour rétrograder le statut de votre forfait.",
            packageCanotDownWp: "Votre forfait ne peut pas être déclassé. Veuillez supprimer plusieurs de vos canaux Whatsapp pour rétrograder votre forfait.",
            planes: "Тарифы",
            sito: "Сайт",
            yearDiscount: "خصم سنوي",
            youHaveAWhatsAppBusiness: "لديك قناة واتساب واحدة للأعمال.",
            youHaveOneWhatsAppQRChannel: "لديك قناة واتساب QR واحدة."
        },
        tour: {
            stats: " ПАНЕЛЬ СТАТИСТИКИ ",
            chats: " ЧАТ ПАНЕЛЬ ",
            settings: " НАСТРОЙКИ ",
            status: " СТАТУС ",
            prevStep: " Предыдущий шаг ",
            nextStep: " Следующий шаг ",
            finish: " Закончи это ",
            skip: " Прыжок ",
            skip2: " Я знаю систему, больше не показываю",
            startTour: "Начать тур",
            firstTimeIntro: " Я обнаружил, что вы впервые вошли в систему, если вы позволите, я хочу начать небольшой вводный тур. ",
            hi: " Привет ",
            welcomeTo: " Добро пожаловать в службу поддержки Supsis Live ",
            statsPanel: " Это строка состояния, показывающая общее количество активных номеров чата, которые мгновенно ожидают вместе с системой.",
            sidebarMenu: " Меню ",
            sidebarMenuContent: " Здесь вы можете переключаться между страницами.",
            representativePrivateMessage: "Межпредставительская дискуссионная панель",
            representativePrivateMessageContent: " Здесь вы можете увидеть личные разговоры между агентами.",
            helpMenu: "Меню помощи",
            helpMenuContent: " Здесь вы можете найти справочную информацию о системе.",
            settingsMenu: " Меню настроек ",
            settingsMenuContent: " Здесь вы можете выбрать язык, ночной режим и увеличение экрана.",
            startChat: "Начать Чат",
            profileMenu: " Меню профиля ",
            profileMenuContent: " Здесь вы можете изменить доступность и настроить параметры делегата.",
            visitorsTab: " Посетители ",
            visitorsTabContent: " Вы можете увидеть посетителей здесь. ",
            visitorTabHistory: " История посетителей ",
            visitorTabHistoryContent: " Вы можете увидеть историю посетителей здесь.",
            representativeTab: " Представители ",
            representativeTabContent: " Вы можете увидеть представителей здесь.",
            liveSupport: " Живая поддержка ",
            liveSupportContent: " Здесь вы можете увидеть количество клиентов, получающих поддержку в реальном времени.",
            siteVisitors: "Посетители сайта",
            siteVisitorsContent: " Здесь вы можете увидеть количество посетителей сайта.",
            tableSettings: " Настройки стола ",
            tableSettingsContent: "Отсюда вы можете показать или скрыть столбцы в таблице.",
            watchModeButton: "Кнопка просмотра",
            watchModeContent: " Вы можете присоединиться сюда в режиме просмотра, и вы можете просматривать только то, что было опубликовано.",
            popoverInfo: " Подробная информация о посетителе ",
            popoverInfoContent: " Дает информацию о посетителе.",
            popoverButton: " Расширенные настройки речи ",
            popoverButtonContent: " Вы можете открыть беседу, отправить сообщение напрямую представителю или заблокировать посетителя.",
            openChat: " Кнопка: Присоединиться к разговору",
            openChatContent: " Вы можете начать разговор здесь ",
            pagination: " Меню подкачки.",
            paginationContent: " Здесь вы можете увеличить количество страниц.",
            chatwindow: {
                chatWindowSettingsButtons: " КНОПКА НАСТРОЕК ОКНА РАЗГОВОРА ",
                chatWindowActionButtons: " ОКНО РЕЧИ КНОПКИ ОБЩИХ ОПЕРАЦИЙ ",
                chatPanelActions: " РАБОТА С РЕЧНОЙ ПАНЕЛЬЮ ",
                otherPanels: "ДРУГИЕ ПАНЕЛИ",
                settingsButton: "Вы можете заблокировать речь, пересылку, конфиденциальное сообщение и назначить делегатов.",
                chatColorButton: " Вы можете узнать, что означает цвет в речевых пузырях, здесь.",
                keyboardShortcutButton: " Здесь вы можете найти ярлыки для функций, которые упрощают ведение переписки или других функций, которые вы используете. ",
                hideButton: "Откладывает открытое выступление и остается открытым на заднем плане",
                closeButton: " Вы заканчиваете откровенный разговор и уходите из разговора ",
                ellipsisButton: " Сюда включены другие транзакции. Здесь выполняются такие операции, как отправка личных сообщений, запрет посетителей, назначение представителей. ",
                userInfoWidget: " Подробная информация о посетителе будет доступна здесь. ",
                preparedContentWidget: "Есть готовые шаблоны контента. Вы можете быстро добавить готовый контент, щелкнув ярлык или набрав серию ярлыков в области письма на экране речи.",
                chatHistoryWidget: " Если у этого посетителя есть прошлые разговоры, они будут перечислены здесь. Вы можете просмотреть старые детали речи здесь ",
                chatBarButton: " Здесь вы можете заблокировать активный разговор, отправить личное сообщение агенту и выйти из разговора."
            },
            representativ_eTab: "Представители",
            selectColumnsToDisplay: "Выберите столбцы для отображения",
            selectAll: "Выбрать все",
            deselectAll: "Снять выбор",
            resetToDefault: "Сбросить по умолчанию",
            settingsSaved: "Настройки сохранены",
            changeLang: "Может менять язык системы",
            changeStatus: "Может менять статус доступности",
            changeTheme: "Может переключать тёмную и светлую тему",
            closeChat: "Закрыть чат",
            contentStep: "Шаг контента",
            formStep: "Шаг формы",
            goToLive: "Подключить представителя",
            logout: "Может выйти из системы отсюда",
            menuStep: "Шаг меню",
            menuTitle: "Заголовок меню",
            messageContent: "Содержимое сообщения",
            ticket: "Заявка"
        },
        adminUser: {
            newAdminUserForm: " Форма регистрации нового администратора ",
            updateAdminUserForm: " Форма обновления пользователя-администратора ",
            adminUsers: " Пользователи с правами администратора ",
            newAdminUser: " Новый пользователь-администратор ",
            noAdminUser: " Еще нет пользователя с правами администратора.",
            adminUserName: " Имя пользователя администратора "
        },
        report: {
            channel: "Канал",
            channelType: "Тип канала",
            contactCount: "Количество контактов",
            tag: "Метка",
            owner: "Владелец",
            email: "Электронная почта",
            language: "Язык",
            approvalCount: "Количество одобрений",
            adTitle: "Название рекламы",
            sourceType: "Тип источника",
            contactDistributions: "Распределение контактов",
            mostUsedTag: "Самый используемый тег",
            leastUsedTag: "Наименее используемый тег",
            timeDistribution: "Распределение контактов по времени",
            channelDistribution: "Распределение контактов по каналам",
            tagDistribution: "Распределение контактов по тегам",
            platformDistribution: "Распределение контактов по платформам",
            ownerDistribution: "Распределение контактов по владельцам",
            languageDistribution: "Распределение контактов по языкам",
            adsDistribution: "Распределение контактов по рекламе",
            contactPropertyDistribution: "Распределение контактов по свойствам контакта",
            mostEffectiveAd: "Самая эффективная реклама",
            leastEffectiveAd: "Наименее эффективная реклама",
            totalPersonCount: "Общее количество контактов",
            mostUsedChannel: "Самый используемый канал",
            leastUsedChannel: "Наименее используемый канал",
            columnChart: "Столбчатая диаграмма",
            pieChart: "Круговая диаграмма",
            mostUsed: "Наиболее используемый",
            leastUsed: "Наименее используемый",
            mostUsedLanguage: "Самый используемый язык",
            leastUsedLanguage: "Наименее используемый язык",
            mostAssigned: "Чаще всего назначается",
            leastAssigned: "Реже всего назначается",
            averagePersonCount: "Среднее количество контактов",
            mostUsedPlatform: "Самая используемая платформа",
            leastUsedPlatform: "Наименее используемая платформа",
            personCount: "Количество контактов",
            person: "Контакт",
            commentAnalysis: "Анализ комментариев",
            whatsappChannelDistribution: "Распределение чатов по каналам WhatsApp",
            instagramChannelDistribution: "Распределение чатов по каналам Instagram",
            messengerChannelDistribution: "Распределение чатов по каналам Messenger",
            trendyolChannelDistribution: "Распределение чатов по каналам Trendyol",
            metaLeadsChannelDistribution: "Распределение чатов по каналам Meta Leads",
            chatDistributionByTelegramChannels: "Распределение чатов по каналам Telegram",
            chatDistributionByLinkedinChannels: "Распределение чатов по каналам Linkedin",
            channelTimeseries: "Временная шкала каналов",
            channelPies2: "Распределение каналов",
            date: "Дата",
            incomingMessages: "Входящие сообщения",
            outgoingMessages: "Исходящие сообщения",
            customerCount: "Подсчет клиентов",
            mailCount: "Подсчет почты",
            answered: "Ответил",
            unanswered: "без ответа",
            selectaChannel: "выбор канала",
            sentMails: "Отправленные письма",
            sentMailCount: "Количество отправленных писем",
            eventCount: "Количество событий",
            ticketDistribution: "Распространение билетов",
            selectWorkflow: "Выберите рабочий процесс",
            distributionOfTasks: "Распределение заданий",
            mostMissioned: "Больше всего задач",
            leastTasked: "Наименьшее количество задач",
            totalNumberTasks: "Общее количество заданий",
            errorFetchingTask: "Ошибка при получении данных задачи:",
            pipelinePhase: "Фаза конвейера",
            status: "Статус",
            numberOfTasks: "Количество задач",
            insufficientData: "Недостаточно данных",
            hourly: "(Часовой)",
            hourlyAverage: "Средний за час",
            hourlyMax: "Максимум за час",
            hourlyMin: "Минимум за час",
            totalAmount: "Общая сумма",
            averageAmount: "Средняя сумма",
            minAmount: "Минимальная сумма",
            maxAmount: "Максимальная сумма",
            siteCount: "site Count",
            agentCount: "Количество агентов",
            channelsTimeSeries: "Временной ряд каналов",
            channelPies: "Пироги каналов",
            pieView: "Круговая диаграмма",
            topVisitorCountry: "Страна с наибольшим количеством посетителей",
            websiteTrafficByCountry: "Трафик веб-сайта по странам",
            visitorCount: "Количество посетителей",
            websiteVisitorTraffic: "Трафик посетителей на сайте",
            websiteTraffic: "Трафик сайта",
            author: "Автор",
            topWorstComments: "Худшие комментарии",
            topBestComments: "Лучшие комментарии",
            topComments: "Лучшие комментарии",
            noComment: "Комментариев пока нет",
            minWaitingTime: "Минимальное время ожидания",
            maxWaitingTime: "Максимальное время ожидания",
            averageWaitTime: "Среднее время ожидания",
            waitTime: "Время ожидания (секунды)",
            agentWaitDurationTitle: "График времени ожидания агента",
            incomingMessage: "Входящее сообщение(я)",
            outgoingMessage: "Исходящее сообщение(я)",
            totalSpent: "Общие расходы",
            avgSpent: "Средние расходы",
            totalPayment: "Общая оплата",
            walletStatus: "Состояние кошелька",
            walletBalanceStatus: "Состояние баланса кошелька",
            messageTraffic: "Сообщения",
            breakCount: "Количество перерывов",
            agentBreakTime: "Количество перерывов агентов ☕",
            agentStatusHour: "Часовой статус агента",
            agentWorkTimeCalendar: "Календарь рабочего времени агента",
            agentActivity: "Активность агента",
            noEnoughtData: "Достаточно данных нет",
            averageFirstResponse: "Среднее время первого ответа",
            slowestResponser: "Самый медленный отвечающий",
            fastestResponder: "Самый быстрый отвечающий",
            firstAnswerTimeSec: "Время первого сообщения (в секундах)",
            firstAnswerByAgent: "Время первого сообщения от агента",
            averageSolutionTime: "Среднее время решения",
            slowestSolver: "Самый медленный решатель",
            fastestSolver: "Самый быстрый решатель",
            averageChat: "Средний чат",
            leastChatReceiver: "Наименее активный получатель чата",
            mostChatRecipients: "Наибольший количество получателей чата",
            averageTicket: "Средняя заявка",
            leastTicketReceiver: "Меньше всего заявок",
            mostTicketRecipients: "Больше всего заявок",
            resolveTime: "Время разрешения (мин)",
            resolveTimeByUser: "Время разрешения чата пользователем (в минутах)",
            chatResolveTimeByAgent: "Время разрешения чата агентами",
            chatDistByHandleType: "Распределение чатов по обработчику",
            chatDistByHandDesc: "Сколько чатов обработали агенты, чатботы и гибриды?",
            chatCountsByHandleType: "Число чатов по типу обработки",
            missed: "Пропущено",
            chatDistByAnsDesc: "Сколько чатов было ответов или пропущено?",
            chatCountsByAns: "Количество чатов по ответу",
            chatCountByPlatform: "Количество чатов по платформе",
            chatDistByPDesc: "Сколько чатов поступило на какую платформу?",
            chatDistByPlatform: "Распределение чатов по платформе",
            ticketCountByUser: "Подсчет билетов по агентам",
            ticketCountByStatus: "Количество билетов по статусу ответа",
            user: "Пользователь",
            saveAsImage: "Сохранить как изображение",
            fullScreen: "Полноэкранный режим",
            download: "Скачать",
            tableView: "Вид таблицы",
            chartView: "Вид диаграммы",
            chatDistByUsers: "Распределение чатов по пользователям",
            chatCountsByUsers: "Количество чатов по пользователям",
            minDuration: "Минимальная продолжительность",
            maxDuration: "Максимальная продолжительность",
            totalDurationByAgent: "Общая продолжительность сеанса по агенту",
            averageDurationByAgent: "Средняя продолжительность сеанса по агенту",
            totalDurationByCB: "Общая продолжительность сеанса по чатботу",
            averageDurationByCB: "Средняя продолжительность сеанса по чатботу",
            viewUnitAs: "Просмотреть единицу как",
            hybrid: "Гибридный",
            handledBy: "Обработано",
            sessionDurationOverall: "Общая продолжительность сессии",
            allChannels: "Все каналы",
            sessionsDurationOverall: "Общая длительность сессий",
            sessionsOverall: "Общее количество сессий",
            sessionsOverallDesc: "Total chat session count in the selected period",
            ratingOverallDesc: "Distribution of customer satisfaction scores",
            sessionDurationOverallDesc: "Average and total session durations",
            totalSessionCountDesc: "Total number of sessions in the selected period",
            averageSessionCountDesc: "Average session count per time unit",
            maxSessionCountDesc: "Highest session count in a single time unit",
            minSessionCountDesc: "Lowest session count in a single time unit",
            totalSessionDurationDesc: "Sum of all session durations",
            averageSessionDurationDesc: "Average duration per session",
            totalDurationByCBDesc: "Total duration handled by chatbot",
            averageDurationByCBDesc: "Average chatbot session duration",
            totalDurationByAgentDesc: "Total duration handled by agents",
            averageDurationByAgentDesc: "Average agent session duration",
            maxDurationDesc: "Longest session in the selected period",
            minDurationDesc: "Shortest session in the selected period",
            totalRatingCountDesc: "Total number of ratings received",
            averageRatingDesc: "Average score of all ratings",
            weightedAverageRatingDesc: "Weighted average based on score distribution",
            chatDistByUsersDesc: "Chat session distribution by agent",
            chatDistByAnsDesc: "Ratio of answered vs missed sessions",
            chatDistByPlatformDesc: "Chat sessions by platform source",
            chatDistByHandleTypeDesc: "Session distribution between chatbot and live agent",
            resolveTimeByUserDesc: "Average resolve time per agent",
            firstAnswerByAgentDesc: "Average first response time per agent",
            agentWaitDurationDesc: "Customer wait time for agent response",
            topCommentsDesc: "Best and worst customer feedback comments",
            websiteTrafficDesc: "Website visitor traffic over time",
            websiteTrafficByCountryDesc: "Website visitor distribution by country",
            channelBreakdownDesc: "Session counts and distribution by channel",
            wabaMessageTrafficDesc: "WhatsApp message traffic (incoming/outgoing)",
            walletStatusDesc: "Balance transactions and wallet status",
            calendarEventsDesc: "Calendar event count time series",
            reservationEventsDesc: "Reservation event count time series",
            mailInboxDesc: "Incoming email count time series",
            mailSendDesc: "Sent email count time series",
            ticketTimeSeriesDesc: "Support ticket time series",
            ticketByStatusDesc: "Support ticket distribution by status",
            ticketByUserDesc: "Support ticket distribution by agent",
            taskOverallDesc: "Task status and pipeline stage distribution",
            contactTimeDistDesc: "Contact distribution over time",
            contactChannelDistDesc: "Contact distribution by channel",
            contactTagDistDesc: "Contact distribution by tag",
            contactPlatformDistDesc: "Contact distribution by platform",
            contactOwnerDistDesc: "Contact distribution by agent",
            contactLanguageDistDesc: "Contact distribution by language",
            contactAdDistDesc: "Contact distribution by advertisement",
            contactPropertyDistDesc: "Contact distribution by contact properties",
            agentActivitiesDesc: "Daily agent activity summary",
            agentPerformanceDesc: "Agent performance metrics",
            agentWorktimeDesc: "Agent work and break durations",
            breakCountDesc: "Break count and duration distribution",
            calendarEvents: "Календарные события",
            reservationEvents: "События бронирования",
            incomingMails: "Входящие письма",
            incomingMailCount: "Количество входящих писем",
            reservation: "Бронирование",
            event: "Событие",
            reservationEventCount: "Количество событий бронирования",
            channelBreakdown: "Разбивка каналов",
            websiteAnalysis: "Анализ веб-сайта",
            customerSatisfaction: "Удовлетворенность клиентов",
            teamBreakAnalysis: "Анализ работы команды/перерыва",
            dailyAgentActivity: "Ежедневная активность агента",
            agentPerformance: "Производительность агента",
            chatDistributions: "Распределение чатов",
            users: "Пользователи",
            segmentTimeseries: "График сегмента",
            segmentsOverall: "Общие сегменты",
            unmatchRatio: "Коэффициент несовпадения",
            totalMatchCount: "Общее количество совпадений",
            totalUnmatchCount: "Общее количество несовпадений",
            matchRatio: "Коэффициент совпадения",
            matched: "Совпадает",
            trainingOverall: "Общая тренировка",
            trainingStatusTimeseries: "График статуса обучения",
            duration: "Продолжительность",
            totalSessionDuration: "Общая продолжительность сессии",
            averageSessionDuration: "Средняя продолжительность сессии",
            second: "секунда",
            minute: "минута",
            hour: "час",
            aggregateAs: "Агрегировать как",
            chatbotSessionDurationOverall: "Общая продолжительность сессии чатбота",
            ratingTimeSeries: "График оценок",
            chatCountTimeseries: "Временной ряд количества чатов",
            notRated: "Не оценено",
            totalRatingCount: "Общее количество оценок",
            averageRating: "Средний рейтинг",
            weightedAverageRating: "Взвешенный средний рейтинг",
            rate: "Оценить",
            ratingOverall: "Общие оценки клиентов",
            session: "Сеанс",
            total: "Всего",
            average: "Среднее",
            max: "Максимум",
            min: "Минимум",
            sessionCount: "Количество сеансов",
            uniqueUsers: "Уникальные пользователи",
            viewAs: "Просмотреть как:",
            overall: "Общий",
            detailReport: " Детальный отчет ",
            dailyReports: " Ежедневный отчет ",
            pointBasedReports: " Отчеты на основе оценок ",
            personDateBasedPointReport: " Отчет об оценке по количеству людей и дней ",
            personDateBasedReport: " Персональный и дневной отчет ",
            personBasedReport: " Персональные отчеты ",
            personAndDateBasedGraph: " График  людей и дней ",
            noReport: " Нет отчета ",
            reports: " Отчеты ",
            totalBar: " Общее ",
            ticketCount: "Количество заявок",
            adNameDistribution: "Распределение контактов по названию объявления",
            adsetDistribution: "Распределение контактов по названию набора объявлений",
            campaignDistribution: "Распределение контактов по названию кампании",
            selectChannel: "Выберите канал",
            leastTask: "Минимум задач",
            dailyAverage: "Среднее за день",
            dailyMax: "Максимум за день",
            dalyMin: "Минимум за день",
            topBestWorstComments: "Лучшие/худшие отзывы",
            erorFetchingTask: "خطأ في تلقي بيانات المهمة:"
        },
        stats: {
            total: " Количество активных разговоров в системе.",
            active: " Количество принадлежащих вам активных разговоров.",
            waiting: " Количество новых активных разговоров, ожидающих делегирования.",
            late: " Количество новых разговоров, прошедших определенный период времени и ожидающих делегирования.",
            free: " Количество разговоров, ожидающих назначения нового представителя после выхода представителя из системы..",
            pco: "[Коэффициент занятости персонала]: коэффициент занятости от общего количества звонков, которые могут принять онлайн-представители в системе.",
            maxCapacity: " Это максимальное количество чатов, которое система может назначить представителям без ожидания. ",
            chatbot: " Количество активных разговоров чат-бота "
        },
        time: {
            lastYear: "Прошлый год",
            thisYear: "Этот год",
            last3Months: "Последние 3 месяца",
            last7: "Последние 7 дней",
            today: " Сегодня ",
            yesterday: "Вчера",
            lastWeek: " Прошлая неделя ",
            currentWeek: " Эта неделя ",
            currentMonth: " Этот месяц ",
            lastMonth: " Прошлый месяц ",
            last30Day: " Последние 30 дней ",
            allTime: " Все время ",
            custom: " Другое время "
        },
        fastWizard: {
            generalColors: "Общие цвета",
            tellUsMore: "Расскажите нам больше, чтобы мы могли персонализировать ваш опыт",
            moreInfo: "Больше информации",
            display: "Отображать",
            availability: "Доступность",
            preview: "Предварительный просмотр",
            installCode: "Установить код",
            previous: "Предыдущий",
            setupSupsisLiveChat: "Настроить чат SUPSIS LIVE",
            continue: "Следующий шаг",
            completeInitialize: "Завершить инициализацию",
            completedMessage: "Настройка чата SUPSIS LIVE успешно завершена.",
            websiteIntegration: "Адрес вашего веб-сайта для интеграции онлайн-чата supsis",
            customizeLiveChat: "Настройте свой онлайн-чат",
            createBrandedExperience: "Создайте фирменный чат для ваших посетителей.",
            chatColor: "Цвет чата",
            chatBubble: "Пузырь чата",
            selectBubble: "Выберите всплывающее окно чата",
            chatBubbleColor: "Цвет пузыря чата",
            selectChatBubbleColor: "Выберите цвет пузыря чата",
            customSelection: "Пользовательский выбор:",
            chatAvailability: "Доступность чата",
            onlineSupportVisitorTime: "Когда вы в сети, чтобы поддержать посетителей?",
            channelAvailability: "Доступность канала",
            availability724: "Чат доступен 7/24",
            basedOnTeam: "На основе статуса члена команды",
            basedOnTeamExplanation: "Чат появится в сети, если хотя бы 1 участник станет доступным.",
            customHours: "Индивидуальные часы работы",
            customHoursExplanation: "Настройте свое рабочее время",
            customHoursTimezone: "Часовой пояс:",
            customHoursFrom: "Из:",
            customHoursTo: "К:",
            customHoursAddHours: "+Добавить часы",
            previewDesktop: "Рабочий стол",
            previewIpad: "IPad",
            installationAndInstructions: "Инструкция & установке",
            installationTrackingCode: "Установите код отслеживания на свой сайт",
            installationTrackingCodePlease: "Вставьте код в соответствии с приведенными ниже инструкциями непосредственно перед концом тега {bodyTag} на любую страницу, на которой вы хотите включить чат SUPSIS Live.",
            installationInstructionsJavascript: " Вставьте приведенный выше код интеграции в тег {bodyTag} непосредственно перед закрывающим",
            installationInstructionsShopify1: "1. Войдите в свою панель Shopify",
            installationInstructionsCopy: "Копировать",
            installationInstructionsCoppyMessage: "Скрипт интеграции скопирован в буфер обмена",
            installationInstructionsShopify2: "2. Перейдите в Интернет-магазин> Темы> раскрывающееся меню Действия в разделе Текущая тема> Изменить код> тема.жидкость.",
            installationInstructionsShopify3: "3. Вставьте приведенный выше код интеграции непосредственно перед тегом {bodyTag} в конце скрипта theme.liquid.",
            installationInstructionsIdeaSoft1: "1. Войдите в свою дилерскую панель.",
            installationInstructionsIdeaSoft2: "2. Зайдите в Настройки -> SEO -> Службы поисковых систем.",
            installationInstructionsIdeaSoft3: "3. Выберите «Проверка сайта с помощью метатега» в разделе «Код отслеживания».",
            installationInstructionsIdeaSoft4: "4. Скопируйте и вставьте приведенный выше код интеграции в открывшееся поле и сохраните.",
            installationInstructionsIdeaSoft5: "5. Внутри настроек -> Оптимизация нажмите кнопку «Очистить кеш». На этом интеграция завершена.",
            installationInstructionsWordPress1: "1. Войдите в свою админ панель WordPress.",
            installationInstructionsWordPress2: "2. Перейдите в Внешний вид> Редактор тем.",
            installationInstructionsWordPress3: "3. В разделе «Файлы темы» (крайний справа) найдите нижний колонтитул темы (footer.php) и выберите его.",
            installationInstructionsWordPress4: "4. Вставьте приведенный выше код интеграции перед тегом {bodyTag} внизу.",
            installationInstructionsWordPress5: "5. Нажмите «Обновить файл», чтобы сохранить изменения.",
            installationInstructionsOpenCart1: "1. Войдите в свою админ панель Opencart.",
            installationInstructionsOpenCart2: "2. Перейдите в Внешний Дизайн > Редактор тем.",
            installationInstructionsOpenCart3: "3. Выберите «общую» папку и откройте файл 'header.twig'.",
            installationInstructionsOpenCart4: "4. Вставьте приведенный выше код интеграции перед тегом {headTag} внизу.",
            installationInstructionsOpenCart5: "5. Нажмите кнопку сохранения.",
            installationInstructionsTicimax1: "1. Войдите в свою административную панель Ticimax.",
            installationInstructionsTicimax2: "2. Откройте «Дизайн» > «Настройки дизайна» > «Дизайн нижнего колонтитула верхнего колонтитула».",
            installationInstructionsTicimax3: "3. Нажмите кнопку «Источник» в разделе дизайна логотипа.",
            installationInstructionsTicimax4: "4. Вставьте код интеграции выше под HTML-кодом.",
            installationInstructionsEticaretteyim1: "1. Войдите в панель администрирования вашего интернет-магазина",
            installationInstructionsEticaretteyim2: "2. Просто назовите SUPSIS из «Плагины»> «Создать HTML»> и скопируйте код.",
            installationInstructions: "инструкции",
            installationVerify: "Убедитесь, что на вашем сайте установлен SUPSIS",
            installationVerifyChecking: "Проверка",
            installationVerifyCheck: "Проверять",
            installationVerifyCheckingStatus: "Проверка статуса интеграции SUPSIS на {website} сайт",
            installationCheckingStatusMessageYes: "Отлично, SUPSIS интегрирован в {website} сайт !!",
            installationCheckingStatusMessageNo: "SUPSIS в настоящее время не интегрирован с веб-сайтом {website}. Вы можете завершить процесс интеграции сейчас или позже.",
            vtippyPreferredLanguage: "предпочтительный язык",
            chooseChatColor: "Выберите цвет акцента."
        },
        akinon: {
            typeOrSelectSKU: "Введите или выберите артикул",
            akinonUserId: "Идентификатор пользователя Акинон",
            userEmail: "Электронная почта пользователя",
            userEmailDesc: "Введите или выберите адрес электронной почты пользователя...",
            send: "Отправлять",
            selectCity: "Выберите город",
            city: "Город",
            selectState: "Выберите штат",
            state: "Состояние",
            useMap: "Использовать карту",
            chooseAddress: "Выберите адрес",
            selectCountry: "Выберите страну",
            country: "Страна",
            productIdDesc: "Введите или выберите продукт...",
            productId: "Код товара",
            userIdDesc: "Введите идентификатор пользователя Akinon...",
            productSKU: "Артикул продукта",
            latitudeDesc: "Введите или выберите широту целевого местоположения...",
            longitudeDesc: "Введите или выберите долготу целевого местоположения...",
            orderNumber: "Ваш номер заказа",
            orderDesc: "Введите номер заказа...",
            longitude: "Долгота",
            latitude: "Широта"
        },
        headBar: {
            source: "Источник",
            label: "Этикетка",
            completed: "Завершено?",
            email: "Электронная почта",
            phone: "телефон",
            name: "Имя",
            date: "История",
            subject: "Предмет",
            situation: "Ситуация",
            representative: "Представитель",
            transactions: "Транзакции",
            channel: "Канал связи",
            Email: "E-mail"
        },
        login: {
            loginTitle1: "Добро пожаловать в",
            loginTitle2: "Supsis AI",
            email: "Ваш адрес электронной почты",
            emailPlaceholder: "Пожалуйста, введите Ваш адрес электронной почты.",
            emailError: "Пожалуйста, введите действительный адрес электронной почты",
            password: "Ваш пароль",
            passwordLogin: "Пароль Бесплатный вход",
            passwordAndLogin: "Войти с паролем",
            passwordNew: "Сбросить пароль",
            loginAnd: "Или",
            passwordPlaceholder: "Пожалуйста введите ваш пароль.",
            loginMemory: "Запомнить это устройство",
            passwordForget: "Я забыл свой пароль",
            passwordNewAgain: "Новый пароль",
            passwordNewAgainTwo: "Повторить новый пароль",
            passwordNewAgainPlaceholder: "Пожалуйста, введите новый пароль.",
            passwordNewAgainPlaceholderTwo: "Пожалуйста, введите новый пароль еще раз.",
            login: "Авторизоваться",
            loginFooter: "Или войдите с электронной почтой",
            emailLogin: "Войти с помощью электронной почты",
            welcomeTitle: "Добро пожаловать",
            welcomeMorning: "Доброе утро",
            welcomeAfternoon: "Добрый день",
            welcomeEvening: "Добрый вечер",
            welcomeNight: "Доброй ночи"
        },
        settings: {
            ipWhitelist: "Список доступа IP",
            loadMore: "Загрузить больше...",
            detectIpAddress: "Определить Мой IP-адрес",
            addWighteListAddress: "Добавить IP-адрес в белый список",
            accessControlSubTitles: "Контроль доступа обеспечивает дополнительный уровень безопасности, позволяющий только авторизованным IP-адресам получать доступ к системе.",
            companyInformation: "Информация о компании",
            ipAddress: "Мой IP-адрес",
            whiteList: "Список защищенных IP-адресов",
            whiteListAdd: "Добавить безопасный IP",
            whiteListDeletedSuccessfully: "Контроль доступа удален успешно",
            whiteListDeletedFailed: "Контроль доступа не удален",
            whiteListAddedSuccessfully: "Контроль доступа добавлен успешно",
            whiteListAddedFailed: "Контроль доступа не добавлен",
            deleteWhiteListTitle: "Вы уверены, что хотите удалить этот белый список?",
            talkSettings: "Настройки речи",
            talkSubtitles: "Управление настройками речи",
            changeSettings: "Изменение настроек для автоматического назначения чата",
            dateAndTime: "Дата и время",
            actor: "Актер",
            event: "Событие",
            accessControl: "Контроль доступа",
            rulesGroup: "Правила",
            organizationLongName: "Длинное имя организации",
            visitorNewDesc: "Вы можете использовать новую версию темы для посетителей.",
            transactionType: "Тип транзакции",
            priorBalance: "Предыдущий баланс",
            nextBalance: "Следующий баланс",
            amount: "Сумма",
            phoneNumber: "Номер телефона",
            profileInfoRemoved: "Информация о профиле удалена",
            newValueUpdated: "Обновлено новое значение",
            balanceToTransferred: "Баланс, подлежащий переводу",
            availableBalance: "Доступный баланс",
            balanceReceived: "Полученный баланс",
            totalBalance: "Общий баланс",
            paymentCard: "Платежная карта",
            wpPhoneNumber: "Номер телефона Whatsapp",
            wpSendingMessage: "Whatsapp отправляет первое сообщение",
            auditlogs: "Журналы аудита",
            myaccount: "Мой аккаунт",
            notifications: "Уведомления",
            company: "Компания",
            features: "Особенности",
            general: "Общий",
            chat: "Чат",
            wallet: "кошелек",
            timings: "Время",
            language: "Язык",
            "bubble-settings": "Настройки пузыря",
            "bubble-actions": "Действия пузыря",
            "theme-settings": "Настройки темы чата",
            visitorLoginForm: "Форма входа посетителя",
            visitorAttribute: "Информация о профиле посетителя",
            timing_settings: "Настройки времени чата",
            auto_assign: "Автоназначение",
            availability: "Доступность",
            "website-integration": "Интеграция веб-сайта",
            General: "Общий",
            Chat: "Чат",
            Timings: "Время",
            Integration: "Интеграция",
            developer: "Разработчик",
            visitorNew: "Новый посетитель",
            companySubtitles: "Управляйте настройками компании.",
            featuresSubtitles: "Управляйте функциями.",
            languageSubtitles: "Установите предпочтительный язык и часовой пояс для вашего бизнеса.",
            bubbleSettings: "Настройки пузыря",
            bubbleSettingsSubtitles: "Управляйте настройками пузыря.",
            bubbleActionsSubtitles: "Управляйте действиями пузыря.",
            chatThemeSettingsSubtitles: "Управляйте настройками темы чата.",
            visitorLoginFormSubtitles: "Управляйте настройками формы входа посетителя.",
            chatTimingSettingsSubtitles: "Управляйте настройками времени чата.",
            webSiteIntegrationSubtitles: "Управляйте настройками интеграции веб-сайта.",
            apiAccessTitle: "Доступ к API",
            apiAccessSubtitles: "Управляйте доступом к API.",
            youTubeActionForm: "Добавьте свой канал YouTube",
            linkedinActionForm: "Добавьте свою учетную запись Linkedin",
            telegramActionForm: "Добавить учетную запись Telegram",
            facebookActionForm: "Добавьте свою страницу Facebook",
            tiwitterActionForm: "Добавьте свою страницу Twitter",
            instagramActionForm: "Добавьте свою страницу Instagram",
            liveSupportDescription: "Поддержка в реальном времени",
            ticketDescription: "Откройте чат с вашими клиентами",
            whatsappDescription: "Ваши клиенты могут связаться с вами через WhatsApp",
            phoneDescription: "Ваши клиенты могут связаться с вами по телефону",
            emailDescription: "Ваши клиенты могут связаться с вами по электронной почте",
            facebookDescription: "Ваши клиенты могут связаться с вами через Facebook",
            twitterDescription: "Ваши клиенты могут связаться с вами через Twitter",
            instagramDescription: "Ваши клиенты могут связаться с вами через Instagram",
            youtubeDescription: "Ваши клиенты могут связаться с вами через YouTube",
            linkedinDescription: "Позвольте вашим клиентам связаться с вами с помощью LinkedIn",
            telegramDescription: "Позвольте вашим клиентам достичь большего с помощью Telegram",
            whatsappModalTitle: "Форма обработки WhatsApp",
            whatsappModalDescription: "Чтобы подключить свой номер WhatsApp, заполните форму ниже.",
            phoneModalTitle: "Форма обработки телефона",
            phoneModalDescription: "Чтобы подключить свой номер телефона, заполните форму ниже.",
            emailModalTitle: "Форма обработки электронной почты",
            emailModalDescription: "Чтобы подключить свой адрес электронной почты, заполните форму ниже.",
            facebookModalTitle: "Форма обработки Facebook",
            facebookModalDescription: "Чтобы подключить свою страницу Facebook, заполните форму ниже.",
            twitterModalTitle: "Форма обработки Twitter",
            twitterModalDescription: "Чтобы подключить свою страницу Twitter, заполните форму ниже.",
            instagramModalTitle: "Форма обработки Instagram",
            instagramModalDescription: "Чтобы подключить свою страницу Instagram, заполните форму ниже.",
            youtubeModalTitle: "Форма обработки YouTube",
            youtubeModalDescription: "Чтобы подключить свой канал YouTube, заполните форму ниже.",
            linkedinModalTitle: "Форма транзакции LinkeIn",
            linkedinModalDescription: "Пожалуйста, заполните форму ниже, чтобы связать свою учетную запись LinkedIn.",
            telegramModalTitle: "Форма транзакции Telegram",
            telegramModalDescription: "Введите ссылку на свой профиль Telegram в форму ниже, чтобы связать свою учетную запись Telegram.",
            instagramAlertTitle: "Требуется интеграция с Instagram",
            instagramAlertDesc: "Извините, посещенная вами страница будет активирована при интеграции с вашим Instagram.",
            instagramActivateText: "Поехали, интегрируем Instagram",
            remove: "Удалить",
            edit: "Редактировать",
            connected: "Подключенный",
            add: "Добавить",
            themeDescription: "Выберите тему чата.",
            fontDescription: "Выберите шрифт чата.",
            isFabsAsIcon: "Показать тексты значков меню.",
            chatBubbleTextSetting: "Настройка текста чата",
            textOnChatBubble: "Вы можете настроить параметры текста, которые будут отображаться в пузыре чата.",
            textToAppearOnChatBubble: "Текст, который будет отображаться в пузыре чата",
            newVisitorProfileInformation: "Информация о профиле нового посетителя",
            newVisitorProfileInformationDescription: "Добавляет новую ценность информации профиля посетителя",
            create: "Создавать",
            newAdd: "Добавить новое",
            toInform: "Довести до сведения",
            toInformDescription: "Вы можете сопоставить значения, которые вы добавляете на этой странице, с формой входа посетителя.",
            showVisitor: "Показать посетителя",
            label: "Билет",
            text: "ПисьмоПисьмо",
            email: "почта",
            phone: "телефон",
            number: "Число",
            url: "URL",
            date: "Время",
            dropdown: "выбираемый",
            languageTimeZone: "Язык и регион",
            timeZoneTitle: "Регион и часовой пояс",
            timeZoneDescription: "Настройки региона и часового пояса",
            ballanceToTransferred: "Баланс для перевода",
            integration: "Интеграция",
            emailTitle: "Введите ваш e-mail",
            emailMessage: "Сообщение первого отправления по e-mail",
            advertising: "Реклама",
            ballanceToTransfer: "Баланс для перевода",
            crm: "CRM",
            ecommerce: "E-commerce",
            sms: "SMS",
            socialMedia: "Социальные сети",
            utilities: "Утилиты",
            web: "Web"
        },
        sessions: {
            mySessions: "Мои сессии",
            mySessionsDesc: "Просмотр и управление активными сессиями, подключенными к вашему аккаунту.",
            allSessions: "Все сессии",
            sessionManagement: "Управление сессиями",
            allSessionsDesc: "Просмотр и управление всеми активными сессиями в системе.",
            noActiveSessions: "Активные сессии не найдены",
            currentSession: "Текущая сессия",
            lastAccess: "Последний доступ",
            createdAt: "Создано",
            revoke: "Отозвать",
            revokeConfirm: "Вы уверены, что хотите отозвать эту сессию?",
            revokeAllConfirm: "Вы уверены, что хотите отозвать все остальные сессии?",
            revokeSuccess: "Сессия успешно отозвана",
            revokeAllSuccess: "Все сессии успешно отозваны",
            revokeFailed: "Не удалось отозвать сессию",
            revokeAllOther: "Отозвать все остальные сессии",
            unknownLocation: "Неизвестное местоположение",
            unknownDevice: "Неизвестное устройство",
            filterByUser: "Фильтр по пользователю",
            mobile: "Мобильный",
            supsisMobileApp: "Мобильное приложение Supsis",
            httpClient: "HTTP-клиент",
            unknown: "Неизвестно",
            ios: "iOS",
            android: "Android"
        },
        contactModuleRules: {
            title: "Правила модуля контактов",
            description: "Определите автоматические действия при создании карточки клиента или открытии чата",
            active: "Активно",
            passive: "Неактивно",
            when: "Когда:",
            conditions: "Условия:",
            actions: "Действия:",
            elseTitle: "Иначе (когда ни одно правило не совпадает)",
            noActionsDefined: "Действия не определены",
            addNewRule: "Добавить новое правило",
            rulesDisabled: "Правила модуля контактов отключены",
            enableHint: "Включите переключатель выше для активации автоматических действий",
            rulesEnabledSuccess: "Правила модуля контактов включены",
            rulesDisabledSuccess: "Правила модуля контактов отключены",
            ruleEnabledSuccess: "Правило включено",
            ruleDisabledSuccess: "Правило отключено",
            ruleUpdateError: "Ошибка при обновлении правила",
            orderUpdatedSuccess: "Порядок правил обновлен",
            orderUpdateError: "Ошибка при обновлении порядка",
            ruleNameTemplate: "Правило {n}",
            ruleSavedSuccess: "Правило сохранено",
            ruleSaveError: "Ошибка при сохранении правила",
            deleteRuleTitle: "Удалить правило",
            deleteRuleConfirm: "Вы уверены, что хотите удалить правило \"{name}\"?",
            delete: "Удалить",
            ruleDeletedSuccess: "Правило удалено",
            ruleDeleteError: "Ошибка при удалении правила",
            elseActionsSavedSuccess: "Действия Иначе сохранены",
            actionsSaveError: "Ошибка при сохранении действий",
            whenContactCreated: "При создании карточки клиента",
            whenChatOpened: "При открытии чата",
            noCondition: "Нет условия",
            and: "и",
            or: "или",
            AND: "И",
            OR: "ИЛИ",
            fieldNotSelected: "Поле не выбрано",
            noAction: "Нет действия",
            doNothing: "Ничего не делать",
            assignToOwnerless: "без назначения",
            assignOwnerlessAction: "Назначить как <strong>{ownerless}</strong>",
            assignTo: "назначить",
            assignToUser: "Назначить <strong>{name}</strong>",
            unknown: "Неизвестно",
            leastContact: "Меньше разговоров",
            roundRobin: "Круговая очередь",
            today: "сегодня",
            last7Days: "последние 7 дней",
            last30Days: "последние 30 дней",
            channelAccessUsers: "пользователи с доступом к каналу",
            usersCount: "{n} пользователей",
            allUsers: "все пользователи",
            random: "Случайно",
            algorithmic: "Алгоритмический",
            addTagNotSelected: "Добавить метку (не выбрано)",
            tagsLabel: "метки",
            tagLabel: "метка",
            addDepartmentNotSelected: "Добавить отдел (не выбрано)",
            addDepartmentTo: "отдел",
            applyToConversation: "(также применить к разговору)",
            updatePropertyNotSelected: "Обновить свойство (не выбрано)",
            changeOwner: "Изменить владельца",
            addTag: "Добавить метку",
            addDepartment: "Добавить отдел",
            updateProperty: "Обновить свойство",
            yes: "Да",
            no: "Нет",
            fields: {
                fullname: "Имя",
                email: "Email",
                phone: "Телефон",
                whatsappNumber: "WhatsApp",
                whatsappCountry: "Страна WhatsApp",
                platform: "Платформа",
                ownerExists: "Владелец",
                ownerIsOnline: "Владелец онлайн",
                ownerStatus: "Статус владельца",
                uptime: "Возраст (мин)",
                tags: "Метки",
                channel: "Канал",
                preferredDepartment: "Отдел",
                hour: "Час",
                day: "День",
                conversationStatus: "Статус чата",
                conversationSubject: "Отдел чата"
            },
            operators: {
                equals: "равно",
                not_equals: "не равно",
                contains: "содержит",
                not_contains: "не содержит",
                gt: "больше",
                gte: "≥",
                lt: "меньше",
                lte: "≤",
                in: "содержит",
                not_in: "не содержит",
                exists: "существует",
                not_exists: "не существует"
            },
            ruleEditor: {
                editTitle: "Редактировать правило",
                createTitle: "Создать новое правило",
                stepWhen: "Когда?",
                stepConditions: "Условия",
                stepActions: "Действия",
                whenQuestion: "Когда должно выполняться правило?",
                ruleName: "Название правила",
                ruleNamePlaceholder: "Введите название правила",
                contactCreatedTitle: "При создании карточки клиента",
                contactCreatedDesc: "Выполняется при создании новой записи клиента",
                chatOpenedTitle: "При открытии чата",
                chatOpenedDesc: "Выполняется при начале новой беседы клиентом",
                conditionsQuestion: "Какие условия должны быть выполнены?",
                actionsQuestion: "Какие действия должны выполняться?",
                back: "Назад",
                cancel: "Отмена",
                next: "Далее",
                save: "Сохранить",
                newRule: "Новое правило"
            },
            elseEditor: {
                title: "Редактировать действия Иначе",
                description: "Определить действия по умолчанию, когда ни одно правило не совпадает"
            },
            ruleTester: {
                title: "Тестировать правило",
                description: "Вы можете проверить, скольким контактам соответствует ваше правило",
                selectRule: "Выбрать правило",
                selectRulePlaceholder: "Выберите правило для тестирования",
                test: "Тестировать",
                ruleInfo: "Информация о правиле",
                conditionCount: "Количество условий:",
                actionCount: "Количество действий:",
                ruleNotFound: "Правило не найдено",
                testComingSoon: "Функция тестирования скоро будет доступна.",
                testError: "Ошибка при тестировании"
            },
            filterBuilder: {
                noConditions: "Условия еще не добавлены",
                addFirstCondition: "Добавить первое условие",
                groupTitle: "Группа {n}",
                deleteGroup: "Удалить группу",
                if: "Если",
                selectField: "выберите поле",
                operator: "оператор",
                select: "выбрать",
                selectValue: "выберите значение",
                enterValue: "введите значение",
                addCondition: "Добавить условие",
                addFilterGroup: "Добавить группу фильтров",
                andOption: "и",
                orOption: "или",
                fieldLabels: {
                    fullname: "Имя контакта",
                    email: "Email контакта",
                    phone: "Телефон контакта",
                    whatsappNumber: "Номер WhatsApp",
                    whatsappCountry: "Страна WhatsApp",
                    platform: "Платформа контакта",
                    ownerExists: "У контакта есть владелец",
                    ownerIsOnline: "Владелец онлайн",
                    ownerStatus: "Статус владельца",
                    uptime: "Возраст контакта (мин)",
                    tags: "Метки контакта",
                    channel: "Канал контакта",
                    preferredDepartment: "Предпочтительный отдел",
                    hour: "Текущий час",
                    day: "Текущий день",
                    conversationStatus: "Статус разговора",
                    conversationSubject: "Отдел разговора"
                },
                operators: {
                    equals: "равно",
                    not_equals: "не равно",
                    contains: "содержит",
                    not_contains: "не содержит",
                    gt: "больше",
                    gte: "больше или равно",
                    lt: "меньше",
                    lte: "меньше или равно",
                    between: "между",
                    exists: "существует",
                    not_exists: "не существует",
                    in: "содержит",
                    not_in: "не содержит"
                }
            },
            actionsEditor: {
                noActions: "Действия еще не добавлены",
                addFirstAction: "Добавить первое действие",
                actionNumber: "Действие {n}",
                actionType: "Тип действия",
                addAction: "Добавить действие"
            },
            changeOwnerConfig: {
                method: "Метод назначения",
                static: "Статический",
                algorithmic: "Алгоритмический",
                random: "Случайный",
                userSelect: "Выбор пользователя",
                assignOwnerless: "Назначить как неназначенного",
                selectUser: "Выберите пользователя",
                userList: "Список пользователей",
                channelAccessUsers: "Все пользователи с доступом к каналу",
                selectUsers: "Выберите пользователей",
                algorithm: "Алгоритм",
                leastContact: "Меньше разговоров",
                roundRobin: "Круговая очередь",
                dateRange: "Диапазон дат",
                today: "Сегодня",
                last7Days: "Последние 7 дней",
                last30Days: "Последние 30 дней",
                onlyOnline: "Включать только онлайн-пользователей"
            },
            addTagConfig: {
                tagsToAdd: "Метки для добавления",
                selectTag: "Выберите метку",
                selectedTagsHint: "Выбранные метки будут добавлены к контакту"
            },
            addDepartmentConfig: {
                departmentSelect: "Выбор отдела",
                selectDepartment: "Выберите отдел",
                departmentHint: "Выбранный отдел будет добавлен в список отделов контакта",
                applyToConversation: "Также применить к разговору",
                applyToConversationHint: "Если включено, отдел открытого разговора также будет установлен"
            },
            upsertContactPropertyConfig: {
                propertySelect: "Выбор свойства",
                selectProperty: "Выберите свойство",
                propertyHint: "Свойство для обновления или создания",
                value: "Значение",
                valuePlaceholder: "Введите значение свойства",
                valueHint: "Это значение будет присвоено свойству"
            }
        },
        taskModuleRules: {
            title: "Правила модуля задач",
            description: "Определите автоматические действия при создании, обновлении задачи или добавлении комментария",
            settingsTitle: "Правила модуля задач",
            settingsDescription: "Определите автоматические правила задач для каждого рабочего процесса",
            selectWorkflow: "Выберите рабочий процесс",
            selectWorkflowPlaceholder: "Выберите рабочий процесс",
            selectWorkflowHint: "Выберите рабочий процесс для редактирования правил модуля задач",
            active: "Активно",
            passive: "Неактивно",
            when: "Когда:",
            conditions: "Условия:",
            actions: "Действия:",
            elseTitle: "Иначе (когда ни одно правило не совпадает)",
            noActionsDefined: "Действия не определены",
            addNewRule: "Добавить новое правило",
            rulesDisabled: "Правила модуля задач отключены",
            enableHint: "Включите переключатель выше для активации автоматических действий",
            rulesEnabledSuccess: "Правила модуля задач включены",
            rulesDisabledSuccess: "Правила модуля задач отключены",
            ruleEnabledSuccess: "Правило включено",
            ruleDisabledSuccess: "Правило отключено",
            ruleUpdateError: "Ошибка во время операции",
            orderUpdatedSuccess: "Порядок правил обновлен",
            orderUpdateError: "Ошибка при обновлении порядка",
            ruleNameTemplate: "Правило {n}",
            ruleSavedSuccess: "Правило сохранено",
            ruleSaveError: "Ошибка при сохранении правила",
            deleteRuleTitle: "Удалить правило",
            deleteRuleConfirm: "Вы уверены, что хотите удалить правило \"{name}\"?",
            delete: "Удалить",
            ruleDeletedSuccess: "Правило удалено",
            ruleDeleteError: "Ошибка при удалении правила",
            elseActionsSavedSuccess: "Действия Иначе сохранены",
            actionsSaveError: "Ошибка при сохранении действий",
            noCondition: "Нет условия",
            and: "и",
            or: "или",
            AND: "И",
            OR: "ИЛИ",
            fieldNotSelected: "Поле не выбрано",
            noAction: "Нет действия",
            chainBadge: "Цепочка",
            chainBadgeTooltip: "Это правило может активировать другие правила",
            automationOffBadge: "Автоматизация выключена",
            automationOffTooltip: "Не передается в Supsis Automations",
            yes: "Да",
            no: "Нет",
            unknown: "Неизвестно",
            cancel: "Отмена"
        },
        userInfoWidget: {
            zohoInfo: "Информация Zoho",
            messageSearch: "Поиск сообщений",
            userInformation: "Информация о пользователе",
            fullName: "Имя и фамилия",
            newValue: "Новое значение",
            newProfileInfo: "Информация о новом профиле",
            affiliatedRepresentatives: "Представители",
            preferredAgents: "Предпочтительный агент(ы)",
            labels: "этикетки",
            agentNotes: "Примечания агента",
            newNote: "Новая заметка",
            note: "заметка",
            available: "Имеются заметки.",
            systemInformation: "Системная информация",
            speechID: "Идентификатор речи",
            customerVersion: "Версия клиента",
            IPAddress: "Айпи адрес",
            pageVisited: "Посещенная страница",
            systemAndBrowser: "Операционная система и браузер",
            countryAndLanguage: "Страна и язык",
            clickToEdit: "Изменить Нажмите внутри поста",
            adsYouAreInterestedIn: "Рекламы, которые вас интересуют",
            detail: "Деталь",
            adsTitle: "Заголовок",
            adUrl: "URL рекламы",
            sourceID: "Идентификатор источника",
            resourceType: "Тип ресурса",
            adsBody: "Содержание",
            adsCreateDate: "Дата создания",
            adsUpdateDate: "Дата обновления"
        },
        newWizartV2: {
            generalSettings: "общие настройки",
            themeSettings: "Настройки темы",
            representativeWorkingHours: "График работы представителя",
            preview: "предварительный просмотр",
            setup: "Настраивать",
            formStepTitle: "Дайте нам больше информации, чтобы мы могли персонализировать ваш опыт",
            supsisEntergation: "На каком вашем веб-сайте вы будете использовать Supsis?:",
            goToNextStep: "Сделайте следующий шаг",
            readytemplate: "Сделайте следующий шаг",
            customSettings: "Пользовательские настройки",
            customerMessageView: "Сообщение клиента Посмотреть",
            backcgroundColor: "Фоновый цвет",
            textColor: "Цвет шрифта",
            agentMessageView: "Представление сообщений агента",
            workingHours: "В какие промежутки времени вы обслуживаете своих посетителей?",
            continuousService: "Непрерывное обслуживание",
            continuousServiceDescription: "Пузырь чата всегда активен. Даже если вы не в системе.",
            vote: "Сделай свой выбор",
            representativeWorking: "График работы представителя",
            representativeWorkingDescription: "Чат появляется в сети, когда хотя бы 1 агент находится в сети. Если онлайн-представителя нет, он будет отображаться как офлайн.",
            computer: "Компьютер",
            tablet: "планшет",
            uploadTrackingCodeToYourWebsite: "Загрузите код отслеживания на свой веб-сайт",
            password: "Установить новый пароль"
        },
        whatsappChannel: {
            whatsappTitleV1: "Каналы Whatsapp V1 (QR)",
            whatsappTitleV2: "Каналы Whatsapp V2 (QR)",
            channelName: "Имя канала",
            phoneNumber: "Номер телефона",
            forwardToChatbot: "Переслать боту",
            forwardingChatbotOrLiveAgent: "Пересылка (бот или живой агент)",
            addChannel: "Добавить канал",
            newWhatsappChannel: "Новый канал WhatsApp",
            newWhatsappChannelDescription: "Создайте новый канал WhatsApp, отсканировав QR-код",
            editWhatsappChannel: "Редактировать канал WhatsApp",
            editWhatsappChannelDescription: "Редактирование канала WhatsApp",
            whatsappChannel: "Канал WhatsApp",
            deleteWhatsappChannelDescription: "Вы уверены, что хотите удалить этот канал?",
            whatsappIntegration: "Интеграция WhatsApp",
            deleteChannel: "Удалить канал",
            restartChannel: "Перезапустить канал",
            wantRestartChannel: "Хотите перезапустить канал?",
            deleteSMSChannelDescription: "Вы уверены, что хотите удалить канал SMS?",
            smsChannel: "СМС-канал",
            maxChannelCount: "Вы не можете создать более одного SMS-канала!",
            smsModalText: "Наша интеграция с современными коммуникационными решениями дает вам возможность легко и эффективно отправлять SMS. Устраните границы в общении, общайтесь напрямую со своими клиентами!",
            smsModalBtn: "Нажмите, чтобы открыть канал SMS...",
            postaCellDetail: "Подробности о канале PostaCell",
            phoneNummer: "Номер телефона"
        },
        noPermission: "У вас нет разрешения на выполнение этой операции.",
        mail_integration_detail: {
            title: "Детали почты",
            integration: "Интеграция",
            sender: "Отправитель",
            signature: "Подпись",
            inbox: "Входящие",
            medias: "Медиа",
            visibility: "Видимость",
            settings_group: "Настройки",
            contacts: "Контакты"
        },
        whatsapp_business_api: {
            userVisibility: "Видимость пользователя",
            userVisibilityDesc: "Каналы, к которым могут получить доступ пользователи, зависят от их роли и настроек видимости канала. Пользователи с ролью Full Admin или root могут видеть все каналы. Если настройки видимости канала пусты, канал является общедоступным. Однако если канал определен для конкретных пользователей или отделов, его могут видеть только эти пользователи или сотрудники отделов.",
            searchTemplate: "Шаблон поиска...",
            forwardToChatbot: "Переслать чатботу",
            forwarding: "Переадресация (чатботу или живому агенту)",
            forwardLiveAgents: "👉 Переслать в службу поддержки",
            forwardingToDepartment: "Переадресация в отдел",
            selectDepartment: "Выбрать отдел",
            createWbChannel: "Чтобы создать канал Whatsapp Business, вы должны приобрести пакет Whatsapp Business. Вы можете получить доступ к доступным пакетам немедленно.",
            wbCreateChannelMax: "Вы достигли предела создания канала Whatsapp Business. Максимум",
            wbContinue: "Вы можете создать бизнес-канал Whatsapp. Чтобы продолжить, обновите свой пакет или удалите некоторые из ваших каналов Whatsapp Business.",
            chatInitiatorTemplate: "Шаблон инициатора чата",
            selectChatInitiatorTemplate: "Выберите шаблон инициатора чата",
            dailyUsageReport: "Отчет о ежедневном использовании",
            metaInsightsTitle: "Meta Insights",
            metaInsightsSubtitle: "Просмотр статистики WhatsApp Business API",
            metaInsightsDateRange: "Диапазон дат",
            metaInsightsDateStart: "Начало",
            metaInsightsDateEnd: "Конец",
            metaInsightsGranularity: "Детализация",
            metaInsightsGranularityDay: "Ежедневно",
            metaInsightsGranularityMonth: "Ежемесячно",
            metaInsightsGranularityHalfHour: "Полчаса",
            metaInsightsRefresh: "Обновить",
            metaInsightsTabMessaging: "Аналитика сообщений",
            metaInsightsTabConversation: "Аналитика разговоров",
            metaInsightsTabPricing: "Аналитика тарифов",
            metaInsightsTabTemplate: "Аналитика шаблонов",
            metaInsightsTabTemplateGroup: "Аналитика групп шаблонов",
            metaInsightsErrorMessaging: "Не удалось загрузить данные аналитики сообщений",
            metaInsightsErrorConversation: "Не удалось загрузить данные аналитики разговоров",
            metaInsightsErrorPricing: "Не удалось загрузить данные аналитики тарифов",
            metaInsightsErrorTemplate: "Не удалось загрузить данные аналитики шаблонов",
            metaInsightsErrorTemplateGroup: "Не удалось загрузить данные аналитики групп шаблонов",
            metaInsightsViewChart: "Вид графика",
            metaInsightsViewTable: "Вид таблицы",
            metaInsightsDownloadExcel: "Скачать Excel",
            metaInsightsTotalSent: "Всего отправлено",
            metaInsightsTotalDelivered: "Всего доставлено",
            metaInsightsDeliveryRate: "Процент доставки",
            metaInsightsUnitMessage: "сообщ.",
            metaInsightsMessageStats: "Статистика сообщений",
            metaInsightsSent: "Отправлено",
            metaInsightsDelivered: "Доставлено",
            metaInsightsDateColumn: "Дата",
            metaInsightsCountryBreakdown: "Разбивка по странам",
            metaInsightsNoData: "Данные не найдены. Проверьте диапазон дат.",
            metaInsightsPieChart: "Круговая диаграмма",
            metaInsightsTotalConversations: "Всего разговоров",
            metaInsightsTotalCost: "Общая стоимость",
            metaInsightsAvgCost: "Средняя стоимость",
            metaInsightsUnitConversation: "разговоров",
            metaInsightsCostPerConversation: "$/разговор",
            metaInsightsCategoryBreakdown: "Разбивка по категориям",
            metaInsightsConversationStats: "Статистика разговоров",
            metaInsightsCategoryDistribution: "Распределение по категориям",
            metaInsightsConversationCount: "Количество разговоров",
            metaInsightsCost: "Стоимость",
            metaInsightsCategory: "Категория",
            metaInsightsType: "Тип",
            metaInsightsConversationCategoryAuth: "Аутентификация",
            metaInsightsConversationCategoryMarketing: "Маркетинг",
            metaInsightsConversationCategoryService: "Сервис",
            metaInsightsConversationCategoryUtility: "Утилита",
            metaInsightsConversationCategoryOther: "Другое",
            metaInsightsConversationDistribution: "Распределение разговоров",
            metaInsightsTotalVolume: "Общий объём",
            metaInsightsAvgUnitCost: "Средняя стоимость единицы",
            metaInsightsCostPerMessage: "$/сообщение",
            metaInsightsPricingCategoryBreakdown: "Разбивка по ценовой категории",
            metaInsightsPricingTypeBreakdown: "Разбивка по типу цены",
            metaInsightsPricingStats: "Статистика тарифов",
            metaInsightsCostDistribution: "Распределение затрат",
            metaInsightsCountry: "Страна",
            metaInsightsVolume: "Объём",
            metaInsightsTier: "Уровень",
            metaInsightsPricingCategoryAuth: "Аутентификация",
            metaInsightsPricingCategoryAuthInternational: "Международная аутентификация",
            metaInsightsPricingCategoryMarketing: "Маркетинг",
            metaInsightsPricingCategoryService: "Сервис",
            metaInsightsPricingCategoryUtility: "Утилита",
            metaInsightsPricingCategoryReferral: "Реферальная конверсия",
            metaInsightsPricingTypeRegular: "Обычный",
            metaInsightsPricingTypeFreeCustomerService: "Бесплатное обслуживание",
            metaInsightsPricingTypeFreeEntryPoint: "Бесплатная точка входа",
            metaInsightsTemplateAboutTitle: "О аналитике шаблонов",
            metaInsightsTemplateAboutDesc: "Для аналитики шаблонов необходимо выбрать шаблоны. Можно выбрать до 10 шаблонов. Данные возвращаются с дневной детализацией, доступно 90 дней истории.",
            metaInsightsTemplateSelectLabel: "Выберите шаблоны (макс. 10)",
            metaInsightsTemplateSelectPlaceholder: "Выберите шаблоны...",
            metaInsightsFetchData: "Загрузить данные",
            metaInsightsTotalRead: "Всего прочитано",
            metaInsightsReadRate: "Процент прочтений",
            metaInsightsRead: "Прочитано",
            metaInsightsTemplatePerformance: "Эффективность шаблонов",
            metaInsightsCostInfo: "Информация о затратах",
            metaInsightsTotalSpent: "Всего потрачено",
            metaInsightsCostPerDelivered: "Затраты на доставку",
            metaInsightsClickInfo: "Информация о кликах",
            metaInsightsClickInfoDesc: "Клики по кнопкам URL и быстрого ответа доступны только для шаблонов категорий MARKETING и UTILITY.",
            metaInsightsTemplateNoData: "Данные аналитики шаблонов не найдены. Выберите ID шаблонов, чтобы загрузить данные.",
            metaInsightsTemplateId: "ID шаблона",
            metaInsightsTemplateGroupAboutTitle: "О аналитике групп шаблонов",
            metaInsightsTemplateGroupAboutDesc: "Для аналитики групп шаблонов необходимо ввести ID групп шаблонов, созданных в Meta. Можно ввести до 10 групп. Данные возвращаются с дневной детализацией, доступно 90 дней истории.",
            metaInsightsTemplateGroupIdsLabel: "ID групп шаблонов (через запятую, макс. 10)",
            metaInsightsTemplateGroupIdsPlaceholder: "Напр.: 1044106240855852, 1044106240855853",
            metaInsightsTemplateGroupPerformance: "Эффективность групп шаблонов",
            metaInsightsGroupBreakdownTitle: "Эффективность по группам",
            metaInsightsGroupLabel: "Группа",
            metaInsightsTemplateGroupNoData: "Данные аналитики групп шаблонов не найдены. Введите ID групп шаблонов, чтобы загрузить данные.",
            metaInsightsGroupId: "ID группы",
            capiStatus: "Статус CAPI",
            capiActive: "Активно",
            capiPassive: "Неактивно",
            capiConnectionMethod: "Способ подключения",
            capiConnectThroughMeta: "Подключение через Meta",
            capiWithDatasetAndToken: "С набором данных и токеном",
            capiOauthInfoDesc: "Необходимо повторно авторизоваться для подключения через Meta. Это не нарушает работу существующего канала, добавляются только дополнительные разрешения.",
            capiConnecting: "Подключение...",
            capiConnectWithMeta: "Подключить с Meta",
            capiDatasetSelection: "Выбор набора данных",
            capiSelectDataset: "Выберите набор данных",
            capiCreating: "Создание...",
            capiCreateNewDataset: "Создать новый набор данных",
            capiDatasetId: "ID набора данных",
            capiEnterDatasetId: "Введите ID набора данных",
            capiAccessToken: "Токен доступа",
            capiEnterAccessToken: "Введите токен доступа",
            capiTesting: "Проверка...",
            capiTestConnection: "Проверить подключение",
            capiConnectionSuccess: "Подключение успешно",
            capiConnectionFailed: "Подключение не удалось",
            capiAutoEventSend: "Автоматическая отправка событий",
            capiEventInitiateCheckout: "Чат начат",
            capiEventInitiateCheckoutDesc: "При создании нового разговора",
            capiEventPurchase: "Покупка",
            capiEventPurchaseDesc: "При завершении покупки",
            capiEventAppointmentBooked: "Запись создана",
            capiEventAppointmentBookedDesc: "При бронировании записи",
            capiEventAddToCart: "Добавлено в корзину",
            capiEventAddToCartDesc: "При добавлении товара в корзину",
            capiEventViewContent: "Контент просмотрен",
            capiEventViewContentDesc: "При просмотре страницы или товара",
            capiEventOrderCreated: "Заказ создан",
            capiEventOrderCreatedDesc: "При успешном создании заказа",
            capiEventOrderShipped: "Заказ отправлен",
            capiEventOrderShippedDesc: "При отправке заказа",
            capiMetaConnectionSuccess: "Подключение к Meta успешно",
            capiMetaConnectionFailed: "Подключение к Meta не удалось",
            capiDatasetsLoadError: "Не удалось загрузить наборы данных",
            capiDatasetCreated: "Новый набор данных создан",
            capiDatasetCreateError: "Не удалось создать набор данных",
            capiConnectionTestSuccess: "Подключение CAPI успешно!",
            capiConnectionTestFailed: "Подключение CAPI не удалось",
            capiConnectionTestError: "Не удалось выполнить проверку подключения",
            wabaMovementsTitle: "Активности Webhook",
            wabaMovementsSubtitle: "Отслеживание активностей канала WhatsApp Business API",
            wabaMovementsTotalActivity: "всего активностей",
            wabaMovementsEmailNotifications: "Уведомления по email",
            wabaMovementsActive: "Включено",
            wabaMovementsOff: "Выключено",
            wabaMovementsEmailSettingTitle: "Получать уведомления аккаунта по email",
            wabaMovementsEmailSettingDesc: "Отправлять уведомления по email об активностях webhook",
            wabaMovementsEmailListHeader: "Адреса email для отправки уведомлений",
            wabaMovementsEmailPlaceholder: "Введите адрес email",
            wabaMovementsNoEmailsYet: "Адреса email пока не добавлены",
            wabaMovementsActivityLoadError: "Ошибка при загрузке журнала активностей",
            wabaMovementsNotificationsOn: "Уведомления по email включены",
            wabaMovementsNotificationsOff: "Уведомления по email отключены",
            wabaMovementsUpdateError: "Ошибка при обновлении",
            wabaMovementsEmailAlreadyAdded: "Этот адрес email уже добавлен",
            wabaMovementsEmailAdded: "Адрес email добавлен",
            wabaMovementsEmailAddError: "Ошибка при добавлении email",
            wabaMovementsEmailRemoved: "Адрес email удалён",
            wabaMovementsEmailRemoveError: "Ошибка при удалении email",
            freeChat: "Бесплатный чат",
            paidChat: "Платный чат",
            templateMessage: "Сообщение шаблона",
            outgoingSession: "Исходящая сессия",
            incomingSession: "Предстоящая сессия",
            totalCost: "Общая стоимость",
            allOptNumbers: "Все номера, на которые вы подписались",
            startChat: "Начать чат",
            lastMessageDate: "Дата последнего сообщения",
            sureDeleteTemplate: "Вы уверены, что хотите удалить этот шаблон?",
            manageWhoChannelChat: "Управлять тем, кто может видеть чаты этого канала",
            profileImageDesc: "Это будет скриншот вашего бизнеса в WhatsApp",
            bussinesDesciption: "Описание бизнеса",
            descOfWork: "Описание вашего бизнеса в нескольких словах (не более 512 символов)",
            accountStatus: "Статус аккаунта",
            dockerStatus: "Статус докера",
            phoneQuality: "Качество телефона",
            customersOrDay: "CustomersDay",
            messagingLimit: "Лимит сообщений",
            canSendMessage: "Сообщение может быть отправлено",
            officialDetails: "Официальные данные",
            officialDetailsDesc: "Эти адреса всегда будут отображаться в разделе профиля для пользователей, которые общаются с вами в WhatsApp. После редактирования мы отправим его в WhatsApp для утверждения.",
            addressLine: "Адресная строка",
            stateIfApplic: "Штат (если применимо)",
            zipCodeOrPostCode: "Почтовый индекс/почтовый код",
            selectCountry: "Выберите страну",
            selectBussVertical: "Выберите район деятельности",
            saveInfo: "Сохранить информацию",
            active: "Активный",
            banned: "Запрещено",
            low: "Низкий",
            medium: "Средний",
            high: "Высокий",
            connected: "Подключен",
            disConnected: "Отключено",
            flagged: "Flagged",
            pending: "Отложенный",
            restricted: "Ограничено",
            unknown: "Неизвестно",
            available: "Доступный",
            limited: "Ограниченный",
            blocked: "Заблокировано",
            loadingProfile: "Загрузка информации профиля...",
            businessProfileTitle: "Бизнес-профиль",
            lastUpdate: "Последнее обновление:",
            updateFromMeta: "Обновить из Meta",
            waitSeconds: "Подождите {n} с",
            wabaInfoTitle: "Информация об аккаунте WhatsApp Business",
            phoneInfo: "Информация о телефоне",
            verifiedNameLabel: "Подтверждённое имя:",
            phoneNumberLabel: "Номер телефона:",
            codeVerificationLabel: "Проверка кода:",
            platformSettings: "Настройки платформы",
            platformTypeLabel: "Тип платформы:",
            throughputLevelLabel: "Уровень пропускной способности:",
            twoFaPinLabel: "PIN 2FA:",
            enabled: "Включено",
            disabled: "Выключено",
            dailyLimit: "Дневной лимит",
            messageSending: "Отправка сообщений",
            businessInfoTitle: "Информация о бизнесе",
            profilePhoto: "Фото профиля",
            change: "Изменить",
            profilePhotoNote: "JPG или PNG (макс. 5 МБ, рекомендуется: 640x640px)",
            aboutText: "Текст «О нас»",
            aboutPlaceholder: "Напишите краткое описание вашего бизнеса...",
            aboutHint: "Краткое описание в профиле WhatsApp (макс. 139 символов)",
            businessDescriptionLabel: "Описание бизнеса",
            businessDescriptionPlaceholder: "Напишите подробное описание вашего бизнеса...",
            descriptionHint: "Подробное описание вашего бизнеса",
            contactEmail: "Контактный e-mail",
            emailPlaceholder: "example@company.com",
            businessAddress: "Адрес компании",
            addressPlaceholder: "Полный адрес",
            website1: "Веб-сайт 1",
            website2: "Веб-сайт 2",
            website1Placeholder: "https://www.company.com",
            website2Placeholder: "https://www.facebook.com/company",
            businessCategory: "Категория бизнеса",
            selectBusinessCategory: "Выберите категорию бизнеса",
            categoryHint: "Выберите сферу деятельности",
            revertChanges: "Отменить изменения",
            updateButton: "Обновить",
            accountModeLabel: "Режим аккаунта:",
            na: "Н/Д",
            verticalOther: "Другое",
            verticalAuto: "Автомобили",
            verticalBeauty: "Красота, спа и салон",
            verticalApparel: "Одежда и одежные изделия",
            verticalEdu: "Образование",
            verticalEntertain: "Развлечения",
            verticalEventPlan: "Планирование мероприятий и услуги",
            verticalFinance: "Финансы и банкинг",
            verticalGrocery: "Продукты и бакалея",
            verticalGovt: "Государственные услуги",
            verticalHotel: "Отели и проживание",
            verticalHealth: "Медицина и здоровье",
            verticalNonprofit: "Некоммерческий",
            verticalProfServices: "Профессиональные услуги",
            verticalRetail: "Шопинг и розница",
            verticalTravel: "Путешествия и транспорт",
            verticalRestaurant: "Ресторан",
            verticalAlcohol: "Алкоголь",
            verticalOnlineGambling: "Онлайн-азартные игры",
            verticalPhysicalGambling: "Офлайн-азартные игры",
            verticalOtcDrugs: "Безрецептурные препараты",
            verticalMatrimonyService: "Служба знакомств",
            success: "Успех",
            succesDesc: "Информация о вашем профиле успешно обновлена",
            wabaOverview: "Обзор здоровья WABA",
            manageChannelDetail: "Управление информацией о вашем канале",
            wpBussChannelDetail: "Деталь бизнес-канала Whatsapp",
            manageWpBussChannel: "Управление бизнес-каналом Whatsapp",
            channelName: "Название канала",
            phoneNumberE164: "Номер телефона",
            phoneNumberE164Place: "Номер телефона, напр.: 908501234455",
            channelUpdatedSucs: "Канал успешно обновлен",
            faieldUpdateChannel: "Не удалось обновить канал",
            completeSetup: "Завершить настройку",
            completeSetupDescription:
                "Чтобы завершить настройку WhatsApp Business API, нажмите кнопку ниже, чтобы перейти на страницу подключения.",
            connectWhatsAppBusinessAccount: "Подключить аккаунт WhatsApp Business",
            infoLabel: "Информация",
            onboardingInfoDescription:
                "Ваш аккаунт Facebook Business и номер WhatsApp должны быть готовы к настройке WhatsApp Business API.",
            businessId: "ID бизнеса",
            phoneNumberId: "ID номера телефона",
            wabaId: "ID WABA",
            verifiedNameLabel: "Подтверждённое имя",
            userAccessibility: "Доступ пользователей",
            userAccessibilityDesc:
                "Указанные ниже пользователи могут видеть контакты и чаты в этом канале (нет доступа при назначенном владельце). Эта настройка используется в: <ul><li><strong>Автоназначение чатов:</strong> входящие клиенты назначаются по видимости; чаты не назначаются тем, у кого нет доступа</li><li><strong>Переадресация:</strong> переадресация чата или добавление другого агента должно соответствовать этим настройкам; переадресация неавторизованным пользователям не разрешена</li><li><strong>Списки контактов/клиентов:</strong> отображаемые списки зависят от этой настройки</li><li><strong>Владение:</strong> вы можете назначить клиента агенту в рамках этой настройки</li></ul>",
            makePublicButton: "Сделать общедоступным",
            channelOwners: "Владельцы канала",
            channelOwnersDesc:
                "Владельцы канала имеют право просматривать все разговоры в этом канале. Они могут читать все сообщения независимо от настроек видимости.",
            editChannelOwners: "Редактировать владельцев канала",
            selectChannelOwner: "Выбрать владельца канала",
            selectChannelOwnerDesc: "Выберите агентов, которые будут владельцами этого канала",
            makePublicConfirmTitle: "Вы уверены, что хотите сделать этот канал общедоступным?",
            makePublicConfirmContent: "После этого действия все агенты смогут видеть разговоры в этом канале.",
            makePublicConfirmOk: "Да, сделать общедоступным",
            makePublicSuccessMessage: "Канал сделан общедоступным",
            stepSetupTemplate: "Настроить шаблон",
            stepEditTemplate: "Редактировать шаблон",
            stepSubmitReview: "Отправить на проверку",
            templateNameAndLanguage: "Название и язык шаблона",
            editModeNoticeText: "В режиме редактирования название и язык шаблона изменить нельзя. Только категория (если не одобрен), компоненты и время жизни.",
            nameYourTemplate: "Название шаблона",
            enterTemplateNamePlaceholder: "Введите название шаблона",
            selectLanguage: "Выберите язык",
            content: "Содержимое",
            footerOptional: "Подвал • Необязательно",
            enterTextPlaceholder: "Введите текст",
            bodyLabel: "Тело сообщения",
            bodyPlaceholder: "Введите текст тела сообщения",
            bold: "Жирный",
            italic: "Курсив",
            strikethrough: "Зачёркнутый",
            headerLabelRecommended: "Рекомендуется",
            headerLabelOptionalTextOnly: "Необязательно (только текст)",
            headerLabelRequiredProduct: "Обязательно (товар)",
            headerLabelOptional: "Необязательно",
            headerNone: "Нет",
            headerTextOption: "Текст",
            headerDocument: "Документ",
            headerProduct: "Товар",
            productHeaderAutoSet: "Заголовок товара задаётся автоматически при использовании шаблонов товара.",
            headerTextPlaceholder: "Добавьте короткую строку текста в заголовок сообщения",
            mediaHintNote: "Примечание:",
            mediaHintIntro: "Допустимые форматы и размеры файлов:",
            mediaHintImage: "Изображение: JPEG, PNG (макс. 5 МБ)",
            mediaHintVideo: "Видео: MP4 (макс. 16 МБ)",
            mediaHintDocument: "Документ: PDF (макс. 100 МБ)",
            productHeaderAutoInfo: "Заголовок товара добавляется автоматически из каталога. Ручная настройка не нужна.",
            carouselContentDescription: "Создайте два сообщения: сначала общий текст (тело), затем карточки карусели. У каждой карточки может быть свой текст и кнопки (минимум 1). В основном теле кнопок быть не может.",
            contentDescriptionProduct: "Добавьте текст тела для шаблона товара. Заголовок добавляется из каталога.",
            contentDescriptionLTO: "Добавьте заголовок и тело для шаблона ограниченного предложения. Подвал для этого типа не поддерживается.",
            contentDescriptionCarousel: "Добавьте общий текст и карточки карусели. У каждой карточки свой заголовок, опциональное тело и кнопки.",
            contentDescriptionDefault: "Добавьте заголовок, тело и подвал для шаблона.",
            readyToSubmit: "Готово к отправке",
            submitReviewDescription: "Шаблон будет отправлен на проверку Meta. Обычно это занимает минуты, до 24 часов.",
            bodyContentAdded: "Содержимое тела добавлено",
            buttonsAddedCount: "Добавлено кнопок: {count}",
            previous: "Назад",
            discard: "Отменить",
            next: "Далее",
            submitForReview: "Отправить на проверку",
            updateTemplate: "Обновить шаблон",
            cannotProceed: "Невозможно продолжить",
            noChangesReason: "В шаблоне нет изменений. Сделайте хотя бы одно изменение.",
            categoryCannotChangeWarning: "Категорию утверждённых шаблонов менять нельзя.",
            setupYourTemplate: "Настройте шаблон",
            setupDescription: "Выберите категорию, которая лучше всего описывает шаблон. Затем тип сообщения.",
            learnMoreCategories: "Подробнее о категориях.",
            marketing: "Маркетинг",
            utility: "Служебный",
            authentication: "Аутентификация",
            categoryCannotChangeApproved: "Категорию утверждённых шаблонов изменить нельзя",
            categoryCannotEditApproved: "Категорию утверждённых шаблонов редактировать нельзя. Только компоненты и время жизни.",
            notSupported: "Не поддерживается",
            selectProductMessageType: "Выберите тип сообщения о товаре",
            selectOtpAutofillType: "Выберите тип автозаполнения OTP",
            templatePreview: "Предпросмотр шаблона",
            previewAlt: "Предпросмотр",
            previewAltCallPermission: "Запрос разрешения на звонок",
            previewSampleCard: "Пример карточки",
            previewCardPreview: "Предпросмотр карточки",
            previewBodyMarketingDefault: "Привет! Посмотрите наши свежие продукты! Используйте код HEALTH для скидки 10%.",
            previewBodyCarouselStep0: "Посмотрите избранные товары! Листайте, чтобы увидеть предложения.",
            previewSpecialOffer: "Специальное предложение",
            previewEndsIn2Days: "Заканчивается через 2 дня",
            previewExpiresLabel: "Истекает: ",
            previewSeeAllOptions: "Все варианты",
            previewBodyLto: "Начинаем! Купите два — получите один бесплатно в нашей новой коллекции мыла.",
            previewWinterSaleHeader: "Зимняя распродажа началась!",
            previewBodyCoupon: "Покупайте до конца декабря и используйте код WINTER25 для скидки 25%!",
            previewViewBizCatalog: "Каталог {BIZ_NAME} в WhatsApp",
            previewBrowseCatalogueDetails: "Просматривайте фото и описание предложений.",
            previewBodyCatalogue: "Покупайте любимые товары в WhatsApp! Просмотрите каталог.",
            previewBodyCatalogueSingle: "Обратите внимание на этот товар! Идеально подойдёт.",
            previewBodyCatalogueMulti: "Что-то забыли? Похоже, эти товары остались в корзине.",
            previewBodyCatalogueCarousel: "Новинки! Просмотрите каталог и найдите нужное.",
            previewBodyUtility: "Хорошие новости! Заказ 23KFEJJ2312 отправлен! Отслеживание по ссылке ниже.",
            previewBodyAuth: "123456 — ваш код подтверждения. Не сообщайте его никому.",
            previewBodyPlaceholder: "Текст сообщения появится здесь",
            previewBodyCarouselPlaceholder: "Текст сообщения карусели появится здесь",
            previewButtonN: "Кнопка {n}",
            previewProductNDescription: "Описание товара {n}",
            previewTemplateGoodFor: "Этот шаблон подходит для",
            previewTemplateAreasCustomise: "Области шаблона, которые можно настроить",
            previewDescCatalogue: "Каталог товаров/услуг, продажи, предложения, маркетинг",
            previewDescCoupon: "Отправка промокодов с кнопкой копирования. Одна кнопка «Копировать код».",
            previewDescCarousel: "Показ нескольких товаров или услуг в прокручиваемом виде. У каждой карточки — изображение, описание и кнопки.",
            previewDescMarketing: "Приветствия, акции, предложения, купоны, рассылки",
            previewDescUtility: "Подтверждения заказов, обновления аккаунта, чеки, напоминания",
            previewDescAuth: "Одноразовый пароль, восстановление аккаунта, верификация",
            previewCustomisableCallPermission: "Заголовок, текст, подвал",
            previewCustomisableCoupon: "Заголовок (текст), текст, кнопка (кроме текста «Копировать код»)",
            previewCustomisableCarousel: "Общий текст, карточки карусели",
            previewCustomisableMarketing: "Медиа, заголовок, текст, подвал, кнопка",
            previewCustomisableUtility: "Заголовок, текст, подвал",
            previewCustomisableAuth: "Текст",
            productMessage: "Сообщение о товаре",
            callUs: "Позвонить нам",
            unsubscribe: "Отписаться",
            trackShipment: "Отследить отправление",
            choosePreference: "Выбрать предпочтение",
            autoVerify: "Автопроверка",
            yourTemplateNamePlaceholder: "имя_шаблона",
            templateNameLabel: "Название шаблона",
            categoryLabel: "Категория",
            languageLabel: "Язык",
            templateCreatedSuccess: "Шаблон успешно создан и отправлен на проверку!",
            templateUpdatedSuccess: "Шаблон успешно обновлён!",
            mediaUploadedSuccess: "Медиа успешно загружено",
            mediaUploadFailedPrefix: "Ошибка загрузки медиа: ",
            nameRequired: "Название шаблона обязательно",
            nameInvalidChars: "Допускаются только строчные буквы, цифры и подчёркивание",
            nameMaxLength: "Название шаблона должно быть не более 512 символов",
            bodyRequired: "Содержимое тела сообщения обязательно",
            ltoRequiresOneButton: "Для ограниченного предложения нужна хотя бы одна кнопка",
            ltoRequiresUrlButton: "Для ограниченного предложения обязательна кнопка URL",
            carouselRequiresOneCard: "Для шаблона карусели нужна хотя бы одна карточка",
            cardMustHaveButton: "У карточки {index} должна быть хотя бы одна кнопка",
            cardMustHaveHeaderMedia: "У карточки {index} должно быть изображение или видео в шапке",
            ltoUrlButtonCannotRemove: "Для ограниченного предложения нужна хотя бы одна кнопка URL, её нельзя удалить",
            ltoRequiresOneButtonWarning: "Для ограниченного предложения нужна хотя бы одна кнопка",
            copyCodeButtonRequired: "Кнопка «Копировать код» обязательна для шаблонов купонов и не может быть удалена",
            carouselCardMustHaveButton: "У каждой карточки карусели должна быть хотя бы одна кнопка",
            imageMaxSize: "Размер изображения должен быть менее 5 МБ",
            videoMaxSize: "Размер видео должен быть менее 16 МБ",
            documentMaxSize: "Размер документа должен быть менее 100 МБ",
            fileUploadFailed: "Ошибка загрузки файла",
            uploadFileLoading: "Загрузка файла...",
            templateTypeDefault: "По умолчанию",
            templateTypeDefaultDesc: "Отправляйте сообщения с медиа и настраиваемыми кнопками для взаимодействия с клиентами.",
            templateTypeLimitedTimeOffer: "Ограниченное по времени предложение",
            templateTypeLimitedTimeOfferDesc: "Создайте срочность с ограниченными по времени акциями и кодами.",
            templateTypeCarousel: "Карусель",
            templateTypeCarouselDesc: "Отправьте карусель карточек с изображениями и кнопками для нескольких товаров или предложений.",
            templateTypeProductMessage: "Сообщение о товаре",
            templateTypeProductMessageDesc: "Отправляйте сообщения, стимулирующие продажи, подключая каталог товаров.",
            templateTypeCallPermission: "Запрос разрешения на звонок",
            templateTypeCallPermissionDesc: "Спросите клиентов, можно ли звонить им в WhatsApp.",
            templateTypeCouponCode: "Код купона",
            templateTypeCouponCodeDesc: "Отправляйте промокоды с кнопкой копирования для удобного использования.",
            templateTypeUtilityDefault: "По умолчанию",
            templateTypeUtilityDefaultDesc: "Отправляйте сообщения о существующем заказе или аккаунте.",
            templateTypeOtp: "Одноразовый код",
            templateTypeOtpDesc: "Отправляйте коды для проверки транзакции или входа.",
            catalogueSubtypeCatalogue: "Сообщение каталога",
            catalogueSubtypeCatalogueDesc: "Покажите полный каталог товаров с кнопкой просмотра каталога.",
            catalogueSubtypeMultiProduct: "Сообщение о нескольких товарах",
            catalogueSubtypeMultiProductDesc: "Покажите до 30 товаров из каталога в одном сообщении.",
            catalogueSubtypeSingleProduct: "Сообщение об одном товаре",
            catalogueSubtypeSingleProductDesc: "Выделите один товар с деталями и кнопкой призыва к действию.",
            catalogueSubtypeProductCardCarousel: "Карусель карточек товаров",
            catalogueSubtypeProductCardCarouselDesc: "Покажите до 10 карточек товаров в виде карусели.",
            catalogueSubtypeDisabledReason: "В настоящее время не поддерживается. Этот тип шаблона требует интеграции с каталогом товаров.",
            authSubtypeCopyCode: "Копировать код",
            authSubtypeCopyCodeDesc: "Пользователь вручную копирует код (стандартный OTP).",
            authSubtypeOneTap: "Одно нажатие",
            authSubtypeOneTapDesc: "Автозаполнение кода одним нажатием на поддерживаемых устройствах Android.",
            authSubtypeZeroTap: "Ноль нажатий",
            authSubtypeZeroTapDesc: "Автозаполнение кода без участия пользователя (требуется согласие).",
            viewCatalog: "Просмотр каталога",
            viewProduct: "Просмотр товара",
            viewProducts: "Просмотр товаров",
            view: "Просмотр",
            copyOfferCode: "Копировать код предложения",
            oneTapAutofill: "Автозаполнение в одно нажатие",
            zeroTapAutofill: "Автозаполнение без нажатий",
            shopNow: "Купить сейчас",
            viewItems: "Просмотр товаров",
            autofill: "Автозаполнение",
            messageTtlOptional: "Время жизни сообщения (TTL) • Необязательно",
            selectTtlPlaceholder: "Выберите TTL или оставьте по умолчанию",
            ttlDescMarketing: "Если не удастся доставить маркетинговое сообщение, повторим попытку в указанный срок.",
            ttlDescUtility: "Укажите, как долго доставлять служебные сообщения (подтверждения заказов и т.д.).",
            ttlDescAuthentication: "Укажите, как долго коды аутентификации действительны для доставки.",
            ttlInfoMarketing: "Маркетинговые шаблоны: от 12 часов до 30 дней. По умолчанию задаётся системой.",
            ttlInfoUtility: "Служебные шаблоны: от 30 секунд до 12 часов или -1 для 30 дней. По умолчанию задаётся системой.",
            ttlInfoAuthentication: "Шаблоны аутентификации: от 30 секунд до 15 минут или -1 для 30 дней. По умолчанию задаётся системой.",
            ttlOption12Hours: "12 часов (43 200 сек.)",
            ttlOption1Day: "1 день (86 400 сек.)",
            ttlOption3Days: "3 дня (259 200 сек.)",
            ttlOption7Days: "7 дней (604 800 сек.)",
            ttlOption15Days: "15 дней (1 296 000 сек.)",
            ttlOption30Days: "30 дней (2 592 000 сек.)",
            ttlOption30Seconds: "30 секунд",
            ttlOption1Minute: "1 минута (60 сек.)",
            ttlOption2Minutes: "2 минуты (120 сек.)",
            ttlOption3Minutes: "3 минуты (180 сек.)",
            ttlOption5Minutes: "5 минут (300 сек.)",
            ttlOption10Minutes: "10 минут (600 сек.)",
            ttlOption15Minutes: "15 минут (900 сек.)",
            ttlOption30Minutes: "30 минут (1 800 сек.)",
            ttlOption1Hour: "1 час (3 600 сек.)",
            ttlOption2Hours: "2 часа (7 200 сек.)",
            ttlOption4Hours: "4 часа (14 400 сек.)",
            ttlOption6Hours: "6 часов (21 600 сек.)",
            ttlOption30DaysSpecial: "30 дней (спец. значение: -1)",
            authSettings: "Настройки аутентификации",
            addSecurityRecommendation: "Добавить рекомендацию по безопасности",
            securityRecommendationHint: "Добавляет сообщение «Не передавайте этот код никому».",
            authMessageTtlHint: "Предел времени доставки сообщения (60-600 сек). Оставьте пустым для значения по умолчанию.",
            authTtlPlaceholder: "60-600",
            authCodeExpPlaceholder: "1-90",
            authPackagePlaceholder: "com.example.app",
            authSignatureHash: "Хеш подписи",
            messageTtlSecondsOptional: "TTL сообщения (секунды) • Необязательно",
            codeExpirationOptional: "Срок действия кода (минуты) • Необязательно",
            codeExpirationHint: "Как долго действителен код OTP. Отображается в подвале.",
            zeroTapTerms: "Принимаю условия Zero Tap",
            zeroTapTermsHint: "Требуется для работы автозаполнения Zero Tap.",
            supportedAndroidAppsOptional: "Поддерживаемые приложения Android • Необязательно",
            addApp: "Добавить приложение",
            limitedTimeOfferLabel: "Ограниченное по времени предложение",
            ltoDescription: "Добавьте текст, создающий срочность. Время истечения задаётся при отправке.",
            ltoPlaceholder: "напр., Срочное предложение!, Распродажа!",
            showExpirationTimer: "Показывать таймер истечения",
            ltoExpirationHint: "При включении WhatsApp покажет обратный отсчёт от момента отправки.",
            carouselCards: "Карточки карусели",
            carouselCardsDescription: "Эти карточки появятся вторым сообщением после основного текста. У каждой должна быть шапка изображение/видео и минимум одна кнопка (до 2). Текст карточки необязателен и поддерживает переменные. До 10 карточек.",
            carouselCardN: "Карточка {n}",
            carouselButtonsLabel: "Кнопки * (минимум 1, до 2)",
            cardHeaderRequired: "Заголовок карточки",
            cardBodyOptional: "Тело карточки • Необязательно",
            cardBodyPlaceholder: "Введите текст тела карточки (необязательно)",
            image: "Изображение",
            video: "Видео",
            moveUp: "Вверх",
            moveDown: "Вниз",
            remove: "Удалить",
            dragDropUpload: "Перетащите для загрузки",
            orChooseFiles: "Или выберите файлы на устройстве",
            uploadingToMeta: "Загрузка в Meta...",
            uploadedSuccessfully: "Загружено успешно",
            addQuickReplyButton: "Добавить кнопку быстрого ответа",
            addCtaButton: "Добавить кнопку CTA",
            urlButtonRequiredLto: "Для ограниченного предложения обязательна кнопка URL",
            copyCodeButtonFixed: "Текст кнопки «Копировать код» в шаблонах купонов изменить нельзя",
            copyCode: "Копировать код",
            fixed: "Фиксировано",
            buttonsHeading: "Кнопки",
            buttonLabelAutoAdded: "Добавляется автоматически",
            buttonLabelRequiredCopyCode: "Обязательно (1 Копировать код + опционально)",
            buttonLabelRequiredUrl: "Обязательно (1 URL + опционально)",
            buttonLabelOptional: "Опционально",
            buttonDescCatalogue: "Кнопка товара добавляется автоматически. Можно настроить текст кнопки.",
            buttonDescCallPermission: "Кнопка разрешения звонка добавляется автоматически. Дополнительные кнопки добавить нельзя.",
            buttonDescAuth: "Кнопка аутентификации добавляется автоматически. Можно настроить текст кнопки.",
            buttonDescCoupon: "Кнопка «Копировать код» обязательна, её текст нельзя изменить. Можно добавить кнопки быстрого ответа или CTA, всего до 10.",
            buttonDescLto: "Ограниченные по времени предложения требуют хотя бы одну кнопку URL. Можно добавить кнопки CTA или быстрого ответа.",
            buttonDescDefault: "Добавьте кнопки быстрого ответа или CTA. Всего не более 10 кнопок.",
            buttonPlaceholderText: "Текст кнопки",
            buttonMax10Warning: "Допускается не более 10 кнопок",
            buttonCopyCodeAutoAddedWarning: "Кнопка «Копировать код» добавляется автоматически и не может быть добавлена вручную",
            exampleValuePlaceholder: "пример_значения",
            copyCodeExamplePlaceholder: "SUMMER20",
            quickReply: "Быстрый ответ",
            visitWebsite: "Перейти на сайт",
            callPhone: "Позвонить",
            addCard: "Добавить карточку",
            addButton: "Добавить кнопку",
            title: "Каналы Whatsapp Business API",
            integration: "Интеграция",
            detail: "Детали",
            visibility: "Видимость",
            templates: "Все шаблоны сообщений",
            settings_group: "Настройки",
            template_message_group: "Шаблоны сообщений",
            chat_initiator_template: "Шаблон инициирования чата",
            contacts: "Контакты",
            numbers: "Числа",
            all_contacts: "Все контакты",
            new_template: "Создать новый шаблон",
            broadcast_group: "Рассылка",
            broadcast_requests: "Запросы на рассылку",
            customer_groups: "Группы клиентов",
            businessChannelDetail: "Детали канала Whatsapp Business",
            wallet: "Wallet",
            postacellMessage: "Отправить SMS",
            postacellAllMessage: "Отправить массовое SMS",
            message_group: "Сообщение",
            createNewTemplate: "Создать новый шаблон сообщения",
            templateName: "Имя шаблона",
            templateNameDesc: "Дайте имя вашему шаблону сообщения.",
            templateInfo: "Информация о шаблоне",
            viewTemplates: "Просмотреть шаблоны",
            templateListTitle: "Шаблоны сообщений",
            templateListShownTotal: "{shown} шаблонов показано (всего: {total})",
            templateListCreateButton: "Создать шаблон",
            templateListSearchPlaceholder: "Поиск шаблонов...",
            templateListAllCategories: "Все категории",
            templateListAllStatus: "Все статусы",
            templateListStatusApproved: "Одобрен",
            templateListStatusPending: "На проверке",
            templateListStatusRejected: "Отклонён",
            templateListRefresh: "Обновить",
            templateListTotalTemplates: "Всего {count} шаблонов",
            templateListCopied: "Скопировано!",
            templateListCopy: "Копировать",
            templateListIdLabel: "ID:",
            templateListPreview: "Предпросмотр",
            templateListEdit: "Изменить",
            templateListDelete: "Удалить",
            templateListPreviewTitle: "Предпросмотр шаблона",
            templateListNameLabel: "Название:",
            templateListCategoryLabel: "Категория:",
            templateListLanguageLabel: "Язык:",
            templateListStatusLabel: "Статус:",
            templateListReasonLabel: "Причина:",
            templateListRecommendationLabel: "Рекомендация:",
            templateListColumnName: "НАЗВАНИЕ ШАБЛОНА",
            templateListColumnCategory: "КАТЕГОРИЯ",
            templateListColumnStatus: "СТАТУС",
            templateListColumnLastEdited: "ПОСЛЕДНЕЕ ИЗМЕНЕНИЕ",
            templateListStatusActive: "Активен",
            templateListStatusInReview: "На проверке",
            templateListStatusRejected: "Отклонён",
            templateListStatusFailed: "Ошибка",
            templateListQualityHigh: "Высокое качество",
            templateListQualityMedium: "Среднее качество",
            templateListQualityLow: "Низкое качество",
            templateListDeleteConfirmTitle: "Удалить шаблон",
            templateListDeleteConfirmContent: "Вы уверены, что хотите удалить «{{name}}»?",
            templateListDeleteConfirmOk: "Удалить",
            templateListDeleteConfirmCancel: "Отмена",
            templateListCopyIdError: "Ошибка при копировании ID",
            templateListDeletedSuccess: "{{name}} успешно удалён.",
            templateListDeleteFailed: "Не удалось удалить шаблон.",
            templateNameRules: "Имя шаблона может включать только строчные буквы, цифры и подчеркивания.",
            category: "Категория",
            categoryDesc: "Выберите, какой тип шаблона вы хотите создать",
            categoryUtility: "Утилита",
            categoryUtilityDesc: "Отправляйте информацию об утилите, такую как обновления аккаунта, обновления заказа, оповещения и многое другое.",
            categoryMarketing: "Маркетинг",
            categoryMarketingDesc: "Отправляйте рекламные предложения, предложения по продукции и многое другое для увеличения осведомленности и вовлеченности.",
            categoryAuth: "Аутентификация",
            categoryAuthDesc: "Отправляйте коды для того, чтобы ваши клиенты могли получить доступ к своим аккаунтам.",
            optional: "По желанию",
            languageDesc: "Выберите язык, на котором будет отправлен ваш шаблонный текст",
            header: "Заголовок",
            headerRules: "Добавьте заголовок к вашему сообщению длиной 60 символов. В заголовке поддерживается только одна переменная.",
            headerOptionMedia: "Медиа",
            headerOptionText: "Текст",
            none: "Нет",
            headerType: "Тип заголовка",
            headerText: "Текст заголовка",
            body: "Тело",
            bodyRules: "Введите текст на выбранном вами языке для вашего сообщения",
            addVariable: "Добавить переменную",
            variables: "Переменные",
            variable: "Переменная",
            defaultVariableName: "Имя переменной по умолчанию",
            defaultVariableToolTip: "Ваша переменная появляется в шаблоне под этим именем. <br><br> Кроме того, это значение отправляется по умолчанию в случае других ситуаций.",
            selectATemplate: "Выберите шаблон сообщения",
            variableSettings: "Настройки переменных",
            example: "Пример",
            footer: "Нижний колонтитул",
            footerDesc: "Добавьте к вашему сообщению нижний колонтитул длиной 60 символов. В подвале не поддерживаются переменные.",
            buttons: "Кнопки",
            buttonType: "Тип кнопки",
            buttonTypeReply: "Ответить",
            submit: "Сохранить",
            submitting: "Подача заявки",
            addButton: "Добавить кнопку",
            rejectWhatsapp: "Отклонено WhatsApp.",
            approvedWhatsapp: "Одобрено WhatsApp.",
            pendingWhatsapp: "В ожидании одобрения",
            daily_usages: "Ежедневные расходы",
            reports: "Отчёты",
            dynamicUrlSampleNote: "Пример динамического URL с переменной (не добавляйте URL в текст примера сообщения выше)",
            businessDescription: "وصف نشاطك التجاري.",
            bussinesDescription: "Описание бизнеса",
            failedUpdateChannel: "Не удалось обновить канал",
            postacellMessagepostacellMessage: "Envoyer un SMS",
            selectBusinessVertical: "Выберите сферу деятельности",
            stateIfApplicable: "Регион (если применимо)",
            successDesc: "Информация профиля успешно обновлена."
        },
        multi_whatsapp_api: {
            profile: "Профиль",
            integration: "Интеграция",
            detail: "Деталь",
            visibility: "Видимость",
            templates: "Все сообщения шаблона",
            settings_group: "Настройки",
            template_message_group: "Сообщения шаблона",
            new_template: "Создать новый шаблон",
            broadcast_group: "Массовые сообщения",
            broadcast_requests: "Массовые отправки сообщений",
            customer_groups: "Группы клиентов",
            chat_initiator_template: "Шаблон инициатора чата",
            contacts: "Контакты",
            numbers: "Номера",
            all_contacts: "Все контакты"
        },
        archive: {
            destroyedBy: {
                agent: "Агент",
                visitor: "Посетитель",
                system: "Система",
                chatbot: "Чатбот"
            }
        },
        upgradeMessages: {
            ticket: "Даже если вы оффлайн, ваши запросы моментально записываются с помощью искусственного интеллекта и чат-бота. Всегда поддерживайте своих клиентов довольными!",
            tasks: "Легко управляйте своими задачами и проектами. Сотрудничайте с вашей командой и сдавайте проекты вовремя!",
            calendar: "Легко планируйте свои встречи и собрания. Синхронизируйтесь с вашей командой и используйте свое время более эффективно!",
            mail_integration: "Легко управляйте своими электронными письмами. Усильте коммуникацию с вашими клиентами и улучшите сотрудничество!",
            team_integration: "Общайтесь быстрее и эффективнее с вашей командой. Улучшайте сотрудничество и обеспечьте своевременную сдачу проектов!",
            webhook_integration: "Соедините свои приложения с помощью интеграции Webhook и упростите обмен данными!",
            whatsapp_v2: "Улучшите общение с вашими клиентами через интеграцию WhatsApp для более быстрого и эффективного общения!",
            whatsapp: "Улучшите общение с вашими клиентами с помощью интеграции WhatsApp для более быстрого и эффективного общения!",
            whatsapp_business_api: "Используйте WhatsApp Business API для более эффективного и продуктивного общения с вашими клиентами!",
            instagram: "Взаимодействуйте с вашими клиентами более эффективно с помощью интеграции Instagram!",
            messenger: "Легко общайтесь с вашими клиентами через интеграцию Messenger!",
            sms_postacell: "Общайтесь быстро и эффективно с вашими клиентами через интеграцию SMS!",
            ready_contents: "Готовые материалы помогут вам общаться с вашими клиентами быстрее и эффективнее.",
            automation: "Автоматизируйте ваши рабочие процессы, чтобы сэкономить время и более эффективно управлять задачами!",
            form: "Используйте конструктор форм для упрощения взаимодействия с клиентами, сбора полезной информации и улучшения сотрудничества!",
            customer_tables: "Создавайте настраиваемые таблицы и эффективно управляйте информацией о клиентах!",
            trendyol: "Улучшите общение с вашими клиентами через интеграцию Trendyol для плавного взаимодействия!",
            access_control: "Защитите ваши данные и предотвратите несанкционированный доступ с помощью функций контроля доступа!",
            upgrade: "Обновить мою подписку",
            upgradeFeature: "Купить дополнительный пакет",
            featureNotAvailable: "Функция недоступна.",
            usageLimitExceeded: "Превышен лимит использования.",
            maxAgentCount: "Обновите свой пакет, чтобы добавить больше агентов и обслуживать больше клиентов.",
            maxTriggerCount: "Обновите свой пакет, чтобы добавить больше триггеров и увеличить взаимодействия.",
            visitorStartChat: "Обновите свой пакет, чтобы начать чат с посетителями, которые еще не взаимодействовали с вами.",
            voiceCalling: "Обновите свой пакет, чтобы более эффективно общаться с клиентами с помощью голосовых звонков.",
            videoCalling: "Обновите свой пакет, чтобы более эффективно общаться с клиентами с помощью видеозвонков.",
            fileAndVoiceMessage: "Обновите свой пакет, чтобы отправлять файлы и голосовые сообщения клиентам.",
            autoTranslation: "Обновите свой пакет, чтобы автоматически переводить сообщения и обслуживать больше клиентов.",
            telegramEntegration: "Обновите свой пакет, чтобы подключить интеграцию с Telegram.",
            chatCopilot: "Обновите свой пакет, чтобы использовать чат-ассистента с искусственным интеллектом для более эффективного обслуживания.",
            calenderEntegration: "Обновите свой пакет, чтобы синхронизировать календарь с другими приложениями.",
            mailEntegration: "Обновите свой пакет, чтобы эффективно управлять электронной почтой и улучшить коммуникацию с клиентами.",
            smsEntegration: "Обновите свой пакет, чтобы быстрее достигать клиентов с помощью SMS-интеграции.",
            ticketSystem: "Обновите свой пакет, чтобы более эффективно управлять запросами клиентов с помощью системы тикетов.",
            taskManagementEntegration: "Обновите свой пакет, чтобы улучшить рабочие процессы с помощью управления задачами.",
            webhookEntegration: "Обновите свой пакет, чтобы синхронизировать другие приложения через вебхуки.",
            readyContents: "Обновите свой пакет, чтобы улучшить общение с клиентами с помощью готового контента.",
            automationEntegration: "Обновите свой пакет, чтобы автоматизировать рабочие процессы.",
            customerTablesEntegration: "Обновите свой пакет, чтобы эффективно управлять данными клиентов с помощью таблиц.",
            formEntegration: "Обновите свой пакет, чтобы эффективно управлять запросами клиентов с помощью форм.",
            maxFormLimit: "Обновите свой пакет, чтобы создавать больше форм и управлять запросами клиентов.",
            maxFormFieldLimit: "Обновите свой пакет, чтобы добавлять больше полей в формы для лучшего управления запросами.",
            maxCustomerTableCount: "Обновите свой пакет, чтобы добавить больше таблиц клиентов.",
            maxCustomerTableFieldCount: "Обновите свой пакет, чтобы добавить больше полей в таблицы клиентов.",
            maxCustomerTableViewCount: "Обновите свой пакет, чтобы сохранить больше представлений таблиц клиентов.",
            maxCustomerTableRecordCount: "Обновите свой пакет, чтобы добавить больше записей в таблицы клиентов.",
            maxAutomationButton: "Обновите свой пакет, чтобы добавить больше блоков автоматизации.",
            automationTimerBase: "Обновите свой пакет, чтобы использовать таймеры автоматизации.",
            automationEventBase: "Обновите свой пакет, чтобы использовать события автоматизации.",
            automationWebhookBase: "Обновите свой пакет, чтобы использовать вебхуки автоматизации.",
            automationButtonBase: "Обновите свой пакет, чтобы использовать кнопки автоматизации.",
            liveScore: "Обновите свой пакет, чтобы активировать функцию мониторинга в реальном времени.",
            multipleChatWindow: "Обновите свой пакет, чтобы открывать несколько окон чата одновременно.",
            maxTaskWorkflowLimit: "Обновите свой пакет, чтобы добавить больше рабочих процессов задач.",
            maxTaskColumnLimit: "Обновите свой пакет, чтобы добавить больше столбцов задач.",
            maxTaskRowLimit: "Обновите свой пакет, чтобы добавить больше строк задач.",
            maxDepartmentLimit: "Обновите свой пакет, чтобы добавить больше отделов.",
            maxRoleLimit: "Обновите свой пакет, чтобы добавить больше ролей.",
            maxReadyContentsLimit: "Обновите свой пакет, чтобы добавить больше готового контента.",
            excelDownload: "Обновите свой пакет, чтобы активировать возможность скачивания Excel-файлов.",
            customerGroup: "Обновите свой пакет, чтобы использовать функцию групп клиентов.",
            maxMailCount: "Обновите свой пакет, чтобы отправлять больше писем.",
            maxWhatsappChannel: "Обновите свой пакет, чтобы добавить больше каналов WhatsApp.",
            maxBusinessWhatsappChannel: "Обновите свой пакет, чтобы добавить больше каналов WhatsApp Business.",
            maxInstagramChannel: "Обновите свой пакет, чтобы добавить больше каналов Instagram.",
            maxMessengerChannel: "Обновите свой пакет, чтобы добавить больше каналов Messenger.",
            maxTelegramChannel: "Обновите свой пакет, чтобы добавить больше каналов Telegram.",
            maxTrendyolChannel: "Обновите свой пакет, чтобы добавить больше каналов Trendyol.",
            maxMetaLeadChannel: "Обновите свой пакет, чтобы добавить больше каналов Meta Lead."
        },
        setupWizard: {
            finishModalVideos: "Обучающие видео",
            finishModalDoc: "Документация",
            finsihModalLiveSupport: "Онлайн поддержка",
            completed: "Хорошо, понял",
            completedWarning: "Нажмите на кнопку, чтобы завершить настройку и закончить руководство",
            supsisSetupGuide: "Настройка Supsis",
            supsisSetupGuideDescription: "Пожалуйста, выполните эти шаги, чтобы полностью использовать возможности Supsis.",
            goToSetup: "Перейти к настройке",
            completionPercentageDescription: "Вы используете только %{percentage} функций, предлагаемых Supsis.",
            aiChatbot: {
                title: "AI Чат-бот",
                content: "Отвечайте на входящие сообщения автоматически, мгновенно и интеллектуально с помощью AI Чат-бота Supsis.",
                steps: {
                    step1: {
                        title: "Создать Чат-бота",
                        content: "Используйте эту кнопку, чтобы создать новый <b>сценарий чат-бота</b>. Вы можете быстро начать, выбрав один из специально подготовленных шаблонов, или разработать полностью оригинальный сценарий с нуля, чтобы создать чат-бота, полностью отвечающего вашим бизнес-потребностям."
                    },
                    step2: {
                        title: "Готовые сценарии",
                        content: "Легко понять основную логику работы чат-бота с помощью <b>готовых шаблонов</b>. Сэкономьте время, настраивая эти шаблоны под свои нужды и разрабатывая индивидуальные решения. Вы можете начать с любого из шаблонов, подходящих для различных случаев использования."
                    },
                    step3: {
                        title: "Интеграции Чат-бота",
                        content: "Интегрируйте вашего чат-бота с <b>популярными платформами, такими как WhatsApp, Instagram и Facebook</b>. Таким образом, вы можете активировать чат-бота напрямую на каналах, которые используют ваши клиенты, увеличивая доступность и вовлеченность."
                    },
                    step4: {
                        title: "Аналитика Чат-бота",
                        content: "Просматривайте и анализируйте <b>производительность вашего чат-бота с помощью детальных графиков и статистики</b>. Фильтруя по определенным периодам времени или платформам, вы можете измерить эффективность чат-бота, выявить области для улучшения и оптимизировать стратегии."
                    }
                }
            },
            aiAssistant: {
                title: "AI Ассистент",
                content: "Активируйте цифрового помощника для поддержки вашей команды.",
                steps: {
                    step1: {
                        title: "Интеграция с OpenAI",
                        content: "<p>Установите <b>бесшовную интеграцию</b> между OpenAI и Supsis AI, чтобы повысить эффективность вашего бизнеса. Таким образом, ваш мощный AI ассистент активируется и начнет оптимизировать процессы. Для завершения интеграции вам нужно только ввести ваш API-ключ OpenAI. <br> <br> <b>Чтобы получить ваш API-ключ OpenAI, <a href='https://platform.openai.com/account/api-keys' target='_blank'>нажмите здесь</a>.</b></p>"
                    }
                }
            },
            aiLiveSupport: {
                title: "AI Поддержка в реальном времени",
                content: "Активируйте систему живого чата с искусственным интеллектом.",
                steps: {
                    step1: {
                        title: "Фильтрация разговоров",
                        content: "Легко управляйте <b>всеми разговорами с клиентами</b> из этой области. Вы можете приоритезировать разговоры, фильтруя их по категориям, таким как непрочитанные, ожидающие или те, что ведутся с чат-ботом, чтобы ни один запрос не остался без внимания."
                    },
                    step2: {
                        title: "Более детальный просмотр",
                        content: "Используйте эти опции для более детального изучения разговоров с клиентами. Вы можете применять <b>более детальные фильтры</b>, такие как неотвеченные вчерашние разговоры или конкретные клиенты, которые связались с вами, или создать свои собственные фильтры для персонализации рабочего процесса."
                    },
                    step3: {
                        title: "Экран живой поддержки",
                        content: "Переключитесь в этот режим, чтобы <b>эффективно управлять всеми разговорами поддержки с централизованного экрана</b>. Просматривайте все сообщения, ответы агентов, текущие статусы и даты каждого разговора в одном месте, что позволит вам принимать быстрые и точные решения."
                    },
                    step4: {
                        title: "Тестовая страница",
                        content: "Используйте этот раздел для тестирования производительности и работы вашего чат-бота в реальном времени. Отправляя сообщения как посетитель, вы можете <b>наблюдать за ответами и поведением чат-бота</b>, что позволит внести необходимые улучшения перед тем, как представить его конечным пользователям."
                    }
                }
            },
            aiAutomation: {
                title: "AI Автоматизация",
                content: "Автоматизируйте процессы поддержки и экономьте время.",
                steps: {
                    step1: {
                        title: "Создать новую автоматизацию",
                        content: "Используйте эту кнопку, чтобы создать новую автоматизацию для оптимизации бизнес-процессов. Вы можете разрабатывать автоматизации на основе событий (например, при получении нового сообщения), времени (например, каждое утро в определенное время) или <b>Webhook-автоматизации</b>, чтобы сделать рабочие процессы умнее."
                    },
                    step2: {
                        title: "Категории автоматизаций",
                        content: "Если у вас много автоматизаций, создайте <b>категории автоматизаций</b> в этом разделе для удобства управления. Категоризация помогает организовать автоматизации и быстро находить их при необходимости. Используйте эту кнопку, чтобы создать новую категорию."
                    },
                    step3: {
                        title: "Выполненные задачи",
                        content: "После создания и публикации автоматизаций вы можете <b>мгновенно отслеживать, сколько задач выполнили ваши автоматизации</b> в этом разделе. Это позволяет наблюдать, насколько активны ваши автоматизации и какие процессы они затрагивают."
                    },
                    step4: {
                        title: "Статистика автоматизаций",
                        content: "Просматривайте <b>детальную статистику производительности</b> ваших автоматизаций в этом разделе. Узнайте, как часто каждая автоматизация запускается, количество успешных задач, процент успеха и возможные ошибки, чтобы оптимизировать стратегии автоматизации."
                    }
                }
            },
            aiDynamicCrm: {
                title: "AI CRM",
                content: "Анализируйте и управляйте взаимодействиями с клиентами с помощью искусственного интеллекта.",
                steps: {
                    step1: {
                        title: "Фильтрация посетителей",
                        content: "Легко <b>фильтруйте посетителей</b> в вашей базе данных клиентов. Вы можете искать посетителей по имени, email, номеру телефона, тегу или пользовательским полям профиля. Также вы можете получить доступ к этому разделу для более детального просмотра и анализа."
                    },
                    step2: {
                        title: "Просмотр посетителей",
                        content: "Все ваши посетители перечислены в этой таблице. <b>Дважды щелкните по соответствующей строке, чтобы получить больше информации и выполнить действия с посетителем</b>. В открывшемся окне вы можете получить доступ к истории общения, заметкам и другой детальной информации о посетителе."
                    },
                    step3: {
                        title: "Ручная блокировка",
                        content: "Вы можете <b>вручную блокировать посетителей</b>, которые демонстрируют нежелательное или неадекватное поведение. Заблокированные посетители отображаются в отдельном списке, и вы можете снять блокировку из этого раздела при необходимости."
                    },
                    step4: {
                        title: "Теги",
                        content: "Сделайте ваш CRM более организованным и управляемым, <b>категоризируя посетителей с помощью тегов</b>. Чтобы назначить теги посетителям, сначала вам нужно создать свои собственные теги. Используйте эту кнопку, чтобы создать новый тег."
                    },
                    step5: {
                        title: "Поля профиля",
                        content: "<b>Поля профиля</b> позволяют собирать дополнительную информацию о ваших посетителях и управлять ею организованно. Таким образом, вы можете углубить сегментацию клиентов, предлагать персонализированный сервис и делать отношения с клиентами более эффективными."
                    }
                }
            },
            whatsappBusiness: {
                title: "WhatsApp Business",
                content: "Управляйте сообщениями поддержки, подключив ваш аккаунт WhatsApp Business.",
                steps: {
                    step1: {
                        title: "Интеграция WhatsApp Business",
                        content: "<p><b>Подключите ваш аккаунт WhatsApp Business к Supsis</b> и управляйте всеми сообщениями поддержки клиентов из единой централизованной панели. С этой интеграцией вы можете отправлять мгновенные сообщения через WhatsApp, делать массовые рассылки, настраивать автоматические ответы и комплексно отслеживать взаимодействия с клиентами.</p>"
                    }
                }
            },
            whatsappWeb: {
                title: "WhatsApp Web",
                content: "Управляйте сообщениями, полученными через WhatsApp Web, с помощью Supsis AI.",
                steps: {
                    step1: {
                        title: "Интеграция WhatsApp Web",
                        content: "<p><b>Легко управляйте всеми сообщениями, полученными через WhatsApp Web, с помощью Supsis AI.</b> С этой интеграцией вы можете отправлять мгновенные сообщения через WhatsApp, создавать массовые рассылки, настраивать автоматические ответы и легко отслеживать взаимодействия с клиентами. Таким образом, вы делаете общение с клиентами более эффективным.</p>"
                    }
                }
            },
            instagram: {
                title: "Instagram",
                content: "Отвечайте на личные сообщения Instagram через Supsis AI.",
                steps: {
                    step1: {
                        title: "Интеграция Instagram",
                        content: "<p><b>Централизуйте общение с клиентами, отвечая напрямую на личные сообщения Instagram через Supsis AI.</b> С этой интеграцией вы можете отправлять мгновенные сообщения через Instagram, делать массовые рассылки, настраивать автоматические ответы и комплексно отслеживать взаимодействия с клиентами.</p>"
                    }
                }
            },
            facebook: {
                title: "Facebook",
                content: "Управляйте сообщениями с вашей страницы Facebook в единой панели.",
                steps: {
                    step1: {
                        title: "Интеграция Facebook",
                        content: "<p><b>Эффективно управляйте всеми сообщениями с вашей страницы Facebook с помощью Supsis AI.</b> С этой интеграцией вы можете отправлять мгновенные сообщения через Facebook Messenger, создавать массовые рассылки, настраивать автоматические ответы и отслеживать взаимодействия с клиентами.</p>"
                    }
                }
            },
            telegram: {
                title: "Telegram",
                content: "Интегрируйте сообщения Telegram с Supsis AI.",
                steps: {
                    step1: {
                        title: "Интеграция Telegram",
                        content: "<p><b>Интегрируйте сообщения Telegram с Supsis AI</b> и управляйте общением с клиентами из единой панели. С этой интеграцией вы можете отправлять мгновенные сообщения через Telegram, создавать массовые рассылки, настраивать автоматические ответы и легко отслеживать все взаимодействия с клиентами.</p>"
                    }
                }
            },
            mail: {
                title: "Почта",
                content: "Интегрируйте ваши поддержку по электронной почте в систему Supsis AI.",
                steps: {
                    step1: {
                        title: "Создать новое письмо",
                        content: "<p>Используйте эту кнопку, чтобы отправить новое письмо. <b>Заполнив содержание письма, получателей и другую необходимую информацию</b>, вы можете быстро отправить ваши личные или массовые письма.</p>"
                    },
                    step2: {
                        title: "Шаблоны писем",
                        content: "<p><b>Управляйте</b> вашими шаблонами писем из этого раздела. Вы можете редактировать, удалять или создавать новые шаблоны. Используя предварительно подготовленные шаблоны, вы можете ускорить процессы отправки писем и обеспечить последовательную коммуникацию.</p>"
                    },
                    step3: {
                        title: "Отправка массовых писем",
                        content: "<p>Используйте эту область, чтобы <b>отправлять массовые письма</b> для охвата большой аудитории. Заполнив необходимые поля, вы можете легко отправить массовые письма вашему списку клиентов или определенным группам в Supsis.</p>"
                    },
                    step4: {
                        title: "Управление группами клиентов",
                        content: "<p><b>Эффективно управляйте</b> вашими группами клиентов из этого раздела. Вы можете редактировать, удалять или создавать новые группы. С этими группами вы можете организовывать целевые email-кампании и персонализировать вашу коммуникацию еще больше.</p>"
                    }
                }
            },
            metaLead: {
                title: "Лид Meta",
                content: "Управляйте формами, полученными из ваших рекламных объявлений Facebook и Instagram.",
                steps: {
                    step1: {
                        title: "Интеграция Meta Lead",
                        content: "<p>С <b>интеграцией Meta Lead</b> управляйте формами потенциальных клиентов, полученными из ваших рекламных объявлений Facebook и Instagram, напрямую через Supsis. Благодаря этой интеграции вы можете более эффективно отслеживать лиды, полученные из рекламных кампаний, ускорить общение с потенциальными клиентами и повысить конверсию.</p>"
                    }
                }
            },
            trendyol: {
                title: "Trendyol",
                content: "Управляйте вашими заказами Trendyol и сообщениями клиентов.",
                steps: {
                    step1: {
                        title: "Интеграция Trendyol",
                        content: "<p>Благодаря <b>операциям интеграции Trendyol</b> централизованно управляйте вашими заказами, полученными через Trendyol, через Supsis. После завершения этой интеграции вы можете сделать ваши процессы обработки заказов более эффективными, упростить общение с клиентами и снизить операционную нагрузку.</p>"
                    }
                }
            },
            formSurvey: {
                title: "Формы и опросы",
                content: "Создавайте формы для сбора отзывов от клиентов.",
                steps: {
                    step1: {
                        title: "Создать новую форму",
                        content: "<p>Используйте эту кнопку, чтобы <b>создать новую форму или опрос</b> для сбора отзывов от ваших клиентов. С формами, которые вы создаете, вы можете собирать ценные отзывы клиентов и делать вашу коммуникацию более эффективной.</p>"
                    },
                    step2: {
                        title: "Управление формами",
                        content: "<p><b>Эффективно управляйте всеми вашими формами</b> из этой области. Вы можете редактировать, архивировать, удалять или создавать новые формы. Вы также можете отслеживать производительность опубликованных форм, просматривать процент ответов и вносить изменения при необходимости. С управлением формами вы можете более эффективно собирать и анализировать отзывы клиентов.</p>"
                    }
                }
            },
            processManagement: {
                title: "Управление процессами",
                content: "Планируйте и управляйте вашими процессами поддержки шаг за шагом.",
                steps: {
                    step1: {
                        title: "Управление бизнес-процессами",
                        content: "<p>Этот раздел позволяет вам эффективно управлять всеми вашими бизнес-процессами. <b>Вы можете создавать задачи, назначать их членам вашей команды и оптимизировать рабочие процессы.</b> Таким образом, вы можете сделать ваши процессы более эффективными, мгновенно отслеживать статус задач и повышать производительность команды.</p>"
                    },
                    step2: {
                        title: "Список задач",
                        content: "<p><b>Просматривайте все ваши задачи в виде списка</b> в этом разделе. Вы можете фильтровать, удалять или создавать новые задачи. Легко отслеживайте вашу рабочую нагрузку с помощью комплексного списка.</p>"
                    },
                    step3: {
                        title: "Метки задач",
                        content: "<p><b>Создавайте метки</b> для лучшей организации и управления вашими задачами. Используя эти метки, вы можете легко категоризировать задачи и ускорять процессы поиска. Используйте эту кнопку, чтобы создать метки.</p>"
                    },
                    step4: {
                        title: "Архив задач",
                        content: "<p><b>Архивируйте завершенные или неактивные задачи, чтобы поддерживать порядок в рабочем пространстве</b>. Архивированные задачи перечислены здесь и могут быть легко восстановлены при необходимости.</p>"
                    },
                    step5: {
                        title: "Завершенные задачи",
                        content: "<p>Просматривайте ваши <b>завершенные задачи</b> в этом разделе. Вы можете изменить статус завершенных задач и архивировать их, если хотите. Таким образом, вы можете вести запись завершенной работы и анализировать прошлую производительность.</p>"
                    }
                }
            },
            calendar: {
                title: "Календарь",
                content: "Управляйте вашим календарем встреч и задач.",
                steps: {
                    step1: {
                        title: "Календарь",
                        content: "<p>Легко планируйте ваши ежедневные встречи с этим интерактивным <b>календарем</b>. Вы можете создавать новые встречи, обновлять существующие через календарь или отменять их. Оптимизируйте управление встречами и эффективно контролируйте ваше расписание.</p>"
                    },
                    step2: {
                        title: "Сайт бронирования",
                        content: "<p>Позвольте вашим клиентам легко бронировать встречи, используя ваш собственный <b>сайт бронирования</b>. Ваши клиенты могут делать бронирования, просматривать, обновлять или отменять существующие встречи через этот сайт.</p>"
                    },
                    step3: {
                        title: "Просмотр вашего сайта",
                        content: "<p>Используйте эту кнопку, чтобы мгновенно просмотреть сайт бронирования, который вы создали. <b>Проверьте финальную версию вашего сайта</b> и посмотрите, как клиенты будут видеть их бронирования. Все ваши активные бронирования будут перечислены на вашем сайте.</p>"
                    },
                    step4: {
                        title: "Создать новое бронирование",
                        content: "<p>Используйте эту кнопку, чтобы <b>вручную создать новое бронирование</b>. Заполнив всю необходимую информацию, вы можете быстро добавить встречу в ваш календарь и планировать встречи с клиентами.</p>"
                    }
                }
            },
            websiteAnalysis: {
                title: "Анализ сайта",
                content: "Анализируйте поведение посетителей и получайте инсайты.",
                steps: {
                    step1: {
                        title: "Всего посетителей",
                        content: "<p>Просматривайте <b>общее количество посетителей</b> вашего сайта из этой области. Этот показатель показывает общее количество уникальных посетителей вашего сайта за определенный период времени и помогает понять общий охват сайта.</p>"
                    },
                    step2: {
                        title: "Среднее количество посетителей",
                        content: "<p>Отслеживайте <b>среднее ежедневное или периодическое количество посетителей</b> вашего сайта здесь. Этот показатель является критическим индикатором для оценки стабильной производительности вашего сайта с течением времени.</p>"
                    },
                    step3: {
                        title: "Максимальное количество посетителей",
                        content: "<p>Наблюдайте <b>времена, когда ваш сайт достиг наибольшего количества посетителей</b> с этим показателем. Он показывает наибольшее количество посетителей вашего сайта за определенный период времени, помогая определить пиковые периоды для кампаний или контента.</p>"
                    },
                    step4: {
                        title: "Минимальное количество посетителей",
                        content: "<p>Отслеживайте <b>времена, когда ваш сайт получил наименьшее количество посетителей</b> с этим показателем. Он показывает наименьшее количество посетителей вашего сайта за определенный период времени, помогая определить периоды низкой производительности и предпринять необходимые действия.</p>"
                    }
                }
            },
            ticketSystem: {
                title: "Система поддержки тикетов",
                content: "Организуйте запросы клиентов с системой тикетов.",
                steps: {
                    step1: {
                        title: "Новый статус",
                        content: "<p><b>Создавайте новые статусы</b> для облегчения управления запросами поддержки. Например, определив пользовательские статусы, такие как \"В процессе\", \"Решено\", \"Ожидание\", вы можете сделать поток запросов более прозрачным.</p>"
                    },
                    step2: {
                        title: "Статусы",
                        content: "<p><b>Просматривайте текущие статусы</b> для каждого открытого запроса поддержки здесь. Отслеживая статусы, такие как \"Прочитано\", \"Отвечено\", \"Отменено\", вы можете легко видеть текущие этапы запросов и обеспечивать эффективное управление процессами.</p>"
                    },
                    step3: {
                        title: "Режим просмотра",
                        content: "<p>Вы можете переключаться между <b>списком или канбан-доской</b> для более эффективного управления запросами поддержки. Изменяя режим просмотра, вы можете визуально отслеживать статусы запросов и выбирать макет, который лучше всего соответствует вашему рабочему процессу.</p>"
                    }
                }
            },
            dynamicTables: {
                title: "Динамические таблицы",
                content: "Настраивайте и управляйте вашими данными с помощью фильтрации.",
                steps: {
                    step1: {
                        title: "Создать категорию",
                        content: "<p><b>Организуйте и управляйте вашими данными лучше, категоризируя ваши таблицы</b>. Используя кнопку создания категории, вы можете определить новые категории, группировать ваши таблицы и быстрее находить нужные данные.</p>"
                    },
                    step2: {
                        title: "Создать новую таблицу",
                        content: "<p>Используйте эту кнопку, чтобы <b>создать новую динамическую таблицу, соответствующую вашим потребностям</b>. Заполнив необходимую информацию на экране создания таблицы, вы можете хранить и управлять вашими данными в персонализированной структуре.</p>"
                    },
                    step3: {
                        title: "Создать таблицу с AI",
                        content: "<p>Используйте эту кнопку, чтобы <b>быстро создавать новые таблицы с поддержкой AI</b>. Достаточно ввести соответствующую информацию для создания таблицы с AI; система поможет вам разработать эффективные таблицы с умными предложениями.</p>"
                    }
                }
            },
            aiVoice: {
                title: "AI Голосовой агент",
                content: "Управляйте разговорами пользователей с голосовыми агентами на основе искусственного интеллекта.",
                steps: {
                    step1: {
                        title: "Интеграция AI Голосового агента",
                        content: "<p><b>Интегрируйте вашего AI голосового агента в Supsis</b>, чтобы автоматизировать и улучшить процессы общения с клиентами. После завершения интеграции вы можете более эффективно управлять голосовыми взаимодействиями и повысить удовлетворенность клиентов.</p>"
                    }
                }
            }
        },
        common: {
            cancel: "Отмена",
            save: "Сохранить",
            yes: "Да",
            no: "Нет",
            create: "Создать",
            delete: "Удалить",
            edit: "Редактировать",
            add: "Добавить",
            back: "Назад",
            active: "Активный",
            inactive: "Неактивный"
        },
        youtubeChannel: {
            youtubeIntegration: "Интеграция с YouTube",
            deleteYoutubeChannelInfo: "Вы уверены, что хотите удалить этот канал YouTube?",
            youtubeChannels: "YouTube каналы",
            title: "Комментарии YouTube",
            channelName: "Название канала",
            channelDetail: "Детали канала",
            channelDetailDesc: "Управляйте своим каналом YouTube",
            youtubeChannel: "Канал YouTube",
            status: "Статус",
            active: "Активный",
            inactive: "Неактивный",
            detail: "Деталь",
            visibility: "Видимость",
            videos: "Видео",
            comments: "Комментарии",
            visibilitySettings: "Настройки видимости",
            visibilityDescription: "Установите, какие пользователи и отделы могут видеть этот канал",
            users: "Пользователи",
            departments: "Отделы",
            owners: "Владельцы",
            selectUsers: "Выберите пользователей",
            selectDepartments: "Выберите отделы",
            selectOwners: "Выберите владельцев",
            deleteChannel: "Удалить канал",
            deleteChannelDescription: "Вы уверены, что хотите удалить этот канал YouTube?",
            channelUpdatedSuccess: "Канал успешно обновлен",
            failedUpdateChannel: "Не удалось обновить канал",
            connectedSuccess: "Аккаунт YouTube успешно подключен",
            failedToCreateChannel: "Не удалось создать канал",
            requiredChannel: "Требуется название канала",
            oauthTimeout: "Тайм-аут авторизации",
            all: "Все",
            new: "Новый",
            replied: "Отвечено",
            resolved: "Решено",
            searchComments: "Поиск комментариев",
            noCommentsFound: "Комментарии не найдены",
            replies: "ответы",
            like: "Нравится",
            reply: "Ответить",
            replyToComment: "Ответить на комментарий",
            writeYourReply: "Напишите ваш ответ",
            pleaseEnterReply: "Введите ответ",
            replySuccess: "Ответ успешно отправлен",
            errorSendingReply: "Ошибка отправки ответа",
            statusUpdated: "Статус обновлён",
            errorUpdatingStatus: "Ошибка обновления статуса",
            errorFetchingComments: "Ошибка загрузки комментариев",
            commentLiked: "Комментарий отмечен как понравившийся",
            errorLikingComment: "Ошибка при отметке комментария",
            noVideosFound: "Видео не найдены",
            errorFetchingVideos: "Ошибка загрузки видео",
            refresh: "Обновить",
            loadMore: "Загрузить ещё",
            ensureYouTubeAccount: "Убедитесь, что у вас есть аккаунт Google/YouTube",
            ensureYouTubeChannel: "Убедитесь, что у вас есть канал YouTube",
            permissionDesc: "Необходимо разрешить Supsis доступ к комментариям YouTube.",
            connectToYouTube: "Подключить YouTube",
            views: "просмотры",
            likes: "лайки",
            sync: "Синхронизация",
            commentsSynced: "Комментарии синхронизированы",
            errorSyncingComments: "Ошибка синхронизации комментариев",
            pending: "На модерации",
            rejected: "Отклонён",
            moderation: "Модерация",
            publish: "Опубликовать",
            holdForReview: "На проверке",
            reject: "Отклонить",
            rejectAndBan: "Отклонить и заблокировать",
            moderationSuccess: "Модерация выполнена успешно",
            errorModeration: "Ошибка модерации",
            videoDetail: "Подробнее о видео",
            duration: "Длительность",
            showMore: "Показать больше",
            showLess: "Показать меньше",
            loadingVideo: "Загрузка видео...",
            videoNotFound: "Видео не найдено",
            goBack: "Назад",
            errorLoadingVideo: "Ошибка загрузки видео",
            videosSynced: "Видео синхронизированы",
            errorSyncingVideos: "Ошибка синхронизации видео",
            selectVideo: "Выбрать видео",
            allVideos: "Все видео",
            selectCommentToPreview: "Выберите комментарий для предпросмотра",
            viewDetails: "Подробнее",
            published: "Опубликовано",
            heldForReview: "На проверке"
        },
        googleBusiness: {
            title: "Отзывы Google Business",
            channels: "Каналы Google Business",
            channelName: "Название канала",
            channelDetails: "Подробности канала",
            connectToGoogleBusiness: "Подключить Google Business",
            ensureGoogleAccount: "Убедитесь, что у вас есть аккаунт Google",
            ensureBusinessProfile: "Убедитесь, что у вас есть профиль Google Business",
            permissionDesc: "Необходимо разрешить Supsis доступ к отзывам Google Business.",
            requiredChannel: "Требуется название канала",
            failedToCreateChannel: "Не удалось создать канал",
            connectedSuccess: "Аккаунт Google Business успешно подключён",
            oauthTimeout: "Время авторизации истекло",
            deleteChannelInfo: "Вы уверены, что хотите удалить этот канал Google Business?",
            deleteChannel: "Удалить канал",
            deleteChannelDescription: "Вы уверены, что хотите удалить этот канал Google Business?",
            detail: "Подробнее",
            visibility: "Видимость",
            locations: "Места",
            reviews: "Отзывы",
            accountInfo: "Информация об аккаунте",
            accountName: "Имя аккаунта",
            accountId: "ID аккаунта",
            status: "Статус",
            enabled: "Включено",
            disabled: "Отключено",
            save: "Сохранить",
            channelUpdated: "Канал успешно обновлён",
            errorUpdatingChannel: "Ошибка обновления канала",
            visibilityDescription: "Укажите пользователей и отделы, которым виден этот канал",
            visibleToUsers: "Видимость для пользователей",
            visibleToDepartments: "Видимость для отделов",
            selectUsers: "Выбрать пользователей",
            selectDepartments: "Выбрать отделы",
            visibilityUpdated: "Настройки видимости обновлены",
            errorUpdatingVisibility: "Ошибка обновления настроек видимости",
            sync: "Синхронизация",
            refresh: "Обновить",
            locationsSynced: "Места синхронизированы",
            errorSyncingLocations: "Ошибка синхронизации мест",
            errorFetchingLocations: "Ошибка загрузки мест",
            noLocationsFound: "Места не найдены",
            selectLocation: "Выбрать место",
            allLocations: "Все места",
            allRatings: "Все оценки",
            all: "Все",
            new: "Новые",
            replied: "Ответ дан",
            resolved: "Решено",
            noReviewsFound: "Отзывы не найдены",
            noComment: "Нет текста отзыва",
            selectReviewToPreview: "Выберите отзыв для предпросмотра",
            yourReply: "Ваш ответ",
            reply: "Ответить",
            updateReply: "Обновить ответ",
            replyToReview: "Ответить на отзыв",
            writeYourReply: "Напишите ваш ответ",
            pleaseEnterReply: "Введите ответ",
            replySuccess: "Ответ успешно отправлен",
            errorSendingReply: "Ошибка отправки ответа",
            statusUpdated: "Статус обновлён",
            errorUpdatingStatus: "Ошибка обновления статуса",
            errorFetchingReviews: "Ошибка загрузки отзывов"
        },
        googlePlay: {
            title: "Отзывы Google Play",
            channels: "Каналы Google Play",
            channelName: "Название канала",
            channelDetails: "Подробности канала",
            connectToGooglePlay: "Подключить Google Play",
            ensureGoogleAccount: "Убедитесь, что у вас есть аккаунт Google",
            ensurePlayConsole: "Убедитесь, что у вас есть аккаунт Google Play Console",
            permissionDesc: "Необходимо разрешить Supsis доступ к отзывам Google Play.",
            requiredChannel: "Требуется название канала",
            failedToCreateChannel: "Не удалось создать канал",
            connectedSuccess: "Аккаунт Google Play успешно подключён",
            oauthTimeout: "Время авторизации истекло",
            deleteChannelInfo: "Вы уверены, что хотите удалить этот канал Google Play?",
            deleteChannel: "Удалить канал",
            deleteChannelDescription: "Вы уверены, что хотите удалить этот канал Google Play?",
            detail: "Подробнее",
            visibility: "Видимость",
            apps: "Приложения",
            reviews: "Отзывы",
            status: "Статус",
            enabled: "Включено",
            disabled: "Отключено",
            save: "Сохранить",
            channelUpdated: "Канал успешно обновлён",
            errorUpdatingChannel: "Ошибка обновления канала",
            visibilityDescription: "Укажите пользователей и отделы, которым виден этот канал",
            visibleToUsers: "Видимость для пользователей",
            visibleToDepartments: "Видимость для отделов",
            selectUsers: "Выбрать пользователей",
            selectDepartments: "Выбрать отделы",
            visibilityUpdated: "Настройки видимости обновлены",
            errorUpdatingVisibility: "Ошибка обновления настроек видимости",
            addApp: "Добавить приложение",
            refresh: "Обновить",
            noAppsFound: "Приложения не найдены",
            packageName: "Имя пакета",
            appName: "Название приложения",
            appNamePlaceholder: "Напр.: Моё приложение",
            iconUrl: "URL иконки",
            fillRequiredFields: "Заполните обязательные поля",
            appAdded: "Приложение успешно добавлено",
            errorAddingApp: "Ошибка добавления приложения",
            syncReviews: "Синхронизировать отзывы",
            reviewsSynced: "Отзывы синхронизированы",
            errorSyncingReviews: "Ошибка синхронизации отзывов",
            removeApp: "Удалить приложение",
            removeAppConfirm: "Вы уверены, что хотите удалить {name}? Все связанные отзывы также будут удалены.",
            appRemoved: "Приложение удалено",
            errorRemovingApp: "Ошибка удаления приложения",
            errorFetchingApps: "Ошибка загрузки приложений",
            selectApp: "Выбрать приложение",
            allApps: "Все приложения",
            allRatings: "Все оценки",
            all: "Все",
            new: "Новые",
            replied: "Ответ дан",
            resolved: "Решено",
            noReviewsFound: "Отзывы не найдены",
            noComment: "Нет текста отзыва",
            selectReviewToPreview: "Выберите отзыв для предпросмотра",
            yourReply: "Ваш ответ",
            reply: "Ответить",
            updateReply: "Обновить ответ",
            replyToReview: "Ответить на отзыв",
            writeYourReply: "Напишите ваш ответ (макс. 350 символов)",
            pleaseEnterReply: "Введите ответ",
            replyTooLong: "Ответ не может превышать 350 символов",
            replySuccess: "Ответ успешно отправлен",
            errorSendingReply: "Ошибка отправки ответа",
            statusUpdated: "Статус обновлён",
            errorUpdatingStatus: "Ошибка обновления статуса",
            errorFetchingReviews: "Ошибка загрузки отзывов",
            deviceInfo: "Информация об устройстве",
            device: "Устройство",
            appVersion: "Версия приложения",
            manufacturer: "Производитель"
        },
        googleDrive: {
            title: "Google Drive",
            googleDriveChannels: "Каналы Google Drive",
            googleDriveIntegration: "Интеграция Google Drive",
            channelName: "Название канала",
            channelInfo: "Информация о канале",
            channelSettings: "Настройки канала",
            connectedAccount: "Подключённый аккаунт",
            storageQuota: "Квота хранилища",
            connectToGoogleDrive: "Подключить Google Drive",
            ensureGoogleAccount: "Убедитесь, что у вас есть аккаунт Google",
            ensureGoogleDriveAccess: "Убедитесь, что у вас есть доступ к Google Drive",
            permissionDesc: "Необходимо разрешить Supsis доступ к файлам Google Drive.",
            requiredChannel: "Требуется название канала",
            failedToCreateChannel: "Не удалось создать канал",
            connectedSuccess: "Аккаунт Google Drive успешно подключён",
            oauthTimeout: "Время авторизации истекло",
            deleteGoogleDriveChannelInfo: "Вы уверены, что хотите удалить этот канал Google Drive?",
            deleteChannel: "Удалить канал",
            deleteChannelDescription: "Вы уверены, что хотите удалить этот канал Google Drive?",
            driveExplorer: "Обозреватель Диска",
            myDrive: "Мой диск",
            sharedDrives: "Общие диски",
            searchFiles: "Поиск файлов...",
            noSharedDrives: "Общие диски не найдены",
            noFiles: "Файлы не найдены",
            loadMore: "Загрузить ещё",
            filesSelected: "файлов выбрано",
            downloadToSupsis: "Скачать в Supsis",
            fileDownloaded: "Файл успешно загружен",
            errorLoadingFiles: "Ошибка загрузки файлов",
            errorLoadingDrives: "Ошибка загрузки дисков",
            errorSearching: "Ошибка поиска",
            errorDownloading: "Ошибка загрузки файла",
            fileName: "Имя файла",
            fileSize: "Размер",
            modifiedTime: "Изменён",
            selectFile: "Выбрать файл",
            selectFileFromGoogleDrive: "Выбрать файл из Google Drive",
            selectChannel: "Выбрать канал",
            noChannelsAvailable: "Доступные каналы Google Drive не найдены",
            selectedFiles: "Выбранные файлы",
            upload: "Загрузить",
            selectUploadMethod: "Выберите способ загрузки:",
            uploadFromComputer: "Загрузить с компьютера",
            downloadingFiles: "Загрузка файлов...",
            myChannel: "Мои",
            manageWhoCanAccess: "Управление доступом к каналу",
            download: "Скачать",
            openInNewTab: "Открыть в новой вкладке",
            openInGoogleDrive: "Открыть в Google Drive",
            fileType: "Тип файла",
            owner: "Владелец",
            previewNotAvailable: "Предпросмотр для этого типа файла недоступен",
            byocTitle: "Использовать учётные данные Google Cloud",
            byocDescription: "Для интеграции Google Drive создайте учётные данные OAuth в Google Cloud Console.",
            clientId: "OAuth Client ID",
            clientIdPlaceholder: "xxxxxxxx.apps.googleusercontent.com",
            clientIdRequired: "Требуется Client ID",
            clientSecret: "OAuth Client Secret",
            clientSecretPlaceholder: "GOCSPX-xxxxxxxxxx",
            clientSecretRequired: "Требуется Client Secret",
            redirectUriCopied: "Redirect URI скопирован",
            setupGuideTitle: "Инструкция (нажмите, чтобы развернуть)",
            setupStep1: "Перейдите в Google Cloud Console и создайте проект или выберите существующий.",
            setupStep2: "Откройте раздел APIs & Services > Credentials.",
            setupStep3: "Нажмите «+ CREATE CREDENTIALS» > «OAuth client ID». Выберите тип приложения «Web application».",
            setupStep4: "Добавьте следующий URL в раздел Authorized redirect URIs:",
            setupStep5: "Включите «Google Drive API» в APIs & Services > Library.",
            setupStep6: "Скопируйте Client ID и Client Secret и вставьте их в поля выше."
        },
        appStore: {
            title: "Отзывы App Store",
            channels: "Каналы App Store",
            channelName: "Название канала",
            channelDetails: "Подробности канала",
            connectToAppStore: "Подключить App Store",
            credentials: "Учётные данные API",
            credentialsHelp: "Введите учётные данные API App Store Connect. Создать API-ключ можно в",
            issuerId: "Issuer ID",
            issuerIdPlaceholder: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
            keyId: "Key ID",
            keyIdPlaceholder: "XXXXXXXXXX",
            privateKey: "Приватный ключ (содержимое .p8)",
            privateKeyPlaceholder: "-----BEGIN PRIVATE KEY-----\n...\n-----END PRIVATE KEY-----",
            requiredField: "Обязательное поле",
            validateCredentials: "Проверить учётные данные",
            credentialsValid: "Учётные данные действительны",
            credentialsInvalid: "Недействительные учётные данные",
            pleaseValidateFirst: "Сначала проверьте учётные данные",
            failedToCreateChannel: "Не удалось создать канал",
            connectedSuccess: "Аккаунт App Store успешно подключён",
            deleteChannelInfo: "Вы уверены, что хотите удалить этот канал App Store?",
            deleteChannel: "Удалить канал",
            deleteChannelDescription: "Вы уверены, что хотите удалить этот канал App Store?",
            detail: "Подробнее",
            visibility: "Видимость",
            apps: "Приложения",
            reviews: "Отзывы",
            status: "Статус",
            enabled: "Включено",
            disabled: "Отключено",
            save: "Сохранить",
            channelUpdated: "Канал успешно обновлён",
            errorUpdatingChannel: "Ошибка обновления канала",
            visibilityDescription: "Укажите пользователей и отделы, которым виден этот канал",
            visibleToUsers: "Видимость для пользователей",
            visibleToDepartments: "Видимость для отделов",
            selectUsers: "Выбрать пользователей",
            selectDepartments: "Выбрать отделы",
            visibilityUpdated: "Настройки видимости обновлены",
            errorUpdatingVisibility: "Ошибка обновления настроек видимости",
            syncApps: "Синхронизировать приложения",
            refresh: "Обновить",
            noAppsFound: "Приложения не найдены",
            appsAutoFetch: "Приложения загружаются из App Store Connect. Нажмите «Синхронизировать приложения» для обновления списка.",
            appsSynced: "Приложения успешно синхронизированы",
            errorSyncingApps: "Ошибка синхронизации приложений",
            syncReviews: "Синхронизировать отзывы",
            reviewsSynced: "Отзывы синхронизированы",
            errorSyncingReviews: "Ошибка синхронизации отзывов",
            errorFetchingApps: "Ошибка загрузки приложений",
            selectApp: "Выбрать приложение",
            allApps: "Все приложения",
            all: "Все",
            new: "Новые",
            replied: "Ответ дан",
            resolved: "Решено",
            noReviewsFound: "Отзывы не найдены",
            noComment: "Нет текста отзыва",
            anonymous: "Анонимно",
            selectReviewToPreview: "Выберите отзыв для предпросмотра",
            yourReply: "Ваш ответ",
            reply: "Ответить",
            edit: "Изменить",
            delete: "Удалить",
            editReply: "Изменить ответ",
            replyToReview: "Ответить на отзыв",
            writeYourReply: "Напишите ваш ответ",
            pleaseEnterReply: "Введите ответ",
            replySuccess: "Ответ успешно отправлен",
            errorSendingReply: "Ошибка отправки ответа",
            deleteResponse: "Удалить ответ",
            deleteResponseConfirm: "Вы уверены, что хотите удалить этот ответ?",
            responseDeleted: "Ответ успешно удалён",
            errorDeletingResponse: "Ошибка удаления ответа",
            statusUpdated: "Статус обновлён",
            errorUpdatingStatus: "Ошибка обновления статуса",
            errorFetchingReviews: "Ошибка загрузки отзывов",
            territory: "Территория",
            region: "Регион"
        },
        LinkedinContacts: "Контакты Linkedin",
        TelegramContacts: "Контакты Telegram",
        announcements: {
            menu: "Объявления",
            newAnnouncementForm: "Форма регистрации нового объявления",
            updateAnnouncementForm: "Форма обновления объявления"
        },
        packages: {
            mostPopular: "САМЫЙ ПОПУЛЯРНЫЙ",
            currency: "₺",
            activePlan: "АКТИВНЫЙ ПЛАН"
        },
        totalCost: {
            title: "СТОИМОСТЬ SUPSİS",
            monthlyPayments: "Ежемесячные платежи",
            currency: "₺",
            currencyMonthly: "₺ / Месяц",
            oneTimePayments: "Единоразовые платежи",
            oneTimeDiscount: "Скидка при годовой подписке",
            currencyYearly: "₺ / Год",
            totalOneTimeCost: "Общая сумма к оплате за первый раз",
            totalTax: "Налог ( %18 )",
            referenceCode: "У вас есть реферальный код?",
            referencePlaceholder: "Пожалуйста, введите код",
            codeButton: "Применить",
            monthlyCost: "Ежемесячная сумма списания с вашего счета?",
            oneTimeFullCost: "Единоразовая сумма «все включено»?",
            payment: "Произвести оплату"
        },
        probel: {
            branchCode: "Код филиала",
            branchCodeDesc: "Введите или выберите код филиала...",
            hospitalBranchCode: "Код отделения",
            hospitalBranchCodeDesc: "Введите или выберите код отделения...",
            clinicCode: "Код поликлиники",
            clinicCodeDesc: "Введите или выберите код поликлиники...",
            date: "Дата приема",
            dateDesc: "Введите или выберите дату приема...",
            patientToken: "Токен пациента",
            patientTokenDesc: "Введите или выберите токен пациента...",
            appointmentId: "ID приема",
            appointmentIdDesc: "Введите или выберите ID приема...",
            identityType: "Тип документа",
            identityNumber: "Номер документа",
            name: "Имя пациента",
            surname: "Фамилия пациента",
            gender: "Пол пациента",
            birthDay: "Дата рождения пациента",
            phoneNumber: "Номер телефона пациента",
            identityTypeDesc: "Введите или выберите тип документа...",
            identityNumberDesc: "Введите или выберите номер документа...",
            nameDesc: "Введите или выберите имя пациента...",
            surnameDesc: "Введите или выберите фамилию пациента...",
            genderDesc: "Введите или выберите пол пациента...",
            birthDayDesc: "Введите или выберите дату рождения пациента...",
            phoneNumberDesc: "Введите или выберите номер телефона пациента..."
        },
        waba: {
            templateCreationFailed: "Ошибка создания шаблона",
            templateError_2388040: "Превышен лимит символов",
            templateErrorDesc_2388040: "Поле в вашем шаблоне превысило максимально допустимый лимит символов.",
            templateError_2388047: "Неверный формат заголовка сообщения",
            templateErrorDesc_2388047: "Ваш заголовок сообщения содержит неверное форматирование.",
            templateError_2388072: "Неверный формат основного текста сообщения",
            templateErrorDesc_2388072: "Основной текст вашего сообщения содержит неверное форматирование.",
            templateError_2388073: "Неверный формат подвала сообщения",
            templateErrorDesc_2388073: "Подвал вашего сообщения содержит неверное форматирование.",
            templateError_2388293: "Соотношение слов в параметрах превышает предел",
            templateErrorDesc_2388293: "В этом шаблоне слишком много переменных для его длины. Уменьшите количество переменных или увеличьте длину сообщения.",
            templateError_2388299: "Начальные или конечные параметры не допускаются",
            templateErrorDesc_2388299: "Переменные не могут находиться в начале или конце шаблона."
        },
        profile: {
            subtitle: "Управляйте настройками своего аккаунта и сессиями"
        },
        integrations: {
            requiredField: "Это поле обязательно для заполнения",
            existingChannels: "Существующие каналы",
            createNewChannel: "Создать новый канал",
            channelName: "Название канала",
            createChannel: "Создать канал",
            channelCreated: "Канал успешно создан",
            channelCreateError: "Произошла ошибка при создании канала",
            channelActivated: "Канал активирован",
            channelDeactivated: "Канал деактивирован",
            channelUpdateError: "Произошла ошибка при обновлении канала",
            deleteChannelConfirm: "Удалить канал",
            deleteChannelConfirmContent: "Вы уверены, что хотите удалить канал {name}?",
            channelDeleted: "Канал успешно удален",
            channelDeleteError: "Произошла ошибка при удалении канала",
            slackIntegration: "Интеграция со Slack",
            slackDescription: "Отправляйте сообщения в свое рабочее пространство Slack через автоматизацию и чат-бота Supsis.",
            slackSetupTitle: "Шаги настройки:",
            slackStep1: "Перейдите на api.slack.com/apps",
            slackStep2: "Выберите существующее приложение Slack или создайте новое",
            slackStep3: "Нажмите 'Incoming Webhooks' в левом меню и включите его ('On')",
            slackStep4: "Нажмите 'Add New Webhook to Workspace' и выберите канал, в который вы хотите отправлять сообщения",
            slackCardDescription: "Отправляйте сообщения в свои каналы Slack через автоматизацию и чат-бота",
            slackChannelNamePlaceholder: "Напр.: Уведомления службы поддержки",
            slackWebhookUrl: "Webhook URL",
            slackWebhookUrlPlaceholder: "https://hooks.slack.com/services/...",
            slackWebhookUrlHelper: "Перейдите в приложение Slack > Incoming Webhooks > Add New Webhook to Workspace",
            slackWebhookUrlInvalid: "Пожалуйста, введите корректный Slack webhook URL",
            slackDefaultChannel: "Канал по умолчанию (необязательно)",
            slackDefaultChannelPlaceholder: "#general",
            slackDefaultChannelHelper: "Если не указано, будет использоваться канал, подключенный к вебхуку",
            pushoverIntegration: "Интеграция с Pushover",
            pushoverCardDescription: "Отправляйте push-уведомления на свои мобильные устройства через автоматизацию и чат-бота",
            pushoverDescription: "Отправляйте push-уведомления на свои мобильные устройства через автоматизацию и чат-бота Supsis. Вы можете создать учетную запись и получить ключ пользователя и токен приложения на pushover.net.",
            pushoverChannelNamePlaceholder: "Напр.: Мобильные уведомления",
            pushoverUserKey: "Ключ пользователя",
            pushoverUserKeyPlaceholder: "Ключ пользователя Pushover",
            pushoverUserKeyHelper: "Вы можете получить его на странице своей учетной записи pushover.net",
            pushoverAppToken: "Токен приложения",
            pushoverAppTokenPlaceholder: "Токен приложения Pushover",
            pushoverAppTokenHelper: "Вы можете создать приложение на pushover.net, чтобы получить токен"
        },
        "В конце месяца будет выставлен счет в соответствии с объемом вашего использования": {
            "": "В конце месяца будет выставлен счет в соответствии с объемом вашего использования"
        },
        "С вашего счета не будут списаны деньги": {
            "": "С вашего счета не будут списаны деньги"
        },
        "Хотите сделать эту историю основной?": "Хотите сделать эту историю основной?",
        shouldAddMethod: "Вы должны заполнить поле способа оплаты и платежный адрес!\nС вашего счета не будут списаны деньги...\nВ конце месяца будет выставлен счет в соответствии с вашим объемом использования.",
        "{contentOfChatBubble}": "{contentOfChatBubble}",
        task_reports: {
            title: "Отчеты о задачах",
            date: "Дата",
            workflow: "Рабочий процесс",
            select: "Выбрать",
            agent: "Агент",
            all: "Все",
            select_workflow_to_view_reports: "Выберите рабочий процесс для просмотра отчетов.",
            created_task: "Созданная задача",
            updated_task: "Обновленная задача",
            assigned_tasks_by_personnel: "Назначенные задачи по персоналу",
            assigned_task: "Назначенная задача",
            no_assigned_task_found_in_date_range: "Назначенные задачи не найдены в выбранном диапазоне дат.",
            updated_tasks: "Обновленные задачи",
            task: "Задача",
            current_stage: "Текущий этап",
            assigned: "Назначено",
            update: "Обновление",
            no_updated_task_found_in_date_range: "Обновленные задачи не найдены в выбранном диапазоне дат.",
            task_distribution_by_agent: "Распределение задач по агентам",
            total: "Всего",
            no_assigned_task_found: "Назначенные задачи не найдены.",
            timeline: "Временная шкала",
            unassigned_tasks: "Неназначенные задачи",
            transition_process: "Процесс перехода",
            no_active_task_found_for_agent: "Активные задачи для этого агента не найдены.",
            select_agent_to_view_timeline: "Выберите агента для просмотра временной шкалы.",
            entry: "Вход",
            exit: "Выход",
            still_in_this_stage: "Все еще на этом этапе",
            duration: "Продолжительность",
            day: "день",
            hour: "час",
            max_30_days_range_warning: "Вы можете выбрать диапазон дат до 30 дней.",
            today: "Сегодня",
            this_week: "На этой неделе",
            this_month: "В этом месяце",
            last_month: "В прошлом месяце",
            unknown: "Неизвестно",
            unassigned: "Не назначено",
            gantt: "Гант",
            table: "Таблица"
        },
        customBlockErrors: {
            BLOCK_NOT_FOUND: "Блок не найден",
            BLOCK_NOT_APPROVED: "Этот блок ещё не одобрен",
            BLOCK_ALREADY_IMPORTED: "Этот блок уже импортирован",
            BLOCK_IMPORT_FAILED: "Не удалось импортировать блок"
        }
    }
};

export default messagesRU;
